import type { Dict } from '../types';

export const th: Dict = {
  "collab.contentUpdate.available": "มีเวอร์ชันใหม่บนคลาวด์",
  "collab.contentUpdate.updating": "กำลังอัปเดต…",
  "collab.contentUpdate.askAgain": "เปิดการแจ้งเตือนอัปเดตอีกครั้ง",
  "collab.contentUpdate.title": "มีการอัปเดตบนคลาวด์",
  "collab.contentUpdate.description": "ซิงค์เนื้อหาล่าสุดจากอุปกรณ์อื่นมายังอุปกรณ์นี้หรือไม่? เนื้อหาโครงการในเครื่องจะถูกแทนที่ หน้าเว็บกู้คืนได้จากประวัติเวอร์ชันในเครื่อง แต่รูปภาพและไฟล์อื่นอาจกู้คืนไม่ได้",
  "collab.contentUpdate.dontPrompt": "ไม่แจ้งเตือนโครงการนี้เป็นเวลา 24 ชั่วโมง",
  "collab.contentUpdate.later": "ยังไม่อัปเดต",
  "collab.contentUpdate.replace": "แทนที่ด้วยเวอร์ชันคลาวด์",
  "collab.contentUpdate.failed": "อัปเดตไม่สำเร็จ โปรดลองอีกครั้ง",
  "collab.contentUpdate.busy": "กำลังสร้างหรืออัปโหลด โปรดลองหลังจากเสร็จสิ้น",
  "collab.contentUpdate.unsupported": "การแทนที่จากคลาวด์ไม่รองรับโฟลเดอร์ที่นำเข้า",
  "fileViewer.versions.sourceSync": "ซิงค์แล้ว",
  'billing.wallet': 'ยอดเงินในกระเป๋าเงิน',
  'billing.codingPlanDesignPlan': 'Design Plan',
  'billing.codingPlanPeriodHours': '{count} ชั่วโมง',
  'billing.codingPlanPeriodDays': '{count} วัน',
  'billing.codingPlanRemainingPercent': 'เหลือ {percent}%',
  "campaign.testReplay": "เปิดกิจกรรมทดสอบอีกครั้ง",
  'invite.header.eyebrow': "Team invitation",
  'invite.loading': "Loading invitation…",
  'invite.landing.title': "Join the team",
  'invite.landing.subtitle': "You’ve been invited to collaborate in OpenDesign.",
  'invite.landing.roleLabel': "Role",
  'invite.landing.invitedEmail': "Invited email",
  'invite.landing.expires': "Expires",
  'invite.role.admin': "Admin",
  'invite.role.member': "Member",
  'invite.role.admin.desc': "Can manage members, seats, and all project settings.",
  'invite.role.member.desc': "Can create your own projects, and view and comment on shared team projects.",
  'invite.accept.cta': "Accept invitation",
  'invite.accountMismatch.title': "You’re signed in as a different account",
  'invite.accountMismatch.body': "This invitation was sent to a different email address. You can continue with your current account, or switch accounts.",
  'invite.accountMismatch.continue': "Continue with current account",
  'invite.accountMismatch.switch': "Switch account",
  'invite.accepting.title': "Joining the team…",
  'invite.accepting.body': "Setting up your membership.",
  'invite.success.title': "You’re in",
  'invite.success.body': "Opening OpenDesign so you can start collaborating.",
  'invite.success.roleReceipt': "Joined as",
  'invite.success.enter': "Enter workspace",
  'invite.open.cta': "Open OpenDesign",
  'invite.open.opening': "Opening OpenDesign…",
  'invite.open.retry': "Already installed? Try opening again",
  'invite.notInstalled.title': "Didn’t open automatically?",
  'invite.notInstalled.body': "You may not have OpenDesign installed yet. Install it, then reopen this link to finish joining.",
  'invite.notInstalled.download': "Download OpenDesign",
  'invite.error.title': "Can’t accept this invitation",
  'invite.error.invite_expired': "This invitation has expired. Ask an admin to send a new one.",
  'invite.error.invite_consumed': "This invitation has already been used.",
  'invite.error.workspace_seat_limit_reached': "The team has no seats left. Ask an admin to free up a seat or add more.",
  'invite.error.workspace_subscription_locked': "The team’s subscription is inactive, so new members can’t join right now.",
  'invite.error.workspace_not_found': "This workspace no longer exists.",
  'invite.error.workspace_forbidden': "Your account isn’t allowed to accept this invitation.",
  'invite.error.invite_unavailable': "This invitation is no longer available.",
  'invite.error.generic': "Something went wrong. Please try again.",
  'invite.error.retry': "Try again",
  "workspaceInvite.dialogAria": "Invite members",
  "workspaceInvite.title": "Invite members to your team",
  "workspaceInvite.freePlanBody": "The free plan includes 1 seat. Inviting teammates will guide you to upgrade to Teams.",
  "workspaceInvite.teamPlanBody": "Invite teammates to share projects, design systems, and plugins together.",
  "workspaceInvite.seatsExhaustedBody": "เวิร์กสเปซนี้ไม่มีที่นั่งเหลือแล้ว เพิ่มที่นั่งเพื่อเชิญเพื่อนร่วมทีม",
  "workspaceInvite.seatsExhaustedAction": "ดูที่นั่งและแพ็กเกจ",
  "workspaceInvite.emailLabel": "Invite members by email",
  "workspaceInvite.roleLabel": "Assign role",
  "workspaceInvite.defaultRoleLabel": "Default role",
  "workspaceInvite.emailPlaceholder": "Enter email address…",
  "workspaceInvite.removeRow": "Remove",
  "workspaceInvite.addMember": "Add member",
  "workspaceInvite.visibilityQuestion": "Will team members see my designs?",
  "workspaceInvite.visibilityAnswer": "Team members can see designs you share to the team space. Private designs kept in Personal projects are not visible to others.",
  "workspaceInvite.sent": "Invitation sent",
  "workspaceInvite.sending": "Inviting…",
  "workspaceInvite.confirm": "Confirm and invite",
  "workspaceInvite.submitFailed": "Failed to send invitation. Try again later.",
  "workspaceInvite.errorAlreadyMember": "อีเมลนี้เป็นสมาชิกทีมอยู่แล้ว",
  "workspaceInvite.errorPendingInvite": "อีเมลนี้มีคำเชิญที่รอดำเนินการอยู่แล้ว",
  "workspaceInvite.errorNoSession": "ลงชื่อเข้าใช้บัญชี Vela ของคุณก่อนเชิญสมาชิก",
  "workspaceInvite.errorNoWorkspace": "ยังไม่มีพื้นที่ทีมสำหรับเชิญสมาชิก",
  "workspaceInvite.errorUnreachable": "ไม่สามารถส่งคำเชิญได้ โปรดลองอีกครั้งในภายหลัง",
  'chat.amrCard.switchTitle': 'เรียกใช้โมเดลล้มเหลว — งานนี้ถูกหยุดชั่วคราว',
  'chat.amrCard.switchBody': 'สลับไปยังบริการโมเดล OpenDesign Cloud อย่างเป็นทางการของ OpenDesign Cloud — ไม่ต้องตั้งค่า API Key หลังจากเข้าสู่ระบบ ให้สิทธิ์ และเติมเงินแล้ว งานนี้จะถูกลองใหม่โดยอัตโนมัติ',
  'chat.amrCard.chipOfficial': 'โฮสติ้งอย่างเป็นทางการ',
  'chat.amrCard.chipNoKey': 'ไม่ต้องใช้ API Key',
  'chat.amrCard.chipAutoRetry': 'ลองใหม่อัตโนมัติหลังเข้าสู่ระบบ',
  'chat.amrCard.switchCta': 'สลับไปยัง OpenDesign Cloud',
  "chat.amrCard.switchedResend": "เปลี่ยนเป็น OpenDesign Cloud แล้ว โปรดส่งงานอีกครั้ง",
  'chat.amrError.authMessage': 'บัญชี OpenDesign Cloud ของคุณยังไม่ได้รับอนุญาต ให้สิทธิ์แล้วงานนี้จะถูกลองใหม่โดยอัตโนมัติ',
  'chat.amrError.balanceMessage': 'ยอดเงิน OpenDesign Cloud ของคุณหมดแล้ว เติมเงินเพื่อดำเนินงานนี้ต่อ',
  'chat.amrError.authorizeCta': 'ให้สิทธิ์และลองใหม่',
  'chat.amrError.rechargeCta': 'เติมเงิน',
  'chat.amrBalanceGate.title': 'ยอดคงเหลือที่ใช้ได้ไม่เพียงพอ',
  'chat.amrBalanceGate.message': 'ยอดคงเหลือไม่เพียงพอ โปรดเติมเงินหรืออัปเกรดแพ็กเกจแล้วลองอีกครั้ง',
  'chat.amrBalanceGate.benefitsTitle': 'สิ่งที่คุณได้รับจาก OpenDesign Cloud',
  'chat.amrBalanceGate.benefit1': 'ไม่ต้องใช้ API Key เลือกใช้ได้หลายโมเดล',
  'chat.amrBalanceGate.benefit2': 'มี Design Agent ระดับ SOTA ในตัว ไม่ต้องตั้งค่า',
  'chat.amrBalanceGate.benefit3': 'บริการทางการ มั่นใจได้',
  'chat.amrBalanceGate.benefit4': 'พัฒนาต่อเนื่อง: ดีพลอยคลิกเดียว มัลติโมดัล ทีม และอื่น ๆ',
  'chat.amrBalanceGate.laterCta': 'ไว้ทีหลัง',
  'chat.amrBalanceGate.plansCta': 'อัปเกรดแพ็กเกจ',
  'chat.amrBalanceGate.signedOutTitle': 'ยังไม่ได้ลงชื่อเข้าใช้ Open Design',
  'chat.amrBalanceGate.signedOutMessage': 'โปรดเข้าสู่ระบบ เพื่อดูโปรเจกต์และสนทนาต่อ',
  'chat.amrBalanceGate.signInCta': 'ลงชื่อเข้าใช้',
  'chat.amrBalanceGate.watchingWallet': 'เมื่อยอดเงินอัปเดตแล้วจะดำเนินการต่อโดยอัตโนมัติ',
  'chat.amrArtifactUpgrade.title': 'ปรับแต่งงานต่อด้วยโมเดลที่ทรงพลังยิ่งขึ้น',
  'chat.amrArtifactUpgrade.message': 'ปลดล็อกโมเดลขั้นสูง งานแบบขนานที่มากขึ้น และเครดิตรายเดือนที่สูงขึ้น',
  'chat.amrArtifactUpgrade.benefit1': 'เข้าถึงโมเดลขั้นสูงได้มากขึ้น เช่น Fable 5 และ GPT-5.6',
  'chat.amrArtifactUpgrade.benefit2': 'ประมวลผลงานพร้อมกันได้มากขึ้นสูงสุด 10 เท่า',
  'chat.amrArtifactUpgrade.benefit3': 'เครดิตรายเดือนมากขึ้นสูงสุด 300 เท่า',
  'chat.amrArtifactUpgrade.benefit4': 'คิวลำดับความสำคัญในช่วงพีค เพื่อสร้างผลงานได้เร็วขึ้น',
  'chat.amrArtifactUpgrade.promoBanner': 'ข้อเสนอจำกัดเวลา: ประหยัดสูงสุด 67% สำหรับแพ็กเกจสมาชิก',
  'chat.amrArtifactUpgrade.countdownLabel': 'สิ้นสุดใน',
  'chat.amrArtifactUpgrade.plansCta': 'อัปเกรดตอนนี้ ลดสูงสุด 67%',
  'chat.amrArtifactUpgrade.homePlansCta': 'ประหยัด 67%',
  'chat.amrArtifactUpgrade.laterCta': 'ใช้ Free ต่อและส่ง',
  'chat.amrArtifactUpgrade.homeTitle': 'ผลงานพร้อมแล้ว พาไอเดียถัดไปให้ไปได้ไกลกว่าเดิม',
  'chat.amrArtifactUpgrade.homeMessage': 'อัปเกรดเพื่อใช้โมเดลที่ทรงพลังขึ้น งานขนานมากขึ้น และเครดิตรายเดือนมากขึ้น',
  'chat.amrArtifactUpgrade.homeArtifactCta': 'ดูผลงาน',
  'chat.antigravityError.launchTerminalCta': 'ลงชื่อเข้าใช้ผ่านเทอร์มินัล',
  'chat.antigravityError.launchSwitchModelCta': 'สลับโมเดลในเทอร์มินัล',
  'chat.connectionDropped': 'โปรดตรวจสอบว่าการเชื่อมต่อเครือข่ายเป็นปกติ แล้วลองอีกครั้ง',
  'chat.runError.title.authRequired': 'ต้องมีการอนุญาต',
  'chat.runError.title.balance': 'ยอดคงเหลือไม่เพียงพอ',
  'chat.runError.title.connectionDropped': 'การเชื่อมต่อเครือข่ายขาดหาย',
  'chat.runError.title.signInRequired.other': 'ยังไม่ได้ลงชื่อเข้าใช้ {agent}',
  'chat.runError.title.signInRequired.amr': 'ยังไม่ได้ลงชื่อเข้าใช้ Open Design',
  'chat.runError.title.rateLimited': 'บริการโมเดลมีคำขอจำนวนมาก',
  'chat.runError.title.modelWindowLimit': 'มีผู้ใช้งานจำนวนมาก',
  'chat.runError.title.membershipConcurrencyLimit': 'ถึงขีดจำกัดงานพร้อมกันแล้ว',
  'chat.runError.title.strategyTaskHalted': "งานถูกหยุดโดยด่านตรวจคุณภาพ",
  "chat.runError.title.agentReplyIncomplete": "ไม่สามารถทำงานให้เสร็จได้",
  'chat.runError.title.noDeliverable': "รอบนี้ยังไม่มีไฟล์ออกมา",
  'chat.runError.title.clarificationRepeated': "เอเจนต์ถามคำถามอีกครั้ง",
  "chat.runError.title.regionNotSupported": "ขณะนี้บริการนี้ยังไม่รองรับในภูมิภาคของคุณ",
  'chat.runError.title.clientEnvironment': 'ปัญหาสภาพแวดล้อมเครือข่าย',
  "chat.runError.title.certificateFailure": "ไม่สามารถเชื่อมต่อบริการได้อย่างปลอดภัย",
  "chat.runError.certificateFailureMessage": "การเชื่อมต่อบริการไม่ผ่านการตรวจสอบความปลอดภัย โปรดลองเปลี่ยนเครือข่าย",
  "chat.runError.title.proxyConfiguration": "ไม่สามารถเชื่อมต่อพร็อกซีได้",
  "chat.runError.proxyConfigurationMessage": "ไม่สามารถเชื่อมต่อพร็อกซีที่ตั้งค่าไว้ได้ โปรดตรวจสอบว่าพร็อกซีเปิดใช้งานและตั้งค่าถูกต้องแล้วลองอีกครั้ง",
  "chat.runError.title.networkConfiguration": "ไม่สามารถเชื่อมต่อบริการได้",
  "chat.runError.networkConfigurationMessage": "ไม่สามารถเข้าถึงบริการได้ชั่วคราว โปรดตรวจสอบการเชื่อมต่อเครือข่ายแล้วลองอีกครั้ง",
  "chat.runError.title.hostPolicyBlock": "การเริ่มโปรแกรมถูกจำกัด",
  "chat.runError.hostPolicyBlockMessage": "Windows บล็อกการเริ่มโปรแกรม โปรดตรวจสอบการตั้งค่าความปลอดภัยของระบบ",
  "chat.runError.title.localStorageFailure": "ไม่สามารถบันทึกไฟล์ได้",
  "chat.runError.localStorageFailureMessage": "ไม่สามารถเขียนไฟล์ลงดิสก์ได้ โปรดตรวจสอบว่ามีพื้นที่ว่างเพียงพอ แล้วลองใหม่อีกครั้ง",
  "chat.runError.title.tierUpgradeRequired": "แพ็กเกจปัจจุบันไม่รองรับงานนี้",
  "chat.runError.tierUpgradeRequiredMessage": "แพ็กเกจปัจจุบันไม่สามารถดำเนินงานนี้ต่อได้ โปรดอัปเกรดแพ็กเกจแล้วลองอีกครั้ง",
  "chat.runError.title.generic": "ไม่สามารถทำงานให้เสร็จได้",
  'chat.runError.title.artifactMissing': "ไม่มีไฟล์ให้ดูตัวอย่าง",
  'chat.runError.artifactMissingMessage': "งานนี้ไม่ได้สร้างไฟล์ให้ดูตัวอย่าง โปรดระบุเนื้อหาที่ต้องการให้สร้างเพิ่มแล้วลองอีกครั้ง",
  'chat.runError.signInMessage.amr': 'โปรดเข้าสู่ระบบ เพื่อดูโปรเจกต์และสนทนาต่อ',
  'chat.runError.signInMessage.other': 'โปรดเข้าสู่ระบบ {agent} ก่อน แล้วลองอีกครั้ง',
  'chat.runError.agentFallback': 'เอเจนต์',
  'chat.runError.sourceLabel': 'รายละเอียดข้อผิดพลาด',
  'chat.runError.sourceExpandAria': 'ขยายแหล่งที่มาของข้อผิดพลาด',
  'chat.runError.sourceCollapseAria': 'ยุบแหล่งที่มาของข้อผิดพลาด',
  'chat.runError.title.cliMissing': 'ไม่พบ {agent}',
  'chat.runError.title.promptTooLarge': 'บทสนทนายาวเกินไป',
  'chat.runError.title.modelUnavailable': "โมเดลปัจจุบันไม่พร้อมใช้งาน",
  'chat.runError.title.modelCapabilityUnsupported': "โมเดลปัจจุบันไม่รองรับงานนี้",
  'chat.runError.title.upstreamUnavailable': 'บริการโมเดลไม่พร้อมใช้งานชั่วคราว',
  "chat.runError.title.toolLoop": "ไม่สามารถดำเนินงานต่อได้",
  'chat.runError.title.outputInvalid': 'ไม่สามารถสร้างคำตอบที่ใช้ได้',
  'chat.runError.title.runtimeConfig': "Open Design ทำงานผิดพลาด",
  'chat.runError.title.apiKeyInvalid': 'การตั้งค่าโมเดลยังไม่ครบ',
  'chat.runError.cliMissingMessage': 'โปรดตรวจสอบว่าติดตั้ง {agent} บนคอมพิวเตอร์เครื่องนี้แล้ว จากนั้นลองอีกครั้ง',
  "chat.runError.promptTooLargeMessage": "บริบทปัจจุบันยาวเกินกว่าที่โมเดลจะประมวลผลได้ โปรดสร้างการสนทนาใหม่แล้วลองอีกครั้ง",
  'chat.runError.modelUnavailableMessage': "โปรดเลือกโมเดลอื่นที่พร้อมใช้งานแล้วลองอีกครั้ง",
  'chat.runError.modelCapabilityUnsupportedMessage': "โมเดลนี้ไม่รองรับความสามารถที่งานนี้ต้องใช้ โปรดเปลี่ยนโมเดลแล้วลองอีกครั้ง",
  'chat.runError.rateLimitedMessage': 'ขณะนี้มีคำขอไปยังบริการโมเดลนี้จำนวนมาก และถึงขีดจำกัดความถี่คำขอของผู้ให้บริการแล้ว โปรดลองใหม่ในภายหลัง หรือลองสลับไปใช้โมเดลอื่น',
  'chat.runError.modelWindowLimitMessage': 'ขณะนี้มีผู้ใช้งานจำนวนมาก โปรดลองอีกครั้งหลัง {retryAt} คำขอนี้ไม่มีการเรียกเก็บเงิน',
  'chat.runError.modelWindowLimitMessageNoTime': 'ขณะนี้มีผู้ใช้งานจำนวนมาก โปรดลองอีกครั้งในภายหลัง คำขอนี้ไม่มีการเรียกเก็บเงิน',
  'chat.runError.membershipConcurrencyLimitMessage': 'สมาชิกของคุณใช้งานถึงขีดจำกัดงานพร้อมกันแล้ว โปรดรอจนถึง {retryAt} แล้วลองใหม่ หรือเปลี่ยนเอเจนต์ การลองซ้ำทันทีจะไม่ช่วย',
  'chat.runError.membershipConcurrencyLimitMessageNoTime': 'สมาชิกของคุณใช้งานถึงขีดจำกัดงานพร้อมกันแล้ว โปรดรอให้งานอื่นเสร็จแล้วลองใหม่ หรือเปลี่ยนเอเจนต์',
  'chat.runError.upstreamUnavailableMessage': 'โมเดลปัจจุบันไม่พร้อมใช้งานชั่วคราว โปรดลองใหม่ในภายหลัง หรือเปลี่ยนโมเดล',
  "chat.runError.toolLoopMessage": "AI ติดอยู่ที่ขั้นตอนเดิมและไม่สามารถดำเนินการต่อได้แม้ลองหลายครั้งแล้ว โปรดลองอีกครั้ง หรือเปลี่ยนโมเดลแล้วลองใหม่",
  'chat.runError.outputInvalidMessage': 'โปรดลองสร้างใหม่ หรือเปลี่ยนโมเดลแล้วลองอีกครั้ง หากยังเกิดปัญหาต่อเนื่อง โปรดติดต่อฝ่ายสนับสนุน',
  'chat.runError.runtimeConfigMessage': 'โปรดลองสร้างใหม่ หรือเปลี่ยนโมเดลแล้วลองอีกครั้ง หากยังเกิดปัญหาต่อเนื่อง โปรดติดต่อฝ่ายสนับสนุน',
  'chat.runError.apiKeyInvalidMessage': 'คีย์ API ตั้งค่าไม่ถูกต้อง โปรดกรอกใหม่ แล้วลองอีกครั้ง',
  'chat.runError.title.quotaExhausted': "ใช้โควตาหมดแล้ว",
  'chat.runError.title.timedOut': "หมดเวลารอการตอบกลับ",
  "chat.runError.title.emptyOutput": "ไม่สามารถสร้างเนื้อหาได้",
  "chat.runError.title.sessionExpired": "ไม่สามารถดำเนินงานก่อนหน้าต่อได้",
  'chat.runError.title.gitBashMissing': "ไม่มี Git Bash",
  "chat.runError.title.cpuUnsupported": "อุปกรณ์นี้ไม่สามารถเรียกใช้โปรแกรมได้",
  "chat.runError.title.osUnsupported": "Windows เวอร์ชันเก่าเกินไป",
  'chat.runError.title.cliSessionRefused': "เวอร์ชันเอเจนต์ไม่รองรับ",
  'chat.runError.quotaExhaustedMessage': "โควตาหรือวงเงินเรียกเก็บของบริการโมเดลที่คุณใช้หมดแล้ว การลองใหม่จึงไม่ช่วย โปรดเติมเงินกับผู้ให้บริการ หรือสลับไปใช้โมเดลหรือบริการอื่น",
  'chat.runError.workspaceCreditsMessage': "เครดิตของพื้นที่ทำงานของคุณหมดแล้ว โปรดเพิ่มเครดิต (หรือขอให้เจ้าของพื้นที่ทำงานเติม) หรือสลับไปใช้โมเดลหรือบริการอื่น",
  'chat.runError.timedOutMessage': "ไม่ได้รับการตอบกลับใหม่จาก AI เป็นเวลานาน การรันนี้จึงหยุดลง โปรดลองใหม่ในภายหลัง",
  'chat.runError.inactivityTimeoutMessage': "ไม่ได้รับการตอบกลับใหม่จาก AI เป็นเวลานาน การรันนี้จึงหยุดลง โปรดลองใหม่ในภายหลัง",
  "chat.runError.emptyOutputMessage": "AI ไม่สามารถสร้างเนื้อหาได้ โปรดเริ่มงานใหม่ หรือเปลี่ยนโมเดลแล้วลองอีกครั้ง",
  "chat.runError.sessionExpiredMessage": "งานก่อนหน้าไม่สามารถดำเนินการต่อได้แล้ว โปรดเริ่มงานใหม่",
  'chat.runError.gitBashMissingMessage': "ต้องใช้ Git Bash เพื่อรันเอเจนต์นี้บน Windows แต่ไม่พบ โปรดติดตั้ง Git for Windows แล้วลองใหม่",
  "chat.runError.cpuUnsupportedMessage": "หน่วยประมวลผลของคอมพิวเตอร์นี้ไม่รองรับฟังก์ชันที่โปรแกรมต้องการ โปรดใช้อุปกรณ์ที่ตรงตามข้อกำหนดของระบบ",
  "chat.runError.osUnsupportedMessage": "Windows เวอร์ชันนี้เก่าเกินกว่าจะเรียกใช้รันไทม์ AMR ได้ โปรดอัปเดตเป็น Windows 10 เวอร์ชัน 1809 (บิลด์ 17763) ขึ้นไป แล้วลองอีกครั้ง",
  'chat.runError.title.agentCrashed': 'งานถูกขัดจังหวะโดยไม่คาดคิด',
  'chat.runError.agentCrashedMessage': 'โปรดลองสร้างใหม่ หรือเปลี่ยนโมเดลแล้วลองอีกครั้ง หากยังเกิดปัญหาต่อเนื่อง โปรดติดต่อฝ่ายสนับสนุน',
  'chat.runError.title.accountSuspended': 'บัญชีถูกระงับ',
  'chat.runError.accountSuspendedMessage': 'หากต้องการทราบสาเหตุหรือขอเปิดใช้งานอีกครั้ง โปรดติดต่อฝ่ายสนับสนุน',
  "chat.runError.fallbackMessage": "การเรียกใช้งานครั้งนี้ล้มเหลว โปรดลองอีกครั้ง หากล้มเหลวอีก โปรดติดต่อฝ่ายสนับสนุน",
  "chat.runError.cliSessionRefusedMessage": "Open Design ยังไม่รองรับเอเจนต์เวอร์ชันนี้ โปรดเปลี่ยนเป็นเวอร์ชันที่รองรับแล้วลองอีกครั้ง",
  'chat.runError.strategyTaskStateMismatchMessage': "งานนี้ถูกหยุดโดยด่านตรวจคุณภาพของกลยุทธ์แล้ว จึงไม่สามารถดำเนินการฟอร์มรอบนี้ต่อได้ โปรดลองส่งคำขออีกครั้งหรือเริ่มคำขอใหม่",
  "chat.runError.agentReplyIncompleteMessage": "การเรียกใช้งานครั้งนี้ล้มเหลว โปรดลองอีกครั้ง หากล้มเหลวอีก โปรดติดต่อฝ่ายสนับสนุน",
  'chat.runError.noDeliverableMessage': "เอเจนต์ทำงานจบแล้ว แต่ยังไม่มีไฟล์ที่เปิดได้ในโปรเจกต์ งานจึงยังบันทึกว่าส่งมอบแล้วไม่ได้ สิ่งที่คุณส่งไปไม่ได้หายไป — ลองใหม่อีกครั้ง หรือเพิ่มอีกสักบรรทัดว่าคุณต้องการอะไร",
  'chat.runError.clarificationRepeatedMessage': "เอเจนต์ขอรายละเอียดเพิ่มเป็นครั้งที่สอง แต่หนึ่งงานเปิดให้ถามได้เพียงรอบเดียว จึงหยุดอยู่ตรงนี้ คำตอบของคุณยังอยู่ในบทสนทนา การลองอีกครั้งจะเริ่มคำขอใหม่ตั้งแต่ต้น และถ้าใส่รายละเอียดที่ต้องการเพิ่มลงไปพร้อมกัน ก็มักจบได้ในรอบเดียว",
  "chat.runError.regionNotSupportedMessage": "ขณะนี้ผู้ให้บริการยังไม่ให้บริการในภูมิภาคของคุณ จึงไม่สามารถดำเนินงานปัจจุบันต่อได้",
  'chat.runError.clientEnvironmentMessage': 'ดูเหมือนคำขอผ่านพร็อกซีหรือเครือข่ายองค์กร และ {agent} ปฏิเสธคำขอ ({cause}) ลองเปลี่ยนเส้นทางเครือข่าย หรือปรับพร็อกซีในการตั้งค่า',
  'chat.runError.clientEnvironmentCause.certificate': 'ตรวจสอบใบรับรองไม่ผ่าน',
  'chat.runError.clientEnvironmentCause.proxy': 'การตั้งค่าพร็อกซีมีปัญหา',
  'chat.runError.clientEnvironmentCause.network': 'เข้าถึงเครือข่ายไม่ได้',
  'chat.runError.clientEnvironmentCause.hostPolicy': 'ถูกบล็อกโดยนโยบายของระบบ',
  'chat.runError.clientEnvironmentCause.localStorage': 'อ่านหรือเขียนที่จัดเก็บในเครื่องไม่สำเร็จ',
  'common.cancel': 'ยกเลิก',
  'chat.selectFromLibrary': 'นำเข้าจากไลบรารี',
  'chat.importFigma': 'นำเข้าจาก Figma',
  'chat.plus.group.files': 'Files',
  'chat.plus.group.code': 'Code',
  'chat.plus.group.designs': 'Designs',
  'chat.plus.group.other': 'Other',
  'chat.plus.attachFiles': 'Attach files',
  'chat.plus.referenceProject': 'Reference another project',
  'chat.plus.linkLocalCode': 'Link local code',
  'chat.plus.uploadFig': 'Upload .fig file',
  'chat.plus.learnHow': 'Learn how',
  'chat.plus.designSystem': 'Design system',
  'chat.plus.skills': 'Skills',
  'chat.plus.noSkills': 'No skills available',
  'chat.plus.connectors': 'Connectors',
  'chat.plus.plugins': 'Plugins',
  'chat.plus.mcp': 'MCP',
  'chat.referenceProject.title': 'Reference another project',
  'chat.referenceProject.search': 'Search projects…',
  'chat.referenceProject.empty': 'No projects match “{query}”',
  'chat.referenceProject.emptyAll': 'No other projects yet',
  'chat.referenceProject.loadFailed': 'Could not load projects. Check that the daemon is running and try again.',
  'chat.referenceProject.confirm': 'Reference project',
  'chat.contextPrompt.referenceProject': 'Use the OpenDesign project “{name}” as reference context. Its local path is: {path}. Before designing or modifying anything, search and read this directory when useful.',
  'chat.contextPrompt.localCode': 'Use the local code folder “{name}” as code reference. Its absolute path is: {path}. Read relevant files when useful and stay consistent with the existing implementation.',
  'chat.figmaHelp.title': 'How to download a .fig file',
  'chat.figmaHelp.intro': 'From the Figma web or desktop app:',
  'chat.figmaHelp.step1': 'Open the file in Figma.',
  'chat.figmaHelp.step2': 'Go to File → Save local copy... (web: main menu → File).',
  'chat.figmaHelp.step3': 'Figma downloads a .fig file. Drop it onto the composer or upload it.',
  'chat.figmaHelp.note': 'The .fig file is parsed locally and is not uploaded to Figma.',
  'designFiles.library.label': 'นำเข้าจากไลบรารี',
  'designFiles.library.title': 'นำเข้าจากไลบรารี',
  'libraryPicker.title': 'นำเข้าจากไลบรารี',
  'libraryPicker.searchPlaceholder': 'ค้นหาในไลบรารี…',
  'libraryPicker.empty': 'ยังไม่มีสินทรัพย์ในไลบรารีของคุณ',
  'libraryPicker.allKinds': 'ทั้งหมด',
  'libraryPicker.add': 'นำเข้า',
  'libraryPicker.loading': 'กำลังโหลด…',
  'common.save': 'บันทึก',
  'fileViewer.commentSync.payloadTooLarge': "ความคิดเห็นบางรายการมีขนาดเกินขีดจำกัดการซิงค์ จึงหยุดลองใหม่อัตโนมัติชั่วคราว โปรดย่อหรือลบความคิดเห็นเหล่านี้เพื่อซิงค์ต่อ",
  'fileViewer.commentSync.sessionMissing': "ยังไม่ได้เข้าสู่ระบบ การซิงค์ความคิดเห็นหยุดชั่วคราว จึงยังไม่เห็นความคิดเห็นใหม่ของผู้เข้าชม",
  'fileViewer.commentSync.shareStoppedPersonal': "ลิงก์ถูกปิดใช้งาน การซิงค์ความคิดเห็นไปยังหน้าที่แชร์หยุดชั่วคราว",
  'fileViewer.commentSync.shareStoppedTeam': "ลิงก์ถูกปิดใช้งาน",
  'fileViewer.commentSync.backfillFailedBody': "ความคิดเห็นที่มีอยู่ยังไม่ได้ซิงค์ ผู้เยี่ยมชมจะยังมองไม่เห็นชั่วคราว",
  'fileViewer.commentSync.backfillTerminalBody': "ไม่สามารถซิงค์ความคิดเห็นที่มีอยู่บางส่วนไปยังหน้าที่แชร์ และจะไม่มีการลองซ้ำโดยอัตโนมัติ ลิงก์แชร์ยังใช้งานได้",
  'fileViewer.commentSync.backfillRetryingBody': "ความคิดเห็นที่มีอยู่ยังไม่ได้ซิงค์ ผู้เข้าชมจึงยังมองไม่เห็นในตอนนี้ กำลังลองใหม่โดยอัตโนมัติ",
  'fileViewer.commentSync.backfillReopenedPendingBody': "กำลังซิงค์ความคิดเห็นของลิงก์แชร์ที่เปิดใช้อีกครั้ง ความคิดเห็นที่ลบหรือแก้ไขแล้วอาจยังปรากฏบนหน้าที่แชร์",
  'fileViewer.commentSync.backfillReopenedRetryingBody': "การซิงค์ความคิดเห็นยังไม่เสร็จ หน้าแชร์อาจยังแสดงความคิดเห็นที่จัดการแล้ว",
  'fileViewer.commentSync.backfillReopenedTerminalBody': "การซิงค์ความคิดเห็นยังไม่เสร็จสิ้น ความคิดเห็นที่ลบหรือแก้ไขแล้วอาจยังปรากฏบนหน้าที่แชร์ การลองใหม่อัตโนมัติหยุดแล้ว แต่ลิงก์แชร์ยังใช้งานได้",
  'fileViewer.commentSync.backfillPendingBody': "กำลังซิงค์ความคิดเห็นที่มีอยู่ ผู้เยี่ยมชมอาจยังมองไม่เห็น",
  'fileViewer.commentSync.backfillPendingCountBody': "กำลังซิงค์ความคิดเห็นที่มีอยู่ · {count}",
  "fileViewer.commentSync.reopenSyncBusy": "กำลังซิงค์ความคิดเห็น…",
  'fileViewer.commentSync.alignFailedBody': "การจัดเรียงความคิดเห็นยังไม่เสร็จสมบูรณ์ อาจมีความคิดเห็นบางส่วนไม่แสดง",
  'fileViewer.shareGuide.title': "แชร์ลิงก์เพื่อรับฟีดแบ็ก",
  'fileViewer.shareGuide.description': "แชร์ลิงก์เพื่อรวบรวมความคิดเห็นได้ทันที เลือกฟีดแบ็กหลายรายการแล้วส่งให้ Agent จัดการทีละรายการ",
  'fileViewer.shareGuide.tryShare': "ลองแชร์ดู",
  'fileViewer.shareGuide.neverShowAgain': "ไม่ต้องแสดงอีก",
  'fileViewer.shareGuide.close': "ปิดคำแนะนำฟีเจอร์ใหม่",
  'fileViewer.shareGuide.preferenceSaveFailed': "บันทึกการตั้งค่าไม่ได้ โปรดลองอีกครั้ง",
  'common.close': 'ปิด',
  'common.clear': 'ล้าง',
  'common.delete': 'ลบ',
  'common.rename': 'เปลี่ยนชื่อ',
  'common.edit': 'แก้ไข',
  'common.preview': 'ดูตัวอย่าง',
  'common.share': 'แชร์',
  'common.search': 'ค้นหา',
  'common.searchEllipsis': 'ค้นหา…',
  'common.loading': 'กำลังโหลด…',
  'common.all': 'ทั้งหมด',
  'common.none': 'ไม่มี',
  'common.default': 'ค่าเริ่มต้น',
  'common.installed': 'ติดตั้งแล้ว',
  'common.notInstalled': 'ยังไม่ได้ติดตั้ง',
  'common.active': 'เปิดใช้งาน',
  'common.inactive': 'ปิดใช้งาน',
  'common.offline': 'ออฟไลน์',
  'common.selected': 'เลือกแล้ว',
  'common.create': 'สร้าง',
  'common.openPreview': 'เปิดหน้าตัวอย่าง',
  'common.exitFullscreen': 'ออกจากเต็มหน้าจอ',
  'common.fullscreen': 'เต็มหน้าจอ',
  'common.openInNewTab': 'เปิดในแท็บใหม่',
  'common.exportPdf': 'ส่งออกเป็น PDF',
  'common.exportZip': 'ดาวน์โหลดเป็น .zip',
  'common.exportHtml': 'ส่งออกเป็น HTML',
  'common.exportImage': 'ส่งออกเป็นรูปภาพ',
  'common.exportImageFailed': 'การจับภาพล้มเหลว โปรดลองอีกครั้งหรือใช้เครื่องมือจับภาพหน้าจอของเบราว์เซอร์',
  'common.justNow': 'เมื่อครู่นี้',
  'common.minutesAgo': '{n} นาทีที่แล้ว',
  'common.hoursAgo': '{n} ชั่วโมงที่แล้ว',
  'common.yesterday': 'เมื่อวาน',
  'common.daysAgo': '{n} วันที่แล้ว',
  'common.weeksAgo': '{n} สัปดาห์ที่แล้ว',
  'common.now': 'ตอนนี้',
  'common.minutesShort': '{n} นาที',
  'common.hoursShort': '{n} ชม.',
  'common.daysShort': '{n} วัน',
  'common.untitled': 'ไม่มีชื่อ',
  'designBrowser.savePageBrief': 'Save page brief',
  'designBrowser.viewport.desktop': 'เดสก์ท็อป',
  'designBrowser.viewport.desktopTitle': 'ใช้ขนาดเต็มของแท็บเบราว์เซอร์',
  'designBrowser.viewport.tablet': 'แท็บเล็ต',
  'designBrowser.viewport.tabletTitle': 'แสดงตัวอย่างที่ความกว้าง 820px',
  'designBrowser.viewport.mobile': 'มือถือ',
  'designBrowser.viewport.mobileTitle': 'แสดงตัวอย่างที่ความกว้าง 390px',
  'designBrowser.menu': 'Browser menu',
  'designBrowser.copyScreenshot': 'Copy screenshot',
  'designBrowser.hardReload': 'Hard reload',
  'designBrowser.copyUrl': 'Copy URL',
  'designBrowser.openExternal': 'Open externally',
  'designBrowser.downloadPage': 'Download page',
  'designBrowser.downloadPageBusy': 'Downloading page...',
  'designBrowser.clearHistory': 'Clear history',
  'designBrowser.clearCookies': 'Clear cookies',
  'designBrowser.clearAllData': 'Clear all browser data',
  'designBrowser.status.noUrlToCopy': 'No URL to copy.',
  'designBrowser.status.urlCopied': 'URL copied.',
  'designBrowser.status.openHttpFirst': 'Open an http or https page first.',
  'designBrowser.status.openBeforeScreenshot': 'Open a page before taking a screenshot.',
  'designBrowser.status.screenshotSaved': 'Screenshot saved.',
  'designBrowser.addImageToChatButton': 'เพิ่มลงในแชท',
  'designBrowser.status.imageAddedToChat': 'เพิ่มรูปภาพลงในแชทแล้ว',
  'designBrowser.status.screenshotFailed': 'Screenshot failed.',
  'designBrowser.status.openBeforeBrief': 'Open a page before saving a brief.',
  'designBrowser.status.briefSaveFailed': 'Page brief save failed.',
  'designBrowser.status.openBeforeDownload': 'Open a page before saving a snapshot.',
  'designBrowser.status.pageSnapshotStarted': 'Saving page snapshot...',
  'designBrowser.status.pageSnapshotUnsupported': 'This page cannot be archived.',
  'designBrowser.status.pageSnapshotFailed': 'Page snapshot save failed.',
  'designBrowser.status.pageSnapshotSaved': 'Saved page snapshot (HTML + CSS).',
  'designBrowser.status.viewDesignFiles': 'View Design Files',
  'designBrowser.status.downloadAssistHint': 'When the page is ready, click Download Page. Return to chat after it is saved.',
  'designBrowser.status.desktopDataUnavailable': 'Desktop browser data is unavailable here.',
  'designBrowser.status.browserDataCleared': 'Browser data cleared.',
  'designBrowser.status.browserDataClearFailed': 'Browser data clear failed.',
  'designBrowser.status.historyCleared': 'History cleared.',
  'plugins.availableDetails.provenance': 'ที่มา',
  'plugins.availableDetails.provenanceLine': 'จาก {source} · {trust} · {resolved}',
  'plugins.availableDetails.provenanceLineWithIntegrity': 'จาก {source} · {trust} · {resolved} · {integrity}',
  'plugins.availableDetails.install': 'ติดตั้ง',
  'plugins.availableDetails.version': 'เวอร์ชัน',
  'plugins.availableDetails.pluginVersion': 'เวอร์ชันปลั๊กอิน',
  'plugins.availableDetails.copyInstallCommand': 'คัดลอกคำสั่งติดตั้ง',
  'plugins.availableDetails.copied': 'คัดลอกแล้ว',
  'plugins.availableDetails.deprecatedPrefix': 'เลิกใช้งานแล้ว: {message}',
  'plugins.availableDetails.deprecatedFallback': 'เวอร์ชันนี้ถูกทำเครื่องหมายว่าเลิกใช้งานแล้ว',
  'plugins.availableDetails.yanked': 'ถูกถอนแล้ว',
  'plugins.availableDetails.yankedWithReason': 'ถูกถอนแล้ว: {reason}',
  'plugins.availableDetails.versionDeprecatedSuffix': ' (เลิกใช้งานแล้ว)',
  'plugins.availableDetails.versionYankedSuffix': ' (ถูกถอนแล้ว)',
  'plugins.availableDetails.ref': 'Ref',
  'plugins.availableDetails.integrity': 'Integrity',
  'plugins.availableDetails.permissions': 'สิทธิ์การเข้าถึง',
  'plugins.availableDetails.capabilitySummary': 'สรุปความสามารถ',
  'plugins.actions.copyInstallCommand': 'คัดลอกคำสั่งติดตั้ง',
  'plugins.actions.copyPluginId': 'คัดลอก ID ปลั๊กอิน',
  'plugins.actions.copyReadmeBadge': 'คัดลอกแบดจ์ README',
  'plugins.actions.openSourceGithub': 'เปิดซอร์สบน GitHub',
  'plugins.actions.openSource': 'เปิดซอร์ส',
  'plugins.actions.openHomepage': 'เปิดหน้าโฮมเพจ',
  'plugins.actions.openMarketplace': 'เปิดใน marketplace',
  'app.brand': 'OpenDesign',
  'app.brandPill': 'ตัวอย่างเพื่อการวิจัย',
  'app.brandSubtitle': 'โดย Nexu Labs',
  'app.welcomeLoading': 'กำลังโหลดพื้นที่ทำงาน…',
  'settings.welcomeKicker': '',
  'settings.welcomeTitle': 'ยินดีต้อนรับสู่ OpenDesign',
  'settings.welcomeSubtitle': '',
  'settings.onboardingCreateTitle': 'เริ่มจากบรีฟ',
  'settings.onboardingCreateBody': 'อธิบายเว็บไซต์ แอป สไลด์ รูปภาพ หรือวิดีโอที่คุณต้องการ OpenDesign จะสร้างโปรเจกต์ให้และเก็บงานไว้ให้แก้ไขได้ตลอด',
  'settings.onboardingMemoryTitle': 'บันทึกบริบทการทำงาน',
  'settings.onboardingMemoryBody': 'เพิ่มค่ากำหนด ข้อเท็จจริงของโปรเจกต์ และกฎที่ใช้ซ้ำ เพื่อให้แชตในอนาคตเข้าใจบริบทที่ถูกต้อง',
  'settings.onboardingMemoryCalloutTitle': 'บันทึกไว้ในหน่วยความจำของคุณแล้ว',
  'settings.onboardingMemoryCalloutBody': 'คำตอบเหล่านี้เป็นพื้นฐานของโปรไฟล์หน่วยความจำของคุณ OpenDesign จะนำกลับมาใช้ในทุกงาน และเรียนรู้ต่อเนื่องขณะที่คุณทำงาน',
  'settings.onboardingMemoryBenefitIntent': 'เข้าใจสิ่งที่คุณต้องการจากคำขอสั้น ๆ',
  'settings.onboardingMemoryBenefitFewerQuestions': 'ข้ามคำถามตั้งค่าที่ถามซ้ำ',
  'settings.onboardingMemoryBenefitPersonalized': 'ปรับผลลัพธ์ให้เข้ากับบทบาท ผู้ชม และรสนิยมของคุณ',
  'settings.onboardingSystemsTitle': 'นำดีไซน์ซิสเต็มของคุณมาใช้',
  'settings.onboardingSystemsBody': 'เลือกหรือสร้างระบบแบรนด์ เพื่อให้งานที่สร้างขึ้นใช้สี ตัวอักษร และภาษาของผลิตภัณฑ์ตามจริง',
  'settings.onboardingExecutionTitle': 'เลือกแหล่งที่มาของโมเดล',
  'settings.onboardingExecutionBody': 'ใช้ OpenDesign Hosted เชื่อมต่อเอเจนต์ในเครื่อง หรือใช้คีย์โมเดลของคุณเอง',
  'settings.onboardingAmrCloudBenefitOfficial': 'แนะนำอย่างเป็นทางการ',
  'settings.onboardingAmrCloudBenefitReady': 'ไม่ต้องดีพลอย',
  'settings.onboardingAmrCloudBenefitModels': 'ใช้ Claude, GPT, Fable 5 และ 5.6 sol พร้อมส่วนลดระยะเวลาจำกัดและการทำงานพร้อมกันสูง',
  'settings.onboardingAmrCloudBenefitPricing': 'SOTA Harness',
  'settings.onboardingAmrCloudUpcomingLabel': 'เร็ว ๆ นี้',
  'settings.onboardingAmrCloudUpcomingImageVideo': 'รูปภาพ/วิดีโอ',
  'settings.onboardingAmrCloudUpcomingSkills': 'Skills จำนวนมาก',
  'settings.onboardingAmrCloudUpcomingRouting': 'การกำหนดเส้นทางอัจฉริยะ',
  'settings.onboardingAmrModelSourceLabel': 'OpenDesign Hosted',
  'settings.onboardingAmrCloudAuthorizeAction': 'อนุญาต OpenDesign Cloud',
  'settings.onboardingAmrCloudAuthorizedAction': 'อนุญาตแล้ว',
  'settings.onboardingStepConnect': 'Connect',
  'settings.onboardingStepDesignSystem': 'สร้างดีไซน์ซิสเต็ม',
  'settings.onboardingStepProfile': 'About you',
  'settings.onboardingStepNewsletter': 'Stay updated',
  'settings.onboardingNewsletterTitle': 'Stay in the loop',
  'settings.onboardingNewsletterBody': 'Get product updates, new templates, design-system drops, and ambassador work in your inbox. Optional — you can skip this.',
  'settings.onboardingConnectTitle': 'Choose a runtime',
  'settings.onboardingConnectBody': '',
  'settings.onboardingCloudTitle': 'ยินดีต้อนรับสู่ OpenDesign',
  'settings.onboardingCloudBody': 'เปลี่ยนไอเดียของคุณให้เป็นดีไซน์',
  'settings.onboardingCloudSignIn': 'เข้าสู่ระบบ / สมัครสมาชิก',
  'settings.onboardingFreeCredits': 'เครดิตฟรี',
  'settings.onboardingFreeCreditsHint': 'ผู้ใช้ใหม่จะได้รับเครดิตฟรีเริ่มต้นเพื่อลองใช้ DeepSeek V4.1 Flash',
  'settings.onboardingOwnAi': 'หรือใช้ AI ของคุณเอง',
  'settings.onboardingLocalAi': 'AI ในเครื่อง',
  'settings.onboardingApiKey': 'คีย์ API',
  'settings.onboardingCloudContinue': 'ดำเนินการต่อ (เข้าสู่ระบบแล้ว)',
  'settings.onboardingCloudAlternative': 'ใช้ CLI ในเครื่องหรือคีย์ API ของคุณเอง',
  'settings.onboardingCloudRights': 'สงวนลิขสิทธิ์ทั้งหมด',
  'settings.onboardingCloudOr': 'หรือ',
  'settings.onboardingGateTooltipNoRuntime': 'ขั้นตอนต่อไปทำงานด้วย AI — เลือกวิธีรันเพื่อดำเนินการต่อ',
  'settings.onboardingGateTooltipAmr': 'ขั้นตอนต่อไปทำงานด้วย AI — ลงชื่อเข้าใช้ OpenDesign Cloud เพื่อดำเนินการต่อ',
  'settings.onboardingGateTooltipLocal': 'ขั้นตอนต่อไปทำงานด้วย AI — เลือก CLI ในเครื่องที่พร้อมใช้งานเพื่อดำเนินการต่อ',
  'settings.onboardingGateTooltipByok': 'ขั้นตอนต่อไปทำงานด้วย AI — เพิ่มและทดสอบคีย์โมเดลของคุณเพื่อดำเนินการต่อ',
  'settings.onboardingRecommended': 'แนะนำ',
  'settings.onboardingAmrCloudOfficialBadge': 'อย่างเป็นทางการ',
  'settings.onboardingLocalTitle': 'เอเจนต์ในเครื่อง',
  'settings.onboardingLocalBody': 'ใช้ Claude Code, Codex, Cursor, OpenCode, Kimi, Qwen, Hermes, Kiro และอื่น ๆ',
  'settings.onboardingLocalAction': 'Open CLI settings',
  'settings.onboardingCliScanHint': 'This usually takes 5-10 seconds.',
  'settings.onboardingByokTitle': 'ใช้คีย์ของคุณเอง',
  'settings.onboardingByokBody': 'เชื่อมต่อผู้ให้บริการโมเดลที่คุณต้องการอย่างปลอดภัยด้วยคีย์ API ของคุณเอง',
  'settings.onboardingByokAction': 'Open BYOK settings',
  'settings.onboardingDesignTitle': 'Design system',
  'settings.onboardingDesignBody': 'Generate once, reuse everywhere.',
  'settings.onboardingDesignIntroGenerateTitle': 'Generate from existing work',
  'settings.onboardingDesignIntroGenerateBody': 'Upload your design system from GitHub or local code repositories, Figma files, images, and other content assets.',
  'settings.onboardingDesignIntroReuseTitle': 'Reuse in future work',
  'settings.onboardingDesignIntroReuseBody': 'Future prototypes, slides, and other content can reference your existing fonts, spacing, logo style, and color tone.',
  'settings.onboardingDesignIntroSkipTitle': 'Optional for now',
  'settings.onboardingDesignIntroSkipBody': 'Skip this step if you want to start without generating a design system.',
  'settings.onboardingGithubTitle': 'Import from GitHub',
  'settings.onboardingGithubBody': 'Use a frontend repository.',
  'settings.onboardingUploadTitle': 'Upload local files',
  'settings.onboardingUploadBody': 'Add project files, screenshots, CSS, docs, or assets.',
  'settings.onboardingPromptTitle': 'Generate from prompt',
  'settings.onboardingPromptBody': 'Describe the product or brand.',
  'settings.onboardingProfileTitle': 'เกี่ยวกับคุณ',
  'settings.onboardingProfileBody': 'ข้อมูลเพิ่มเติม (ไม่บังคับ) เพื่อตั้งค่าเริ่มต้นที่เหมาะกับคุณมากขึ้น',
  'settings.onboardingRoleLabel': 'บทบาทของคุณ',
  'settings.onboardingOrgSizeLabel': 'ขนาดองค์กร',
  'settings.onboardingUseCaseLabel': 'กรณีการใช้งาน',
  'settings.onboardingSourceLabel': 'คุณรู้จักเราจากที่ไหน?',
  'settings.onboardingSourceX': '🐦 X / Twitter',
  'settings.onboardingSourceGithub': '🐙 GitHub',
  'settings.onboardingSourceYoutube': '▶️ YouTube',
  'settings.onboardingSourceTiktok': '🎵 TikTok',
  'settings.onboardingSourceReddit': '👽 Reddit',
  'settings.onboardingSourceLinkedin': '💼 LinkedIn',
  'settings.onboardingSourceMetaSocial': '📸 Instagram / Threads / Facebook',
  'settings.onboardingSourceSearch': '🔍 การค้นหา (Google / Bing)',
  'settings.onboardingSourceAiTool': '🤖 เครื่องมือ AI (ChatGPT / Perplexity)',
  'settings.onboardingSourceFriend': '👥 เพื่อนหรือเพื่อนร่วมงาน',
  'settings.onboardingSourceCommunity': '💬 Discord / ชุมชน',
  'settings.onboardingSourceEmail': '✉️ อีเมล / จดหมายข่าว',
  'settings.onboardingSourceBlog': '📝 บล็อก / บทความ',
  'settings.onboardingSourceOther': '✨ อื่น ๆ',
  'settings.onboardingSourceOtherPlaceholder': 'บอกเราหน่อยว่าจากที่ไหน (ไม่บังคับ)',
  'settings.onboardingSelectPlaceholder': 'เลือกหนึ่งรายการ',
  'settings.onboardingSelectMultiplePlaceholder': 'เลือกหนึ่งรายการหรือมากกว่า',
  'settings.onboardingOrgSolo': 'ส่วนตัว / คนเดียว (1)',
  'settings.onboardingOrgTeam': 'ทีมเล็ก (2-10)',
  'settings.onboardingOrgStartup': 'สตาร์ทอัพ / SMB (11-50)',
  'settings.onboardingOrgGrowth': 'บริษัทกำลังเติบโต (51-200)',
  'settings.onboardingOrgMidMarket': 'ธุรกิจขนาดกลาง (201-1000)',
  'settings.onboardingOrgEnterprise': 'องค์กรขนาดใหญ่ (1000+)',
  'settings.onboardingRolePm': '📋 ผู้จัดการผลิตภัณฑ์',
  'settings.onboardingRoleDesigner': '🎨 นักออกแบบ',
  'settings.onboardingRoleEngineer': '💻 วิศวกร',
  'settings.onboardingRoleMarketing': '📣 การตลาด',
  'settings.onboardingRoleAgency': '📣 เอเจนซีการตลาด',
  'settings.onboardingRoleGrowth': '📈 การเติบโต',
  'settings.onboardingRoleOps': '⚙️ ฝ่ายปฏิบัติการ',
  'settings.onboardingRoleFounder': '🚀 ผู้ก่อตั้ง / ผู้บริหาร',
  'settings.onboardingRoleStudent': '🎓 นักเรียน / ผู้สอน',
  'settings.onboardingRoleOther': '✨ อื่น ๆ',
  'settings.onboardingUseProduct': '🎨 การออกแบบผลิตภัณฑ์',
  'settings.onboardingUseDesignSystem': '🧩 ดีไซน์ซิสเต็ม',
  'settings.onboardingUsePrototype': '📱 ต้นแบบ / UI แอป',
  'settings.onboardingUseLanding': '🌐 หน้าแลนดิ้งเพจ',
  'settings.onboardingUseAds': '📣 โฆษณา / คอนเทนต์โซเชียล',
  'settings.onboardingUseDashboard': '📊 แดชบอร์ด / เครื่องมือภายใน',
  'settings.onboardingUseDeck': '🖥️ งานนำเสนอ / สไลด์',
  'settings.onboardingUseMarketing': '📈 การตลาด / การเติบโต',
  'settings.onboardingUseEngineering': '🤝 การส่งงานให้วิศวกร',
  'settings.onboardingUseAgency': '💼 งานเอเจนซี / งานลูกค้า',
  'settings.onboardingBack': 'Back',
  'settings.onboardingContinue': 'Continue',
  'settings.onboardingFinish': 'Finish setup',
  'settings.kicker': 'การตั้งค่า',
  'settings.title': 'โมเดลและผู้ให้บริการ',
  'settings.subtitle': 'เลือกระหว่าง Local CLI และ BYOK',
  'settings.general': 'ทั่วไป',
  'settings.generalHint': 'ภาษา รูปลักษณ์ การแจ้งเตือน ตำแหน่งโปรเจกต์ ความเป็นส่วนตัว และรายละเอียดแอป',
  'settings.modeAria': 'โหมดการทำงาน',
  'settings.protocolAria': 'โปรโตคอล API',
  'settings.modeDaemon': 'CLI ในเครื่อง',
  'settings.modeDaemonHelp': 'ทำงานผ่าน code-agent CLI บนเครื่องของคุณ',
  'settings.modeDaemonOffline': 'Daemon ไม่ได้ทำงานอยู่',
  'settings.modeDaemonOfflineMeta': 'daemon ออฟไลน์',
  'settings.modeDaemonInstalledMeta': 'ติดตั้งแล้ว {count} ตัว',
  'settings.modeApi': 'ผู้ให้บริการ API',
  'settings.cloudCalloutTitle': 'Use OpenDesign Cloud',
  'settings.cloudCalloutBody': 'Sign in to the cloud version to enable team spaces, shared projects, member permissions, and the audit dashboard.',
  'settings.cloudCalloutButton': 'Sign in / Register',
  'settings.modeApiMeta': 'ผู้ให้บริการ API',
  'settings.byokNoFileToolsNotice': 'BYOK ใช้ OpenCode เพื่ออ่าน เขียน และแก้ไขไฟล์โปรเจกต์ ต้องติดตั้ง OpenCode และพร้อมใช้งาน',
  'settings.byokDraftNotice': 'กรอกช่องที่จำเป็นเพื่อบันทึกผู้ให้บริการนี้ การตั้งค่าปัจจุบันจะยังคงใช้งานอยู่',
  'settings.codeAgent': 'เอเจนต์โค้ด',
  'settings.codeAgentHint': 'ตรวจพบจากการสแกน PATH ของคุณ เลือก CLI ที่คุณต้องการให้ระบบใช้งาน',
  'settings.rescan': '↻ สแกนใหม่',
  'settings.rescanTitle': 'สแกน PATH ใหม่',
  'settings.rescanRunning': 'กำลังสแกน...',
  'settings.rescanSuccess': 'สแกนเสร็จสิ้น พบ {count} ตัวที่ใช้งานได้',
  'settings.designSystemRenameFailed': 'การเปลี่ยนชื่อล้มเหลว ตรวจสอบ daemon แล้วลองอีกครั้ง',
  'settings.rescanFailed': 'การสแกนล้มเหลว ตรวจสอบ daemon แล้วลองอีกครั้ง',
  'settings.test': 'ทดสอบ',
  'settings.testTitle': 'ส่งข้อความทดสอบขนาดเล็กเพื่อยืนยันการเชื่อมต่อ',
  'settings.testRunning': 'กำลังทดสอบการเชื่อมต่อ…',
  'settings.byokReadyToTest': 'พร้อมทดสอบ',
  'settings.testCancel': 'ยกเลิก',
  'settings.testRetry': 'ลองทดสอบอีกครั้ง',
  'settings.required': 'จำเป็น',
  'settings.testMissingFields': 'กรอก {fields} เพื่อทดสอบการเชื่อมต่อ',
  'settings.testSuccessApi': 'เชื่อมต่อแล้ว ตอบกลับใน {ms} มิลลิวินาที — \'{sample}\'',
  'settings.testSuccessCli': '{agentName} ตอบกลับใน {ms} มิลลิวินาที — \'{sample}\'',
  'settings.testAuthFailed': 'การยืนยันตัวตนล้มเหลว ตรวจสอบ API Key ของคุณ',
  'settings.testForbidden': 'ถูกปฏิเสธการเข้าถึง ตรวจสอบบัญชี ภูมิภาค หรือองค์กรของคุณ',
  'settings.testNotFoundModel': 'ไม่พบโมเดล \'{model}\' ใน Endpoint นี้',
  'settings.testInvalidModelId': 'ID โมเดล \'{model}\' ไม่ถูกต้อง ID ต้องขึ้นต้นด้วยตัวอักษรหรือตัวเลข และไม่มีช่องว่าง',
  'settings.testInvalidBaseUrl': 'Base URL ไม่ถูกต้องหรือไม่สามารถเข้าถึงได้',
  'settings.testRateLimited': 'ผู้ให้บริการจำกัดอัตราการส่งข้อมูล',
  'settings.testUpstream': 'ผู้ให้บริการตอบกลับด้วยสถานะ {status} โปรดลองอีกครั้งในภายหลัง',
  'settings.testTimeout': 'การทดสอบหมดเวลาหลังจาก {ms} มิลลิวินาที',
  'settings.testAgentMissing': 'ยังไม่ได้ติดตั้ง {agentName} หรือไม่ได้อยู่ใน PATH',
  'settings.testAgentSpawn': 'ไม่สามารถเริ่ม {agentName} ได้: {detail}',
  'settings.testUnknown': 'การทดสอบล้มเหลว: {detail}',
  'settings.agentInstall.install': 'ติดตั้ง',
  'settings.agentInstall.docs': 'เอกสาร',
  'settings.agentInstall.pathHint': 'หากคุณติดตั้ง CLI ด้วย npm หรือ Homebrew แล้วแต่ยังแสดงว่าไม่ได้ติดตั้ง โปรดตรวจสอบว่าโฟลเดอร์ bin ของเครื่องมือนั้นอยู่ใน PATH ที่ OpenDesign daemon ใช้งาน (บน macOS ค่า PATH ของ Terminal และแอป GUI อาจต่างกัน) ดู QUICKSTART.md (ส่วน "Local agent CLI and PATH")',
  'settings.agentInstall.stepOpenLinks': 'เปิดลิงก์ติดตั้งหรือเอกสารสำหรับเอเจนต์ที่ต้องการ',
  'settings.agentInstall.stepAuth': 'ยืนยันตัวตนกับ CLI ของผู้ให้บริการ (ลงชื่อเข้าใช้หรือเพิ่มข้อมูลรับรอง API) ก่อนกลับไปที่ OpenDesign',
  'settings.agentInstall.stepRescan': 'คลิกสแกนใหม่ในส่วนนี้',
  'settings.agentInstall.stepSelect': 'เลือกการ์ดเอเจนต์เมื่อแสดงว่าได้ติดตั้งแล้ว',
  'settings.noAgentsDetected': 'ยังไม่พบเอเจนต์ โปรดติดตั้งอย่างใดอย่างหนึ่ง: Claude Code, Codex, Devin for Terminal, OpenCode, Cursor Agent, Qwen หรือ GitHub Copilot CLI แล้วคลิกสแกนใหม่',
  'settings.agentInstalledGroup': 'CLI ของคุณ ({count})',
  'settings.agentInstallGroup': 'พร้อมให้ติดตั้ง ({count})',
  'settings.agentAuthRequired': 'ต้องยืนยันตัวตน',
  'settings.agentAuthUnknown': 'ไม่ทราบสถานะการยืนยันตัวตน',
  'settings.amrCloud': 'OpenDesign Cloud',
  'settings.amrAuthorize': 'อนุญาต',
  'settings.amrBenefitOfficial': 'ทางการ',
  'settings.amrBenefitLowerPrice': 'ต้นทุนต่ำกว่า',
  'settings.amrBenefitManyModels': 'โมเดลจำนวนมาก',
  'settings.amrPromoBonus': 'โบนัสจำกัด: +100%',
  'settings.amrSignInToContinue': 'ลงชื่อเข้าใช้เพื่อดำเนินการต่อ',
  'settings.amrSignIn': 'ลงชื่อเข้าใช้',
  'settings.amrSignedIn': 'ลงชื่อเข้าใช้แล้ว',
  'settings.amrWalletBalance': 'Wallet balance',
  'settings.amrWalletUnavailable': 'Balance temporarily unavailable',
  'settings.amrWalletUpdatedAt': 'Updated {time}',
  'settings.amrWalletCached': 'cached',
  'settings.amrWalletRefresh': 'Refresh',
  'settings.amrWalletRefreshTitle': 'Refresh OpenDesign Cloud wallet balance',
  'settings.amrNotSignedIn': 'ยังไม่ได้ลงชื่อเข้าใช้',
  'settings.amrSigningIn': 'กำลังลงชื่อเข้าใช้…',
  'settings.amrActivationHint': 'หน้าลงชื่อเข้าใช้ไม่เปิดใช่ไหม แตะปุ่มด้านล่างเพื่อเปิดอีกครั้ง',
  'settings.amrActivationBrowserFailedTitle': 'ไม่สามารถเปิดหน้าเข้าสู่ระบบได้',
  'settings.amrActivationBrowserFailedDescription': 'เบราว์เซอร์ไม่ได้เปิดขึ้นโดยอัตโนมัติ โปรดลองเข้าสู่ระบบอีกครั้ง',
  'settings.amrActivationOpen': 'เปิดหน้าเข้าสู่ระบบ',
  'settings.amrCancelSignIn': 'ยกเลิกการลงชื่อเข้าใช้',
  'settings.onboardingActivationPrompt': 'หน้าลงชื่อเข้าใช้ไม่เปิดขึ้นใช่ไหม',
  'settings.onboardingActivationBrowserFailed': 'ไม่สามารถเปิดเบราว์เซอร์โดยอัตโนมัติได้',
  'settings.onboardingActivationReopen': 'เปิดอีกครั้ง',
  'settings.amrAccountStatus': 'สถานะบัญชี OpenDesign Cloud',
  'settings.amrConsole': 'จัดการ',
  'settings.amrBalance': 'โควตา',
  'settings.amrPlan': 'แพ็กเกจ',
  'settings.amrUpgrade': 'อัปเกรด',
  'settings.amrModelUpgradeHint': 'อัปเกรดเพื่อใช้งาน',
  'settings.amrLoginErrorCompact': 'การลงชื่อเข้าใช้ OpenDesign Cloud ล้มเหลว',
  'settings.advanced': 'ขั้นสูง',
  'settings.amrLogin': 'ลงชื่อเข้าใช้',
  'settings.amrLogout': 'ออกจากระบบ',
  'settings.amrLoggingIn': 'กำลังลงชื่อเข้าใช้…',
  'settings.amrLoggingOut': 'กำลังลงชื่อออก…',
  'settings.amrLoggedInAs': 'ลงชื่อเข้าใช้ในชื่อ {email}',
  'settings.amrLoggedInWithPlan': 'ลงชื่อเข้าใช้ในชื่อ {email} · {plan}',
  'settings.amrLoggedInPill': 'ลงชื่อเข้าใช้แล้ว',
  'settings.amrNotLoggedIn': 'ยังไม่ได้ลงชื่อเข้าใช้',
  'settings.apiSection': 'Anthropic API',
  'settings.quickFillProvider': 'เลือกผู้ให้บริการอย่างรวดเร็ว',
  'settings.providerPreset': 'พรีเซ็ตผู้ให้บริการ',
  'settings.protocolGroupProtocols': 'โปรโตคอล',
  'settings.protocolGroupGateways': 'เกตเวย์',
  'settings.customProvider': 'กำหนดผู้ให้บริการเอง',
  'settings.apiKey': 'API Key',
  'settings.apiKeyGetLink': 'รับคีย์ ↗',
  'settings.showKey': 'แสดง Key',
  'settings.hideKey': 'ซ่อน Key',
  'settings.show': 'แสดง',
  'settings.hide': 'ซ่อน',
  'settings.model': 'โมเดล',
  'settings.apiKeyInvalid': 'API key ไม่ถูกต้อง',
  'settings.apiKeyCleaned': 'ลบช่องว่างส่วนเกินออกจาก API key แล้ว',
  'settings.modelsLoadedFromAccount': '✓ โหลด {count} โมเดลจากบัญชีของคุณแล้ว',
  'settings.modelsLoadedCount': '✓ โหลด {count} โมเดลแล้ว',
  'settings.modelSourceAccount': 'จากบัญชีของคุณ',
  'settings.modelSourceSuggested': 'แนะนำ',
  'modelCapability.standard': 'Standard',
  'modelCapability.advanced': 'Advanced',
  'modelCapability.bestQuality': 'Best Quality',
  'modelCapability.standardDescription': 'Solid quality for regular tasks.',
  'modelCapability.advancedDescription': 'Stronger quality for more demanding tasks.',
  'modelCapability.bestQualityDescription': 'Best output quality for the most demanding work.',
  'modelCost.upToHalf': 'ต้นทุนต่ำ',
  'modelCost.halfToOne': 'ต้นทุนปานกลาง',
  'modelCost.oneToFour': 'ต้นทุนสูง',
  'modelCost.overFour': 'ต้นทุนสูงสุด',
  'settings.fetchModels': 'ดึงโมเดล',
  'settings.fetchModelsTitle': 'ดึงโมเดลที่มีอยู่จากผู้ให้บริการนี้',
  'settings.fetchModelsRunning': 'กำลังดึงโมเดล…',
  'settings.fetchModelsMissingFields': 'กรอก {fields} เพื่อดึงโมเดล',
  'settings.fetchModelsInvalidBaseUrl': 'ใส่ Base URL ที่ถูกต้องเพื่อดึงโมเดล',
  'settings.fetchModelsUnsupportedAzure': 'Azure OpenAI ใช้ชื่อ deployment ดังนั้นจึงไม่สามารถค้นหาโมเดลได้ที่นี่',
  'settings.fetchModelsUnsupportedOllama': 'ยังไม่สามารถค้นหาโมเดลของ Ollama Cloud ได้ในขณะนี้ เลือกหรือพิมพ์ชื่อโมเดล',
  'settings.fetchModelsSuccess': 'ดึงโมเดลมาแล้ว {count} รายการ',
  'settings.fetchModelsEmpty': 'ไม่มีโมเดลข้อความที่เข้ากันได้ส่งกลับมา',
  'settings.fetchModelsUnsupported': 'ไม่สามารถค้นหาโมเดลสำหรับโปรโตคอลนี้ได้',
  'settings.fetchModelsFailed': 'ไม่สามารถดึงโมเดลได้: {detail}',
  'settings.suggestedModelsHint': 'นี่คือโมเดลที่แนะนำสำหรับโปรโตคอลนี้ ผู้ให้บริการของคุณอาจรองรับโมเดลอื่นๆ',
  'settings.baseUrl': 'Base URL',
  'settings.baseUrlInvalid': 'ใช้ URL สาธารณะ http:// หรือ https://',
  'settings.baseUrlCustomize': 'ปรับแต่ง URL',
  'settings.baseUrlDefaultHint': 'เปลี่ยนเฉพาะเมื่อใช้พร็อกซีหรือเกตเวย์ที่เข้ากันได้',
  'settings.azureBaseUrlPlaceholder': 'วาง URL ปลายทางของ Azure',
  'settings.azureBaseUrlHint': 'ดูได้ใน Azure portal → ทรัพยากรของคุณ → Endpoint',
  'settings.azureDeploymentModel': 'ชื่อ Deployment',
  'settings.azureCustomDeploymentName': 'ชื่อ deployment ที่กำหนดเอง',
  'settings.azureDeploymentModelHint': 'สำหรับ Azure OpenAI ฟิลด์นี้ใช้เป็นชื่อ Deployment ใน /openai/deployments/<model> ป้อนชื่อ Deployment ที่คุณสร้างใน Azure',
  'settings.azureModelFetchHint': 'กรอกชื่อ deployment จากทรัพยากร Azure ของคุณ Azure deployment ไม่สามารถดึงข้อมูลอัตโนมัติได้',
  'settings.apiVersion': 'เวอร์ชัน API',
  'settings.byokImageModel': 'โมเดลสร้างภาพ',
  'settings.byokVideoModel': 'โมเดลสร้างวิดีโอ',
  'settings.byokVideoI2vHint': 'โมเดลภาพเป็นวิดีโอ: ต้องมีภาพอ้างอิง (หากไม่ระบุ จะใช้ภาพล่าสุดในโปรเจกต์โดยอัตโนมัติ)',
  'settings.byokSpeechModel': 'โมเดลเสียงพูด',
  'settings.byokSpeechVoice': 'เสียงพูด',
  'settings.byokModelDefaultOption': 'ค่าเริ่มต้น',
  'settings.maxTokens': 'Max tokens (เลือกได้)',
  'settings.maxTokensHint': 'ความยาวการตอบกลับสูงสุด เว้นว่างเพื่อใช้ค่าเริ่มต้นของโมเดล',
  'settings.apiHint': 'จัดเก็บไว้ในเครื่องนี้เท่านั้น',
  'settings.skipForNow': 'ข้ามไปก่อน',
  'settings.getStarted': 'เริ่มต้นใช้งาน',
  'settings.envConfigure': 'โมเดลและผู้ให้บริการ',
  'settings.localCli': 'CLI ในเครื่อง',
  'settings.dshSetupTitle': 'Connect DeepSeek Harness',
  'settings.dshSetupDescription': 'OpenDesign will install its connection component through the dsh CLI on this computer.',
  'settings.dshSetupNote': 'Only the OpenDesign profile component is installed. DeepSeek Harness remains user-installed and user-managed.',
  'settings.dshSetupConfirm': 'Install and select',
  'settings.dshSetupInstalling': 'Installing…',
  'settings.dshSetupRequired': 'Connection setup required',
  'settings.anthropicApi': 'Anthropic API',
  'settings.noAgentSelected': 'ไม่ได้เลือกเอเจนต์',
  'settings.language': 'ภาษา',
  'settings.languageHint': 'เปลี่ยนภาษาอินเทอร์เฟซ บันทึกไว้ในเบราว์เซอร์นี้',
  'settings.agentModelHead': 'โมเดลสำหรับ:',
  'settings.modelPicker': 'โมเดล',
  'settings.modelSourceLive': 'สดจาก CLI',
  'settings.modelUsesCliDefault': 'ค่าเริ่มต้น CLI',
  'settings.modelSourceFallback': 'รายการในตัว',
  'settings.reasoningPicker': 'ความพยายามในการให้เหตุผล',
  'settings.serviceTierPicker': 'ระดับบริการ',
  'settings.modelPickerHint': 'ดึงข้อมูลจาก CLI เมื่อมีคำสั่ง `models`',
  'settings.modelPickerLiveHint': 'รีเฟรชโมเดลจาก CLI ที่ติดตั้งแล้ว ค่าเริ่มต้นยังใช้การตั้งค่าของ CLI',
  'settings.modelPickerLiveCatalogOnlyHint': 'รีเฟรชโมเดลจาก CLI ที่ติดตั้งแล้ว',
  'settings.modelPickerFallbackHint': 'กำลังแสดงค่าเริ่มต้นในตัว คลิกสแกนอีกครั้งเพื่อดึงโมเดลสดจาก CLI',
  'settings.cliEnvTitle': 'ขั้นสูง: พร็อกซีและพาธกำหนดเอง',
  'settings.cliEnvHint': 'ใช้ค่านี้เพื่อ override environment ของ CLI ที่เลือก: API key, proxy base URL, home แบบกำหนดเอง หรือพาธ binary ที่ไม่ใช่มาตรฐาน หากไม่ใส่ base URL CLI จะใช้ endpoint เริ่มต้นของตัวเอง ข้อมูลลับจะอยู่ในการตั้งค่าแอปบนเครื่องและ CLI ที่เลือกเท่านั้นที่เห็นค่าเหล่านี้',
  'settings.cliEnvClaudeConfigDir': 'ไดเรกทอรีการตั้งค่า Claude Code',
  'settings.cliEnvClaudeBaseUrl': 'Base URL ของ Claude proxy',
  'settings.cliEnvClaudeApiKey': 'Claude CLI API key',
  'settings.cliEnvCodexHome': 'โฮมของ Codex',
  'settings.cliEnvCodexBin': 'เส้นทางไฟล์เรียกทำงาน Codex',
  'settings.cliEnvCodexBaseUrl': 'Base URL พร็อกซีของ Codex/OpenAI',
  'settings.cliEnvCodexApiKey': 'Codex/OpenAI CLI API key',
  'settings.modelCustom': 'กำหนดเอง (พิมพ์ด้านล่าง)…',
  'settings.modelCustomLabel': 'ID โมเดลที่กำหนดเอง',
  'settings.modelCustomPlaceholder': 'เช่น anthropic/claude-sonnet-4-6',
  'settings.onboardingModelUseCustom': 'Use "{query}"',
  'settings.mediaProviders': 'ผู้ให้บริการสื่อ',
  'settings.mediaProvidersHint': 'API keys สำหรับการสร้างภาพ วิดีโอ และเสียง บันทึกในเครื่องและซิงค์กับ local daemon',
  'settings.mcpServerTitle': 'OpenDesign MCP',
  'settings.mcpServerHint': 'เปิดให้ OpenDesign เป็นเซิร์ฟเวอร์ MCP สำหรับเอเจนต์โค้ด',
  'settings.externalMcpTitle': 'MCP ภายนอก',
  'settings.externalMcpHint': 'เพิ่มเครื่องมือ MCP จากบริการภายนอก (Higgsfield, GitHub, …)',
  'settings.mediaProviderApiKey': 'API key',
  'settings.mediaProviderBaseUrl': 'Base URL',
  'settings.mediaProviderConfigured': 'ตั้งค่าแล้ว',
  'settings.mediaProviderUnset': 'ยังไม่ได้ตั้งค่า',
  'settings.mediaProviderClear': 'ล้าง',
  'settings.mediaProviderClearConfirm': 'ล้างการตั้งค่า {name} ที่บันทึกไว้ใช่หรือไม่? คุณจะต้องตั้งค่าใหม่อีกครั้งเพื่อใช้งาน {name}',
  'settings.mediaProviderPlaceholder': 'วาง API key',
  'settings.mediaProviderBaseUrlPlaceholder': 'กำหนด Base URL แท่นค่าเริ่มต้น',
  'settings.mediaProviderReload': 'โหลดใหม่จาก daemon',
  'settings.mediaProviderReloadError': 'ไม่สามารถโหลดการตั้งค่าผู้ให้บริการสื่อใหม่จาก daemon ในเครื่องได้',
  'settings.mediaProviderReloadSuccess': 'โหลดการตั้งค่าผู้ให้บริการสื่อใหม่จาก daemon ในเครื่องแล้ว',
  'settings.mediaProviderLoadError': 'ไม่สามารถโหลดการตั้งค่าผู้ให้บริการสื่อจาก daemon ในเครื่องได้ ขณะนี้กำลังใช้การตั้งค่าที่บันทึกไว้ในเบราว์เซอร์ไปก่อน',
  'settings.mediaProviderComingSoonHint': 'เราติดตามสิ่งเหล่านี้สำหรับแผนงาน daemon ยังไม่ได้จัดส่งไคลเอนต์ ดังนั้นจึงไม่มีอะไรให้กำหนดค่า',
  'settings.privacy': 'ความเป็นส่วนตัว',
  'settings.privacyHint': 'ข้อมูลที่แชร์กับทีม OpenDesign',
  'settings.privacyConsentKicker': 'ช่วยเราพัฒนา OpenDesign',
  'settings.privacyConsentLead': 'การแชร์ข้อมูลการใช้งานช่วยให้เราเข้าใจว่า OpenDesign ทำงานอย่างไรในเวิร์กโฟลว์จริง เพื่อปรับปรุงส่วนที่ส่งผลต่อประสบการณ์ของคุณมากที่สุด',
  'settings.privacyConsentFooter': 'คุณสามารถเปลี่ยนตัวเลือกเหล่านี้ได้ทุกเมื่อใน การตั้งค่า → ความเป็นส่วนตัว',
  'settings.privacyConsentShare': 'แชร์',
  'settings.privacyConsentDecline': 'ไม่แชร์',
  'settings.privacyConsentAccept': 'เข้าใจแล้ว',
  'settings.privacyConsentBannerFooter': 'การแชร์ข้อมูลเปิดใช้งานโดยค่าเริ่มต้น คุณสามารถปิดได้ทุกเมื่อใน การตั้งค่า → ความเป็นส่วนตัว',
  'settings.privacyConsentPolicyLink': 'อ่านนโยบายความเป็นส่วนตัว',
  'settings.privacyMetrics': 'ข้อมูลผู้ใช้นิรนาม',
  'settings.privacyMetricsHint': 'จำนวนการใช้งาน, การใช้โทเค็น, อัตราข้อผิดพลาด และระยะเวลา เป็นตัวชี้วัดพื้นฐาน',
  'settings.privacyContent': 'เนื้อหาการสนทนา',
  'settings.privacyContentHint': 'หลังจากลบข้อมูลลับและข้อมูลอ่อนไหวอื่นๆ แล้ว เราจะใช้พรอมป์ การตอบกลับของผู้ช่วย อินพุต/เอาต์พุตของเครื่องมือ และบริบทที่จำเป็นสำหรับการตรวจสอบคุณภาพ',
  'settings.privacyInstallationId': 'ID ผู้ใช้นิรนาม',
  'settings.privacyOptedOut': 'ปฏิเสธแล้ว',
  'settings.privacyDataDeletion': 'ลบข้อมูลของฉัน',
  'settings.privacyDataDeletionHint': 'รีเซ็ต ID ผู้ใช้นิรนามและหยุดการส่งข้อมูล',
  'settings.about': 'เกี่ยวกับ',
  'settings.aboutHint': 'เวอร์ชันและรายละเอียดระบบ',
  'settings.appVersion': 'เวอร์ชัน',
  'settings.appChannel': 'ช่องทาง',
  'settings.appRuntime': 'รันไทม์',
  'settings.appPlatform': 'แพลตฟอร์ม',
  'settings.appArchitecture': 'สถาปัตยกรรม',
  'settings.runtimePackaged': 'แอปที่แพ็กเกจแล้ว',
  'settings.runtimeDevelopment': 'การพัฒนา',
  'settings.versionUnavailable': 'ข้อมูลเวอร์ชันไม่พร้อมใช้งานขณะที่ daemon ออฟไลน์',
  "settings.allowSilentUpdates": "อนุญาตให้ติดตั้งอัปเดตในแอปในอนาคตโดยอัตโนมัติ",
  "settings.allowSilentUpdatesDesc": "เมื่ออัปเดตในแอปพร้อม ติดตั้งอัตโนมัติเมื่อเริ่มครั้งถัดไป ไม่อัปเกรดเซสชันปัจจุบันทันที การอัปเดตผ่านตัวติดตั้งยังคงถามก่อน",
  'settings.installLatest': 'ติดตั้งเวอร์ชันล่าสุด',
  'settings.alreadyLatest': 'คุณใช้เวอร์ชันล่าสุดอยู่แล้ว',
  'settings.updateCheck': 'ตรวจสอบอัปเดต',
  'settings.updateNow': 'อัปเดตตอนนี้',
  'settings.updateRecheck': 'ตรวจสอบอีกครั้ง',
  'settings.updateRetry': 'ลองอีกครั้ง',
  'settings.updateViewReleases': 'บันทึกประจำรุ่น',
  'settings.updateActionFailed': 'ไม่สามารถทำงานอัปเดตให้เสร็จได้',
  'settings.updateQuitFailed': 'เปิดตัวติดตั้งแล้ว แต่ OpenDesign ไม่สามารถปิดอัตโนมัติได้',
  'settings.updateStatusNotChecked': 'ยังไม่ได้ตรวจสอบ',
  'settings.updateStatusDevelopment': 'บิลด์พัฒนาไม่รองรับการอัปเดตในแอป',
  'settings.updateStatusUnsupported': 'สภาพแวดล้อมนี้ไม่รองรับการอัปเดตในแอป',
  'settings.updateStatusChecking': 'กำลังตรวจสอบอัปเดต...',
  'settings.updateStatusUpToDate': 'คุณใช้เวอร์ชันล่าสุดแล้ว',
  'settings.updateStatusAvailable': 'พบเวอร์ชัน {version} กำลังเตรียมดาวน์โหลด',
  'settings.updateStatusAvailableUnknown': 'พบเวอร์ชันใหม่ กำลังเตรียมดาวน์โหลด',
  'settings.updateStatusDownloading': 'กำลังดาวน์โหลดอัปเดต...',
  'settings.updateStatusDownloadingPercent': 'กำลังดาวน์โหลดอัปเดต {percent}%',
  'settings.updateStatusReady': 'เวอร์ชัน {version} พร้อมติดตั้ง',
  'settings.updateStatusReadyUnknown': 'อัปเดตพร้อมติดตั้ง',
  'settings.updateStatusInstalling': 'กำลังติดตั้งอัปเดต...',
  'settings.updateStatusFailed': 'ตรวจสอบล้มเหลว โปรดลองอีกครั้ง',
  'settings.mcpTitle': 'เซิร์ฟเวอร์ MCP',
  'settings.mcpHint': 'ให้ coding agent (Cursor, Claude Code, VS Code…) อ่านโปรเจกต์ OpenDesign ของคุณได้โดยตรง',
  'settings.mcpDaemonError': 'ไม่สามารถเชื่อมต่อกับ daemon ในเครื่องเพื่อระบุพาธการติดตั้งได้ ({error}) โปรดตรวจสอบว่า OpenDesign กำลังทำงานอยู่ จากนั้นเปิดแผงนี้ใหม่',
  'settings.mcpBuildDaemon': 'สร้าง daemon ก่อน',
  'settings.mcpNodeMissing': 'ไม่พบไบนารีของ Node',
  'settings.mcpBuildHint': 'ไม่พบ apps/daemon/dist/cli.js รัน `pnpm --filter @open-design/daemon build` แล้วรีเฟรช',
  'settings.mcpMethodCli': 'คำสั่ง CLI',
  'settings.mcpInstructionCli': 'รันคำสั่งนี้ใน terminal ของคุณ',
  'settings.mcpMethodToml': 'การตั้งค่า TOML',
  'settings.mcpInstructionCodex': 'เพิ่มตารางนี้ต่อท้าย {path} การตั้งค่าเดียวกันนี้ใช้ร่วมกันระหว่าง Codex CLI และส่วนขยาย Codex IDE',
  'settings.mcpMethodOneClick': 'ติดตั้งด้วยคลิกเดียว',
  'settings.mcpInstructionCursor': 'คลิก "Install in Cursor" เพื่อติดตั้งพร้อมกล่องโต้ตอบขออนุมัติ หรือผสาน JSON นี้เข้ากับ {path}',
  'settings.mcpDeeplinkInstallCursor': 'ติดตั้งใน Cursor',
  'settings.mcpMethodJson': 'การตั้งค่า JSON',
  'settings.mcpInstructionKiro': 'เปิด {path} แล้วรวม JSON นี้ สำหรับการตั้งค่าระดับ workspace ให้ใช้ .kiro/settings/mcp.json',
  'settings.mcpInstructionCopilot': 'เปิด Command Palette ({shortcut}) รัน "MCP: Open User Configuration" แล้วผสาน JSON นี้ Copilot Chat ต้องอยู่ในโหมด Agent เพื่อให้เครื่องมือแสดงขึ้นมา',
  'settings.mcpInstructionAntigravity': 'ใน Antigravity: เมนู "..." ของแผง Agent → MCP Servers → Manage MCP Servers → View raw config แล้วรวม JSON นี้',
  'settings.mcpInstructionZed': 'เปิด Zed Settings ({shortcut}) แล้วผสานสิ่งนี้เข้ากับอ็อบเจกต์ระดับบนสุด Zed ใช้ "context_servers" ไม่ใช่ "mcpServers"',
  'settings.mcpInstructionWindsurf': 'เปิด {path} (หรือใช้ไอคอน MCPs ใน Cascade → Configure) แล้วรวม:',
  'settings.mcpCopyAria': 'คัดลอกสคริปต์การตั้งค่า MCP',
  'settings.mcpResolvingFailed': '# resolving paths failed, see the error above',
  'settings.mcpLoadingPaths': '# loading install paths from the local daemon…',
  'settings.mcpCopied': 'คัดลอกแล้ว',
  'settings.mcpCopy': 'คัดลอก',
  'settings.mcpCursorApproval': 'Cursor จะแสดงกล่องโต้ตอบขออนุมัติก่อนเขียนการตั้งค่า',
  'settings.mcpCodexOneClickInstall': 'ติดตั้งใน Codex',
  'settings.mcpCodexOneClickUninstall': 'ลบออกจาก Codex',
  'settings.mcpCodexOneClickUnavailable': 'ไม่พบ Codex CLI บน PATH — ติดตั้ง Codex หรือวาง snippet ด้วยตนเอง',
  'settings.mcpCodexInstallSuccess': 'ติดตั้งแล้ว รีสตาร์ท Codex เพื่อโหลดเซิร์ฟเวอร์ใหม่',
  'settings.mcpCodexUninstallSuccess': 'ลบออกจาก Codex แล้ว',
  'settings.mcpCodexBusy': 'กำลังทำงาน…',
  'settings.mcpCodexInstallError': 'การดำเนินการล้มเหลว: {error}',
  'settings.mcpRestartNote': 'รีสตาร์ทไคลเอนต์ของคุณเพื่อรับเซิร์ฟเวอร์ใหม่',
  'settings.mcpRestartDetail': 'โปรแกรมแก้ไขส่วนใหญ่จะโหลดเซิร์ฟเวอร์ MCP เฉพาะตอนเริ่มต้นเท่านั้น ใน Cursor / VS Code / Antigravity / Windsurf คุณสามารถรัน `Developer: Reload Window` จาก command palette แทนการรีสตาร์ททั้งหมดได้ ส่วน Zed และ Claude Code ต้องปิดแล้วเปิดใหม่',
  'settings.mcpCapabilitiesTitle': 'สิ่งที่ Agent ของคุณทำได้',
  'settings.mcpCapabilityRead': 'อ่านหรือค้นหาไฟล์ใดก็ได้ในโปรเจกต์ (HTML, JSX, CSS, JSON, SVG, Markdown)',
  'settings.mcpCapabilityPull': 'ดึงชุดดีไซน์ในการเรียกครั้งเดียว: ไฟล์เริ่มต้นพร้อมทุก CSS variable, คอมโพเนนต์ และฟอนต์ที่อ้างอิงถึง',
  'settings.mcpCapabilityDefault': 'ตั้งค่าเริ่มต้นเป็นโปรเจกต์และไฟล์ที่คุณเปิดอยู่ใน OpenDesign เพื่อให้คุณพูดได้ว่า "สร้างสิ่งนี้ในแอปของฉัน" โดยไม่ต้องระบุดีไซน์ซ้ำอีก',
  'settings.mcpRunningNote': 'OpenDesign ต้องกำลังทำงานอยู่เพื่อให้การเรียกเครื่องมือ MCP สำเร็จ หากคุณเริ่มต้นโค้ดดิ้ง Agent ก่อนเปิด OpenDesign ให้รีสตาร์ท Agent เพื่อให้สามารถเชื่อมต่อกับ daemon ที่ทำงานอยู่ได้',
  'entry.tabDesigns': 'ดีไซน์',
  'entry.tabTemplates': 'ตัวอย่าง',
  'entry.tabDesignSystems': 'ระบบการออกแบบ',
  'entry.tabConnectors': 'ตัวเชื่อมต่อ',
  'entry.openSettingsTitle': 'การตั้งค่า',
  'entry.openSettingsAria': 'เปิดการตั้งค่า',
  'entry.communityLabel': 'เข้าร่วม Discord',
  'entry.communityAria': 'เข้าร่วม Discord รับเครดิตฟรี',
  'entry.discordAriaWithOnline': 'เข้าร่วม Discord ของ OpenDesign - {online}',
  'entry.discordOnlineLabel': 'ออนไลน์ {count} คน',
  'entry.xAria': 'ติดตาม @OpenDesignHQ เพื่อดูฟีเจอร์ใหม่',
  'entry.mailAria': 'มีคำถาม? ส่งอีเมลถึงเรา',
  'entry.accountSettings': 'การตั้งค่า',
  'chat.collapsePane': 'ย่อแผงสนทนา',
  'collabPresence.ariaOne': '1 collaborator online',
  'collabPresence.aria': '{count} collaborators online',
  'collabPresence.ariaWithSelfOne': '1 collaborator online, including you',
  'collabPresence.ariaWithSelf': '{count} collaborators online, including you',
  'collabPresence.moreOnline': '{count} more online',
  'collabPresence.dialogTitle': 'Online collaborators',
  'collabPresence.onlineCount': '{count} online',
  'collabPresence.selfBadge': 'You',
  'collabPresence.roleOwner': 'Owner',
  'collabPresence.roleAdmin': 'Admin',
  'collabPresence.roleMember': 'Member',
  'collabPresence.viewingFileSelf': 'You are viewing {file}',
  'collabPresence.viewingFileOther': 'Viewing {file}',
  'collabPresence.viewingProjectSelf': 'You are viewing this project',
  'collabPresence.viewingProjectOther': 'Viewing this project',
  'entry.followXLabel': 'ติดตาม @OpenDesignHQ บน X',
  'entry.followThreadsLabel': 'Follow OpenDesign on Threads',
  'entry.youtubeLabel': 'OpenDesign on YouTube',
  'entry.followInstagramLabel': 'ติดตาม @opendesign.ai บน Instagram',
  'entry.followLinkedinLabel': 'ติดตาม OpenDesign บน LinkedIn',
  'entry.followXiaohongshuLabel': 'ติดตาม OpenDesign บน Xiaohongshu',
  'entry.resizeAria': 'ปรับขนาดแถบด้านข้าง',
  'entry.loadingWorkspace': 'กำลังโหลดพื้นที่ทำงาน…',
  'entry.useEverywhereTitle': 'ใช้ได้ทุกที่',
  'entry.useEverywhereAria': 'เปิดคู่มือ Use Everywhere (CLI, MCP, HTTP, Skills)',
  'entry.workspaceTeamsLabel': 'Teams',
  'workspaceSwitcher.invite': 'Invite colleague',
  'workspaceSwitcher.createTeam': 'New team',
  "workspaceSwitcher.draftsTooltip": "โปรเจกต์ทั้งหมด",
  "workspaceSwitcher.allProjectsTooltip": "โปรเจกต์ทีม",
  "entry.primaryNavAria": "Primary",
  "entry.billingTierTeam": "Teams",
  "entry.billingTierFree": "Free",
  "entry.billingTierPro": "Pro",
  "entry.billingTierPlus": "Plus",
  "entry.billingTierMax": "Max",
  "entry.billingTierGo": "Go",
  "entry.billingFamilyCreator": "Creator",
  "entry.creditsAria": "{tier} · credits remaining",
  "entry.creditsAriaWithBalance": "{tier} · {balance} credits remaining",
  "entry.creditsGrantTip": "Teams credits are granted by subscription allowance. Usage is available in billing.",
  "entry.creditsUpgrade": "อัปเกรด",
  "entry.creditsManage": "จัดการ",
  "entry.creditsOpening": "Opening...",
  "entry.creditsRemaining": "Credits remaining",
  "entry.credits": "โควตา",
  "entry.creditsUsage": "ดูการใช้งาน",
  "entry.creditsMemberNoticeTitle": "Need more credits?",
  "entry.creditsMemberNoticeBody": "You are currently a Member and cannot add credits yourself. Ask a team Admin to increase the allowance when you need more.",
  "entry.creditsMemberNoticeAction": "Ask Admin to increase allowance",
  "entry.accountToggleTheme": "สลับธีม",
  "entry.accountSwitchLanguage": "เปลี่ยนภาษา",
  "entry.accountLanguageMeta": "中文 / English",
  "entry.accountGithubHelp": "ขอความช่วยเหลือ",
  "entry.accountFeatureRequest": "Submit feature request",
  "entry.accountBilling": "การเรียกเก็บเงิน",
  "entry.accountAddAccount": "เพิ่มบัญชี",
  "entry.accountSignOut": "ออกจากระบบ",
  "signOut.confirmTitle": "ออกจากระบบ",
  "signOut.confirmMessage": "คุณแน่ใจหรือไม่ว่าต้องการออกจากระบบ?",
  "signOut.confirmAction": "ออกจากระบบ",
  "entry.navRecents": "หน้าแรก",
  "entry.navDashboard": "Dashboard",
  "entry.blankDraftsTitle": "Start a private draft",
  "entry.blankDraftsDescription": "Create a project here first. It stays private until you move it into the team space.",
  "entry.projectsLoadFailed": "ไม่สามารถโหลดโปรเจกต์ได้ โปรดลองอีกครั้ง",
  "entry.blankAllProjectsTitle": "No team projects yet",
  "entry.blankAllProjectsDescription": "Projects shared to the team will appear here for everyone in the workspace.",
  "entry.blankCreate": "New project",
  'entry.workspaceTeamsTitle': 'Workspace สำหรับทีม — บอกเราว่าทีมของคุณต้องการอะไร',
  'entry.workspaceTeamsAria': 'เปิดหน้า Workspace สำหรับทีม',
  'entry.navExpand': 'ขยายแถบด้านข้าง',
  'entry.navCollapse': 'ย่อแถบด้านข้าง',
  'entry.navNewProject': 'โปรเจกต์ใหม่',
  'entry.navHome': 'หน้าแรก',
  'entry.navProjects': 'โปรเจกต์',
  'entry.navTasks': 'การทำงานอัตโนมัติ',
  'entry.navPlugins': 'ปลั๊กอิน',
  'entry.navDesignSystems': 'ดีไซน์ซิสเต็ม',
  'entry.navBrands': 'ชุดแบรนด์',
  'entry.navIntegrations': 'การเชื่อมต่อ',
  'entry.navMembers': 'Members',
  'entry.navWorkspaceSettings': 'Workspace settings',
  'entry.navDrafts': 'โปรเจกต์ทั้งหมด',
  'entry.navAllProjects': 'โปรเจกต์ทีม',
  'entry.draftsDescription': 'Projects you created, visible only to you',
  'entry.allProjectsDescription': 'Projects owned by everyone on the team',
  'entry.navBoard': 'Board',
  'entry.navTeamSection': 'Team',
  'entry.teamSlotNote': 'This space is provided by the team service. Integration is in progress.',
  "entry.cloudCalloutTitle": "OpenDesign Cloud",
  'entry.cloudRecovering': 'Account connection interrupted. Recovering automatically…',
  'entry.authExpiredBody': 'ยังไม่ได้ลงชื่อเข้าใช้ Open Design\nโปรดเข้าสู่ระบบ เพื่อดูโปรเจกต์และสนทนาต่อ',
  'home.createFailed': 'Failed to start the run. Try again.',
  'home.daemonRecovering': 'การเชื่อมต่อภายในเครื่องขาดหาย\nขณะนี้ไม่สามารถเชื่อมต่อกับบริการ Open Design บนคอมพิวเตอร์เครื่องนี้ได้ โปรดรีสตาร์ตแอป',
  'home.createTimedOut': 'การเตรียมโปรเจกต์หมดเวลาก่อนจะเริ่มได้ โปรดส่งอีกครั้ง',
  'home.amrGateUnavailable': 'ไม่สามารถยืนยันยอดคงเหลือ OpenDesign Cloud ได้ โปรดส่งอีกครั้ง',
  'home.bundledScenarioMissing': 'Bundled scenario "{scenarioId}" is not installed. Reinstall the daemon to restore the default plugin set.',
  "entry.cloudCalloutBody": "ลงชื่อเข้าใช้เพื่อใช้ OpenDesign Cloud และทำงานร่วมกันบนคลาวด์",
  "entry.cloudCreditsTitle": "รับเครดิตฟรี",
  "entry.cloudCreditsBody": "สมัครบัญชี OpenDesign ใหม่เพื่อรับเครดิตฟรี และออกแบบด้วยโมเดลที่ล้ำหน้าที่สุด",
  "entry.cloudCreditsCta": "สมัคร / เข้าสู่ระบบ",
  "entry.localAccountName": "โหมดโลคัล",
  "entry.cloudCalloutDismissAria": "ปิดข้อความ OpenDesign Cloud",
  'entry.workspaceLockedNote': 'This workspace is locked. Restore billing to resume editing shared projects.',
  'entry.workspaceLockedRecover': 'Restore access',
  'messageCenter.openAria': 'Open message center',
  'messageCenter.unreadCount': '{count} unread',
  'messageCenter.title': 'Message center',
  'messageCenter.subtitle': 'OpenDesign updates, platform announcements, and account notices.',
  'messageCenter.filterAll': 'All',
  'messageCenter.filterUnread': 'Unread',
  'messageCenter.filterRead': 'Read',
  'messageCenter.markAllRead': 'Mark all read',
  'messageCenter.emptyAllTitle': 'No messages yet',
  'messageCenter.emptyUnreadTitle': 'All caught up',
  'messageCenter.emptyReadTitle': 'No read messages',
  'messageCenter.archive': 'เก็บเข้าคลัง',
  'messageCenter.unarchive': 'ย้ายกลับกล่องข้อความ',
  'messageCenter.archivedTitle': 'เก็บเข้าคลังแล้ว',
  'messageCenter.emptyArchivedTitle': 'ไม่มีข้อความที่เก็บไว้',
  'messageCenter.emptyBody': 'New platform messages will appear here.',
  'messageCenter.close': 'Close message center',
  'messageCenter.desktopSettings': 'Desktop notification settings',
  'messageCenter.desktopSettingsHint': 'Task completion sounds and system notifications stay in Settings.',
  'goPlanSunset.closeAria': 'Close announcement',
  'goPlanSunset.title': 'Notice: Go subscriptions are ending',
  'goPlanSunset.subtitle': 'We’ve heard your feedback and recognize that Go’s allowance rules and product experience need improvement. We’re sorry.',
  'goPlanSunset.decisionsAria': 'What’s changing',
  'goPlanSunset.decisionsIntro': 'What’s changing',
  'goPlanSunset.decisionStopSales': 'New Go subscriptions end today',
  'goPlanSunset.decisionRefund': 'Existing subscribers will receive full refunds by August 31; Go access ends after refund',
  'goPlanSunset.decisionUnaffected': 'Other plans are unaffected',
  'goPlanSunset.closing': 'Refunds return to the original payment method; timing depends on the provider. Thank you for your feedback and support.',
  'goPlanSunset.dismissError': 'Could not confirm. Please try again.',
  'goPlanSunset.viewSubscriptions': 'View other plans',
  'goPlanSunset.confirming': 'Confirming…',
  'goPlanSunset.acknowledge': 'Got it',
  'workspaceTabs.project': 'โปรเจกต์',
  'workspaceTabs.pluginDetails': 'รายละเอียดปลั๊กอิน',
  'workspaceTabs.marketplace': 'Marketplace',
  'homeHero.title': 'มาสร้าง{word}กัน',
  "homeHero.titleUnselected": "คุณอยากสร้างอะไร?",
  'homeHero.titleWords': 'ต้นแบบ,สไลด์,เอกสาร',
  'homeHero.subtitle': 'ผลงานที่ดีเริ่มต้นที่นี่',
  'homeHero.startWithTemplate': 'เริ่มต้นด้วยเทมเพลต…',
  'homeHero.startBlankProject': 'เริ่มโปรเจกต์เปล่า',
  'homeHero.templatePicker.label': 'ประเภทงานสร้าง',
  'homeHero.templatePicker.searchPlaceholder': 'ค้นหาเทมเพลต',
  'homeHero.templatePicker.projectTypes': 'ประเภทโปรเจกต์',
  'homeHero.subtitlePrefix': 'ทางเลือกแบบ source-available แทน Claude Design',
  'homeHero.placeholder': 'อธิบายสิ่งที่คุณต้องการสร้าง…',
  'homeHero.placeholderActive': 'แก้ไขตัวอย่างคำค้นหรือเขียนของคุณเอง…',
  'homeHero.carousel.hint': 'แนบไฟล์ เชื่อมต่อดีไซน์ซิสเต็ม หรืออธิบายสิ่งที่คุณอยากสร้าง',
  'homeHero.carousel.onePageBrief': 'ร่างบรีฟโปรเจกต์แบบหน้าเดียว',
  'homeHero.carousel.notesToDeck': 'เปลี่ยนโน้ตของฉันเป็นงานนำเสนอ',
  'homeHero.carousel.signupFlow': 'ออกแบบโครงร่างขั้นตอนการสมัคร',
  'homeHero.carousel.improveBrief': 'ปรับปรุงบรีฟโปรเจกต์ที่มีอยู่',
  'homeHero.carousel.loadingAnimation': 'สร้างแอนิเมชันตอนโหลด',
  'homeHero.carousel.teamUpdateSlides': 'ออกแบบสไลด์สำหรับอัปเดตทีม',
  'homeHero.carousel.ordersDashboard': 'สร้างต้นแบบแดชบอร์ดติดตามคำสั่งซื้อ',
  'homeHero.carousel.productDetail': 'จัดเลย์เอาต์หน้ารายละเอียดสินค้า',
  'homeHero.carousel.caseStudy': 'ร่างโครงกรณีศึกษา',
  'homeHero.carousel.landingIntro': 'ออกแบบบทเกริ่นนำสั้น ๆ สำหรับแลนดิงเพจ',
  'homeHero.carousel.pitchDeck': 'ทำพิตช์เด็คสำหรับสินค้าใหม่',
  'homeHero.carousel.appIdea': 'อธิบายไอเดียแอป',
  'homeHero.carousel.landingLayout': 'ร่างเลย์เอาต์แลนดิงเพจ',
  'homeHero.skills': 'Skills',
  'homeHero.addMenu': 'เพิ่มบริบท',
  'homeHero.addPlugin': 'เพิ่มปลั๊กอิน',
  'homeHero.addConnectors': 'เพิ่มตัวเชื่อมต่อ',
  'homeHero.addMcp': 'เพิ่มเซิร์ฟเวอร์ MCP',
  'homeHero.noPlugins': 'ไม่มีปลั๊กอินที่ติดตั้ง',
  'homeHero.noMcp': 'ไม่มีเซิร์ฟเวอร์ MCP',
  'homeHero.noConnectors': 'ไม่มีตัวเชื่อมต่อที่เชื่อมต่ออยู่',
  'homeHero.applying': 'กำลังปรับใช้…',
  'homeHero.pluginTitle': 'ปลั๊กอิน: {title}',
  'homeHero.pluginPrefix': 'ปลั๊กอิน: {title}',
  'homeHero.skillPrefix': 'Skill: {title}',
  'homeHero.removePlugin': 'ลบปลั๊กอิน',
  'homeHero.removePluginAria': 'ลบปลั๊กอิน {title}',
  'homeHero.clearActivePlugin': 'ล้างปลั๊กอินที่ใช้งานอยู่',
  'homeHero.clearActiveSkill': 'ล้าง skill ที่ใช้งานอยู่',
  'homeHero.contextItemsResolved': 'แก้ไขรายการบริบทแล้ว {n} รายการ',
  'homeHero.attachmentsScrollPrev': 'เลื่อนไฟล์แนบไปทางซ้าย',
  'homeHero.attachmentsScrollNext': 'เลื่อนไฟล์แนบไปทางขวา',
  'homeHero.removeFile': 'ลบไฟล์',
  'homeHero.contextSearchResults': 'ผลการค้นหาบริบท',
  'homeHero.contextSurfaces': 'พื้นผิวบริบท',
  'homeHero.loadingContext': 'กำลังโหลดบริบท…',
  'homeHero.noResults': 'ไม่มีผลลัพธ์สำหรับ "{query}"',
  'homeHero.searchPrompt': 'ค้นหาไฟล์ ปลั๊กอิน skills, MCP server และคอนเนกเตอร์',
  'homeHero.details': 'รายละเอียด',
  'homeHero.toRun': 'เพื่อเรียกใช้',
  'homeHero.forNewLine': 'เพื่อขึ้นบรรทัดใหม่',
  'homeHero.run': 'เรียกใช้',
  'homeHero.typeSomethingToRun': 'พิมพ์บางอย่างเพื่อเรียกใช้',
  'homeHero.promptExamples': 'ตัวอย่าง',
  'homeHero.footer.designSystem': 'สไตล์',
  'homeHero.footer.autoDesignSystem': 'อัตโนมัติ',
  'homeHero.footer.autoDesignSystemSummary': 'จับคู่ระบบออกแบบและสไตล์ภาพที่เหมาะกับพรอมป์ปัจจุบันโดยอัตโนมัติ',
  'homeHero.footer.ratio': 'สัดส่วน',
  'homeHero.footer.duration': 'ระยะเวลา',
  'homeHero.footer.resolution': 'ความละเอียด',
  'homeHero.footer.speakerNotes': 'บันทึก',
  'homeHero.footer.noSpeakerNotes': 'ไม่มีโน้ต',
  'homeHero.footer.availableCount': 'พร้อมใช้งาน {n} รายการ',
  'homeHero.footer.noMatches': 'ไม่พบรายการที่ตรงกัน',
  'homeHero.moreShortcuts': 'เพิ่มเติม',
  'homeHero.railAria': 'เลือกหมวดหมู่โปรเจกต์หรือทางลัดเริ่มต้น',
  'homeHero.subTypeAria': 'เลือกประเภทย่อย',
  'homeHero.subTypeMore': 'เพิ่มเติม',
  'homeHero.confirmReplaceTitle': 'แทนที่ prompt ปัจจุบันหรือไม่?',
  'homeHero.confirmReplaceBody': 'การใช้ {title} จะแทนที่ข้อความที่อยู่ในช่องป้อนข้อมูลในขณะนี้',
  'homeHero.confirmReplace': 'แทนที่',
  'homeHero.chip.prototype': 'ต้นแบบ',
  'homeHero.chip.webClone': 'โคลนเว็บไซต์',
  'homeHero.chip.liveArtifact': 'Artifact แบบเรียลไทม์',
  'homeHero.chip.deck': 'ชุดสไลด์',
  'homeHero.chip.image': 'รูปภาพ',
  'homeHero.chip.video': 'วิดีโอ',
  "homeHero.chip.motionDesign": "โมชันดีไซน์",
  "homeHero.chip.motionDesignDesc": "กราฟิกเคลื่อนไหว งานศิลปะ และวิดีโอสินค้า",
  "homeHero.chip.motionDesignHint": "อธิบายแนวคิด รูปแบบภาพ และความยาวเพื่อสร้างวิดีโอแอนิเมชัน",
  'homeHero.chip.hyperframes': 'HyperFrames',
  'homeHero.chip.webgl': 'WebGL',
  'homeHero.chip.webglDesc': 'เชดเดอร์ 3D และภาพ GPU เชิงกำเนิด',
  'homeHero.chip.worker': 'ตัววิชวลไลซ์ Worker',
  'homeHero.chip.workerDesc': 'ซิมนอกเธรด อนุภาค และการแสดงผลข้อมูล',
  'homeHero.chip.audio': 'เสียง',
  'homeHero.chip.createBrandKit': 'สร้างชุดแบรนด์',
  'homeHero.chip.createPlugin': 'สร้างปลั๊กอิน',
  'homeHero.chip.figma': 'จาก Figma',
  'homeHero.chip.folder': 'จากโฟลเดอร์',
  'homeHero.chip.template': 'จากเทมเพลต',
  'homeHero.chip.liveArtifactHint': 'สร้าง artifact แบบ HTML/CSS/JS ที่โต้ตอบได้ ซึ่งคุณสามารถดูตัวอย่างแบบสดได้',
  'homeHero.chip.hyperframesHint': 'สร้างภาพเคลื่อนไหวแบบ HTML: คำบรรยาย ภาพที่ตอบสนองต่อเสียง และการเปลี่ยนฉาก',
  'homeHero.chip.createBrandKitHint': 'ดึงชุดแบรนด์จากเว็บไซต์ แล้วนำไปใช้ในแชทใดก็ได้',
  'homeHero.chip.createPluginHint': 'สร้างปลั๊กอิน OpenDesign ที่นำกลับมาใช้ใหม่ได้ และเพิ่มลงในปลั๊กอินของฉัน',
  'homeHero.chip.figmaHint': 'ย้าย frame ของ Figma เข้าสู่ design system ที่ใช้งานอยู่',
  'homeHero.chip.folderHint': 'นำเข้าโฟลเดอร์ภายในเครื่องที่มีอยู่และแก้ไขต่อ',
  'homeHero.chip.templateHint': 'เริ่มจากเทมเพลตที่มาพร้อมกัน',
  'homeHero.chip.wireframe': 'ไวร์เฟรม',
  'homeHero.chip.mobile': 'แอปมือถือ',
  'homeHero.chip.document': 'เอกสาร',
  'homeHero.chip.prototypeDesc': 'ม็อกอัปแอปแบบโต้ตอบได้',
  'homeHero.chip.webCloneDesc': 'จำลองเว็บไซต์โดยยึดตามซอร์ส',
  'homeHero.chip.wireframeDesc': 'หน้าจอและโฟลว์แบบคร่าว ๆ',
  'homeHero.chip.mobileDesc': 'หน้าจอ iOS และ Android',
  'homeHero.chip.deckDesc': 'งานนำเสนอและพิตช์เด็ค',
  'homeHero.chip.documentDesc': 'เรซูเม่ รายงาน และ PDF',
  'homeHero.chip.imageDesc': 'โปสเตอร์ กราฟิก และงานศิลป์',
  'homeHero.chip.videoDesc': 'คลิป รีล และวิดีโอโปรโมต',
  'homeHero.chip.audioDesc': 'เสียงพากย์ เพลง และเอฟเฟกต์เสียง',
  'homeHero.chip.hyperframesDesc': 'โมชันกราฟิกและลูป',
  'homeHero.chip.liveArtifactDesc': 'แดชบอร์ดสดที่ขับเคลื่อนด้วยข้อมูล',
  'homeHero.chip.createBrandKitDesc': 'ดึงดีไซน์ซิสเต็มของแบรนด์',
  'homeHero.chip.prototypeNext': 'เปิดแชทที่สร้างต้นแบบเว็บความละเอียดสูงที่คลิกได้ และปรับแต่งได้ทีละรอบ',
  'homeHero.chip.webCloneNext': 'เปิดแชทที่ขอ URL เป้าหมาย สร้างเว็บไซต์ขึ้นใหม่ และตรวจสอบผลการโคลน',
  'homeHero.chip.wireframeNext': 'เปิดแชทที่ร่างหน้าจอและโฟลว์แบบคร่าว ๆ เพื่อตรวจสอบโครงสร้างก่อน',
  'homeHero.chip.mobileNext': 'เปิดแชทที่จัดวางหน้าจอมือถือสำหรับ iOS และ Android',
  'homeHero.chip.deckNext': 'เปิดแชทที่สร้างชุดสไลด์ซึ่งคุณนำเสนอและส่งออกได้',
  'homeHero.chip.documentNext': 'เปิดแชทที่ร่างเอกสารอย่างประณีต — เรซูเม่ รายงาน หรือ PDF',
  'homeHero.chip.imageNext': 'เปิดแชทที่สร้างภาพตามแบรนด์ซึ่งคุณปรับแก้ซ้ำได้',
  'homeHero.chip.videoNext': 'เปิดแชทที่ผลิตวิดีโอสั้นซึ่งคุณปรับแต่งต่อได้',
  'homeHero.chip.audioNext': 'เปิดแชทที่สร้างเสียงพากย์ เพลง หรือเอฟเฟกต์เสียง',
  'homeHero.chip.webClonePromptSeed': 'ลิงก์เว็บไซต์ที่ต้องการโคลน: ',
  'homeWorkingDir.trigger': 'เลือกไดเรกทอรีทำงาน',
  'homeWorkingDir.triggerShort': 'ไดเรกทอรีทำงาน',
  'homeWorkingDir.pick': 'เลือกโฟลเดอร์',
  'homeWorkingDir.replace': 'เปลี่ยนไดเรกทอรีทำงาน',
  'homeWorkingDir.recent': 'โฟลเดอร์ล่าสุด',
  'homeWorkingDir.clear': 'นำไดเรกทอรีทำงานออก',
  'homeWorkingDir.hint': 'ให้เอเจนต์อ่านโฟลเดอร์ในเครื่องนี้ได้ (ไม่นำเข้าสู่ Design Files)',
  'homeWorkingDir.missing': 'โฟลเดอร์ทำงานนี้ไม่มีอยู่แล้ว — โปรดเลือกโฟลเดอร์อื่น',
  'homeWorkingDir.applyFailed': 'ไม่สามารถตั้งค่าไดเรกทอรีทำงานได้ — โฟลเดอร์อาจไม่มีอยู่แล้ว',
  'workingDirPicker.title': 'โฟลเดอร์',
  'workingDirPicker.homeTitle': 'บันทึกในที่จัดเก็บในเครื่อง — คลิกเพื่อเลือกโฟลเดอร์',
  'workingDirPicker.processing': 'กำลังประมวลผล…',
  'workingDirPicker.select': 'ที่จัดเก็บในเครื่อง',
  'workingDirPicker.clearAria': 'ล้างไดเรกทอรีทำงาน',
  'workingDirPicker.replaceFailed': 'ไม่สามารถแทนที่ไดเรกทอรีทำงานได้',
  'workingDirPicker.unavailable': 'ตัวเลือกโฟลเดอร์ไม่พร้อมใช้งานในบิลด์นี้ เรียกใช้แอปเดสก์ท็อปเพื่อเลือกโฟลเดอร์',
  'workingDirPicker.openUnavailable': 'เปิดโปรเจกต์นี้ในแอปเดสก์ท็อปเพื่อแสดงโฟลเดอร์',
  'workingDirPicker.openFailed': 'ไม่สามารถแสดงโฟลเดอร์นี้ได้',
  'workingDirPicker.showInFileManager': 'แสดงในตัวจัดการไฟล์',
  'workingDirPicker.replace': 'เลือกโฟลเดอร์…',
  'workingDirPicker.recent': 'ไดเรกทอรีล่าสุด',
  'workingDirPicker.defaultLabel': 'พื้นที่จัดเก็บในเครื่อง',
  'handoff.toTarget': 'ส่งต่อไปยัง {target}',
  'handoff.openInTarget': 'เปิดใน {target}',
  'handoff.openAction': 'เปิด',
  'handoff.menuTitle': 'เปิดในเอดิเตอร์ใด?',
  'handoff.action': 'ส่งต่อ',
  'handoff.fallbackTitle': 'ไม่พบเอดิเตอร์บน $PATH - จะเปิดใน {target}',
  'handoff.chooseTargetAria': 'เลือกเป้าหมายการส่งต่อ',
  'handoff.optionsAria': 'ตัวเลือกการส่งต่อ',
  'handoff.editorSection': 'เปิดด้วยเอดิเตอร์',
  'handoff.cliSection': 'คัดลอกสำหรับ CLI',
  'handoff.clickOpen': 'คลิกเพื่อเปิด',
  'handoff.framework': 'เฟรมเวิร์กโค้ด',
  'handoff.framework.react': 'React',
  'handoff.framework.vue': 'Vue.js',
  'handoff.framework.svelte': 'Svelte',
  'handoff.framework.solid': 'SolidJS',
  'handoff.framework.next': 'Next.js',
  'handoff.framework.vanilla': 'JS',
  'handoff.frameworkPrompt.react': 'React',
  'handoff.frameworkPrompt.vue': 'Vue.js',
  'handoff.frameworkPrompt.svelte': 'Svelte',
  'handoff.frameworkPrompt.solid': 'SolidJS',
  'handoff.frameworkPrompt.next': 'Next.js / React',
  'handoff.frameworkPrompt.vanilla': 'vanilla JavaScript, HTML และ CSS',
  'handoff.amrWebsite': 'เปิดเว็บไซต์ OpenDesign Cloud',
  'handoff.copyPrompt': 'คัดลอกพรอมป์ต์',
  'handoff.copyPromptForTarget': 'คัดลอกพรอมป์ต์สำหรับ {target}',
  'handoff.copied': 'คัดลอกแล้ว',
  'handoff.projectPathUnavailable': 'กำลังโหลดพาธของโปรเจกต์ โปรดลองอีกครั้งในอีกสักครู่',
  'handoff.copyFailed': 'การเขียนลงคลิปบอร์ดถูกบล็อก โปรดลองอีกครั้งในอีกสักครู่',
  'handoff.promptIntro': 'ดำเนินการต่อจากโฟลเดอร์โปรเจกต์ OpenDesign ในเครื่องนี้:',
  'handoff.promptTarget': 'เป้าหมาย',
  'handoff.promptCli': 'CLI',
  'handoff.promptStepsLead': 'คุณกำลังเข้ามาดำเนินการต่อใน {cli} กรุณา:',
  'handoff.promptReadFiles': 'เข้าหรืออ่านไดเรกทอรีนี้ก่อน โดยให้ความสำคัญกับ DESIGN.md, README, ไฟล์ HTML/CSS/JS ที่มีอยู่, แอสเซต และ package.json หากมี',
  'handoff.promptKeepDesign': 'รักษาการออกแบบภาพ เลย์เอาต์ การโต้ตอบ และแอสเซตในปัจจุบันไว้ อย่าหยุดอยู่แค่แผน',
  'handoff.promptProduceCode': 'สร้างหรือแก้ไขโค้ด {framework} ที่รันได้จริง หากโปรเจกต์มีสแตกที่ชัดเจนกว่าอยู่แล้ว ให้ชี้ให้เห็นความขัดแย้งและทำให้ผลลัพธ์ยังรันได้',
  'handoff.promptVerify': 'จบด้วยการบอกคำสั่งสำหรับรัน พรีวิว และตรวจสอบให้ฉัน',
  'handoff.promptCommandHint': 'หากต้องการเริ่มจากไดเรกทอรีของโปรเจกต์ ให้ใช้:',
  'handoff.promptProject': 'โปรเจกต์',
  'handoff.promptProjectId': 'Project ID',
  'handoff.notInstalled': 'ยังไม่ได้ติดตั้ง',
  'handoff.notDetectedTitle': '{target} - ไม่พบบน $PATH',
  'designSystemPicker.select': 'เลือกดีไซน์ซิสเต็ม',
  'designSystemPicker.loading': 'กำลังโหลด design systems…',
  'designSystemPicker.searchPlaceholder': 'ค้นหาดีไซน์ซิสเต็ม (ชื่อ / หมวดหมู่ / สรุป)',
  'designSystemPicker.searchCompactPlaceholder': 'ค้นหาดีไซน์ซิสเต็ม',
  'designSystemPicker.noneTitle': 'ไม่ใช้ดีไซน์ซิสเต็ม',
  'designSystemPicker.noneSummary': 'ให้โมเดลเลือกได้อย่างอิสระ',
  'designSystemPicker.empty': 'ไม่พบดีไซน์ซิสเต็มที่ตรงกัน',
  'designSystemPicker.openPreview': 'เปิดพรีวิว',
  'designSystemPicker.loadingPreview': 'กำลังโหลดตัวอย่าง…',
  'designSystemPicker.noPreview': 'ไม่มีหน้าพรีวิว เปิด Design Systems เพื่อดูพรีวิวแบบเต็ม',
  'designSystemPicker.previewHint': 'ชี้เมาส์ที่ดีไซน์ซิสเต็มเพื่อพรีวิว',
  'designSystemPicker.fullscreenAria': 'พรีวิวเต็มจอของ {title}',
  'designSystemPicker.closeFullscreen': 'ปิดพรีวิวเต็มจอ',
  'designSystemPicker.closeEsc': 'ปิด (Esc)',
  'designSystemPicker.previewFrameTitle': 'พรีวิวของ {title}',
  'designSystemPicker.fullscreenFrameTitle': 'พรีวิวเต็มจอของ {title}',
  'recentProjects.title': 'โปรเจกต์ล่าสุด',
  'recentProjects.viewAll': 'ดูทั้งหมด',
  'recentProjects.empty': 'ยังไม่มีโปรเจกต์ — พิมพ์ prompt เพื่อเริ่มต้น',
  'recentProjects.ownerAll': 'All',
  'recentProjects.ownerMine': 'Mine',
  'recentProjects.ownerOthers': 'Others',
  'recentProjects.kindAll': 'Any type',
  'recentProjects.kindPrototype': 'Prototype',
  'recentProjects.kindSlides': 'Slides',
  'recentProjects.kindDocument': 'Document',
  'recentProjects.kindImage': 'รูปภาพ',
  'recentProjects.kindMedia': 'Media',
  'recentProjects.kindOther': 'Other',
  'recentProjects.inviteTeammates': 'Invite teammates',
  'recentProjects.multiSelect': 'Multi-select',
  'recentProjects.sortAria': 'Sort projects',
  'recentProjects.sortNewest': 'Newest first',
  'recentProjects.sortOldest': 'Oldest first',
  'recentProjects.sortName': 'Name',
  'recentProjects.collectionRecent': 'Recently viewed',
  'recentProjects.collectionPersonalProjects': 'โปรเจกต์ส่วนตัว',
  'recentProjects.collectionTeamProjects': 'โปรเจกต์ทีม',
  'recentProjects.viewList': 'List view',
  'recentProjects.sharedBadge': 'Shared',
  'recentProjects.sharedProjectFallbackName': 'Shared project',
  'recentProjects.creatorLine': 'Created by {name}',
  'recentProjects.selfCreator': 'Me',
  'recentProjects.teamMemberCreator': 'Team member',
  'recentProjects.ownOnlyMutation': 'Only projects you created can be changed or deleted.',
  'recentProjects.shareInProgress': 'Sharing…',
  'recentProjects.duplicateInProgress': 'กำลังทำสำเนา…',
  'recentProjects.sharedInTeam': 'In team space',
  'recentProjects.moveToTeam': 'Move to team space',
  'recentProjects.moveToTeamDescPre': 'Once moved to the team space, ',
  'recentProjects.moveToTeamDescStrong': 'all team members can view and comment',
  'recentProjects.moveToTeamDescPost': ', and only the creator can edit. You can find it under "Team projects".',
  'recentProjects.moveToPersonalDescPre': 'Once moved out of the team space, it returns to a personal project, ',
  'recentProjects.moveToPersonalDescStrong': 'only you can view and edit it',
  'recentProjects.moveToPersonalDescPost': '.',
  'recentProjects.moveDontRemind': 'Don\'t remind me again',
  'recentProjects.confirmMoveToTeam': 'Confirm move',
  'recentProjects.confirmMoveToPersonal': 'Confirm move',
  'recentProjects.unshareInProgress': 'Moving out…',
  'recentProjects.moveOutOfTeam': 'Move out of team space',
  'recentProjects.unshareFailed': 'Could not move out of team space. Try again.',
  'recentProjects.shareFailed': 'Could not move to team space. Try again.',
  'recentProjects.shareOwnerConflict': 'Could not move to team space: another member already shares this project with the team.',
  'recentProjects.clearFilters': 'ล้างตัวกรอง',
  'pluginsHome.title': 'คอมมูนิตี้',
  'pluginsHome.subtitle': 'เวิร์กโฟลว์ OpenDesign พร้อมใช้งานที่มาพร้อมกับรันไทม์นี้ เลือกหนึ่งรายการเพื่อโหลดพรอมป์ต์เริ่มต้น หรือเรียกดูรีจิสตรีเพื่อดูเพิ่มเติม',
  'pluginsHome.browseRegistry': 'เรียกดู registry',
  'pluginsHome.count': '{filtered} จาก {total}',
  'pluginsHome.loadingCatalog': 'กำลังโหลดแคตตาล็อก…',
  'pluginsHome.emptyCatalog': 'แคตตาล็อกว่างเปล่า ปลั๊กอินที่มาพร้อมกับ OpenDesign ควรปรากฏที่นี่โดยอัตโนมัติ — ลองรีสตาร์ท daemon หากยังเกิดปัญหานี้อยู่',
  'pluginsHome.emptyFiltered': 'ไม่มีปลั๊กอินที่ตรงกับตัวกรองปัจจุบัน',
  'pluginsHome.clearFilters': 'ล้างตัวกรอง',
  'pluginsHome.modeAria': 'โหมดปลั๊กอิน',
  'pluginsHome.featured': 'บันทึกแล้ว',
  'pluginsHome.totalInCatalog': '{n} รายการในแคตตาล็อก',
  'pluginsHome.categoryFilterAria': 'ตัวกรองหมวดหมู่',
  'pluginsHome.subcategoryFilterAria': 'ตัวกรองหมวดหมู่ย่อย {label}',
  'pluginsHome.allCategory': '{label} ทั้งหมด',
  'pluginsHome.searchPlaceholder': 'ค้นหาปลั๊กอิน…',
  'pluginsHome.searchAria': 'ค้นหาปลั๊กอิน',
  'pluginsHome.clearSearch': 'ล้างการค้นหา',
  'pluginsHome.sortAria': 'ลำดับการจัดเรียง',
  'pluginsHome.sortHot': 'มาแรง',
  'pluginsHome.sortNewest': 'ใหม่ล่าสุด',
  'pluginsHome.facet.import': 'นำเข้า',
  'pluginsHome.facet.create': 'สร้าง',
  'pluginsHome.facet.export': 'ส่งออก',
  'pluginsHome.facet.share': 'แชร์',
  'pluginsHome.facet.deploy': 'ดีพลอย',
  'pluginsHome.facet.refine': 'ปรับแต่ง',
  'pluginsHome.facet.extend': 'ขยายเพิ่ม',
  'pluginsHome.facet.figma': 'Figma',
  'pluginsHome.facet.github': 'GitHub',
  'pluginsHome.facet.codeFolder': 'โค้ด / โฟลเดอร์',
  'pluginsHome.facet.url': 'URL',
  'pluginsHome.facet.screenshot': 'ภาพหน้าจอ',
  'pluginsHome.facet.pdf': 'PDF',
  'pluginsHome.facet.pptx': 'PPTX',
  'pluginsHome.facet.framer': 'Framer',
  'pluginsHome.facet.webflow': 'Webflow',
  'pluginsHome.facet.slides': 'สไลด์',
  'pluginsHome.facet.publicLink': 'ลิงก์สาธารณะ',
  'pluginsHome.facet.githubPr': 'GitHub PR',
  'pluginsHome.facet.githubGist': 'GitHub Gist',
  'pluginsHome.subfacet.business-dashboards': 'แดชบอร์ด',
  'pluginsHome.subfacet.app-prototypes': 'แอป',
  'pluginsHome.subfacet.landing-marketing': 'แลนดิ้ง / การตลาด',
  'pluginsHome.subfacet.developer-tools': 'เครื่องมือนักพัฒนา',
  'pluginsHome.subfacet.docs-reports': 'เอกสาร / รายงาน',
  'pluginsHome.subfacet.brand-design': 'แบรนด์ / ดีไซน์',
  'pluginsHome.subfacet.pitch-business': 'พิตช์ / ธุรกิจ',
  'pluginsHome.subfacet.course-training': 'คอร์ส / อบรม',
  'pluginsHome.subfacet.reports-briefings': 'รายงาน / สรุปย่อ',
  'pluginsHome.subfacet.product-sales': 'ผลิตภัณฑ์ / ฝ่ายขาย',
  'pluginsHome.subfacet.engineering-talks': 'ทอล์กเทคนิค',
  'pluginsHome.subfacet.creative-decks': 'เด็คครีเอทีฟ',
  'pluginsHome.subfacet.ui-product-mockups': 'UI / ม็อกอัป',
  'pluginsHome.subfacet.brand-visuals': 'แบรนด์ / โลโก้',
  'pluginsHome.subfacet.storyboards-motion-refs': 'สตอรีบอร์ด',
  'pluginsHome.subfacet.social-content': 'โซเชียล / คอนเทนต์',
  'pluginsHome.subfacet.avatar-portrait': 'อวตาร / พอร์ตเทรต',
  'pluginsHome.subfacet.illustration-style': 'ภาพประกอบ / สไตล์',
  'pluginsHome.subfacet.motion-effects': 'โมชัน / เอฟเฟกต์',
  'pluginsHome.subfacet.social-short-form': 'โซเชียล / วิดีโอสั้น',
  'pluginsHome.subfacet.marketing-product': 'การตลาด / ผลิตภัณฑ์',
  'pluginsHome.subfacet.data-explainers': 'ข้อมูล / อธิบาย',
  'pluginsHome.subfacet.cinematic-story': 'ซีเนแมติก / เรื่องราว',
  'pluginsHome.commercialCategory.student-coursework': 'Student coursework',
  'pluginsHome.commercialCategory.corporate-strategy': 'Corporate strategy',
  'pluginsHome.commercialCategory.professional-training': 'Professional training',
  'pluginsHome.commercialCategory.b2b-sales': 'B2B sales',
  'pluginsHome.commercialCategory.academic-research': 'Academic research',
  'pluginsHome.commercialCategory.marketing-gtm': 'Marketing & GTM',
  'pluginsHome.commercialCategory.data-finance': 'Data & finance',
  'pluginsHome.commercialCategory.fundraising-pitch': 'Fundraising pitch',
  'pluginsHome.commercialCategory.government-policy': 'Government & policy',
  'pluginsHome.commercialCategory.product-management': 'Product management',
  'pluginsHome.commercialCategory.consulting': 'Consulting',
  'pluginsHome.commercialCategory.career': 'Career',
  'pluginsHome.commercialCategory.ai-literacy': 'AI literacy',
  'pluginsHome.commercialCategory.life': 'Life & story',
  'pluginsHome.commercialCategory.design-craft': 'Design craft',
  'pluginsView.lede': 'เรียกดูเวิร์กโฟลว์ที่ติดตั้งไว้ ค้นพบรายการใน registry จัดการแหล่งที่มา และเตรียมปลั๊กอินสำหรับการแจกจ่ายให้ทีม',
  'pluginsView.importPlugin': 'นำเข้าปลั๊กอิน',
  'pluginsView.agentContext': 'บริบทของ Agent',
  'pluginsView.summaryAria': 'สรุปปลั๊กอิน',
  'pluginsView.areasAria': 'พื้นที่ของปลั๊กอิน',
  'pluginsView.loading': 'กำลังโหลดปลั๊กอิน…',
  'pluginsView.tab.installed': 'ติดตั้งแล้ว',
  'pluginsView.tab.available': 'พร้อมใช้งาน',
  'pluginsView.tab.sources': 'แหล่งที่มา',
  'pluginsView.tab.team': 'ทีม',
  'pluginsView.tabHint.installed': 'ปลั๊กอินของคุณ',
  'pluginsView.tabHint.available': 'จากแหล่งที่มา',
  'pluginsView.tabHint.sources': 'แคตตาล็อก',
  'pluginsView.tabHint.team': 'องค์กร',
  'pluginsView.installedTitle': 'ปลั๊กอินที่ติดตั้งแล้ว',
  'pluginsView.installedSubtitle': 'ปลั๊กอินที่คุณนำเข้าหรือติดตั้งจากแหล่งที่มาในมาร์เก็ตเพลส',
  'pluginsView.installedEmpty': 'ยังไม่มีปลั๊กอินของผู้ใช้ที่ติดตั้งไว้ ใช้ สร้าง / นำเข้า หรือติดตั้งรายการที่พร้อมใช้งาน',
  'pluginsView.availableTitle': 'พร้อมใช้งานจากแหล่งที่มา',
  'pluginsView.availableSubtitle': 'รายการในแคตตาล็อกที่ค้นพบจากมาร์เก็ตเพลสที่กำหนดค่าไว้',
  'pluginsView.availableFiltersAria': 'ตัวกรองปลั๊กอินที่พร้อมใช้งาน',
  'pluginsView.searchAvailableAria': 'ค้นหาปลั๊กอินที่พร้อมใช้งาน',
  'pluginsView.searchAvailablePlaceholder': 'ค้นหาปลั๊กอินที่พร้อมใช้งาน',
  'pluginsView.clearAvailableSearch': 'ล้างการค้นหาปลั๊กอินที่พร้อมใช้งาน',
  'pluginsView.source': 'แหล่งที่มา',
  'pluginsView.availableEmptyInstalled': 'ยังไม่มีรายการที่พร้อมใช้งาน รายการในแคตตาล็อกที่ติดตั้งแล้วจะถูกนำออกจากรายการพร้อมใช้งาน ถอนการติดตั้งรายการหนึ่งเพื่อให้กลับมาพร้อมใช้งานอีกครั้ง',
  'pluginsView.availableEmptyFiltered': 'ไม่มีรายการที่พร้อมใช้งานตรงกับตัวกรองของคุณ',
  'pluginsView.availableEmptyNoSources': 'ยังไม่มีรายการที่พร้อมใช้งาน เพิ่มแหล่งที่มาในแท็บแหล่งที่มา',
  'pluginsView.installing': 'กำลังติดตั้ง…',
  'pluginsView.installWaiting': 'กำลังรอ…',
  'pluginsView.installQueuedHint': 'กำลังติดตั้งปลั๊กอินอื่นอยู่ การติดตั้งจะทำทีละรายการ — ปุ่มนี้จะใช้ได้เมื่อรายการนั้นเสร็จ',
  'pluginsView.install': 'ติดตั้ง',
  'pluginsView.sourcesTitle': 'แหล่งที่มาของ registry',
  'pluginsView.sourcesSubtitle': 'แค็ตตาล็อก Marketplace ที่ป้อนรายการ plugin ที่พร้อมใช้งาน',
  'pluginsView.sourceUrl': 'Source URL',
  'pluginsView.defaultTrust': 'ความเชื่อถือเริ่มต้น',
  'pluginsView.trust.restricted': 'จำกัด',
  'pluginsView.trust.trusted': 'เชื่อถือได้',
  'pluginsView.trust.official': 'ทางการ',
  'pluginsView.adding': 'กำลังเพิ่ม…',
  'pluginsView.addSource': 'เพิ่มแหล่งที่มา',
  'pluginsView.sourcesEmpty': 'ยังไม่ได้กำหนดค่าแหล่งที่มาของ registry',
  'pluginsView.pluginsCount': '{n} ปลั๊กอิน',
  'pluginsView.catalogVersion': 'แค็ตตาล็อก v{version}',
  'pluginsView.trustFor': 'ความเชื่อถือสำหรับ {name}',
  'pluginsView.refreshing': 'กำลังรีเฟรช…',
  'pluginsView.removing': 'กำลังลบ…',
  "pluginsView.marketplaceTitle": "Extensions",
  "pluginsView.marketplaceBody": "Install expert suites, skills, and connectors to add new work capabilities to OpenDesign.",
  "pluginsView.marketplaceModeAria": "Marketplace mode",
  "pluginsView.marketplaceSourceFiltersAria": "Marketplace source filters",
  "pluginsView.scope.official": "OpenDesign official",
  "pluginsView.scope.team": "Team",
  "pluginsView.scope.personal": "Personal",
  "pluginsView.kind.plugins": "Expert suites",
  "pluginsView.kind.skills": "Skills",
  "pluginsView.searchPlugins": "Search expert suites",
  "pluginsView.searchSkills": "Search skills",
  "pluginsView.modeNote.plugins": "Expert suites are role- and industry-focused toolkits. Type @ or slash in the composer to use them.",
  "pluginsView.modeNote.skills": "Skills are reusable task workflows and review rules. Use them directly or compose them into expert suites.",
  "pluginsView.create": "Add",
  "pluginsView.createTitle": "Add {kind}",
  "pluginsView.createWithAgent": "Describe it and let the agent build it",
  "pluginsView.createWithAgentBody": "Start from a prompt in the home composer instead of importing an existing extension.",
  "pluginsView.createWithAgentAction": "Start from a prompt",
  "pluginsView.createPluginBody": "Import a plugin from GitHub or a local folder, then upload it for team use.",
  "pluginsView.createSkillBody": "Create a reusable task workflow or review rule that can later be reused by plugins.",
  "pluginsView.createClose": "Close add panel",
  "pluginsView.createTypeAria": "Create type",
  "pluginsView.importFromUrl": "Import from link",
  "pluginsView.importUrlBody": "Paste a public link for a {kind}. OpenDesign will fetch the manifest, validate capabilities, and upload it to the team space.",
  "pluginsView.uploadFolder": "Upload local folder",
  "pluginsView.uploadFolderBody": "Choose a local folder containing {manifest}. After validation, it will upload as a team {kind}.",
  "pluginsView.importing": "Importing…",
  "pluginsView.importAndUpload": "Import and upload",
  "pluginsView.uploading": "Uploading…",
  "pluginsView.uploadKind": "Upload {kind}",
  "pluginsView.filesSelected": "{count} files selected",
  "pluginsView.chooseFolder": "Choose folder",
  "pluginsView.emptyNoMatchTitle": "No matching results",
  "pluginsView.emptyNoMatchHint": "Try another keyword.",
  "pluginsView.emptyTeamTitle": "No content shared to the team yet",
  "pluginsView.emptyTeamHint": "Share expert suites or skills from Personal to Team, and they will appear here.",
  "pluginsView.emptyPersonalPluginsTitle": "No personal expert suites yet",
  "pluginsView.emptyPersonalSkillsTitle": "No personal skills yet",
  "pluginsView.emptyPersonalHint": "Install from OpenDesign official, or use Add in the top right to create one.",
  "pluginsView.emptyOfficialPluginsTitle": "No official expert suites available",
  "pluginsView.emptyOfficialSkillsTitle": "No official skills available",
  "pluginsView.emptyOfficialHint": "Check back later, or add a marketplace in plugin sources.",
  "pluginsView.teamSharedBadge": "Shared with team",
  "pluginsView.tryIt": "Try it",
  "pluginsView.categoriesAria": "Categories",
  "pluginsView.statSkills": "{count} skills",
  "pluginsView.statConnectors": "{count} connectors",
  "pluginsView.uninstall": "Uninstall",
  "pluginsView.uninstalling": "Uninstalling…",
  "pluginsView.uninstallConfirm": "Uninstall {title}?",
  "pluginsView.uninstallSuccess": "Uninstalled {title}",
  "pluginsView.uninstallFailed": "Could not uninstall {title}",
  "pluginsView.sharing": "Sharing…",
  "pluginsView.unsharing": "Removing…",
  "pluginsView.shareToTeam": "Share with team",
  "pluginsView.syncToTeam": "ซิงค์กับทีม",
  "pluginsView.unshareFromTeam": "Remove from team",
  "pluginsView.moreActions": "{title} more actions",
  "pluginsView.skillUrlUnsupported": "Skills do not support import from link yet. Use Upload local folder instead.",
  "pluginsView.importPluginSuccess": "Imported and uploaded expert suite",
  "pluginsView.importFailed": "Import failed. Check the link and try again.",
  "pluginsView.uploadPluginSuccess": "Uploaded expert suite",
  "pluginsView.uploadFailed": "Upload failed. Check the folder contents.",
  "pluginsView.importSkillSuccess": "Imported Skill \"{name}\". You can share it with the team from Personal.",
  "pluginsView.shareSuccess": "Shared \"{title}\" with the team. Teammates can now use it.",
  "pluginsView.shareUnavailable": "Could not share \"{title}\" yet. Confirm you are in a team workspace.",
  "pluginsView.shareFailed": "Failed to share \"{title}\". Try again later.",
  "pluginsView.syncSuccess": "ซิงค์เวอร์ชันล่าสุดของ \"{title}\" กับทีมแล้ว",
  "pluginsView.syncUnavailable": "ยังไม่สามารถซิงค์ \"{title}\" ได้ โปรดยืนยันว่าคุณอยู่ในพื้นที่ทำงานของทีม",
  "pluginsView.syncFailed": "ซิงค์ \"{title}\" กับทีมไม่สำเร็จ โปรดลองอีกครั้งภายหลัง",
  "pluginsView.unshareSuccess": "Removed \"{title}\" from team sharing.",
  "pluginsView.unshareUnavailable": "Could not remove \"{title}\" from team sharing. Confirm you have permission.",
  "pluginsView.unshareFailed": "Failed to remove \"{title}\" from team sharing. Try again later.",
  "pluginsView.installSuccess": "Installed \"{title}\"",
  "pluginsView.installFailed": "Failed to install \"{title}\"",
  "pluginsView.skillMissingFile": "No SKILL.md was found in the selected folder.",
  "pluginsView.skillReadFailed": "Could not read SKILL.md. Try again.",
  "pluginsView.skillMissingName": "SKILL.md is missing a name field.",
  "pluginsView.skillEmptyBody": "SKILL.md content is empty.",
  'pluginsView.teamTitle': 'Marketplace ของทีมส่วนตัว',
  'pluginsView.teamBody': 'พื้นที่นี้สงวนไว้สำหรับแค็ตตาล็อกขององค์กรและทีม นโยบายความเชื่อถือส่วนตัว และการควบคุมวงจรชีวิตของ plugin ที่แชร์ร่วมกัน',
  'pluginCard.details': 'รายละเอียด',
  'pluginCard.use': 'ใช้งาน',
  'pluginCard.useWithQuery': 'ใช้งานพร้อมคำค้นหา',
  'pluginCard.applying': 'กำลังปรับใช้…',
  'pluginCard.duplicate': 'Remix',
  'pluginCard.duplicating': 'กำลัง Remix…',
  'pluginCard.duplicateFailed': 'ไม่สามารถ Remix เทมเพลตนี้ได้',
  'pluginCard.saved': 'บันทึกแล้ว',
  'pluginCard.publish': 'เผยแพร่',
  'pluginCard.contribute': 'ร่วมสนับสนุน',
  'pluginCard.starting': 'กำลังเริ่ม…',
  'pluginCard.detailsAria': 'ดูรายละเอียดของ {title}',
  'pluginCard.chooseUseAria': 'เลือกวิธีใช้งาน {title}',
  'pluginCard.useOptionsAria': 'ตัวเลือกการใช้งานสำหรับ {title}',
  'pluginCard.duplicateAria': 'Remix {title} เป็นโปรเจกต์ใหม่',
  'pluginCard.saveAria': 'บันทึก {title}',
  'pluginCard.savedAria': 'บันทึก {title} แล้ว',
  'pluginCard.shareAria': 'แชร์ {title}',
  'pluginCard.publishAria': 'เผยแพร่ {title} เป็น GitHub repository',
  'pluginCard.publishTitle': 'เผยแพร่ plugin เป็น GitHub repository',
  'pluginCard.contributeAria': 'ร่วมสนับสนุน {title} ให้กับ OpenDesign',
  'pluginCard.contributeTitle': 'ร่วมสนับสนุน plugin ให้กับ OpenDesign ด้วย pull request',
  'integrations.kicker': 'การผสานรวม',
  'integrations.lede': 'เชื่อมต่อระบบภายนอก นำเครื่องมือ MCP เข้าสู่ลูปของ Agent และใช้งาน OpenDesign จาก IDE สคริปต์ และระบบอัตโนมัติอื่น ๆ',
  'integrations.agentReady': 'พร้อมสำหรับ Agent',
  'integrations.areasAria': 'พื้นที่การผสานรวม',
  'integrations.tabLabel.mcp': 'MCP',
  'integrations.tabLabel.skills': 'Skills',
  'integrations.tabHint.mcp': 'เครื่องมือภายนอก',
  'integrations.tabHint.connectors': 'บัญชีและ API',
  'integrations.tabHint.useEverywhere': 'CLI, HTTP, MCP',
  'integrations.skillsTitle': 'การผสานรวม Skills',
  'integrations.skillsBody': 'การจัดการการผสานรวมระดับ Skill กำลังถูกย้ายมาจากอีก branch หนึ่ง แท็บนี้สงวนไว้เพื่อให้การตั้งค่า MCP, Connectors และ Skills ในอนาคตอยู่ในเส้นทาง Integration เดียวกัน',
  'mcpClient.title': 'เซิร์ฟเวอร์ MCP ภายนอก',
  'mcpClient.subtitle': 'เครื่องมือจากภายนอกสำหรับ Agent เขียนโค้ดของคุณ',
  'mcpClient.addServer': 'เพิ่มเซิร์ฟเวอร์',
  'mcpClient.emptyTitle': 'ยังไม่ได้กำหนดค่าเซิร์ฟเวอร์ MCP',
  'mcpClient.emptyBody': 'คลิก "Add server" เพื่อเริ่มต้น — เลือกเทมเพลต (Higgsfield OpenClaw, Pollinations, Allyson, Imagician, EdgeOne Pages, GitHub, Filesystem…) หรือตั้งค่าเซิร์ฟเวอร์ stdio / HTTP แบบกำหนดเอง',
  'mcpClient.saveChanges': 'บันทึกการเปลี่ยนแปลง',
  'mcpClient.storedAt': 'จัดเก็บที่',
  'mcpClient.daemonError': 'ไม่สามารถเชื่อมต่อกับ daemon ภายในเครื่องได้ โปรดตรวจสอบว่า OpenDesign กำลังทำงานอยู่ จากนั้นเปิดแผงนี้อีกครั้ง',
  'mcpClient.saveFailed': 'บันทึกไม่สำเร็จ โปรดตรวจสอบว่า daemon กำลังทำงานอยู่ แล้วลองอีกครั้ง',
  'useEverywhere.modalAria': 'ใช้ OpenDesign ได้ทุกที่',
  'useEverywhere.modalTitle': 'ใช้ OpenDesign ได้ทุกที่',
  'useEverywhere.modalSubtitle': 'นำ OpenDesign ไปใช้ใน IDE, Agent หรือสคริปต์ใดก็ได้ — CLI, HTTP, MCP และ Skills ใช้ “Copy guide for an agent” แล้ววางลงใน Claude Code, Codex, Cursor, openclaw หรือ hermes เพื่อตั้งค่าทุกอย่าง',
  'useEverywhere.closeAria': 'ปิดการใช้งานทุกที่',
  'useEverywhere.closeTitle': 'ปิด (Esc)',
  'useEverywhere.tabsAria': 'พื้นผิวการผสานรวม',
  'useEverywhere.footStrong': 'ส่งต่อด้วยคลิกเดียว',
  'useEverywhere.footBody': 'คัดลอกคู่มือ markdown แบบมีโครงสร้างที่ Agent ของคุณนำไปใช้งานได้ทันที — ติดตั้ง ตรวจสอบ และใช้งาน',
  'useEverywhere.configureMcp': 'กำหนดค่าเซิร์ฟเวอร์ MCP',
  'useEverywhere.copyGuide': 'คัดลอกคู่มือสำหรับ Agent',
  'useEverywhere.copy': 'คัดลอก',
  'useEverywhere.copied': 'คัดลอกแล้ว',
  'useEverywhere.copyFailed': 'คัดลอกไม่สำเร็จ',
  'useEverywhere.copySnippetAria': 'คัดลอกสนิปเพ็ต: {label}',
  'useEverywhere.section.overview.tab': 'ภาพรวม',
  'useEverywhere.section.overview.heading': 'OpenDesign ทำงานได้ทุกที่ที่ agent ของคุณทำงาน',
  'useEverywhere.section.overview.intro': 'OpenDesign เป็นมากกว่าหน้าต่าง — มันคือ daemon ที่มีสิทธิ์พิเศษบนเครื่อง (`od`) บวกกับ registry ของ Skills + Design-Systems + Atoms เมื่อมันทำงานอยู่บนเครื่องของคุณ code agent ใดก็ตาม (Claude Code, Codex, Cursor, OpenCode/openclaw, Hermes หรือสคริปต์ของคุณเอง) สามารถสั่งการสร้างงาน ตรวจสอบโปรเจกต์ และผลิต design artifact ผ่านสี่ส่วนติดต่อที่ใช้แทนกันได้',
  'useEverywhere.section.overview.bullet1': 'CLI — `od <command>` สำหรับสคริปต์แบบ headless, CI และการทำงานอัตโนมัติบน shell',
  'useEverywhere.section.overview.bullet2': 'MCP server — เชื่อม OpenDesign ให้เป็นเซิร์ฟเวอร์ Model Context Protocol เพื่อให้ Agent ที่รองรับ MCP สามารถแสดงรายการ skills, รัน scenario และอ่าน artifact ได้',
  'useEverywhere.section.overview.bullet3': 'HTTP API — `http://127.0.0.1:7456/api/*` endpoint แบบ REST + SSE; เป็นส่วนติดต่อเดียวกับที่ web UI ใช้',
  'useEverywhere.section.overview.bullet4': 'Skills — แพ็ก `SKILL.md` แบบ drop-in (รองรับ Claude) ที่ Agent ใดก็ตามซึ่งอยู่ใน PATH ของคุณสามารถเรียกใช้ได้โดยไม่ต้องมี OpenDesign เลย',
  'useEverywhere.section.overview.bullet5': 'Artifact มาตรฐาน — สร้างโปรเจกต์ HTML จริงจาก Skills, ปลั๊กอินเริ่มต้นที่มาพร้อมกัน และตัวอย่างปลั๊กอินจากชุมชนก่อนที่ daemon จะเริ่มทำงาน',
  'useEverywhere.section.overview.snippet1': 'เริ่ม daemon (และ web UI) ในเครื่อง',
  'useEverywhere.section.overview.snippet2': 'ยืนยันว่าเข้าถึงได้',
  'useEverywhere.section.overview.snippet3': 'นำเข้าอาร์ติแฟกต์มาตรฐานก่อนบูต',
  'useEverywhere.section.overview.footer': 'โดยค่าเริ่มต้น daemon จะเขียนไปที่ `./.od/` (เฉพาะโปรเจกต์) ตั้งค่า `OD_DATA_DIR=~/.open-design` เพื่อแชร์ข้อมูลข้ามโปรเจกต์',
  'useEverywhere.section.cli.tab': 'CLI · od',
  'useEverywhere.section.cli.heading': 'ควบคุม OpenDesign จาก shell ใดก็ได้',
  'useEverywhere.section.cli.intro': 'ไบนารี `od` มาพร้อมกับ daemon และเป็นไบนารีเดียวกันกับที่ Claude Code / Codex ใช้เมื่อรันการสร้าง ซับคำสั่งส่วนใหญ่เป็นไคลเอนต์ขนาดเล็กที่ POST ไปยัง daemon ในเครื่อง จึงทำงานเหมือนกันไม่ว่าคุณจะเปิดใช้ผ่าน `pnpm tools-dev` หรือในรูปแบบแอปแพ็กเกจ',
  'useEverywhere.section.cli.bullet1': '`od` (ไม่มี args) — บูต daemon และเปิด web UI',
  'useEverywhere.section.cli.bullet2': '`od media generate ...` — ผลิตข้อมูลไบต์ของรูปภาพ / วิดีโอ / เสียงผ่าน media protocol แบบรวมศูนย์',
  'useEverywhere.section.cli.bullet3': '`od run ...` — เริ่มการรันโปรเจกต์จาก prompt + skill',
  'useEverywhere.section.cli.bullet4': '`od plugin install <source>` / `od plugin apply <id>` — ติดตั้งและปรับใช้ปลั๊กอินจากชุมชน',
  'useEverywhere.section.cli.bullet5': '`od skills list` / `od design-systems list` — ตรวจสอบสิ่งที่มีอยู่ในเครื่อง',
  'useEverywhere.section.cli.bullet6': '`od status` / `od doctor` — ตรวจสอบสถานะของ daemon และตรวจหา agent CLIs ใน PATH ของคุณ',
  'useEverywhere.section.cli.snippet1': 'สร้างรูปภาพ (มอบหมายให้ media provider ที่ตั้งค่าไว้)',
  'useEverywhere.section.cli.snippet2': 'รัน scenario plugin แบบ headless และสตรีมอีเวนต์เป็นบรรทัด JSON',
  'useEverywhere.section.cli.snippet3': 'แสดงรายการสกิลและ design system ที่มีในเครื่อง',
  'useEverywhere.section.cli.snippet4': 'ตรวจสอบอาร์ติแฟกต์ที่ซีดไว้ผ่าน CLI',
  'useEverywhere.section.cli.snippet5': 'ตรวจสอบสภาพแวดล้อม + Agent ที่ตรวจพบ (Claude, Codex, Cursor, …)',
  'useEverywhere.section.cli.footer': 'คำสั่งย่อยทั้งหมดรองรับ `--daemon-url http://127.0.0.1:<port>` เพื่อกำหนดเป้าหมายเป็น daemon ที่กำลังทำงานอยู่ — มีประโยชน์เมื่อรันอินสแตนซ์ที่สองแบบ sandbox สำหรับการทดสอบ',
  'useEverywhere.section.mcp.tab': 'เซิร์ฟเวอร์ MCP',
  'useEverywhere.section.mcp.heading': 'เปิดเผย OpenDesign เป็นเซิร์ฟเวอร์ MCP ให้กับ coding agent ใดก็ได้',
  'useEverywhere.section.mcp.intro': 'OpenDesign มาพร้อมกับเซิร์ฟเวอร์ Model Context Protocol (`od mcp`) ที่ให้ client ใดก็ตามซึ่งรองรับ MCP — Cursor, Claude Code, Antigravity, VS Code Copilot Chat, openclaw, hermes — ค้นพบเครื่องมือของ OpenDesign (แสดงรายการ skills, เรนเดอร์ตัวอย่าง, สร้างมีเดีย, รันปลั๊กอิน) ได้โดยไม่ต้องเรียกผ่าน shell เอง daemon จะเผยแพร่ snippet การติดตั้งที่พร้อมวางผ่าน `GET /api/mcp/install-info` สำหรับ client หลักแต่ละตัว',
  'useEverywhere.section.mcp.bullet1': 'Stdio transport — ไม่ต้องใช้พอร์ตเพิ่ม client จะ spawn `od mcp` โดยตรง',
  'useEverywhere.section.mcp.bullet2': 'ค้นหา URL ของ daemon ที่ทำงานอยู่โดยอัตโนมัติผ่าน IPC status socket ในเครื่องเมื่อเปิดใช้เป็น sidecar',
  'useEverywhere.section.mcp.bullet3': 'ใช้ `--daemon-url http://127.0.0.1:<port>` เป็นตัวสำรองสำหรับการติดตั้งแบบทั่วไป เพื่อให้กระบวนการ MCP พบ daemon ที่ทำงานอยู่เสมอ',
  'useEverywhere.section.mcp.bullet4': 'ตรึง `OD_DATA_DIR` เพื่อให้กระบวนการ MCP ที่ถูกสร้างขึ้นเขียนไปยังตำแหน่งเดียวกันกับที่ daemon ใช้อยู่แล้ว (หลีกเลี่ยง EPERM ในแอปบันเดิลแพ็กเกจของ macOS)',
  'useEverywhere.section.mcp.snippet1': 'การตั้งค่า MCP client แบบทั่วไป (ใช้ได้ใน Cursor, Claude Code, Codex, …)',
  'useEverywhere.section.mcp.snippet2': 'หรือ: ขอสนิปเพ็ตที่ปรับให้เหมาะกับการติดตั้งของคุณจาก daemon',
  'useEverywhere.section.mcp.snippet3': 'ตัวแปร MCP แบบ Live-artifacts (อ่านและรีเฟรช dashboard)',
  'useEverywhere.section.mcp.footer': 'ในแอป OpenDesign ให้เปิด Settings → Integrations เพื่อคัดลอกคำสั่งติดตั้งเฉพาะ client (Cursor, Claude Code, Antigravity, VS Code) แทนการแก้ไข JSON ด้วยมือ',
  'useEverywhere.section.http.tab': 'HTTP API',
  'useEverywhere.section.http.heading': 'REST + SSE surface เดียวกันกับที่ web UI ใช้',
  'useEverywhere.section.http.intro': 'daemon ในเครื่องให้บริการ HTTP API ที่ `http://127.0.0.1:7456` (กำหนดพอร์ตได้) ทุก endpoint ที่ web UI เรียกใช้สามารถใช้กับสคริปต์ของคุณได้เช่นกัน endpoint แบบสตรีมมิง (chat turn, project run) จะส่ง Server-Sent Events พร้อมชนิดตามสัญญาใน `@open-design/contracts`',
  'useEverywhere.section.http.bullet1': '`GET /api/health` — สถานะการทำงานของ daemon',
  'useEverywhere.section.http.bullet2': '`GET /api/skills` และ `GET /api/design-systems` — registry ที่มีให้ใช้งาน',
  'useEverywhere.section.http.bullet3': '`GET /api/projects` และ `POST /api/projects` — แสดงรายการและสร้างโปรเจกต์ (POST จะคืนค่าโปรเจกต์ + บทสนทนาแรก)',
  'useEverywhere.section.http.bullet4': '`GET /api/projects/:id/chat` — สตรีม SSE ของเหตุการณ์ Agent สำหรับบทสนทนา',
  'useEverywhere.section.http.bullet5': '`POST /api/plugins/:id/apply` — ผูกปลั๊กอินที่ติดตั้งไว้และรับ query ตัวอย่างที่เรนเดอร์แล้ว + อินพุต',
  'useEverywhere.section.http.bullet6': '`GET /api/agents` — code-agent CLIs ที่ตรวจพบใน PATH ของคุณ',
  'useEverywhere.section.http.snippet1': 'แสดงรายการสกิลที่ติดตั้งไว้ (agent จะใช้สิ่งเหล่านี้เป็นเทมเพลต)',
  'useEverywhere.section.http.snippet2': 'สร้างโปรเจกต์จากพรอมต์ (โฟลว์ฝั่งเซิร์ฟเวอร์แบบเต็ม)',
  'useEverywhere.section.http.snippet3': 'สตรีมรอบการสนทนาหนึ่งครั้ง (SSE — แต่ละบรรทัดเข้ากันได้กับ JSON-Lines)',
  'useEverywhere.section.http.footer': 'ไทป์ TypeScript ล้วนสำหรับทุก request/response อยู่ใน `@open-design/contracts` — import เข้าสคริปต์ของคุณเพื่อ autocomplete เต็มรูปแบบโดยไม่ต้องตั้งค่า generator',
  'useEverywhere.section.skills.tab': 'สกิลและ headless',
  'useEverywhere.section.skills.heading': 'Skills แบบ drop-in สำหรับ Agent ใดก็ตาม — แม้ไม่ได้รัน OpenDesign อยู่',
  'useEverywhere.section.skills.intro': 'Skill คือไดเรกทอรีที่มี `SKILL.md` ซึ่งรองรับ Claude (YAML front-matter + เนื้อหา) OpenDesign ขยายรูปแบบด้วย namespace `od:` (`mode`, `preview`, `design_system`, `inputs`, …) เพื่อให้ artifact เดียวกันใช้งานได้ทั้งภายใน OpenDesign และโดย Agent ทั่วไปอย่าง Claude Code, Codex, openclaw หรือ hermes การค้นพบจะเป็นไปตามลำดับความสำคัญเพื่อให้โปรเจกต์สามารถแทนที่ skills ของตัวเองได้',
  'useEverywhere.section.skills.bullet1': 'การค้นพบ: `./.claude/skills/` → `./skills/` → `~/.claude/skills/` (โปรเจกต์ชนะ)',
  'useEverywhere.section.skills.bullet2': 'Symlink สกิลหนึ่งเข้าไปในหลายโปรเจกต์เพื่อแชร์โดยไม่ต้องคัดลอก',
  'useEverywhere.section.skills.bullet3': 'แต่ละสกิลสามารถประกาศ connector, atom, ข้อกำหนด design-system และตัวอย่างผลลัพธ์ `preview` สำหรับแกลเลอรีได้',
  'useEverywhere.section.skills.bullet4': 'Headless: agent ที่มี `od` อยู่ใน PATH สามารถเรียก `od skills list` แล้วรันสกิลใดก็ได้ ส่วน daemon เป็นตัวเลือกสำหรับโฟลว์แบบอ่านอย่างเดียว',
  'useEverywhere.section.skills.bullet5': '`pnpm seed:test-projects` ทดสอบรูปแบบอาร์ติแฟกต์เดียวกันด้วยตัวอย่าง plugin เริ่มต้นและตัวอย่าง plugin จากชุมชน จากนั้นเก็บโปรเจกต์ `index.html` ที่ได้เป็นข้อมูลทดสอบที่นำกลับมาใช้ใหม่ได้',
  'useEverywhere.section.skills.snippet1': 'SKILL.md แบบขั้นต่ำ (front matter ที่เข้ากันได้กับ Claude + ส่วนเสริมของ OpenDesign)',
  'useEverywhere.section.skills.snippet2': 'Symlink สกิลที่แชร์ไว้เข้าไปในโปรเจกต์ (สไตล์ cc-switch)',
  'useEverywhere.section.skills.snippet3': 'Headless: แสดงรายการสกิลที่ daemon เห็นในตอนนี้',
  'useEverywhere.section.skills.snippet4': 'บันเดิล fixture ของอาร์ติแฟกต์แบบ headless',
  'useEverywhere.section.skills.footer': 'ข้อกำหนด: `docs/skills-protocol.md` และ `docs/agent-adapters.md` ครอบคลุม adapter surface ทั้งหมด (Claude Code, Codex, Cursor, agent ที่รองรับ MCP, การสำรองด้วย BYOK API) และกลยุทธ์การฉีดสกิลแยกตาม adapter',
  'tasks.kicker': 'เวิร์กสเปซระบบอัตโนมัติ',
  'tasks.comingSoon': 'เร็วๆ นี้',
  'tasks.lede': 'ระบบอัตโนมัติเปลี่ยนพรอมต์ให้เป็นงานที่คงทน: Orbit รันงานเหล่านั้น routine คอยเก็บรักษาไว้ schedule ตัดสินใจว่าจะทำงานเมื่อใด และ live artifact แสดงสิ่งที่เปลี่ยนไป',
  'tasks.newAutomation': 'ระบบอัตโนมัติใหม่',
  'tasks.previewNote': 'เป็นเพียงพื้นผิวพรีวิวเท่านั้น การตั้งค่า Orbit ใช้ได้แล้ววันนี้ ส่วน routine, schedule และการเชื่อมต่อ live artifact จะมาเมื่อ branch ฝั่งแบ็กเอนด์ถูกผสานเข้ามา',
  'tasks.primitivesAria': 'องค์ประกอบพื้นฐานของระบบอัตโนมัติ',
  'tasks.primitive.orbit.title': 'Orbit',
  'tasks.primitive.orbit.body': 'รันไทม์ที่คงอยู่ถาวรสำหรับงาน agent ที่ทำงานยาวนานหรือทำซ้ำ',
  'tasks.primitive.orbit.enabled': 'เปิดใช้สรุปประจำวันแล้ว',
  'tasks.primitive.orbit.manualOnly': 'แบบแมนนวลเท่านั้น',
  'tasks.primitive.routines.title': 'รูทีน',
  'tasks.primitive.routines.body': 'คำนิยามงานที่คงทนซึ่งยังคงอยู่หลังจากแชตเดียวจบลง',
  'tasks.primitive.routines.meta': 'Product shell พร้อมแล้ว',
  'tasks.primitive.schedules.title': 'กำหนดการ',
  'tasks.primitive.schedules.body': 'ทริกเกอร์ตามเวลาหรืออีเวนต์ที่ตัดสินใจว่า routine ควรทำงานเมื่อใด',
  'tasks.primitive.schedules.meta': 'รอ branch',
  'tasks.primitive.liveArtifacts.title': 'อาร์ติแฟกต์แบบเรียลไทม์',
  'tasks.primitive.liveArtifacts.body': 'รายงานและบันทึกที่อัปเดตต่อเนื่องในขณะที่ agent ทำงาน',
  'tasks.primitive.liveArtifacts.meta': 'โมเดลพรีวิว',
  'tasks.listAria': 'รายการระบบอัตโนมัติ',
  'tasks.routinesAndRuns': '{n} routine และการรัน',
  'tasks.filtersAria': 'ตัวกรองระบบอัตโนมัติ',
  'tasks.filter.scheduled': 'ตั้งเวลาแล้ว',
  'tasks.filter.running': 'กำลังทำงาน',
  'tasks.filter.done': 'เสร็จสิ้น',
  'tasks.configurationAria': 'การตั้งค่าระบบอัตโนมัติ',
  'tasks.slot.trigger': 'ทริกเกอร์',
  'tasks.slot.pattern': 'รูปแบบ',
  'tasks.slot.runtime': 'รันไทม์',
  'tasks.slot.output': 'เอาต์พุต',
  'tasks.liveArtifact': 'อาร์ติแฟกต์แบบเรียลไทม์',
  'tasks.viewProgress': 'ดูความคืบหน้า',
  'tasks.pause': 'หยุดชั่วคราว',
  'tasks.runNow': 'เรียกใช้ทันที',
  'tasks.openArtifact': 'เปิดอาร์ติแฟกต์',
  'tasks.status.dailyAt': 'รายวัน · {time}',
  'tasks.status.pausedManual': 'หยุดชั่วคราว · เฉพาะแบบกำหนดเอง',
  'tasks.sample.orbit.title': 'สรุป Connector ประจำวันของ Orbit',
  'tasks.sample.orbit.metaEnabled': 'กำหนดเวลาสรุป Connector แล้ว',
  'tasks.sample.orbit.metaDisabled': 'เปิดการตั้งค่า Orbit เพื่อเปิดใช้งาน',
  'tasks.sample.orbit.previewEnabled': 'orbit_daily.html · artifact แบบเรียลไทม์',
  'tasks.sample.orbit.previewDisabled': 'ไม่มีการกำหนดเวลาเรียกใช้',
  'tasks.sample.orbit.triggerEnabled': 'กำหนดเวลา · รายวันเวลา {time}',
  'tasks.sample.orbit.triggerDisabled': 'กำหนดเอง · รันตามต้องการ',
  'tasks.sample.orbit.pattern': 'กิจวัตร · สรุปจาก connector',
  'tasks.sample.orbit.runtime': 'Orbit · ตั้งเวลา daemon แล้ว',
  'tasks.sample.orbit.output': 'Artifact สด · รายงานที่รีเฟรชได้',
  'tasks.sample.orbit.artifactMetaEnabled': 'รีเฟรชหลังการเรียกใช้แต่ละครั้ง',
  'tasks.sample.orbit.artifactMetaDisabled': 'กำลังรอกำหนดเวลา',
  'tasks.sample.orbit.body1': '# สรุปกิจกรรมประจำวันของ Orbit',
  'tasks.sample.orbit.body2': 'ตรวจสอบ connector แล้ว · สำเร็จ, ข้าม และล้มเหลว',
  'tasks.sample.orbit.body3': 'ไฮไลต์จะกลายเป็นอาร์ติแฟกต์แบบเรียลไทม์ที่รีเฟรชได้',
  'tasks.sample.mcp.title': 'การวิจัยทางเลือกของ MCP',
  'tasks.sample.mcp.status': 'กำลังทำงานใน orbit · 2 ชม. 14 น.',
  'tasks.sample.mcp.meta': 'ประมวลผลแหล่งข้อมูลแล้ว 14 / 30 แหล่ง',
  'tasks.sample.mcp.preview': 'research_notes.md · สด',
  'tasks.sample.mcp.trigger': 'ด้วยตนเอง · ครั้งเดียว',
  'tasks.sample.mcp.pattern': 'พรอมต์การวิจัยเชิงลึก',
  'tasks.sample.mcp.runtime': 'ระยะไกล · ถาวร',
  'tasks.sample.mcp.output': 'รายงานสด · อัปเดตอัตโนมัติ',
  'tasks.sample.mcp.artifactMeta': 'อัปเดตเมื่อ 12 วินาทีที่แล้ว',
  'tasks.sample.mcp.body1': '# ทางเลือกของ MCP - ผลการวิเคราะห์เบื้องต้น',
  'tasks.sample.mcp.body2': 'ตรวจสอบแล้ว 14 แหล่ง · คัดเลือก 3 ตัวเต็ง',
  'tasks.sample.mcp.body3': '## รายชื่อที่คัดเลือก',
  'tasks.sample.mcp.body4': '- สคีมาการเรียกใช้เครื่องมือผ่าน JSON-RPC...',
  'tasks.sample.mcp.body5': '- โปรโตคอล Agent ที่ใช้ gRPC...',
  'tasks.sample.weekly.title': 'สรุปทีมประจำสัปดาห์',
  'tasks.sample.weekly.status': 'ครั้งถัดไป: จันทร์ 9:00 น.',
  'tasks.sample.weekly.meta': 'อัปเดตเอกสารประจำสัปดาห์ของทีม',
  'tasks.sample.weekly.preview': 'team_weekly.md · artifact ถัดไป',
  'tasks.sample.weekly.trigger': 'กำหนดเวลา · รายสัปดาห์',
  'tasks.sample.weekly.pattern': 'กิจวัตร · สรุปของทีม',
  'tasks.sample.weekly.runtime': 'ระยะไกล · ทำซ้ำ',
  'tasks.sample.weekly.output': 'Artifact สด · markdown',
  'tasks.sample.weekly.artifactMeta': 'อัปเดตล่าสุดเมื่อ 4 วันที่แล้ว',
  'tasks.sample.weekly.body1': '# ทีมประจำสัปดาห์',
  'tasks.sample.weekly.body2': '## กำลังดำเนินการ',
  'tasks.sample.weekly.body3': '- รอบการผสานรวมระบบดีไซน์',
  'tasks.sample.weekly.body4': '- การตรวจสอบคุณภาพ Connector',
  'tasks.sample.weekly.body5': '## ความเสี่ยง',
  'tasks.sample.pr.title': 'การแจ้งเตือนรีวิว PR',
  'tasks.sample.pr.status': 'เมื่อมี PR ใหม่ · ทำงานไปเมื่อ 23 น. ที่แล้ว',
  'tasks.sample.pr.meta': 'ส่งข้อความตรงทาง Slack',
  'tasks.sample.pr.preview': 'การส่งครั้งล่าสุดสำเร็จ',
  'tasks.sample.pr.trigger': 'เหตุการณ์ · PR ใหม่',
  'tasks.sample.pr.pattern': 'กิจวัตร · การแจ้งเตือน',
  'tasks.sample.pr.runtime': 'ในเครื่อง · รันด่วน',
  'tasks.sample.pr.output': 'ข้อความ · Slack DM',
  'tasks.sample.pr.artifactMeta': 'เรียกใช้ครั้งล่าสุดเมื่อ 23 นาทีที่แล้ว',
  'tasks.sample.pr.body1': 'เปิด PR #184 เพื่อรีวิว',
  'tasks.sample.pr.body2': 'ผู้รีวิวที่ตรงกัน: design-platform, web-runtime',
  'tasks.sample.pr.body3': 'การส่ง: ส่งข้อความตรงทาง Slack แล้ว',
  'tasks.sample.meeting.title': 'การเตรียมตัวก่อนการประชุม',
  'tasks.sample.meeting.status': 'พรุ่งนี้ · 10:00 น.',
  'tasks.sample.meeting.meta': 'ครั้งเดียว · ส่งสรุป',
  'tasks.sample.meeting.preview': 'meeting_brief.md · อยู่ในคิว',
  'tasks.sample.meeting.trigger': 'กำหนดเวลา · ครั้งเดียว',
  'tasks.sample.meeting.pattern': 'พรอมต์สรุปบรีฟ',
  'tasks.sample.meeting.runtime': 'ระยะไกล · จำกัด',
  'tasks.sample.meeting.output': 'อาร์ติแฟกต์ + ข้อความ',
  'tasks.sample.meeting.artifactMeta': 'อยู่ในคิวสำหรับการสร้าง',
  'tasks.sample.meeting.body1': '# บรีฟการประชุม',
  'tasks.sample.meeting.body2': 'แหล่งวาระการประชุม: กิจกรรมในปฏิทิน + เอกสารที่เชื่อมโยง',
  'tasks.sample.meeting.body3': 'เอาต์พุตจะประกอบด้วยการตัดสินใจ ปัญหาที่ติดขัด และคำถาม',
  'tasks.sample.candidate.title': 'การติดตามผู้สมัคร',
  'tasks.sample.candidate.status': 'ล้มเหลว · ต้องการความสนใจ',
  'tasks.sample.candidate.meta': 'การยืนยันตัวตนหมดอายุ',
  'tasks.sample.candidate.preview': 'เชื่อมต่อ Greenhouse อีกครั้งเพื่อดำเนินการต่อ',
  'tasks.sample.candidate.trigger': 'กำหนดเวลา · รายวัน',
  'tasks.sample.candidate.pattern': 'กิจวัตร · ซิงก์ผู้สมัคร',
  'tasks.sample.candidate.runtime': 'ระยะไกล · ทำซ้ำ',
  'tasks.sample.candidate.output': 'Artifact สด · ตาราง',
  'tasks.sample.candidate.artifactMeta': 'หยุดชั่วคราวจนกว่าการยืนยันตัวตนจะกลับมาใช้งานได้',
  'tasks.sample.candidate.body1': '# ไปป์ไลน์ผู้สมัคร',
  'tasks.sample.candidate.body2': 'การซิงค์สำเร็จครั้งล่าสุด: 2 วันที่แล้ว',
  'tasks.sample.candidate.body3': 'ต้องดำเนินการ: เชื่อมต่อบัญชีแหล่งข้อมูลอีกครั้ง',
  'routines.title': 'ระบบอัตโนมัติ',
  'routines.subtitle': 'ระบบอัตโนมัติที่กำหนดเวลาไว้ซึ่งทำงานโดยไม่ต้องดูแล',
  'routines.newAutomation': 'ระบบอัตโนมัติใหม่',
  'routines.loading': 'กำลังโหลด…',
  'routines.empty': 'ยังไม่มีการทำงานอัตโนมัติ',
  'routines.emptyHint': 'คลิก สร้างการทำงานอัตโนมัติ เพื่อตั้งเวลาให้ Agent ทำงานแบบไม่ต้องดูแล',
  'routines.runHistoryLoading': 'กำลังโหลดการทำงาน…',
  'routines.runHistoryEmpty': 'ยังไม่มีการรัน',
  'routines.fieldName': 'ชื่อ',
  'routines.fieldNamePlaceholder': 'สรุปข่าวประจำเช้า',
  'routines.fieldPrompt': 'พรอมต์',
  'routines.fieldPromptPlaceholder': 'ดึงกิจกรรม GitHub + Linear ของเมื่อวานและสรุปสิ่งที่เปลี่ยนแปลง',
  'routines.fieldSchedule': 'กำหนดเวลา',
  'routines.fieldMinute': 'นาทีของทุกชั่วโมง',
  'routines.fieldTime': 'เวลา',
  'routines.fieldTimezone': 'เขตเวลา',
  'routines.fieldsetProject': 'โปรเจกต์',
  'routines.kind.hourly': 'ทุกชั่วโมง',
  'routines.kind.daily': 'ทุกวัน',
  'routines.kind.weekdays': 'วันธรรมดา',
  'routines.kind.weekly': 'ทุกสัปดาห์',
  'routines.weekday.short.0': 'อา.',
  'routines.weekday.short.1': 'จ.',
  'routines.weekday.short.2': 'อ.',
  'routines.weekday.short.3': 'พ.',
  'routines.weekday.short.4': 'พฤ.',
  'routines.weekday.short.5': 'ศ.',
  'routines.weekday.short.6': 'ส.',
  'routines.weekday.long.0': 'วันอาทิตย์',
  'routines.weekday.long.1': 'วันจันทร์',
  'routines.weekday.long.2': 'วันอังคาร',
  'routines.weekday.long.3': 'วันพุธ',
  'routines.weekday.long.4': 'วันพฤหัสบดี',
  'routines.weekday.long.5': 'วันศุกร์',
  'routines.weekday.long.6': 'วันเสาร์',
  'routines.timeAm': 'AM',
  'routines.timePm': 'PM',
  'routines.describe.hourly': 'รันทุกชั่วโมงเมื่อถึงนาทีที่ :{minute}',
  'routines.describe.daily': 'รันทุกวันเวลา {time} {tz}',
  'routines.describe.weekdays': 'ทำงานทุกวันจันทร์–ศุกร์ เวลา {time} {tz}',
  'routines.describe.weekly': 'รันทุก{day}เวลา {time} {tz}',
  'routines.modeCreate': 'สร้างโปรเจกต์ใหม่ทุกครั้งที่รัน',
  'routines.modeCreateHint': 'พื้นที่ทำงานใหม่ที่แยกอิสระในแต่ละครั้งที่ทำงาน',
  'routines.modeReuse': 'ใช้โปรเจกต์ที่มีอยู่เดิม',
  'routines.modeReuseHint': 'การรันแต่ละครั้งจะเป็นการสนทนาใหม่ภายในโปรเจกต์',
  'routines.pickProject': '— เลือกโปรเจกต์ —',
  'routines.targetReuse': '→ {project}',
  'routines.targetCreate': '→ โปรเจกต์ใหม่ทุกครั้งที่ทำงาน',
  'routines.tagPaused': 'หยุดชั่วคราว',
  'routines.metaNext': 'ครั้งถัดไป: {when}',
  'routines.metaLast': 'ครั้งล่าสุด:',
  'routines.triggerManual': 'ด้วยตนเอง',
  'routines.triggerScheduled': 'ตามกำหนดเวลา',
  'routines.openProject': 'เปิดโปรเจกต์',
  'routines.openProjectTitle': 'เปิดโปรเจกต์ที่การรันนี้บันทึกข้อมูลลงไป',
  'routines.runNow': 'รันตอนนี้',
  'routines.edit': 'แก้ไข',
  'routines.pause': 'หยุดชั่วคราว',
  'routines.resume': 'ดำเนินการต่อ',
  'routines.history': 'ประวัติ',
  'routines.hideHistory': 'ซ่อนประวัติ',
  'routines.delete': 'ลบ',
  'routines.deleteTitle': 'ลบการทำงานอัตโนมัตินี้',
  'routines.cancel': 'ยกเลิก',
  'routines.save': 'บันทึก',
  'routines.saving': 'กำลังบันทึก…',
  'routines.create': 'สร้าง',
  'routines.creating': 'กำลังสร้าง…',
  'routines.status.queued': 'อยู่ในคิว',
  'routines.status.running': 'กำลังรัน',
  'routines.status.succeeded': 'สำเร็จ',
  'routines.status.failed': 'ล้มเหลว',
  'routines.status.canceled': 'ยกเลิกแล้ว',
  'routines.confirmDelete': 'ลบการทำงานอัตโนมัตินี้หรือไม่? การรันที่ผ่านมาและโปรเจกต์ของการรันเหล่านั้นจะยังคงอยู่',
  'routines.errorPickProject': 'เลือกโปรเจกต์เพื่อใช้ซ้ำ หรือสลับไปที่ “สร้างใหม่ทุกครั้งที่ทำงาน”',
  'routines.errorAgentEmptyOutput': 'Agent ทำงานเสร็จโดยไม่ได้สร้างผลลัพธ์ใดๆ โมเดลหรือผู้ให้บริการอาจส่งคืนการตอบสนองที่ว่างเปล่า — ตรวจสอบบันทึกของ agent เพื่อหาข้อผิดพลาดจากต้นทาง',
  'entry.githubStarLabel': 'ติดดาว',
  'entry.githubStarTitle': 'คลิกเพื่อติดดาวให้เราบน GitHub',
  'entry.githubStarAria': 'ติดดาว OpenDesign บน GitHub',
  'entry.tabImageTemplates': 'เทมเพลตภาพ',
  'entry.tabVideoTemplates': 'เทมเพลตวิดีโอ',
  'promptTemplates.emptyNoMatch': 'ไม่พบเทมเพลตที่ตรงกับการค้นหา',
  'promptTemplates.fetchError': 'ไม่สามารถโหลดเนื้อหาเทมเพลตนี้',
  'promptTemplates.promptLabel': 'เนื้อหาคำสั่ง',
  'promptTemplates.copyPrompt': 'คัดลอกคำสั่ง',
  'promptTemplates.copyDone': 'คัดลอกแล้ว!',
  'promptTemplates.allSources': 'ทุกแหล่งที่มา',
  'promptTemplates.retry': 'ลองใหม่',
  'connectors.title': 'ตัวเชื่อมต่อ',
  'connectors.subtitle': 'แหล่งข้อมูลที่สามารถใช้ใน live artifacts',
  'connectors.account': 'บัญชี',
  'connectors.noAccount': 'ไม่ได้เชื่อมต่อ',
  'connectors.tools': 'เครื่องมือ',
  'connectors.connect': 'เชื่อมต่อ',
  'connectors.disconnect': 'ตัดการเชื่อมต่อ',
  'connectors.authorizationPending': 'รอการอนุญาต...',
  'connectors.authorizationPendingHint': 'ดำเนินการอนุญาตให้เสร็จสมบูรณ์ในหน้าต่างที่เปิดขึ้น',
  'connectors.cancelAuthorization': 'ยกเลิก',
  'connectors.configure': 'กำหนดค่า',
  'connectors.unavailable': 'ไม่พร้อมใช้งาน',
  'connectors.phaseStubTitle': 'Connector APIs เป็นการแสดงตัวอย่างสำหรับ Phase 3',
  'connectors.statusAvailable': 'พร้อมใช้งาน',
  'connectors.statusConnected': 'เชื่อมต่อแล้ว',
  'connectors.statusError': 'ข้อผิดพลาด',
  'connectors.statusDisabled': 'ปิดการใช้งาน',
  'connectors.gateTitle': 'เพิ่ม Composio API key ของคุณเพื่อดำเนินการต่อ',
  'connectors.gateBody': 'วาง API key ด้านบนและคลิกบันทึกเพื่อดูการผสานรวมที่พร้อมใช้งาน',
  'connectors.aboutLabel': 'เกี่ยวกับ',
  'connectors.detailsLabel': 'รายละเอียด',
  'connectors.statusLabel': 'สถานะ',
  'connectors.category.aiAgents': 'เอเจนต์ AI',
  'connectors.category.aiInfrastructure': 'โครงสร้างพื้นฐาน AI',
  'connectors.category.accounting': 'การบัญชี',
  'connectors.category.admin': 'ผู้ดูแลระบบ',
  'connectors.category.advertising': 'การโฆษณา',
  'connectors.category.analytics': 'การวิเคราะห์',
  'connectors.category.automation': 'ระบบอัตโนมัติ',
  'connectors.category.cms': 'CMS',
  'connectors.category.crm': 'CRM',
  'connectors.category.calendar': 'ปฏิทิน',
  'connectors.category.commerce': 'พาณิชย์',
  'connectors.category.communication': 'การสื่อสาร',
  'connectors.category.contacts': 'รายชื่อติดต่อ',
  'connectors.category.dataPlatform': 'แพลตฟอร์มข้อมูล',
  'connectors.category.database': 'ฐานข้อมูล',
  'connectors.category.design': 'การออกแบบ',
  'connectors.category.developer': 'ผู้พัฒนา',
  'connectors.category.documentation': 'เอกสารประกอบ',
  'connectors.category.erp': 'ERP',
  'connectors.category.education': 'การศึกษา',
  'connectors.category.email': 'อีเมล',
  'connectors.category.events': 'กิจกรรม',
  'connectors.category.fieldService': 'บริการภาคสนาม',
  'connectors.category.finance': 'การเงิน',
  'connectors.category.fitness': 'ฟิตเนส',
  'connectors.category.forms': 'แบบฟอร์ม',
  'connectors.category.gaming': 'เกม',
  'connectors.category.hr': 'ฝ่ายบุคคล',
  'connectors.category.hospitality': 'การบริการลูกค้า',
  'connectors.category.itsm': 'ITSM',
  'connectors.category.integration': 'การผสานรวม',
  'connectors.category.localization': 'การปรับให้เข้ากับท้องถิ่น',
  'connectors.category.logistics': 'โลจิสติกส์',
  'connectors.category.maps': 'แผนที่',
  'connectors.category.marketing': 'การตลาด',
  'connectors.category.media': 'สื่อ',
  'connectors.category.meetings': 'การประชุม',
  'connectors.category.nonprofit': 'ไม่แสวงหาผลกำไร',
  'connectors.category.observability': 'ระบบการสังเกตการณ์',
  'connectors.category.payments': 'การชำระเงิน',
  'connectors.category.personal': 'ส่วนบุคคล',
  'connectors.category.presentations': 'งานนำเสนอ',
  'connectors.category.procurement': 'การจัดซื้อ',
  'connectors.category.product': 'ผลิตภัณฑ์',
  'connectors.category.productivity': 'ผลิตภาพ',
  'connectors.category.projectManagement': 'การจัดการโครงการ',
  'connectors.category.recruiting': 'การสรรหา',
  'connectors.category.research': 'การวิจัย',
  'connectors.category.salesIntelligence': 'ระบบข้อมูลการขาย',
  'connectors.category.scheduling': 'การจัดตารางเวลา',
  'connectors.category.search': 'ค้นหา',
  'connectors.category.security': 'ความปลอดภัย',
  'connectors.category.signing': 'เซ็นเอกสาร',
  'connectors.category.social': 'โซเชียลมีเดีย',
  'connectors.category.spreadsheets': 'สเปรดชีต',
  'connectors.category.storage': 'พื้นที่เก็บข้อมูล',
  'connectors.category.support': 'สนับสนุน',
  'connectors.category.surveys': 'แบบสำรวจ',
  'connectors.category.tasks': 'งาน',
  'connectors.category.timeTracking': 'ติดตามเวลา',
  'connectors.category.video': 'วิดีโอ',
  'connectors.category.whiteboard': 'กระดานไวท์บอร์ด',
  'connectors.categoryLabel': 'หมวดหมู่',
  'connectors.providerLabel': 'ผู้ให้บริการ',
  'connectors.toolsSection': 'เครื่องมือ',
  'connectors.toolsLoading': 'กำลังโหลดเครื่องมือ…',
  'connectors.noToolsAvailable': 'ยังไม่มีเครื่องมือที่พร้อมใช้งาน',
  'connectors.toolDetailsUnavailable': 'รายละเอียดเครื่องมือไม่พร้อมใช้งาน แต่ตัวเชื่อมต่อนี้มีเครื่องมือ {n} ตัว',
  'connectors.loadMoreTools': 'โหลดเครื่องมือเพิ่มเติม',
  'connectors.openDetailsAria': 'เปิดรายละเอียด {name}',
  'connectors.toolsBadgeNone': 'ไม่มีเครื่องมือ',
  'connectors.toolsBadgeOne': '{n} เครื่องมือ',
  'connectors.toolsBadgeMany': '{n} เครื่องมือ',
  'connectors.searchPlaceholder': 'ค้นหาตัวเชื่อมต่อ…',
  'connectors.searchAriaLabel': 'ค้นหาตัวเชื่อมต่อตามชื่อ',
  'connectors.searchClear': 'ล้างการค้นหา',
  'connectors.emptyNoMatchTitle': 'ไม่มีตัวเชื่อมต่อที่ตรงกับ “{query}”',
  'connectors.emptyNoMatchBody': 'ลองใช้คำหลักอื่น',
  'connectors.emptyNoMatchAction': 'ล้างการค้นหา',
  'newproj.tabPrototype': 'ต้นแบบ (Prototype)',
  'newproj.tabLiveArtifact': 'อาร์ติแฟกต์แบบสด',
  'newproj.tabDeck': 'สไลด์นำเสนอ',
  'newproj.tabTemplate': 'จากเทมเพลต',
  'newproj.tabMedia': 'สื่อ',
  'newproj.tabOther': 'อื่นๆ',
  'newproj.titlePrototype': 'ต้นแบบใหม่',
  'newproj.titleLiveArtifact': 'Live artifact ใหม่',
  'newproj.titleDeck': 'สไลด์นำเสนอใหม่',
  'newproj.titleTemplate': 'เริ่มจากเทมเพลต',
  'newproj.titleImage': 'ภาพใหม่',
  'newproj.titleVideo': 'วิดีโอใหม่',
  'newproj.titleAudio': 'เสียงใหม่',
  'newproj.titleMedia': 'สื่อใหม่',
  'newproj.titleOther': 'โปรเจกต์ใหม่',
  'newproj.namePlaceholder': 'ชื่อโปรเจกต์',
  'newproj.fidelityLabel': 'ความละเอียด',
  'newproj.fidelityWireframe': 'ไวร์เฟรม',
  'newproj.fidelityHigh': 'ความละเอียดสูง',
  'newproj.toggleSpeakerNotes': 'ใช้บันทึกผู้บรรยาย',
  'newproj.toggleSpeakerNotesHint': 'ลดข้อความในสไลด์ — ให้ข้อมูลอยู่ในบันทึกแทน',
  'newproj.toggleAnimations': 'รวมแอนิเมชัน',
  'newproj.toggleAnimationsHint': 'เพิ่มแอนิเมชันตอนเข้าหน้า',
  'newproj.targetPlatformsLabel': 'แพลตฟอร์มเป้าหมาย',
  'newproj.targetPlatformsHint': 'เลือกได้หนึ่งรายการหรือมากกว่า เว็บแบบ Responsive ครอบคลุมเฉพาะเบรกพอยต์ของเบราว์เซอร์เท่านั้น เพิ่ม iOS, Android, แอปแท็บเล็ต หรือแอปเดสก์ท็อปสำหรับเวอร์ชันเนทีฟข้ามแพลตฟอร์ม',
  'newproj.platform.responsive.label': 'เว็บแบบ Responsive',
  'newproj.platform.responsive.hint': 'ประสบการณ์เว็บเดียวที่ปรับให้เหมาะกับเบราว์เซอร์บนเดสก์ท็อป แท็บเล็ต และมือถือ',
  'newproj.platform.webDesktop.label': 'เว็บเดสก์ท็อป',
  'newproj.platform.webDesktop.hint': 'ผลิตภัณฑ์หรือหน้าแลนดิ้งที่เน้นเบราว์เซอร์เป็นหลัก',
  'newproj.platform.mobileIos.label': 'แอป iOS',
  'newproj.platform.mobileIos.hint': 'เฟรม iPhone และกฎการโต้ตอบของ iOS',
  'newproj.platform.mobileAndroid.label': 'แอป Android',
  'newproj.platform.mobileAndroid.hint': 'เฟรม Pixel และกฎการโต้ตอบแบบ Material',
  'newproj.platform.tablet.label': 'แอปแท็บเล็ต',
  'newproj.platform.tablet.hint': 'ประสบการณ์แท็บเล็ตสไตล์เนทีฟพร้อมมุมมองแบบแยกส่วน',
  'newproj.platform.desktopApp.label': 'แอปเดสก์ท็อป',
  'newproj.platform.desktopApp.hint': 'กรอบหน้าต่างแอป macOS/Windows',
  'newproj.surfaceOptionsLabel': 'พื้นผิวเสริม',
  'newproj.includeLandingPage': 'รวมหน้าแลนดิ้ง',
  'newproj.includeLandingPageHint': 'เพิ่มหน้าการตลาดแบบ Responsive สำหรับโฆษณา รายการรอ แคมเปญเปิดตัว การดาวน์โหลดแอป หรือคำอธิบายผลิตภัณฑ์',
  'newproj.includeOsWidgets': 'รวมวิดเจ็ตของ OS',
  'newproj.includeOsWidgetsHint': 'เพิ่มวิดเจ็ตหน้าจอหลัก หน้าจอล็อก หรือวิดเจ็ตเข้าถึงด่วนแบบเนทีฟของแพลตฟอร์มสำหรับแอปมือถือ/แท็บเล็ต',
  'newproj.includeOsWidgetsDisabledHint': 'ใช้ได้เมื่อเลือกแอป iOS, Android หรือแท็บเล็ตเป็นแพลตฟอร์มเป้าหมาย',
  'newproj.templateLabel': 'เทมเพลต',
  'newproj.noTemplatesTitle': 'ยังไม่มีเทมเพลต',
  'newproj.noTemplatesBody': 'เปิดโปรเจกต์แล้วเลือกบันทึกเป็นเทมเพลตเพื่อใช้งานที่นี่',
  'newproj.savedTemplate': 'เทมเพลตที่บันทึกแล้ว',
  'newproj.fileSingular': 'ไฟล์',
  'newproj.filePlural': 'ไฟล์',
  'newproj.create': 'สร้าง',
  'newproj.locationLabel': 'บันทึกไปยัง',
  'newproj.locationDefault': 'โปรเจกต์ OpenDesign',
  'newproj.locationExternalBase': 'ฐานภายนอก',
  'newproj.createLiveArtifact': 'สร้าง live artifact',
  'newproj.createFromTemplate': 'สร้างจากเทมเพลต',
  'newproj.createDisabledTitle': 'คุณต้องบันทึกโปรเจกต์เป็นเทมเพลตก่อน',
  'newproj.openFolder': 'เปิดโฟลเดอร์',
  'newproj.openingFolder': 'กำลังเปิด…',
  'newproj.importClaudeZip': 'นำเข้า Claude Design ZIP',
  'newproj.importClaudeZipTitle': 'นำเข้า .zip จาก Claude Design',
  'newproj.importingClaudeZip': 'กำลังนำเข้า…',
  'newproj.privacyFooter': 'โดยค่าเริ่มต้น คุณเท่านั้นที่สามารถดูโปรเจกต์ของคุณได้',
  'newproj.designSystem': 'ระบบการออกแบบ',
  'newproj.dsNoneFreeform': 'ไม่มี — ฟรีฟอร์ม',
  'newproj.dsNoneSubtitleEmpty': 'เลือกพาเลตต์สีของคุณเอง',
  'newproj.dsNoneSubtitleSelected': 'ให้ระบบเลือกพาเลตต์สีให้',
  'newproj.dsCategoryFallback': 'ระบบการออกแบบ',
  'newproj.dsSearch': 'ค้นหา Design systems…',
  'newproj.dsModeAria': 'โหมดการเลือก',
  'newproj.dsModeSingle': 'เดี่ยว',
  'newproj.dsModeMulti': 'หลาย',
  'newproj.dsNoneTitle': 'ไม่มี — ฟรีฟอร์ม',
  'newproj.dsNoneSub': 'ให้ระบบเลือกพาเลตต์สีให้',
  'newproj.dsEmpty': 'ไม่พบ Design systems ที่ตรงกับ “{query}”',
  'newproj.dsFootSingular': 'เพื่อเป็นแรงบันดาลใจเท่านั้น',
  'newproj.dsFootPlural': 'เพื่อเป็นแรงบันดาลใจเท่านั้น',
  'newproj.dsFootClear': 'ล้าง',
  'newproj.dsBadgeDefault': 'ค่าเริ่มต้น',
  'newproj.dsPrimaryFallback': 'หลัก',
  'newproj.surfaceImage': 'รูปภาพ',
  'newproj.surfaceVideo': 'วิดีโอ',
  'newproj.surfaceAudio': 'เสียง',
  'newproj.modelLabel': 'โมเดล',
  'newproj.modelSearch': 'ค้นหาโมเดล…',
  'newproj.modelEmpty': 'ไม่พบโมเดลที่ตรงกัน',
  'newproj.modelRecommended': 'แนะนำ',
  'newproj.modelMissingTitle': 'เลือกโมเดล',
  'newproj.modelMissingSub': 'เลือกโมเดลสำหรับพื้นที่นี้',
  'newproj.aspectLabel': 'อัตราส่วน',
  'newproj.videoLengthLabel': 'ความยาว',
  'newproj.videoLengthSeconds': '{n}วิ',
  'newproj.audioKindLabel': 'ประเภทเสียง',
  'newproj.audioKindMusic': 'เพลง',
  'newproj.audioKindSpeech': 'คำพูด',
  'newproj.audioKindSfx': 'เอฟเฟกต์',
  'newproj.audioDurationLabel': 'ระยะเวลา',
  'newproj.audioDurationSeconds': '{n}วิ',
  'newproj.voiceLabel': 'เสียงพูด',
  'newproj.voicePlaceholder': 'Voice id ของผู้ให้บริการ (ไม่บังคับ)',
  'newproj.connectorsLabel': 'ตัวเชื่อมต่อ',
  'newproj.connectorsHint': 'แหล่งข้อมูลที่ artifact นี้ดึงข้อมูลมาได้',
  'newproj.connectorsEmptyTitle': 'ยังไม่ได้ตั้งค่าตัวเชื่อมต่อ',
  'newproj.connectorsEmptyBody': 'เชื่อมต่อแหล่งข้อมูลเพื่อให้ได้ตัวเลขจริง',
  'newproj.connectorsEmptyCta': 'ตั้งค่าตัวเชื่อมต่อ →',
  'newproj.connectorsLoading': 'กำลังโหลดตัวเชื่อมต่อ…',
  'newproj.connectorsCountOne': 'เชื่อมต่อแล้ว {n} ตัว',
  'newproj.connectorsCountMany': 'เชื่อมต่อแล้ว {n} ตัว',
  'newproj.connectorsManage': 'จัดการ',
  'newproj.promptTemplateLabel': 'เทมเพลตอ้างอิง',
  'newproj.promptTemplateNoneTitle': 'เขียนคำสั่งเอง',
  'newproj.promptTemplateNoneSub': 'ไม่ต้องใช้ตัวอ้างอิง อธิบายในแบบของคุณ',
  'newproj.promptTemplateRefSub': 'เทมเพลตอ้างอิง',
  'newproj.promptTemplateSearch': 'ค้นหาเทมเพลต…',
  'newproj.promptTemplateEmpty': 'ยังไม่ได้ติดตั้งเทมเพลตสำหรับส่วนนี้',
  'newproj.promptTemplateBodyLabel': 'คำสั่ง (แก้ไขได้)',
  'newproj.promptTemplateOptimizeHint': 'การปรับแก้ของคุณจะส่งผลต่อเอเจนต์ด้วย',
  'newproj.promptTemplateBodyEmpty': 'เนื้อหาว่างเปล่า เอเจนต์จะไม่ได้ข้อมูลอ้างอิง',
  'newproj.deleteTemplateTitle': 'ลบเทมเพลต',
  'newproj.deleteTemplateConfirm': 'ลบ "{name}" ใช่ไหม การลบนี้ไม่สามารถย้อนกลับได้',
  'newproj.deleteTemplateConfirmCta': 'ลบเทมเพลต',
  'newproj.deleteTemplateError': 'ไม่สามารถลบเทมเพลตนี้ได้ โปรดลองอีกครั้ง',
  'designs.subRecent': 'ล่าสุด',
  'designs.subYours': 'ดีไซน์ของคุณ',
  'designs.filterAria': 'ตัวกรอง',
  'designs.searchPlaceholder': 'ค้นหา…',
  'designs.emptyNoProjects': 'ยังไม่มีโปรเจกต์',
  'designs.emptyNoMatch': 'ไม่พบโปรเจกต์',
  'designs.deleteTitle': 'ลบโปรเจกต์',
  'designs.deleteConfirm': 'ลบ "{name}"?',
  'designs.deleteActiveShares': "โปรเจกต์นี้มี {count} หน้าที่กำลังแชร์ การลบจะทำให้ลิงก์แชร์ใช้ไม่ได้ และผู้เข้าชมจะเปิดไม่ได้อีก",
  'designs.deletedShareTitle': "ไฟล์ต้นฉบับถูกลบแล้ว",
  'designs.deletedShareRetrying': "โปรเจกต์ถูกลบแล้ว กำลังหยุดลิงก์แชร์ของ '{filePath}'…",
  'designs.deletedShareFailed': "โปรเจกต์ถูกลบแล้ว ลิงก์แชร์ของ '{filePath}' หยุดไม่สำเร็จ และอาจยังเข้าถึงได้",
  'designs.deletedShareRetry': "ลองอีกครั้ง",
  'designs.cardFreeform': 'ฟรีฟอร์ม',
  'designs.badgeLive': 'สด',
  'designs.liveArtifactBadgesAria': 'ป้ายกำกับ',
  'designs.liveCount': '{n} สด',
  'designs.statusLive': 'อาร์ติแฟกต์แบบสด',
  'designs.statusArchived': 'เก็บถาวรแล้ว',
  'designs.statusError': 'ข้อผิดพลาด',
  'designs.statusRefreshing': 'กำลังรีเฟรช…',
  'designs.statusRefreshFailed': 'รีเฟรชไม่สำเร็จ',
  'designs.statusRefreshed': 'รีเฟรชแล้ว',
  'designs.status.notStarted': 'ยังไม่เริ่ม',
  'designs.status.queued': 'อยู่ในคิว',
  'designs.status.running': 'กำลังทำงาน',
  'designs.status.awaitingInput': 'ต้องการข้อมูลเพิ่ม',
  'designs.status.incomplete': 'ไม่สมบูรณ์',
  'designs.status.succeeded': 'สำเร็จ',
  'designs.status.published': 'เผยแพร่แล้ว',
  'designs.status.failed': 'ล้มเหลว',
  'designs.status.canceled': 'ยกเลิกแล้ว',
  'designs.viewToggleAria': 'โหมดมุมมอง',
  'designs.viewGrid': 'ตาราง',
  'designs.viewKanban': 'บอร์ด',
  'designs.kanbanEmptyColumn': 'ไม่มีรายการ',
  'designs.deleteAria': 'ลบ {name}',
  'designs.menuMore': 'การดำเนินการเพิ่มเติม',
  'designs.menuRename': 'เปลี่ยนชื่อ',
  'designs.menuDuplicate': 'Duplicate project',
  'designs.menuDelete': 'ลบ',
  'designs.renamePrompt': 'ชื่อใหม่สำหรับ "{name}"',
  'designs.selectMode': 'เลือก',
  'designs.cancelSelect': 'ยกเลิก',
  'designs.deleteSelected': 'ลบรายการที่เลือก',
  'designs.selectedCount': 'เลือกแล้ว {n} รายการ',
  'designs.deleteSelectedConfirm': 'ลบ {n} โปรเจกต์หรือไม่',
  'designs.deleteSelectedSuccess': 'ลบ {n} โปรเจกต์สำเร็จแล้ว',
  'designs.deleteSelectedPartial': 'ลบ {deleted} โปรเจกต์แล้ว ล้มเหลว {failed} รายการ',
  'designs.tagPrototype': 'ต้นแบบ',
  'designs.tagLiveArtifact': 'อาร์ติแฟกต์แบบสด',
  'designs.tagWebClone': 'โคลนเว็บไซต์',
  'designs.tagSlide': 'สไลด์',
  'designs.tagMedia': 'สื่อ',
  'designs.renameTitle': 'เปลี่ยนชื่อโปรเจกต์',
  'designs.renameSave': 'OK',
  'designs.renameCancel': 'ยกเลิก',
  'examples.typeLabel': 'ประเภท',
  'examples.surfaceLabel': 'พื้นที่',
  'examples.surfaceWeb': 'เว็บไซต์',
  'examples.surfaceImage': 'รูปภาพ',
  'examples.surfaceVideo': 'วิดีโอ',
  'examples.surfaceAudio': 'เสียง',
  'examples.scenarioLabel': 'สถานการณ์',
  'examples.modeAll': 'ทั้งหมด',
  'examples.modePrototypeDesktop': 'ต้นแบบ · เดสก์ท็อป',
  'examples.modePrototypeMobile': 'ต้นแบบ · มือถือ',
  'examples.modeDeck': 'สไลด์นำเสนอ',
  'examples.modeDocument': 'เอกสารและเทมเพลต',
  'examples.modeOrbit': 'Orbit',
  'examples.modeLive': 'สด',
  'examples.scenarioGeneral': 'ทั่วไป',
  'examples.scenarioEngineering': 'วิศวกรรม',
  'examples.scenarioProduct': 'ผลิตภัณฑ์',
  'examples.scenarioDesign': 'การออกแบบ',
  'examples.scenarioMarketing': 'การตลาด',
  'examples.scenarioSales': 'ฝ่ายขาย',
  'examples.scenarioFinance': 'การเงิน',
  'examples.scenarioHr': 'ทรัพยากรบุคคล',
  'examples.scenarioOperations': 'ฝ่ายปฏิบัติการ',
  'examples.scenarioSupport': 'ฝ่ายสนับสนุน',
  'examples.scenarioLegal': 'กฎหมาย',
  'examples.scenarioEducation': 'การศึกษา',
  'examples.scenarioPersonal': 'ส่วนบุคคล',
  'examples.searchPlaceholder': 'ค้นหาตัวอย่าง…',
  'examples.searchAria': 'ค้นหา',
  'examples.emptyNoSkills': 'ไม่มีทักษะที่พร้อมใช้งาน',
  'examples.emptyNoMatch': 'ไม่มีตัวอย่างที่ตรงกัน',
  'examples.openPreview': '⤢ เปิดหน้าตัวอย่าง',
  'examples.loadingPreview': 'กำลังโหลด…',
  'examples.hoverPreview': 'เลื่อนเมาส์ไปที่นี่เพื่อดูตัวอย่าง',
  'examples.usePrompt': 'ใช้คำสั่งนี้',
  'examples.previewModalTitle': 'ดูตัวอย่าง',
  'examples.shareTitle': 'แชร์ตัวอย่างนี้',
  'examples.shareLoadFirst': 'โหลดหน้าตัวอย่างก่อน',
  'examples.unavailablePlaceholder': 'ไม่มีตัวอย่าง {kind} ที่เผยแพร่แล้ว — เปิดเพื่อดูข้อมูลเพิ่มเติม',
  'examples.shareUnavailable': 'ไม่มีตัวอย่าง {kind} ที่ส่งมอบแล้วให้แชร์',
  'examples.shareMenu': 'แชร์ ▾',
  'examples.exportPdfAllSlides': 'ดาวน์โหลด PDF',
  'examples.exportPptxLocked': 'ดาวน์โหลด PPTX',
  'examples.tagSlideDeck': 'สไลด์นำเสนอ',
  'examples.tagTemplate': 'เทมเพลต',
  'examples.tagDesignSystem': 'ระบบการออกแบบ',
  'examples.tagMobilePrototype': 'ต้นแบบมือถือ',
  'examples.tagDesktopPrototype': 'ต้นแบบเดสก์ท็อป',
  'examples.tagImage': 'ภาพ',
  'examples.tagVideo': 'วิดีโอ',
  'examples.tagAudio': 'เสียง',
  'examples.previewLabel': 'ดูตัวอย่าง',
  'ds.surfaceLabel': 'พื้นที่',
  'ds.surfaceWeb': 'เว็บไซต์',
  'ds.surfaceImage': 'รูปภาพ',
  'ds.surfaceVideo': 'วิดีโอ',
  'ds.surfaceAudio': 'เสียง',
  'ds.searchPlaceholder': 'ค้นหา design systems…',
  'ds.emptyNoMatch': 'ไม่พบ design systems',
  'ds.badgeDefault': 'ค่าเริ่มต้น',
  'ds.preview': 'ดูตัวอย่าง',
  'ds.previewTitle': 'ตัวอย่าง',
  'ds.categoryAll': 'ทั้งหมด',
  'ds.categoryUncategorized': 'ไม่มีหมวดหมู่',
  'ds.showcase': 'โชว์เคส',
  'ds.tokens': 'โทเค็น',
  'ds.specToggle': 'DESIGN.md',
  'ds.specLoading': 'กำลังโหลด…',
  'avatar.title': 'บัญชีและการตั้งค่า',
  'avatar.localCli': 'CLI ในเครื่อง',
  'avatar.anthropicApi': 'Anthropic API',
  'avatar.useLocal': 'ใช้ Local CLI',
  'avatar.useApi': 'ใช้ API · BYOK',
  'avatar.codeAgent': 'เอเจนต์โค้ด',
  'avatar.rescan': 'สแกนหาใหม่',
  'avatar.amrConsole': 'บัญชี OpenDesign Cloud',
  'avatar.amrConsoleMeta': 'ยอดคงเหลือและการเติมเงิน',
  'avatar.settings': 'การตั้งค่า',
  'avatar.backToProjects': 'กลับไปยังโปรเจกต์',
  'avatar.metaActive': 'เปิดใช้งาน',
  'avatar.metaOffline': 'ออฟไลน์',
  'avatar.metaSelected': 'เลือกแล้ว',
  'avatar.noAgentSelected': 'ไม่ได้เลือกเอเจนต์',
  'avatar.modelSection': 'โมเดล',
  'avatar.modelLabel': 'โมเดล',
  'avatar.reasoningLabel': 'การใช้เหตุผล',
  'avatar.serviceTierLabel': 'ระดับบริการ',
  'avatar.customSuffix': '(กำหนดเอง)',
  'socialShare.openDesignSection': 'แชร์ OpenDesign',
  'socialShare.openDesignTitle': 'OpenDesign บน GitHub',
  'socialShare.openDesignText': 'OpenDesign คือพื้นที่ทำงานแบบ source-available สำหรับการสร้าง แก้ไข เผยแพร่ และส่งต่อชิ้นงานออกแบบ',
  'socialShare.openDesignCopyText': '{text}\n{url}',
  'socialShare.projectSection': 'แชร์ลงโซเชียล',
  'socialShare.publishPageTitle': 'เผยแพร่หน้าแชร์',
  'socialShare.publishPageSubtitle': 'เผยแพร่ตัวอย่างนี้เพื่อแชร์บนแพลตฟอร์มโซเชียลได้',
  'socialShare.projectTitle': '{title} · OpenDesign',
  'socialShare.projectText': 'สร้างด้วย OpenDesign: {title} ดูชิ้นงานที่เผยแพร่และกดดาวให้ repo: {repo}',
  'socialShare.projectCopyText': 'สร้างด้วย OpenDesign: {title}\n{url}\nrepo ของ OpenDesign: {repo}',
  'socialShare.deployFirst': 'ดีพลอยแล้วแชร์…',
  'socialShare.copied': 'คัดลอกแล้ว',
  'socialShare.platform.x': 'X',
  'socialShare.platform.linkedin': 'LinkedIn',
  'socialShare.platform.facebook': 'Facebook',
  'socialShare.platform.reddit': 'Reddit',
  'socialShare.platform.telegram': 'Telegram',
  'socialShare.platform.whatsapp': 'WhatsApp',
  'socialShare.platform.weibo': 'Weibo',
  'socialShare.platform.line': 'LINE',
  'socialShare.platform.instagram': 'Instagram',
  'socialShare.platform.xiaohongshu': 'Xiaohongshu',
  'inlineSwitcher.chipTitle': 'สลับ CLI / โมเดล',
  'inlineSwitcher.chipCli': 'CLI ในเครื่อง',
  'inlineSwitcher.chipByok': 'BYOK',
  'inlineSwitcher.modelDefault': 'ค่าเริ่มต้น',
  'inlineSwitcher.noAgent': 'ไม่มี Agent',
  'inlineSwitcher.modeLabel': 'โหมด',
  'inlineSwitcher.agentLabel': 'Agent',
  'inlineSwitcher.providerLabel': 'ผู้ให้บริการ',
  'inlineSwitcher.modelLabel': 'โมเดล',
  'inlineSwitcher.useCli': 'ใช้ CLI ในเครื่อง',
  'inlineSwitcher.useByok': 'ใช้ API key แบบ BYOK',
  'inlineSwitcher.daemonOffline': 'Daemon ออฟไลน์ — เปิดการตั้งค่า',
  'inlineSwitcher.noAgentsDetected': 'ไม่พบ CLI ใน PATH',
  'inlineSwitcher.openSettingsForModel': 'ตั้งค่าผู้ให้บริการในการตั้งค่า',
  'inlineSwitcher.missingApiKey': 'ยังไม่ได้ตั้งค่า API key — เปิดการตั้งค่าเพื่อเพิ่ม',
  'inlineSwitcher.openFullSettings': 'เปิดการตั้งค่าการดำเนินการ',
  'inlineSwitcher.customSuffix': '(กำหนดเอง)',
  'inlineSwitcher.unlimitedBadge': 'ไม่จำกัด',
  'project.backToProjects': 'กลับไปยังโปรเจกต์',
  'project.brandReadyTitle': 'ระบบดีไซน์ {name} พร้อมแล้ว',
  'project.brandReadyTitleGeneric': 'ระบบดีไซน์ของคุณพร้อมแล้ว',
  'project.brandReadyCta': 'ดูตัวอย่างใน ดีไซน์ซิสเต็ม',
  'project.brandReadyDismiss': 'ปิด',
  'project.brandReadyRefineHint': 'Automatic extraction can miss details. Refine it before using this system broadly.',
  'project.brandReadyAiOptimize': 'AI Optimize',
  'project.brandReadyEditManually': 'Edit manually',
  'project.brandReadyPreviewOpened': 'เปิดตัวอย่างระบบออกแบบแล้ว',
  'project.previewCommentSaveFailed': 'ไม่สามารถบันทึกความคิดเห็นได้ กรุณาลองใหม่อีกครั้ง',
  'project.previewCommentSaveFailedTitle': 'บันทึกความคิดเห็นไม่สำเร็จ',
  'project.previewCommentSaveFailedDescription': 'ความคิดเห็นนี้ยังไม่ได้รับการบันทึก กรุณาลองใหม่อีกครั้ง',
  'project.previewCommentReorderFailed': 'ไม่สามารถบันทึกลำดับความคิดเห็นได้ และอาจรีเซ็ตเมื่อโหลดหน้าใหม่',
  'project.metaFreeform': 'ฟรีฟอร์ม',
  'project.typePrototype': 'ต้นแบบ',
  'project.typeDeck': 'สไลด์',
  'project.typeTemplate': 'เทมเพลต',
  'project.typeImage': 'รูปภาพ',
  'project.typeVideo': 'วิดีโอ',
  'project.typeAudio': 'เสียง',
  'project.customInstructions': 'คำแนะนำของโปรเจกต์',
  'project.customInstructionsPlaceholder': 'คำสั่งสำหรับโปรเจกต์นี้ (แทรกในทุกข้อความ)…',
  'project.resizeChatPanel': 'ปรับขนาดแผงแชท',
  'project.instructionsActive': 'ใช้งานอยู่ — รวมอยู่ในทุกข้อความ',
  'project.missing': 'This project has been deleted or no longer exists.',
  'chat.tabChat': 'แชท',
  'chat.tabComments': 'ความคิดเห็น',
  'chat.commentsSoon': 'ความคิดเห็น — เร็วๆ นี้',
  'chat.comments.attached': 'แนบในแชทแล้ว',
  'chat.comments.emptyAttached': 'ไม่มีความคิดเห็น',
  'chat.comments.saved': 'บันทึกความคิดเห็นแล้ว',
  'chat.comments.emptySaved': 'ไม่มีการบันทึกความคิดเห็น',
  'chat.comments.add': 'เพิ่ม',
  'chat.comments.addAll': 'เพิ่มทั้งหมด',
  'chat.comments.remove': 'ลบ',
  'chat.comments.placeholder': 'แสดงความคิดเห็นเกี่ยวกับส่วนนี้…',
  'chat.comments.addSend': 'เพิ่ม & ส่ง',
  'chat.comments.updateSend': 'อัปเดต & ส่ง',
  'chat.comments.removeAttachment': 'ลบไฟล์แนบ',
  'chat.comments.removeAttachmentAria': 'ลบไฟล์แนบความคิดเห็นสำหรับ {name}',
  'chat.comments.comment': 'ความคิดเห็น',
  'chat.comments.sendToChat': 'ส่งไปยังแชต',
  'chat.comments.viewAll': 'ดูความคิดเห็นทั้งหมด',
  'chat.comments.sending': 'กำลังส่ง…',
  'chat.comments.edit': 'แก้ไข',
  'chat.comments.select': 'เลือก',
  'chat.comments.expandBody': 'ขยาย',
  'chat.comments.collapseBody': 'ย่อ',
  'chat.comments.selectAll': 'เลือกทั้งหมด',
  'chat.comments.deselect': 'ยกเลิกการเลือก',
  'chat.comments.nSelected': 'เลือกแล้ว {n} รายการ',
  'chat.comments.pin': 'ปักหมุด',
  'chat.comments.addNote': 'เพิ่มโน้ต',
  'chat.comments.savedToast': 'บันทึกความคิดเห็นแล้ว',
  'chat.comments.pinSavedToast': 'บันทึกหมุดแล้ว',
  'chat.comments.pinAtCoords': 'at {x}, {y}',
  'chat.comments.capturedItems': 'รายการที่บันทึกไว้ {n} รายการ',
  'chat.comments.clear': 'ล้าง',
  'chat.comments.targetImage': 'รูปภาพ',
  'chat.comments.targetControl': 'ตัวควบคุม',
  'chat.comments.targetLink': 'ลิงก์',
  'chat.comments.targetText': 'ข้อความ',
  'chat.comments.targetSection': 'ส่วน',
  'chat.comments.targetPage': 'หน้า',
  'chat.comments.targetArea': 'พื้นที่',
  'chat.annotationNotePlaceholder': 'เพิ่มโน้ตสำหรับเครื่องหมายนี้',
  'chat.annotationAttachImage': 'แนบรูปภาพ',
  'chat.annotationAttachedImages': 'รูปภาพที่แนบ',
  'chat.annotationAttachedRemove': 'ลบรูปภาพล่าสุด',
  'chat.annotationAddToInput': 'เพิ่มลงในช่องป้อนข้อมูล',
  'chat.annotationAddingToInput': 'กำลังเพิ่ม...',
  'chat.annotationQueue': 'คิว',
  'chat.annotationQueueing': 'กำลังเข้าคิว...',
  'chat.annotationSubmitOptions': 'ตัวเลือกการส่ง',
  'chat.annotationSending': 'กำลังส่ง...',
  'chat.annotationSendDisabledReason': 'มีงานกำลังทำงานอยู่',
  'chat.annotationPreviewMissing': 'ไม่สามารถจับภาพตัวอย่างได้ โปรดลองอีกครั้ง',
  'chat.annotationPreviewMissingInk': 'ไม่สามารถจับภาพตัวอย่างได้ ลองอีกครั้งเพื่อหลีกเลี่ยงการส่งเฉพาะลายเส้น',
  'chat.annotationSentWithoutScreenshot': 'ไม่สามารถจับภาพตัวอย่างได้ ส่งคำอธิบายประกอบโดยไม่มีภาพหน้าจอแล้ว',
  'chat.annotationTimeout': 'การส่งคำอธิบายประกอบหมดเวลา โปรดลองอีกครั้ง',
  'chat.annotationFailed': 'การส่งคำอธิบายประกอบล้มเหลว โปรดลองอีกครั้ง',
  'chat.annotationProjectCreateFailed': 'ไม่สามารถสร้างโปรเจกต์ได้ จึงไม่ได้ส่งคำอธิบายประกอบ',
  'chat.annotationUploadFailed': 'การอัปโหลดไฟล์แนบล้มเหลว โปรดลองอีกครั้ง',
  'chat.attachmentFolderUnsupported': 'ไม่สามารถแนบโฟลเดอร์ที่นี่ได้ โปรดแนบไฟล์ภายในโฟลเดอร์แทน',
  'chat.conversationsTitle': 'การสนทนา',
  'chat.conversationsAria': 'ประวัติ',
  'chat.newConversation': 'สนทนาใหม่',
  'chat.newSession': 'สนทนาใหม่',
  'chat.newConversationsTitle': 'เริ่มใหม่',
  'chat.conversationsHeading': 'บทสนทนาทั้งหมด',
  'chat.emptyConversations': 'ยังไม่มีบทสนทนา',
  'chat.deleteConversation': 'ลบบทสนทนา',
  'chat.renameConversationLabel': 'เปลี่ยนชื่อ "{title}"',
  'chat.deleteConversationConfirm': 'ลบ "{title}" หรือไม่?',
  'chat.untitledConversation': 'บทสนทนาที่ไม่มีชื่อ',
  'chat.forkConversationFailed': 'ไม่สามารถเริ่มสนทนาใหม่ได้',
  'chat.startTitle': 'เริ่มแชทได้เลย',
  'chat.startHint': 'อธิบายสิ่งที่ต้องการสร้าง หรือเริ่มจากตัวอย่างเหล่านี้:',
  'chat.brandBrowserAssistDesktopOnly': 'Browser assist needs the desktop app so OpenDesign can read the live browser page.',
  'chat.brandBrowserAssistReadFailed': 'Could not read the browser page. Make sure the brand site is open and fully loaded.',
  'chat.memoryWrittenSummary': 'จดจำ {count} ความชอบแล้ว',
  'chat.brandBrowserAssistMessage': 'OpenDesign needs browser assist to finish this brand extraction. Use the card below to open Browser, then click More, choose Download Page, wait for the success message, and use the left Next Step card to continue extraction.',
  'chat.brandBrowserLocalSnapshotMissing': 'No saved page snapshot is available for this URL.',
  'chat.brandBrowserLocalSnapshotReadFailed': 'Could not read the saved page snapshot.',
  'chat.brandBrowserSnapshotSaveFailed': 'Could not save a page snapshot from the browser.',
  'chat.brandBrowserAssistDownloadGuideTitle': 'Browser opened',
  'chat.brandBrowserAssistDownloadGuideDetails': 'Step 1: Browser is open. Step 2: click More, then Download Page. Step 3: wait for the saved snapshot success message. Step 4: return to the left Next Step card and click Continue extraction to continue the programmatic extraction.',
  'brandEnrichment.title': "เพิ่มประสิทธิภาพด้วย AI",
  'brandEnrichment.body': "OpenDesign จะรันการดึงข้อมูลเชิงลึกในเบื้องหลัง ใช้ skills ของ design system ที่เหมาะสมโดยอัตโนมัติ และอัปเดตระบบนี้ในที่เดิม อาจใช้เวลา 10-20 นาที คุณยังทำงานต่อได้",
  'brandEnrichment.cta': "เพิ่มประสิทธิภาพด้วย AI",
  'brandEnrichment.busy': "กำลังเริ่มเพิ่มประสิทธิภาพด้วย AI...",
  'brandExtractionTranscript.sourceDesignMd': 'DESIGN.md ที่วางไว้',
  'brandExtractionTranscript.user': 'ดึงระบบออกแบบจาก {source}',
  'brandExtractionTranscript.doneTitle': 'การดึงข้อมูลแบบโปรแกรมสำหรับ {name} เสร็จแล้ว',
  'brandExtractionTranscript.doneBody': 'ฉันสร้างและลงทะเบียนระบบออกแบบ {designSystemId} จาก {source} แล้ว ตอนนี้พร้อมดูตัวอย่างและใช้ในงานออกแบบใหม่ได้',
  'brandExtractionTranscript.next': 'ขั้นต่อไป คุณสามารถเรียกใช้ AI Optimize เพื่อดึงข้อมูลเชิงลึกขึ้น หรือสร้างงานออกแบบใหม่ด้วยระบบนี้',
  'chat.fillInputTitle': 'คลิกเพื่อใส่ข้อความ',
  'chat.jumpToLatest': 'เลื่อนไปล่าสุด',
  'chat.scrollToLatest': 'เลื่อนลงล่าง',
  'chat.messageRail.aria': 'การนำทางข้อความผู้ใช้',
  'chat.messageRail.jumpAria': 'ข้ามไปยังข้อความผู้ใช้ {index}',
  'chat.messageRail.empty': '(ไม่มีเนื้อหา)',
  'chat.you': 'คุณ',
  'chat.record.retryImage': 'สร้างภาพประกอบไม่สำเร็จ {count} ภาพ — ช่วยสร้างใหม่อีกครั้ง',
  'chat.quote.add': 'เพิ่มลงในแชท',
  'chat.quote.count': '{count} บันทึก',
  'chat.quote.duplicate': 'เพิ่มลงในแชทแล้ว',
  'chat.quote.removeAria': 'ลบบันทึก',
  'chat.support.title': 'ติดต่อฝ่ายสนับสนุน',
  'chat.support.join': 'เข้าร่วม',
  'chat.sendFailedRetryAria': 'ส่งไม่สำเร็จ — ลองอีกครั้ง',
  'chat.sendTargetMissing': "ไม่สามารถส่งได้: โปรเจกต์หรือการสนทนาถูกลบหรือไม่มีอยู่อีกต่อไป",
  'chat.audio.play': 'เล่น',
  'chat.audio.pause': 'หยุดชั่วคราว',
  'chat.audio.download': 'ดาวน์โหลด {name}',
  'chat.upgrade.balance': 'ยอดคงเหลือ',
  'chat.upgrade.whyLow': 'อาจไม่พอสำหรับงานถัดไป — ถ้าหมดระหว่างทาง งานจะค้างอยู่ครึ่งทาง',
  'chat.upgrade.whyOut': 'ตอนนี้ยังเริ่มงานใหม่ไม่ได้',
  'chat.upgrade.pausedTitle': 'ยอดคงเหลือไม่เพียงพอ งานถูกหยุดชั่วคราว',
  'chat.upgrade.pausedMessage': 'ยอดคงเหลือไม่เพียงพอ โปรดเติมเงินหรืออัปเกรดแพ็กเกจแล้วลองอีกครั้ง',
  'chat.upgrade.pausedTeamTitle': 'ยอดคงเหลือของทีมไม่เพียงพอ งานถูกหยุดชั่วคราว',
  'chat.upgrade.pausedTeamMessage': 'ยอดคงเหลือของทีมไม่เพียงพอ โปรดติดต่อผู้ดูแลทีมเพื่อเติมเงินหรืออัปเกรดการสมัครใช้งาน',
  'chat.openFile': 'เปิด {name}',
  'chat.copyPrompt': 'คัดลอกพรอมต์',
  'chat.copyErrorDiagnostic': 'คัดลอกข้อมูลวิเคราะห์ข้อผิดพลาด',
  'chat.copyDone': 'คัดลอกแล้ว!',
  'chat.inspect.noEditableTargets': 'ไม่พบข้อความหรือเป้าหมายสไตล์ที่แก้ไขได้',
  'chat.inspect.noCommentTargets': 'ไม่พบข้อความหรือเป้าหมายภาพที่แสดงความคิดเห็นได้',
  'chat.inspect.editHint': 'เลือกข้อความหรือเป้าหมายสไตล์ในตัวอย่างเพื่อแก้ไข',
  'chat.inspect.commentHint': 'เลือกข้อความหรือพื้นที่ในตัวอย่างเพื่อแสดงความคิดเห็น',
  'chat.composerPlaceholder': 'อธิบายสิ่งที่ต้องการสร้าง…',
  'chat.activeFileEditingLabel': 'กำลังแก้ไข',
  'chat.activeFilePlaceholder': 'ขอให้ OpenDesign แก้ไข {file}...',
  'chat.designArtifactsShowMore': 'แสดงไฟล์ดีไซน์เพิ่มอีก {count} ไฟล์',
  'chat.mode.chat.label': 'ถาม',
  'chat.mode.chat.title': 'โหมดถาม',
  'chat.mode.chat.summary': 'สำหรับคำตอบเร็ว การแก้ไข การวางแผน และการสนทนา โดยไม่ถือว่าต้องสร้างชิ้นงานออกแบบเสมอไป',
  'chat.mode.chat.solves': 'ใช้เพื่อทำความคิดให้ชัด ปรับ prompt เปรียบเทียบตัวเลือก หรือถามเกี่ยวกับงานที่มีอยู่',
  'chat.mode.chat.query1': 'สรุปร่างนี้และชี้จุดที่ยังขาด',
  'chat.mode.chat.query2': 'ช่วยเลือกโครงสร้างที่ดีที่สุดสำหรับ landing page นี้',
  'chat.mode.chat.query3': 'รีวิวดีไซน์นี้และเสนอการปรับปรุงที่ชัดเจน',
  'chat.mode.plan.label': "Plan",
  'chat.mode.plan.title': "Plan mode",
  'chat.mode.plan.summary': "Creates an editable plan document first, then hands off to Design after you review it.",
  'chat.mode.plan.solves': "Use it for PRDs, slide outlines, prototype briefs, wireframes, storyboards, and any broad request that needs confirmation before generation.",
  'chat.mode.plan.query1': "Create a slide-by-slide PPT outline first.",
  'chat.mode.plan.query2': "Draft a PRD before generating the prototype.",
  'chat.mode.plan.query3': "Turn this idea into an editable design plan.",
  'chat.mode.design.label': 'ออกแบบ',
  'chat.mode.design.title': 'โหมดออกแบบ',
  'chat.mode.design.summary': 'สำหรับสร้างหรือแก้ไขผลงานจริง เช่น หน้าเว็บ prototype live artifact สไลด์ รูปภาพ วิดีโอ HyperFrames เสียง dashboard และไฟล์โปรเจกต์',
  'chat.mode.design.solves': 'ใช้เมื่ออยากให้ OpenDesign สร้างไฟล์ อัปเดต workspace หรือเปลี่ยน brief เป็นงานส่งมอบหลายรูปแบบ',
  'chat.mode.design.query1': 'สร้าง landing page เปิดตัวผลิตภัณฑ์และ HyperFrames prototype จาก brief นี้',
  'chat.mode.design.query2': 'ทำ deck นักลงทุน 10 สไลด์พร้อม speaker notes',
  'chat.mode.design.query3': 'สร้างคอนเซ็ปต์รูปภาพ วิดีโอ และเสียงสำหรับแคมเปญนี้',
  'chat.mode.cardBestFor': 'เหมาะสำหรับ',
  'chat.mode.cardTry': 'ลองถามว่า',
  'chat.mode.cardCost': 'การใช้งานโดยทั่วไป',
  'chat.mode.chat.cost': 'ต่ำ',
  'chat.mode.chat.costNote': 'เป็นเพียงการสนทนา ไม่มีการสร้างไฟล์ จึงใช้ทรัพยากรน้อยที่สุด',
  'chat.mode.plan.cost': 'มาตรฐาน',
  'chat.mode.plan.costNote': 'สร้างเอกสารแผนที่แก้ไขได้หนึ่งฉบับก่อนเริ่มสร้างงานจริง',
  'chat.mode.design.cost': 'สูง',
  'chat.mode.design.costNote': 'สร้างไฟล์และสื่อหลายรูปแบบ การทำงานหนึ่งครั้งจึงอาจใช้ทรัพยากรมากที่สุด',
  'chat.modePicker.choose': 'เลือกโหมด',
  'chat.modePicker.current': 'โหมด: {name}',
  'chat.modePicker.clear': 'ล้างโหมด',
  'chat.modePicker.mode': 'โหมด',
  'chat.composerHint': '⌘/Ctrl + Enter เพื่อส่ง · ระบุเป้าหมาย เนื้อหา สไตล์ และรูปแบบ',
  'chat.cliSettingsTitle': 'ตั้งค่าโมเดลและ CLI',
  'chat.cliSettingsAria': 'ตั้งค่า',
  'chat.attachTitle': 'แนบไฟล์ (วาง / ลาก)',
  'chat.addContextTitle': 'Add context',
  'chat.attachAria': 'แนบไฟล์',
  'chat.importTitle': 'นำเข้าจากที่อื่น (เร็วๆ นี้)',
  'chat.importLabel': 'นำเข้า',
  'chat.importComingSoon': 'เร็วๆ นี้',
  'chat.importSoon': 'เร็วๆ นี้',
  'chat.importFig': 'อัปโหลดไฟล์ Figma',
  'chat.importGitHub': 'ต่อ GitHub',
  'chat.importWeb': 'ดึงหน้าเว็บ',
  'chat.importFolder': 'ลิ้งก์โค้ดโฟลเดอร์',
  'chat.importSkills': 'ทักษะและระบบการออกแบบ',
  'chat.importProject': 'อ้างอิงโปรเจกต์อื่น',
  'chat.importDesignSystemHeader': 'เลือกระบบดีไซน์',
  'chat.importDesignSystemBack': 'กลับ',
  'chat.importDesignSystemSearch': 'ค้นหาระบบดีไซน์…',
  'chat.importDesignSystemEmpty': 'ไม่มีระบบดีไซน์ที่ตรงกับ "{query}"',
  'chat.importDesignSystemNone': 'ไม่มี — อิสระ',
  'chat.importDesignSystemNoneSub': 'รอบนี้ไม่ยึดติดกับระบบใด',
  'chat.importDesignSystemActive': 'ใช้งานอยู่',
  'chat.importDesignSystemSwitched': 'สลับระบบดีไซน์ไปเป็น {title}',
  'chat.importDesignSystemFailed': 'ไม่สามารถสลับระบบดีไซน์ได้ โปรดลองอีกครั้ง',
  'chat.importDesignSystemLoadFailed': 'ไม่สามารถโหลดระบบการออกแบบได้',
  'browserUse.title': 'แรงบันดาลใจ',
  'browserUse.summary': 'การกระทำบนเว็บ {count} รายการ โดยให้ความสำคัญกับการดึงทรัพยากร ภาษาการออกแบบ การเคลื่อนไหว การตรวจสอบภาพ และโครงสร้างคอมโพเนนต์',
  'browserUse.searchAria': 'ค้นหาแรงบันดาลใจ',
  'browserUse.searchPlaceholder': 'ค้นหาภาพหน้าจอ ฟอนต์ สี a11y...',
  'browserUse.empty': 'ไม่มีแรงบันดาลใจที่ตรงกัน',
  'browserUse.unavailable': 'ไม่มีแรงบันดาลใจให้ใช้งานที่นี่',
  'browserUse.added': 'เพิ่มลงในตัวเรียบเรียงแล้ว',
  // Design Browser
  'designBrowser.aria': 'Design Browser',
  'designBrowser.goBack': 'Go Back',
  'designBrowser.goForward': 'Go Forward',
  'designBrowser.reload': 'Reload',

  'designBrowser.stopLoading': 'หยุดโหลด',
  'designBrowser.viewportAria': 'Browser viewport',
  'designBrowser.addressPlaceholder': 'Enter URL or search...',
  'designBrowser.addressAria': 'Browser address',
  'designBrowser.suggestion.reference': 'Reference',
  'designBrowser.suggestion.history': 'History',
  'designBrowser.menu.copyScreenshot': 'Copy Screenshot',
  'designBrowser.menu.hardReload': 'Hard Reload',
  'designBrowser.menu.copyUrl': 'Copy URL',
  'designBrowser.menu.openInBrowser': 'Open in Browser',
  'designBrowser.menu.savePageBrief': 'Save Page Brief',
  'designBrowser.menu.clearBrowsingHistory': 'Clear Browsing History',
  'designBrowser.menu.clearCookies': 'Clear Cookies',
  'designBrowser.menu.clearAllData': 'Clear All Data',
  'designBrowser.status.openHttpUrlFirst': 'Open an http URL first',
  'designBrowser.status.openPageBeforeScreenshot': 'Open a page before taking a screenshot',
  'designBrowser.status.screenshotCopied': 'Screenshot copied to clipboard',
  'designBrowser.status.openPageBeforeBrief': 'Open a page before saving a brief',
  'designBrowser.status.openPageBeforeTools': 'Open a page before using browser tools',
  'designBrowser.status.clickElementToComment': 'Click an element to comment',
  'designBrowser.status.clickElementToTune': 'Click an element to tune',
  'designBrowser.status.noElementSelected': 'No browser element selected',
  'designBrowser.status.addBrowserComment': 'Add a browser comment',
  'designBrowser.status.tuneElementThenSaveHtml': 'Tune the element, then save HTML',
  'designBrowser.status.tuneLiveOnly': 'Tune is live only for non-project pages',
  'designBrowser.status.pickerFailed': 'Browser element picker failed',
  'designBrowser.status.applyStyleFailed': 'Could not apply style in browser page',
  'designBrowser.status.editTextFailed': 'Could not edit text in browser page',
  'designBrowser.status.onlyProjectHtmlCanSave': 'Only project-local HTML pages can be saved',
  'designBrowser.status.htmlSaved': 'HTML changes saved',
  'designBrowser.status.htmlSaveFailed': 'HTML save failed',
  'designBrowser.status.commentSavingUnavailable': 'Comment saving is unavailable',
  'designBrowser.status.commentSaved': 'Browser comment saved',
  'designBrowser.status.commentSendingUnavailable': 'Comment sending is unavailable',
  'designBrowser.comments.aria': 'Browser comments',
  'designBrowser.comments.openFor': 'Open browser comment for {label}',
  'designBrowser.comment.dialog': 'Browser comment',
  'designBrowser.comment.elementFallback': 'Browser element',
  'designBrowser.comment.close': 'Close browser comment',
  'designBrowser.comment.noteAria': 'Browser comment note',
  'designBrowser.comment.placeholder': 'Describe the change or issue...',
  'designBrowser.comment.addNote': 'Add note',
  'designBrowser.comment.saveComment': 'Save comment',
  'designBrowser.comment.sending': 'Sending...',
  'designBrowser.comment.sendToChat': 'Send to chat',
  'designBrowser.inspect.editTitle': 'Edit HTML element',
  'designBrowser.inspect.tuneTitle': 'Tune browser element',
  'designBrowser.inspect.closeTune': 'Close browser tune',
  'designBrowser.inspect.colors': 'Colors',
  'designBrowser.inspect.text': 'Text',
  'designBrowser.inspect.fill': 'Fill',
  'designBrowser.inspect.type': 'Type',
  'designBrowser.inspect.size': 'Size',
  'designBrowser.inspect.weight': 'Weight',
  'designBrowser.inspect.spacing': 'Spacing',
  'designBrowser.inspect.pad': 'Pad',
  'designBrowser.inspect.radius': 'Radius',
  'designBrowser.inspect.content': 'Content',
  'designBrowser.inspect.elementText': 'Element text',
  'designBrowser.inspect.saving': 'Saving...',
  'designBrowser.inspect.saveHtml': 'Save HTML',
  'designBrowser.inspect.liveOnly': 'Live only',
  'designBrowser.reference.kicker': 'OpenDesign browser',
  'designBrowser.reference.title': 'Reference Board',
  'designBrowser.reference.subtitle': 'A curated set of references across inspiration, real product UI, motion, color, type, assets, and design systems. Open one to browse it live while gathering design language for the next artifact.',
  'designBrowser.reference.categoryAria': 'Reference category',
  'designBrowser.reference.searchPlaceholder': 'Search references...',
  'designBrowser.reference.searchAria': 'Search references',
  'designBrowser.reference.clearSearch': 'Clear search',
  'designBrowser.reference.noMatches': 'No references match “{query}”.',
  'designBrowser.reference.clearFilters': 'Clear filters',
  'designBrowser.reference.open': 'Open',
  'designBrowser.reference.group.inspiration': 'Inspiration',
  'designBrowser.reference.group.interfaces': 'Real Interfaces',
  'designBrowser.reference.group.motion': 'Motion',
  'designBrowser.reference.group.color': 'Color',
  'designBrowser.reference.group.type': 'Typography',
  'designBrowser.reference.group.icons': 'Icons',
  'designBrowser.reference.group.illustration': 'Illustration',
  'designBrowser.reference.group.photography': 'Photography',
  'designBrowser.reference.group.3d': '3D & Graphics',
  'designBrowser.reference.group.mockups': 'Mockups',
  'designBrowser.reference.group.systems': 'Design Systems',
  'designBrowser.reference.group.components': 'Components',
  'designBrowser.reference.group.guidelines': 'Guidelines & A11y',
  'designBrowser.reference.group.tools': 'Tools & Resources',
  'designBrowser.reference.site.dribbble.detail': 'Design shots and UI inspiration.',
  'designBrowser.reference.site.behance.detail': 'Creative portfolios and case studies.',
  'designBrowser.reference.site.awwwards.detail': 'Award-winning website design.',
  'designBrowser.reference.site.godly.detail': 'Curated modern web design.',
  'designBrowser.reference.site.land_book.detail': 'Landing page gallery and patterns.',
  'designBrowser.reference.site.mobbin.detail': 'Real app screens and UI patterns.',
  'designBrowser.reference.site.screenlane.detail': 'Latest UI design patterns from apps.',
  'designBrowser.reference.site.pageflows.detail': 'Real product user flows and onboarding.',
  'designBrowser.reference.site.uisources.detail': 'Interaction patterns from top apps.',
  'designBrowser.reference.site.collectui.detail': 'Daily UI collection by category.',
  'designBrowser.reference.site.gsap.detail': 'Production animation engine and examples.',
  'designBrowser.reference.site.animations.detail': 'Animation patterns and interaction examples.',
  'designBrowser.reference.site.transitions.detail': 'Transition patterns for modern interfaces.',
  'designBrowser.reference.site.motionsites.detail': 'High-end motion and interaction references.',
  'designBrowser.reference.site.motion.detail': 'Scroll and timeline animation inspiration.',
  'designBrowser.reference.site.animography.detail': 'Animated type and kinetic lettering.',
  'designBrowser.reference.site.reactbits.detail': 'React text animation reference for shiny kinetic type.',
  'designBrowser.reference.site.coolors.detail': 'Fast color palette generator.',
  'designBrowser.reference.site.colorhunt.detail': 'Curated color palettes.',
  'designBrowser.reference.site.realtimecolors.detail': 'Preview palettes on a real UI.',
  'designBrowser.reference.site.color_adobe.detail': 'Color wheel and harmony rules.',
  'designBrowser.reference.site.happyhues.detail': 'Palettes shown in real context.',
  'designBrowser.reference.site.fonts_google.detail': 'Open-source font library.',
  'designBrowser.reference.site.fontshare.detail': 'Quality fonts free for commercial use.',
  'designBrowser.reference.site.typewolf.detail': 'Fonts in use and pairing guidance.',
  'designBrowser.reference.site.fontpair.detail': 'Font pairing suggestions.',
  'designBrowser.reference.site.fontsinuse.detail': 'Typography in real-world design.',
  'designBrowser.reference.site.thesvg.detail': 'SVG assets and vector references.',
  'designBrowser.reference.site.svglogos.detail': 'Clean SVG logos for product and brand mocks.',
  'designBrowser.reference.site.icons_lobehub.detail': 'Product and AI-brand icons for interfaces.',
  'designBrowser.reference.site.icon_sets_iconify.detail': '200k+ open-source icons in one place.',
  'designBrowser.reference.site.lucide.detail': 'Clean, consistent open icon set.',
  'designBrowser.reference.site.heroicons.detail': 'Tailwind-made SVG icons.',
  'designBrowser.reference.site.svgrepo.detail': 'Free SVG vectors and icons.',
  'designBrowser.reference.site.storyset.detail': 'Customizable vector illustrations.',
  'designBrowser.reference.site.undraw.detail': 'Open-source MIT illustrations.',
  'designBrowser.reference.site.blush.detail': 'Mix-and-match illustrations.',
  'designBrowser.reference.site.lummi.detail': 'Free AI-generated visuals.',
  'designBrowser.reference.site.whirrls.detail': 'Hand-drawn image references.',
  'designBrowser.reference.site.worldindots.detail': 'Dot-map and data-viz references.',
  'designBrowser.reference.site.unsplash.detail': 'Free high-resolution photos.',
  'designBrowser.reference.site.pexels.detail': 'Free stock photos and video.',
  'designBrowser.reference.site.pixabay.detail': 'Royalty-free images and media.',
  'designBrowser.reference.site.cosmos.detail': 'Visual discovery and mood boards.',
  'designBrowser.reference.site.spline.detail': 'Browser-based 3D design.',
  'designBrowser.reference.site.threejs.detail': 'WebGL 3D references and demos.',
  'designBrowser.reference.site.womp.detail': 'Easy in-browser 3D creation.',
  'designBrowser.reference.site.pixcap.detail': '3D icons, mockups, and scenes.',
  'designBrowser.reference.site.shots.detail': 'Device and browser mockups.',
  'designBrowser.reference.site.mockuuups.detail': 'Drag-and-drop device mockups.',
  'designBrowser.reference.site.angle.detail': '3D device mockup library.',
  'designBrowser.reference.site.rotato.detail': 'Animated 3D product mockups.',
  'designBrowser.reference.site.impeccable.detail': 'High-quality style and interface references.',
  'designBrowser.reference.site.styles_refero.detail': 'Design style references and visual systems.',
  'designBrowser.reference.site.brandfetch.detail': 'Brand assets, logos, and identity.',
  'designBrowser.reference.site.designsystemsrepo.detail': 'Gallery of public design systems.',
  'designBrowser.reference.site.startups.detail': 'Top startup product and brand references.',
  'designBrowser.reference.site.base_ui.detail': 'Unstyled accessible primitives for custom systems.',
  'designBrowser.reference.site.ui_shadcn.detail': 'Composable React components built on Radix and Tailwind.',
  'designBrowser.reference.site.heroui.detail': 'Modern React component library and design system.',
  'designBrowser.reference.site.radix_ui.detail': 'Accessible low-level UI primitives.',
  'designBrowser.reference.site.react_spectrum_adobe.detail': 'Accessible behavior primitives from Adobe.',
  'designBrowser.reference.site.headlessui.detail': 'Unstyled accessible components for Tailwind projects.',
  'designBrowser.reference.site.mui.detail': 'Material-based React component ecosystem.',
  'designBrowser.reference.site.mantine.detail': 'Full-featured React components and hooks.',
  'designBrowser.reference.site.chakra_ui.detail': 'Accessible React components with theme tokens.',
  'designBrowser.reference.site.ant.detail': 'Enterprise component system and patterns.',
  'designBrowser.reference.site.ark_ui.detail': 'Headless components across modern frameworks.',
  'designBrowser.reference.site.daisyui.detail': 'Tailwind CSS component classes and themes.',
  'designBrowser.reference.site.developer_apple.detail': 'Apple platform design guidelines.',
  'designBrowser.reference.site.m3_material.detail': 'Google\'s Material Design 3.',
  'designBrowser.reference.site.lawsofux.detail': 'UX principles and heuristics.',
  'designBrowser.reference.site.webaim.detail': 'Color contrast checker.',
  'designBrowser.reference.site.a11yproject.detail': 'Accessibility checklist and patterns.',
  'designBrowser.reference.site.toolfolio.detail': 'Design tools, resources, and collections.',
  'designBrowser.reference.site.getdesign.detail': 'Curated design resources.',
  'designBrowser.reference.site.tasteskill.detail': 'Design taste training and critique references.',
  'designBrowser.reference.site.uigoodies.detail': 'Hand-picked design resources.',
  'designBrowser.reference.site.sidebar.detail': 'Five design links, every day.',
  'designBrowser.reference.site.github.detail': 'Reference implementation for embedded browser workflows.',
  'browserUse.category.assets': 'การดึงทรัพยากร',
  'browserUse.category.tokens': 'ภาษาการออกแบบ',
  'browserUse.category.motion': 'การเคลื่อนไหว',
  'browserUse.category.visual': 'การตรวจสอบภาพ',
  'browserUse.category.structure': 'คอมโพเนนต์',
  'browserUse.category.project': 'การรันโปรเจกต์',
  'browserUse.category.general': 'ทั่วไป',
  'browserUse.input.none': 'ไม่มีอินพุต',
  'browserUse.input.assetKind': 'kind: images | svgs | media | fonts, limit=200',
  'browserUse.input.optionalSelector': 'ตัวเลือก (ไม่บังคับ)',
  'browserUse.input.requirementSelector': 'ข้อกำหนด, ตัวเลือก (ไม่บังคับ)',
  'browserUse.input.selectorOptional': 'ตัวเลือก (ไม่บังคับ)',
  'browserUse.input.scaleOne': 'scale=1',
  'browserUse.input.selectorScaleTwo': 'ตัวเลือก, scale=2',
  'browserUse.input.gridOverlay': '12 คอลัมน์, สูงสุด 1200, ระยะห่าง 24',
  'browserUse.input.bodySelector': 'selector=\'body\'',
  'browserUse.input.navigate': 'URL, โดเมน, หรือคำค้นหา',
  'browserUse.input.selector': 'ตัวเลือก',
  'browserUse.input.selectorText': 'ตัวเลือกและข้อความ',
  'browserUse.input.scroll': 'พิกเซล, บน, ล่าง, หรือทั้งหน้า',
  'browserUse.input.terminalRun': 'คำสั่ง, หมดเวลา 120 วินาที',
  'browserUse.input.command': 'คำสั่ง',
  'browserUse.input.maxChars': 'maxChars=8000',
  'browserUse.input.custom': '{input}',
  'browserUse.action.extract_logo.output': 'ผู้สมัครโลโก้ที่ดีที่สุดจากส่วนหัว, นำทาง, ชื่อคลาส, ตำแหน่ง, ภาพ OG, และการสำรองด้วย favicon',
  'browserUse.action.list_images.output': 'img, srcset, source ทั้งหมด และภาพพื้นหลัง CSS พร้อมขนาดและข้อความ alt',
  'browserUse.action.download_assets.output': 'โฟลเดอร์ทรัพยากรที่ดาวน์โหลดพร้อม _manifest.json ที่รองรับ referer และ cookie',
  'browserUse.action.extract_svgs.output': 'SVG แบบอินไลน์และไฟล์ .svg ที่ลิงก์ไว้ บันทึกเป็นไฟล์ SVG แต่ละไฟล์',
  'browserUse.action.optimize_svgs.output': 'ไฟล์ SVG ที่ปรับให้เหมาะสมพร้อมอัตราการบีบอัด',
  'browserUse.action.extract_colors.output': 'จานสีแบบถ่วงน้ำหนักพร้อมตัวแปรสี CSS :root เป็น palette.json และ palette.html',
  'browserUse.action.extract_fonts.output': 'ตระกูลฟอนต์ ขนาด น้ำหนัก และกฎ @font-face ยอดนิยม เป็น typography.json',
  'browserUse.action.extract_design_tokens.output': 'รัศมี, เงา, ระยะห่าง, และตัวแปร CSS เป็น tokens.json',
  'browserUse.action.extract_type_scale.output': 'สเกลของหัวเรื่อง, เนื้อหา, และปุ่ม พร้อมขนาด น้ำหนัก ความสูงบรรทัด และอัตราส่วน',
  'browserUse.action.extract_buttons.output': 'คลังสไตล์ปุ่มที่ตัดข้อมูลซ้ำแล้ว เป็น buttons.html และ buttons.json',
  'browserUse.action.extract_grid_system.output': 'คอนเทนเนอร์ grid และ flex, ทิศทาง, ระยะห่าง, คอลัมน์, และความกว้างสูงสุด เป็น layout.json',
  'browserUse.action.extract_breakpoints.output': 'เบรกพอยต์ของ media-query แบบ responsive เป็น breakpoints.json',
  'browserUse.action.extract_gradients.output': 'เกรเดียนต์ CSS เป็น gradients.css, gradients.json, และ HTML แสดงตัวอย่าง',
  'browserUse.action.extract_shadows.output': 'เงากล่อง, เงาข้อความ, และเงาทอด เป็น shadows.json พร้อมตัวอย่าง',
  'browserUse.action.extract_easings.output': 'ฟังก์ชัน easing ของทรานซิชันและแอนิเมชัน เป็น easings.json',
  'browserUse.action.export_tokens.output': 'tokens.css, tokens.scss, tailwind.theme.js, และ style-dictionary.tokens.json',
  'browserUse.action.extract_animations.output': '@keyframes, กฎทรานซิชันและทรานส์ฟอร์ม, ไลบรารีการเคลื่อนไหวที่ตรวจพบ, motion.css, และ motion.json',
  'browserUse.action.validate_view.output': 'เส้นทางภาพหน้าจอพร้อมปัญหาภาพและเลย์เอาต์ที่จัดโครงสร้างแล้ว',
  'browserUse.action.audit_layout.output': 'ข้อบกพร่องของเลย์เอาต์ รวมถึงการล้น, ขอบเขต, การซ้อนทับ, และข้อความที่ถูกตัด เป็น audit.json',
  'browserUse.action.audit_accessibility.output': 'ปัญหาการเข้าถึง (A11y) เกี่ยวกับ selector, label, role, focus, ความต่างของสี และภาพหน้าจอในจุดที่เป็นประโยชน์',
  'browserUse.action.responsive_screenshots.output': 'ภาพหน้าจอแบบ Mobile 390, tablet 834 และ desktop 1440',
  'browserUse.action.screenshot_full.output': 'ภาพหน้าจอเต็มหน้าที่เกินขอบเขตของ viewport',
  'browserUse.action.screenshot_element.output': 'ภาพหน้าจอขององค์ประกอบเดียวที่ 2x โดยค่าเริ่มต้น',
  'browserUse.action.screenshot_with_grid.output': 'ภาพหน้าจอพร้อมเลเยอร์ grid แสดงเลย์เอาต์',
  'browserUse.action.screenshot_dark_mode.output': 'ภาพหน้าจอแบบ prefers-color-scheme: dark',
  'browserUse.action.generate_styleguide.output': 'สไตล์ไกด์หน้าเดียวพร้อมสี, type scale, radius และเงา',
  'browserUse.action.extract_html.output': 'HTML ที่สะอาดและครบในตัว ไม่มี script, noscript หรือ attribute ของ event แบบ inline',
  'browserUse.action.extract_component_inventory.output': 'รูปแบบคอมโพเนนต์ที่ใช้ซ้ำ, selector, จำนวน และภาพหน้าจอ',
  'browserUse.action.extract_copy.output': 'หัวข้อ, CTA, เนื้อหา และคำอธิบายในรูปแบบ copy.md และ copy.json',
  'browserUse.action.extract_nav.output': 'เมนูนำทางหลักและลิงก์ส่วนท้ายในรูปแบบ sitemap.md และ nav.json',
  'browserUse.action.extract_forms.output': 'ฟิลด์ฟอร์ม, label, คำแนะนำการตรวจสอบ และการดำเนินการส่งในรูปแบบ forms.json',
  'browserUse.action.run_project.output': 'URL ของ dev server ที่ตรวจพบ เปิดในแท็บ Browser',
  'browserUse.action.detect_project.output': 'เฟรมเวิร์ก, package manager, คำสั่งติดตั้ง, คำสั่ง dev และพอร์ต',
  'browserUse.action.page_info.output': 'URL, ชื่อเรื่อง, คำอธิบาย, OG image, สีธีม, favicon และ viewport',
  'browserUse.action.snapshot.output': 'องค์ประกอบแบบโต้ตอบและข้อความที่มองเห็นได้สูงสุด 120 รายการ พร้อม tag, label, href และพิกัด',
  'browserUse.action.navigate.output': 'เปิดหน้าและส่งคืน page_info',
  'browserUse.action.click.output': 'คลิกองค์ประกอบแรกที่ตรงกันหลังจากเลื่อนให้อยู่ในมุมมอง',
  'browserUse.action.type_text.output': 'กรอกข้อมูลในช่อง input และส่ง event input และ change',
  'browserUse.action.scroll.output': 'ตำแหน่งการเลื่อนปัจจุบันและสูงสุด',
  'browserUse.action.extract_og_metadata.output': 'Meta title, คำอธิบาย, canonical URL, OG/Twitter card, ภาพสำหรับโซเชียล และสีธีม',
  'browserUse.action.terminal_run.output': 'stdout, stderr และ exit code',
  'browserUse.action.terminal_run_background.output': 'id ของงานที่ทำงานเบื้องหลัง และผลลัพธ์ล่าสุด',
  'browserUse.action.terminal_read.output': 'ผลลัพธ์ terminal ที่แชร์ล่าสุด',
  'chat.designToolbox.title': 'กล่องเครื่องมือออกแบบ',
  'chat.designToolbox.tooltip': 'กล่องเครื่องมือออกแบบ',
  'chat.designToolbox.aria': 'เปิดกล่องเครื่องมือออกแบบ',
  'chat.designToolbox.searchPlaceholder': 'ค้นหา skill / MCP / plugin / connector / ไฟล์ออกแบบ...',
  'chat.designToolbox.searchAria': 'ค้นหาทรัพยากรในกล่องเครื่องมือออกแบบ',
  'chat.designToolbox.followupSection': 'ติดตามผล',
  'chat.designToolbox.resourcesSection': 'ทรัพยากรทั่วไป',
  'chat.designToolbox.selected': 'ที่เลือก',
  'chat.designToolbox.noResources': 'ไม่พบทรัพยากรสำหรับ "{query}"',
  'chat.designToolbox.badge.video': 'วิดีโอ',
  'chat.designToolbox.badge.image': 'รูปภาพ',
  'chat.designToolbox.badge.motion': 'การเคลื่อนไหว',
  'chat.designToolbox.badge.polish': 'ขัดเกลา',
  'chat.designToolbox.action.auto-match.title': 'จับคู่ขั้นตอนถัดไป',
  'chat.designToolbox.action.auto-match.badge': 'จับคู่',
  'chat.designToolbox.action.auto-match.description': 'กำหนดมาตรฐานรสนิยมก่อน จากนั้นจึงจับคู่ skill, MCP, plugin, connector และไฟล์',
  'chat.designToolbox.action.asset-search.title': 'Find images / references',
  'chat.designToolbox.action.asset-search.badge': 'Assets',
  'chat.designToolbox.action.asset-search.description': 'Search for usable images, reference screenshots, moodboards, and source candidates for the current design.',
  'chat.designToolbox.action.icon-workflow.title': 'Find / replace icons',
  'chat.designToolbox.action.icon-workflow.badge': 'Icons',
  'chat.designToolbox.action.icon-workflow.description': 'Find, generate, or swap iconography, SVGs, Lucide icons, and visual symbols with a consistent style.',
  'chat.designToolbox.action.image-replace.title': 'Replace page images',
  'chat.designToolbox.action.image-replace.badge': 'Swap',
  'chat.designToolbox.action.image-replace.description': 'Audit current imagery and replace weak hero, section, background, or card images with better assets.',
  'chat.designToolbox.action.reference-extract.title': 'Extract visual references',
  'chat.designToolbox.action.reference-extract.badge': 'Refs',
  'chat.designToolbox.action.reference-extract.description': 'Analyze a reference screenshot or site for palette, typography, layout posture, motion, and asset direction.',
  'chat.designToolbox.action.motion.title': 'เพิ่มอนิเมชัน / การเคลื่อนไหว',
  'chat.designToolbox.action.motion.badge': 'การเคลื่อนไหว',
  'chat.designToolbox.action.motion.description': 'เพิ่มการเคลื่อนไหวแบบ entrance, scroll, state-transition และ micro-interaction ให้กับ HTML หรือองค์ประกอบหน้าปัจจุบัน',
  'chat.designToolbox.action.motion-polish.title': 'ขัดเกลาการเคลื่อนไหว',
  'chat.designToolbox.action.motion-polish.badge': 'จังหวะเวลา',
  'chat.designToolbox.action.motion-polish.description': 'ตรวจสอบจังหวะเวลา, easing, ประสิทธิภาพ และ fallback แบบ reduced-motion สำหรับการเคลื่อนไหวที่มีอยู่',
  'chat.designToolbox.action.transition-motion.title': 'Design transitions',
  'chat.designToolbox.action.transition-motion.badge': 'Transition',
  'chat.designToolbox.action.transition-motion.description': 'Design page, scene, loading, and state transitions with restrained timing and reduced-motion fallbacks.',
  'chat.designToolbox.action.threejs-scene.title': '3D / Three.js scene',
  'chat.designToolbox.action.threejs-scene.badge': '3D',
  'chat.designToolbox.action.threejs-scene.description': 'Add or plan Three.js, Spline, Vanta, particle, WebGL, map, or deck.gl-style interactive visuals.',
  'chat.designToolbox.action.anti-ai-polish.title': 'ลบความรู้สึกแบบ AI',
  'chat.designToolbox.action.anti-ai-polish.badge': 'รสนิยม',
  'chat.designToolbox.action.anti-ai-polish.description': 'ลบความรู้สึกแบบเทมเพลต, AI gradient, การวางการ์ดซ้อนแบบราคาถูก และเนื้อหาที่คลุมเครือ',
  'chat.designToolbox.action.visual-polish.title': 'ขัดเกลาการออกแบบ / พร้อมส่งมอบ',
  'chat.designToolbox.action.visual-polish.badge': 'ขัดเกลา',
  'chat.designToolbox.action.visual-polish.description': 'ตรวจสอบลำดับชั้นทางสายตา, ตัวอักษร, ระยะห่าง, พฤติกรรมแบบ responsive, การเข้าถึง และคุณภาพการส่งมอบ',
  'chat.designToolbox.action.image-gen.title': 'สร้างรูปภาพ / ภาพอ้างอิง',
  'chat.designToolbox.action.image-gen.badge': 'รูปภาพ',
  'chat.designToolbox.action.image-gen.description': 'สร้างภาพอ้างอิงของส่วนต่างๆ, asset, ไอคอน, ภาพสำหรับโซเชียล หรือ moodboard สำหรับหน้าปัจจุบัน',
  'chat.designToolbox.action.chart-gen.title': 'Generate charts / diagrams',
  'chat.designToolbox.action.chart-gen.badge': 'Charts',
  'chat.designToolbox.action.chart-gen.description': 'Generate ECharts, React Flow, diagrams, dashboards, relationship maps, or data-visualization assets.',
  'chat.designToolbox.action.logo-gen.title': 'Generate logo / identity',
  'chat.designToolbox.action.logo-gen.badge': 'Logo',
  'chat.designToolbox.action.logo-gen.description': 'Create logo routes, wordmarks, lockups, marks, and identity-system prompts for the current brand.',
  'chat.designToolbox.action.plan-outline.title': "Generate PPT outline from idea",
  'chat.designToolbox.action.plan-outline.badge': "Plan",
  'chat.designToolbox.action.plan-outline.description': "Turn a rough idea into an editable Markdown deck outline before creating slides.",
  'chat.designToolbox.action.video-gen.title': 'สร้างวิดีโอ / สคริปต์การเคลื่อนไหว',
  'chat.designToolbox.action.video-gen.badge': 'วิดีโอ',
  'chat.designToolbox.action.video-gen.description': 'แปลงงานออกแบบเป็นวิดีโอสั้น, สตอรีบอร์ด Remotion / Hyperframes หรือพรอมต์ที่พร้อมสำหรับการสร้าง',
  'chat.designToolbox.kind.skill': 'Skill',
  'chat.designToolbox.kind.plugin': 'ปลั๊กอิน',
  'chat.designToolbox.kind.mcp': 'MCP',
  'chat.designToolbox.kind.mcpTemplate': 'เทมเพลต MCP',
  'chat.designToolbox.kind.connector': 'Connector',
  'chat.designToolbox.kind.designFile': 'ไฟล์ดีไซน์',
  'chat.designToolbox.context.browser': 'เบราว์เซอร์',
  'chat.designToolbox.context.designFiles': 'ไฟล์ดีไซน์',
  'chat.designToolbox.context.designSystem': 'ระบบดีไซน์',
  'chat.designToolbox.context.folder': 'โฟลเดอร์',
  'chat.designToolbox.context.terminal': 'เทอร์มินัล',
  'chat.designToolbox.context.sideChat': 'แชทด้านข้าง',
  'chat.designToolbox.context.liveArtifact': 'Artifact สด',
  'chat.designToolbox.context.file': 'ไฟล์',
  'chat.designToolbox.prompt.contextGeneric': 'เป้าหมายปัจจุบัน: ไฟล์ HTML / ไฟล์ดีไซน์ / เว็บเอลิเมนต์ที่เปิดอยู่ในขณะนี้',
  'chat.designToolbox.prompt.contextSpecific': 'เป้าหมายปัจจุบัน: {kind} · {label}',
  'chat.designToolbox.prompt.preserveDraft': 'คงเจตนาที่มีอยู่แล้วในกล่องเขียนข้อความไว้: {draft}',
  'chat.designToolbox.prompt.selectedSkill': 'สกิลที่เลือก: {skill} ใช้เป็นเวิร์กโฟลว์หลักสำหรับรอบนี้',
  'chat.designToolbox.prompt.noSkill': 'หากไม่มีสกิลที่ตรงกันโดยเฉพาะ ให้เลือกชุดผสมผสานที่ดีที่สุดจากสกิล, MCP, ปลั๊กอิน, connector และไฟล์ดีไซน์ที่มีอยู่ก่อน',
  'chat.designToolbox.prompt.autoMatchIntro': 'ทำหน้าที่เป็นตัวประสานงานในบทบาท Creative Director และทำเวิร์กโฟลว์ดีไซน์ให้เสร็จสมบูรณ์:',
  'chat.designToolbox.prompt.autoMatchStep1': '1. กำหนดความหมายของ “ดีไซน์ที่ดูดี” ก่อน: กลุ่มเป้าหมาย เป้าหมายทางธุรกิจ ความรู้สึกของแบรนด์ ตัวอย่างอ้างอิงสไตล์ ความหนาแน่นของข้อมูล มาตรฐานสี/ตัวอักษร/การเคลื่อนไหว/แอสเซ็ต และรูปแบบ AI/เทมเพลตที่ควรหลีกเลี่ยง',
  'chat.designToolbox.prompt.autoMatchStep2': '2. ค้นหาและจับคู่กับดัชนีทรัพยากรทั้งหมดด้านบน อย่าใช้เฉพาะคำแนะนำจากกล่องเครื่องมือดีไซน์เท่านั้น แต่ให้ผสมผสานสกิล, MCP, ปลั๊กอิน, connector และไฟล์ดีไซน์เมื่อเป็นประโยชน์',
  'chat.designToolbox.prompt.autoMatchStep3': '3. If the target or aesthetic bar is still unclear, guide me with a structured question-form, include recommended defaults, and make each finite-choice question editable with a custom answer field. If it is clear enough, execute the next step directly.',
  'chat.designToolbox.prompt.autoMatchStep4': '4. ทำขั้นตอนให้ครบตามลำดับนี้: วินิจฉัย -> ทิศทางสไตล์ -> การเลือกทรัพยากร -> การแก้ไข/สร้างงานที่เป็นรูปธรรม -> การตรวจสอบ ในแต่ละขั้นตอน ให้อธิบายว่าทำไมจึงเลือกทรัพยากรเหล่านี้ และมีอะไรที่ต้องยืนยันในขั้นตอนถัดไป',
  'chat.designToolbox.prompt.assetSearch': 'Find the best image/reference assets for the current design. Search available files, connectors, MCPs, browser captures, and generation tools. Return concrete candidates with usage notes, licensing/source caveats when relevant, and a fallback generation prompt if no usable asset exists.',
  'chat.designToolbox.prompt.iconWorkflow': 'Improve the icon system for the current design: find missing icons, replace weak icons, keep stroke/fill/radius/weight consistent, prefer existing icon libraries when available, and generate SVG/icon prompts only when a library icon is insufficient.',
  'chat.designToolbox.prompt.imageReplace': 'Audit every visible image slot in the current design, identify weak or placeholder imagery, then replace or specify better hero, section, background, card, and social images. Preserve layout and provide exact file/prompt/source choices.',
  'chat.designToolbox.prompt.referenceExtract': 'Use the current reference image/site/design file as visual input. Extract palette, type scale, layout rhythm, component posture, motion cues, and asset style, then apply those findings to the current design without copying protected brand assets verbatim.',
  'chat.designToolbox.prompt.motion': 'Add high-quality motion to the current HTML / page element: choose the most useful 1-2 entrance, scroll, state-transition, transition, Rive/Lottie-style icon motion, or GSAP/Motion micro-interaction moments. Keep it restrained, prefer transform / opacity, and include prefers-reduced-motion fallbacks.',
  'chat.designToolbox.prompt.planOutline': "Create or update a Markdown planning document for a PPT/deck outline from this idea. Do not generate the final deck yet. Include slide-by-slide titles, goals, content bullets, visual direction, required data/assets, and open questions. Save it as a `.md` file in Design Files and tell me which file to review.",
  'chat.designToolbox.prompt.motionPolish': 'ตรวจสอบและขัดเกลาจังหวะเวลา, easing, ประสิทธิภาพ และการเข้าถึงของโมชันที่มีอยู่ ลบแอนิเมชันที่กระตุก ดูราคาถูก หรือบั่นทอนความอ่านง่ายออก และใช้ไทม์ไลน์ที่ประณีตขึ้นเมื่อจำเป็น',
  'chat.designToolbox.prompt.transitionMotion': 'Design high-quality transitions for the current design: page/scene changes, loading bridges, state changes, and section handoffs. Use GSAP/Motion/CSS where appropriate, keep it performant, and include reduced-motion behavior.',
  'chat.designToolbox.prompt.threejsScene': 'Plan or implement a focused Three.js/WebGL visual for the current design. Consider Three.js, Spline-style scenes, Vanta backgrounds, particle systems, Mapbox/deck.gl data layers, or browser portal effects, but keep the scene useful and verify it renders.',
  'chat.designToolbox.prompt.antiAiPolish': 'ทำการขัดเกลาหนึ่งรอบเพื่อลดความรู้สึกแบบ AI: ลบเลย์เอาต์แบบเทมเพลต, ไล่สี/แสงเรืองที่ดูราคาถูก, การ์ดซ้อนกันที่ไร้ความหมาย และข้อความที่คลุมเครือออก คงข้อมูลไว้และทำให้รู้สึกเหมือนนักออกแบบจริงเป็นผู้ส่งมอบงาน',
  'chat.designToolbox.prompt.visualPolish': 'ขัดเกลาดีไซน์นี้จนพร้อมส่งมอบ: ตรวจสอบลำดับชั้น, ตัวอักษร, ระยะห่าง, พฤติกรรมแบบ responsive, สถานะของปุ่ม, สถานะว่าง/กำลังโหลด/ข้อผิดพลาด และการเข้าถึง แล้วแก้ไขปัญหาสำคัญที่สุดโดยตรง',
  'chat.designToolbox.prompt.imageGen': 'สร้างแผนสำหรับ visual asset ถัดไปของดีไซน์นี้: ภาพอ้างอิงของแต่ละส่วน, hero asset, ภาพประกอบ, ไอคอน, ภาพสำหรับโซเชียล หรือ moodboard ให้ตัดสินใจก่อนว่าขาดภาพประเภทใด แล้วจึงให้พรอมต์สำหรับสร้างที่นำไปใช้ได้จริง / แผนของไฟล์',
  'chat.designToolbox.prompt.chartGen': 'Generate the right chart, diagram, or data-visualization for the current design. Choose between ECharts, React Flow, SVG/CSS diagrams, radar charts, relationship maps, dashboards, or deck.gl/map visualizations based on the data and user goal.',
  'chat.designToolbox.prompt.logoGen': 'Create logo and identity directions for the current brand. Produce multiple routes for wordmark, symbol, lockup, palette, usage rules, and generation prompts; make sure the result is original and usable in the current artifact.',
  'chat.designToolbox.prompt.videoGen': 'ปรับดีไซน์นี้ไปสู่วิดีโอ: สร้างสตอรีบอร์ดวิดีโอสั้น, โครงสร้างเฟรมแบบ Hyperframes / Remotion หรือพรอมต์ที่พร้อมใช้กับ Sora/fal เน้นทำให้เนื้อหา HTML / หน้าเว็บที่มีอยู่กลายเป็นช็อตได้อย่างเป็นธรรมชาติ',
  'chat.designToolbox.prompt.useSkill': 'ใช้ {skill} กับดีไซน์ปัจจุบัน',
  'chat.designToolbox.prompt.skillInstruction': 'ตัดสินใจเป้าหมายต่อยอดที่ดีที่สุดก่อน แล้วทำให้เสร็จหนึ่งรอบอย่างเป็นรูปธรรม หากต้องพึ่งพา asset หรือ API ภายนอก ให้จัดเตรียมทางเลือกสำรองที่รันได้ หรือระบุว่าฉันต้องจัดหาอะไรให้',
  'chat.designToolbox.prompt.selectedResource': 'ทรัพยากรที่เลือก: {kind} · {title} ({id})',
  'chat.designToolbox.prompt.resourceDescription': 'คำอธิบายทรัพยากร: {description}',
  'chat.designToolbox.prompt.pluginResource': 'ใช้ปลั๊กอินนี้เป็นบริบทหลักสำหรับขั้นตอนดีไซน์ปัจจุบัน หากมันเปิดให้ป้อนข้อมูลหรือมี GenUI ให้นำทางฉันเลือกเมื่อจำเป็น หากไม่เหมาะกับเป้าหมาย ให้เลือกทรัพยากรส่วนกลางที่ดีกว่าและอธิบายเหตุผล',
  'chat.designToolbox.prompt.mcpResource': 'ให้เลือกใช้ความสามารถของ MCP นี้สำหรับขั้นตอนดีไซน์ถัดไป เมื่อต้องการ asset ภายนอก, การจับภาพเว็บ, การสร้างภาพ/วิดีโอ หรือข้อมูล ให้ตัดสินใจก่อนว่ามันทำงานนั้นได้หรือไม่ แล้วจึงให้แผนที่นำไปใช้ได้จริง',
  'chat.designToolbox.prompt.mcpTemplateResource': 'MCP นี้เป็นเทมเพลตที่ตั้งค่าได้ หากเป็นเครื่องมือที่มีประโยชน์ที่สุดสำหรับขั้นตอนดีไซน์นี้ ให้นำทางการตั้งค่าก่อน หากมีทางเลือกที่ตั้งค่าไว้แล้ว ให้ดำเนินการต่อด้วยทางเลือกนั้น',
  'chat.designToolbox.prompt.connectorResource': 'ใช้ connector นี้เมื่อต้องการข้อมูลจริง, asset, เนื้อหาในบัญชี หรือการเข้าถึงเวิร์กโฟลว์ภายนอก ก่อนใช้งาน ให้อธิบายว่าจะมีการอ่านหรือเขียนอะไรบ้าง และขอการยืนยันเมื่อเหมาะสม',
  'chat.designToolbox.prompt.fileResource': 'ใช้ไฟล์ดีไซน์นี้เป็นเป้าหมายดีไซน์ปัจจุบันหรือ asset อ้างอิง แล้วทำขั้นตอนถัดไปจากมัน หากต้องเปรียบเทียบกับไฟล์อื่น ให้ค้นหาต่อในไฟล์ดีไซน์ทั้งหมด',
  'chat.designToolbox.prompt.resourceIndex': 'ดัชนีทรัพยากรส่วนกลาง: สกิล({skills}), ปลั๊กอิน({plugins}), MCP({mcpEnabled} เปิดใช้งาน / {mcpTemplates} เทมเพลต), connector({connectors} เชื่อมต่อแล้ว), ไฟล์ดีไซน์({files})',
  'chat.designToolbox.prompt.searchableSkills': 'สกิลที่ค้นหาได้',
  'chat.designToolbox.prompt.searchablePlugins': 'ปลั๊กอินที่ค้นหาได้',
  'chat.designToolbox.prompt.availableMcp': 'MCP ที่มีให้ใช้',
  'chat.designToolbox.prompt.connectedConnectors': 'connector ที่เชื่อมต่อแล้ว',
  'chat.designToolbox.prompt.referenceDesignFiles': 'ไฟล์ดีไซน์อ้างอิง',
  'chat.designToolbox.prompt.mcpTemplateName': 'เทมเพลต {name}',
  'chat.designToolbox.prompt.processRule': 'Workflow rule: define the aesthetic goal and constraints first, then search and match resources; when user choice is needed, generate a structured question-form with editable custom answers and continue after confirmation.',
  'chat.designToolbox.prompt.moreSuffix': ', +อีก {count} รายการ',
  'chat.designToolbox.prompt.compactLine': '{label}: {values}{suffix}.',
  'chat.mentionTabsAria': 'พื้นที่สำหรับการ mention',
  'chat.mentionTabAll': 'ทั้งหมด',
  'chat.mentionTabTabs': 'แท็บ',
  'chat.mentionTabPlugins': 'ปลั๊กอิน',
  'chat.mentionTabSkills': 'สกิล',
  'chat.mentionTabMcp': 'MCP',
  'chat.mentionTabConnectors': 'ตัวเชื่อมต่อ',
  'chat.mentionTabFiles': 'ไฟล์ดีไซน์',
  'chat.mentionNoResults': 'ไม่พบผลลัพธ์สำหรับ “{query}”',
  'chat.mentionSearchPrompt': 'ค้นหาไฟล์ดีไซน์, แท็บ, ปลั๊กอิน, สกิล, เซิร์ฟเวอร์ MCP และ connector',
  'chat.mentionSectionTabs': 'แท็บ',
  'chat.mentionSectionPlugins': 'ปลั๊กอิน',
  'chat.mentionSectionSkills': 'สกิล',
  'chat.mentionSectionMcp': 'MCP',
  'chat.mentionSectionConnectors': 'ตัวเชื่อมต่อ',
  'chat.mentionSectionFiles': 'ไฟล์ดีไซน์',
  'chat.mentionActiveSkill': 'ใช้งานอยู่',
  'chat.mentionUseMcpTitle': 'ใช้ {name}',
  'chat.mentionUseConnectorTitle': 'ใช้ {name}',
  'chat.mentionPluginOfficial': 'ทางการ',
  'chat.mentionPluginMine': 'ปลั๊กอินของฉัน',
  'chat.linkedFolderRemoveAria': 'ลบโฟลเดอร์ที่ลิงก์ {path}',
  'chat.linkedFolderNotFound': 'หาโฟลเดอร์ไม่เจอ',
  'chat.linkedFolderAlready': 'ลิงก์ไว้แล้ว',
  'chat.linkedFolderPickError': 'เปิดโฟลเดอร์ไม่ได้',
  'chat.queuedEditQueuedTaskAria': 'แก้ไขงานในคิว',
  'chat.queuedSave': 'บันทึก',
  'chat.queuedCancel': 'ยกเลิก',
  'chat.queuedReorder': 'ลากเพื่อจัดลำดับใหม่',
  'chat.queuedEdit': 'แก้ไข',
  'chat.queuedHeader': 'อยู่ในคิว',
  'chat.queuedSteer': 'ชี้นำรอบนี้',
  'chat.queuedSteerInterrupts': 'ชี้นำรอบนี้ — จะหยุดการทำงานที่กำลังดำเนินอยู่',
  'chat.queuedSteerUnsupported': 'เอเจนต์นี้รับข้อความระหว่างรอบไม่ได้',
  'chat.queuedSteerClosed': 'รอบนี้หยุดรับข้อความแล้ว',
  'chat.queuedSteerFailed': 'ชี้นำรอบนี้ไม่สำเร็จ',
  'chat.queuedSteerTextOnly': 'รอบที่กำลังทำงานรับได้เฉพาะข้อความ — ส่งรายการที่มีไฟล์แนบนี้แยกต่างหาก',
  'chat.queuedFollowUpFallback': 'งานต่อเนื่องในคิว',
  'chat.send': 'ส่ง',
  'chat.stop': 'หยุด',
  'chat.removeAria': 'ลบ {name}',
  'chat.example1Title': 'ตัวอย่างคำสั่งบรรณาธิการ',
  'chat.example1Tag': 'นิตยสาร',
  'chat.example1Prompt': 'สไลด์บทความบรรณาธิการ 10 หน้า จัดวางแบบคลาสสิค สไตล์นิตยสารและเพิ่มตัวหนังสือใหญ่ๆ',
  'chat.example2Title': 'ตัวอย่างแดชบอร์ด Analytics',
  'chat.example2Tag': 'ข้อมูล',
  'chat.example2Prompt': 'แดชบอร์ดการวิเคราะห์เครื่องมือ SaaS — แถบแสดง KPI และตารางวิเคราะห์สถิติ',
  'chat.example3Title': 'ตัวอย่างรายงานหน้ายาว',
  'chat.example3Tag': 'บรรณาธิการ',
  'chat.example3Prompt': 'หน้าจอรายงานผลกิจกรรมประจำปีแบบแสดงข้อความและกราฟ เลื่อนดูได้ยาวๆ',
  'home.recommendation.eyebrow': 'แนะนำสำหรับคุณ',
  'home.recommendation.primaryCta': 'เริ่มสร้าง',
  'home.recommendation.change': 'ลองแบบอื่น',
  'home.recommendation.browseAll': 'ทุกประเภท',
  'home.recommendation.defaultProjectName': 'โปรเจกต์ใหม่',
  'home.recommendation.startFailed': 'ไม่สามารถเริ่มสร้างได้ โปรดลองอีกครั้ง',
  'studio.firstArtifactHint.title': 'งานออกแบบชิ้นแรกของคุณพร้อมแล้ว',
  'studio.firstArtifactHint.body': 'ลองแก้ไขและใส่คำอธิบายได้เลย พอใจเมื่อไรก็ส่งออกหรือแชร์ได้ทุกเมื่อ',
  'studio.firstArtifactHint.dismiss': 'เข้าใจแล้ว',
  'home.starter.product_ui_prototype.title': 'เริ่มด้วยต้นแบบผลิตภัณฑ์ที่แก้ไขได้',
  'home.starter.product_ui_prototype.desc': 'จากเป้าหมายของคุณ เริ่มด้วยอินเทอร์เฟซที่คลิกได้และปรับแต่งต่อได้',
  'home.starter.product_ui_prototype.firstPrompt': 'ออกแบบต้นแบบผลิตภัณฑ์ที่แก้ไขได้สำหรับ [ผลิตภัณฑ์ของคุณ] พร้อมหน้าจอหลักและโฟลว์หลักที่ชัดเจน',
  'home.starter.product_ui_component.title': 'เริ่มจากคอมโพเนนต์ที่นำกลับมาใช้ซ้ำได้',
  'home.starter.product_ui_component.desc': 'สร้างคอมโพเนนต์เดียวก่อน แล้วนำไปประกอบเป็นหน้าจอเต็ม',
  'home.starter.product_ui_component.firstPrompt': 'ออกแบบคอมโพเนนต์ [ชื่อคอมโพเนนต์] ที่นำกลับมาใช้ซ้ำได้ พร้อมสถานะหลักและรูปแบบต่าง ๆ',
  'home.starter.product_ui_lowfi.title': 'เริ่มด้วยต้นแบบความละเอียดต่ำ',
  'home.starter.product_ui_lowfi.desc': 'ร่างโครงสร้างก่อน แล้วค่อยเพิ่มความละเอียด',
  'home.starter.product_ui_lowfi.firstPrompt': 'สร้างไวร์เฟรมความละเอียดต่ำของหน้าจอหลักสำหรับ [ผลิตภัณฑ์ของคุณ]',
  'home.starter.marketing_landing.title': 'เริ่มด้วยแลนดิงเพจ',
  'home.starter.marketing_landing.desc': 'เปลี่ยนแคมเปญของคุณให้เป็นแลนดิงเพจที่พร้อมเผยแพร่',
  'home.starter.marketing_landing.firstPrompt': 'ออกแบบแลนดิงเพจสำหรับ [ผลิตภัณฑ์ของคุณ] พร้อมส่วนฮีโร่ ประโยชน์หลัก และคำกระตุ้นการกระทำที่ชัดเจน',
  'home.starter.marketing_multivariant.title': 'เริ่มด้วยแลนดิงเพจหลายแบบ',
  'home.starter.marketing_multivariant.desc': 'สร้างหลายเวอร์ชันเพื่อเปรียบเทียบก่อนตัดสินใจ',
  'home.starter.marketing_multivariant.firstPrompt': 'สร้างแลนดิงเพจ 3 แบบสำหรับ [ผลิตภัณฑ์ของคุณ] ด้วยข้อความฮีโร่ที่แตกต่างกันเพื่อเปรียบเทียบ',
  'home.starter.internal_dashboard.title': 'เริ่มด้วยแดชบอร์ดภายใน',
  'home.starter.internal_dashboard.desc': 'เริ่มจากเลย์เอาต์แดชบอร์ดสำหรับเวิร์กโฟลว์ของคุณ',
  'home.starter.internal_dashboard.firstPrompt': 'ออกแบบแดชบอร์ดภายในที่แสดง [ตัวชี้วัดหลัก] พร้อมตัวกรองและตารางข้อมูล',
  'home.starter.internal_report.title': 'เริ่มด้วยรายงาน',
  'home.starter.internal_report.desc': 'อธิบายข้อมูลและฟิลด์ที่คุณต้องการเห็น',
  'home.starter.internal_report.firstPrompt': 'สร้างหน้ารายงานที่สรุป [อธิบายข้อมูล ฟิลด์ และตัวชี้วัดที่คุณสนใจ]',
  'home.starter.general_menu.title': 'เริ่มด้วยโปรเจกต์แรกของคุณ',
  'home.starter.general_menu.desc': 'อธิบายสิ่งที่คุณต้องการ แล้วเราจะสร้างเวอร์ชันแรกที่แก้ไขได้ให้',
  'home.starter.general_menu.firstPrompt': 'สร้างเวอร์ชันแรกที่แก้ไขได้ของ [อธิบายสิ่งที่คุณต้องการสร้าง]',
  'chat.example4Title': 'วิดีโอ Motion สินค้า',
  'chat.example4Tag': 'Motion',
  'chat.example4Prompt': 'สร้างสตอรี่บอร์ดวิดีโอ motion 15 วินาทีสำหรับเปิดตัวแอปเพิ่มประสิทธิภาพ: hook เปิดเรื่อง, ภาพ UI ระยะใกล้, ตัวอักษรเคลื่อนไหว, transition ของฟีเจอร์, logo ตอนจบ และ CTA พร้อม timing คำอธิบายฉาก มุมกล้อง และข้อความบนจอ',
  'preview.usePlugin': 'ใช้ปลั๊กอิน',
  'preview.usePluginOnly': 'ใช้โดยไม่มีพรอมต์',
  'preview.usePluginOnlyDesc': 'ใช้โครงสร้างปลั๊กอินโดยไม่โหลดพรอมต์ตัวอย่าง',
  'preview.replicateContent': 'ใช้งาน',
  'preview.replicateContentDesc': 'ใช้พรอมต์ตัวอย่างเพื่อสร้างพรีวิวขึ้นใหม่',
  'preview.duplicateTemplate': 'Remix',
  'preview.duplicateTemplateDesc': 'Remix ตัวอย่างนี้เป็นโปรเจกต์ใหม่ที่แก้ไขได้',
  'preview.shareMenu': 'แชร์',
  'preview.exportMenu': 'ส่งออก',
  'preview.shareTemplateBadge': 'เทมเพลต',
  'preview.shareToX': 'X / Twitter',
  'preview.shareToReddit': 'Reddit',
  'preview.shareToFacebook': 'Facebook',
  'preview.shareToLinkedIn': 'LinkedIn',
  'preview.shareToInstagram': 'Instagram',
  'preview.shareToXiaohongshu': '小红书',
  'preview.copyTemplateLink': 'คัดลอกลิงก์เทมเพลต',
  'preview.copyShareText': 'คัดลอกข้อความสำหรับแชร์',
  'preview.shareSocialGroup': 'แชร์ไปยังโซเชียล',
  'preview.shareCopyGroup': 'คัดลอก',
  'preview.shareExportGroup': 'ส่งออกไฟล์',
  'preview.shareCopied': 'คัดลอกแล้ว',
  'preview.shareCopyFailed': 'คัดลอกไม่สำเร็จ',
  'preview.shareTextDefault': 'เทมเพลต OpenDesign: {title}',
  'preview.openInNewTab': 'เปิดในแท็บใหม่',
  'preview.exit': '⤓ ออก',
  'preview.fullscreen': '⤢ เต็มหน้าจอ',
  'preview.closeTitle': 'ปิด (Esc)',
  'preview.loading': 'กำลังโหลด {label}…',
  'preview.errorTitle': 'โหลดผิดพลาด',
  'preview.errorBody': 'โหลด HTML ไม่สำเร็จ โปรดลองอีกครั้ง',
  'preview.retry': 'ลองอีกครั้ง',
  'preview.unavailableTitle': 'ไม่มีตัวอย่างที่เผยแพร่สำหรับ {noun}',
  'preview.unavailableBody': 'เรียกใช้พรอมต์ในแชทเพื่อสร้างผลลัพธ์ {kind}',
  'preview.nounSkill': 'สกิลนี้',
  'preview.nounPlugin': 'ปลั๊กอินนี้',
  'preview.nounTemplate': 'เทมเพลตนี้',
  'preview.showSidebar': 'แสดง {label}',
  'preview.hideSidebar': 'ซ่อน {label}',
  'misc.savedTemplate': 'เทมเพลตที่เก็บไว้',
  'misc.primary': 'หลัก',
  'misc.designSystem': 'ระบบการออกแบบ',
  'workspace.designFiles': 'ไฟล์งานดีไซน์',
  'workspace.focusMode': 'โหมดโฟกัส',
  'workspace.showChat': 'เปิดแชท',
  'workspace.closeTab': 'ปิดแท็บ',
  'workspace.fileSyncDownloading': 'กำลังดาวน์โหลดจากทีม…',
  'workspace.fileSyncUploading': 'กำลังซิงค์กับทีม…',
  'workspace.deleteFileConfirm': 'ลบ "{name}" ทิ้งไปเลยหรือไม่?',
  'workspace.readonlyNotice': 'นี่คือโปรเจกต์ที่แชร์ — คุณสามารถดูและแสดงความคิดเห็นได้ แต่ไม่สามารถแก้ไขอาร์ติแฟกต์ผ่าน Chat หรือเครื่องมือแก้ไข',
  'workspace.readonlyNoticeBy': 'นี่คือโปรเจกต์ที่แชร์ซึ่งสร้างโดย {owner} — คุณสามารถดูและแสดงความคิดเห็นได้ แต่ไม่สามารถแก้ไขอาร์ติแฟกต์ผ่าน Chat หรือเครื่องมือแก้ไข',
  'workspace.deleteSelectedFilesConfirm': 'ลบไฟล์ {n} รายการที่เลือกออกจากโปรเจกต์?',
  'workspace.deleteSelectedFilesPartial': 'ลบ {n} รายการไม่ผ่าน',
  'workspace.openFromDesignFiles': 'เปิดไฟล์จาก',
  'workspace.designFilesLink': 'หน้าไฟล์งาน',
  'workspace.loadingSketch': 'กำลังโหลดกระดานวาด…',
  'workspace.newTab': 'แท็บใหม่',
  'workspace.searchFilesPlaceholder': 'Search files…',
  'workspace.openTabs': 'แท็บที่เปิดอยู่',
  'workspace.searchTabs': 'Search tabs',
  'workspace.noTabsFound': 'No tabs found',
  'workspace.openFile': 'Open a file',
  'workspace.noFilesMatch': 'No files match',
  'workspace.allFiles': 'All',
  'workspace.createNew': 'Create new',
  'workspace.tabOpen': 'Open',
  'workspace.sideChatContextBanner': 'Integrated context from the current conversation',
  'workspace.sideChatDefaultTitle': 'Side chat',
  'workspace.newTerminal': 'New Terminal',
  'workspace.newTerminalDescription': 'Open a shell in the project directory in a new tab',
  'workspace.newBrowser': 'New Browser',
  'workspace.newBrowserDescription': 'Open a built-in browser tab for reference sites and design research',
  'workspace.newSketchDescription': 'Sketch rough layouts and notes for the agent to use as design context',
  'workspace.terminalStarting': 'กำลังเริ่มเทอร์มินัล…',
  'workspace.terminalStartingDescription': 'กำลังเตรียมเชลล์ของโปรเจกต์ โดยปกติใช้เวลาไม่กี่วินาที',
  'workspace.terminalSessionEnded': 'เซสชันสิ้นสุดแล้ว',
  'workspace.terminalReconnecting': 'กำลังเชื่อมต่อใหม่…',
  'workspace.terminalStartFailed': 'ไม่สามารถเริ่มเซสชันเทอร์มินัลได้',
  'workspace.terminalRestart': 'เริ่มใหม่',
  'designFiles.title': 'ไฟล์ดีไซน์',
  'designFiles.upload': 'อัปโหลดไฟล์',
  'designFiles.pasteText': 'วางข้อความมาเป็นไฟล์',
  'designFiles.newSketch': 'กระดานวาดใหม่',
  'designFiles.newDocument': 'เอกสารใหม่',
  'designFiles.newDocumentTitle': 'สร้างเอกสาร Markdown ใหม่',
  'designFiles.empty': 'ลากไฟล์มาใส่เลย หรือสร้างภาพสเก็ตช์',
  'designFiles.buildingPreview': 'ดูตัวอย่างเต็มจอ',
  'designFiles.syncing': 'กำลังซิงค์ไฟล์ที่ทีมแชร์…',
  'designFiles.refresh': 'รีเฟรช',
  'designFiles.delete': 'ลบ',
  'designFiles.searchPlaceholder': 'ค้นหาไฟล์…',
  'designFiles.up': 'กลับขึ้นบน',
  'designFiles.back': 'ย้อนกลับ',
  'designFiles.crumbs': 'โปรเจกต์',
  'designFiles.rowMenu': 'เมนูจัดการ',
  'designFiles.openInTab': 'เปิดในแท็บ',
  'designFiles.download': 'ดาวน์โหลด',
  'designFiles.downloadSelected': 'โหลด {n} ลงเป็น ZIP',
  'designFiles.deleteSelected': 'ลบ {n}',
  'designFiles.clearSelection': 'ล้างการเลือก',
  'designFiles.selectPage': 'เลือกทั้งหมดหน้านี้',
  'designFiles.selectAll': 'เลือกทุกอย่าง',
  'designFiles.dropTitle': '⤓ วางไฟล์ที่นี่',
  'designFiles.dropDesc': 'รูป เอกสาร อ้างอิง — เอเจนต์จะเก็บมาใช้วิเคราะห์',
  'designFiles.dropLabel': 'วางไฟล์ที่นี่',
  'designFiles.upload.title': 'อัปโหลดไฟล์',
  'designFiles.paste.title': "วางข้อความแทนไฟล์",
  'designFiles.upload.label': 'อัปโหลด',
  'designFiles.paste.label': "วาง",
  'designFiles.documentTemplate.titleFallback': 'Document',
  'designFiles.documentTemplate.goalHeading': 'Goal',
  'designFiles.documentTemplate.goalBody': 'Describe what OpenDesign should generate, edit, or decide from this document.',
  'designFiles.documentTemplate.capabilitiesHeading': 'How to use this document',
  'designFiles.documentTemplate.capabilityMarkdown': 'Use any Markdown format: headings, tables, checklists, links, quotes, code blocks, and images.',
  'designFiles.documentTemplate.capabilityAgent': 'The OpenDesign agent can read, edit, and use this file as project context.',
  'designFiles.documentTemplate.capabilityImages': 'Paste images, or drag image files onto the editor; uploaded images are inserted at the cursor.',
  'designFiles.documentTemplate.scenarioHeading': 'Scenario guide',
  'designFiles.documentTemplate.scenario.prototype': 'For prototypes, outline the product goal, target users, flows, screens, modules, interaction states, responsive breakpoints, and design tokens such as color, type, spacing, radius, and motion.',
  'designFiles.documentTemplate.scenario.wireframe': 'For wireframes, describe the user flow, screen list, layout hierarchy, content blocks, low-fidelity constraints, and the questions the structure should answer before visual design.',
  'designFiles.documentTemplate.scenario.mobile': 'For mobile apps, list target platforms, screens, navigation model, gestures, native patterns, device sizes, states, and mobile design tokens.',
  'designFiles.documentTemplate.scenario.slideDeck': 'For slides, write a paginated PPT outline: one section per slide with title, purpose, key message, evidence, visual direction, speaker notes, and export needs.',
  'designFiles.documentTemplate.scenario.document': 'For documents, define audience, tone, section structure, source material, citations or data, layout expectations, and PDF/export requirements.',
  'designFiles.documentTemplate.scenario.image': 'For images, specify subject, aspect ratio, composition, visual style, brand tokens, reference files, and negative constraints.',
  'designFiles.documentTemplate.scenario.video': 'For video, draft a storyboard with scenes, timing, captions, motion, assets, audio notes, and output format.',
  'designFiles.documentTemplate.scenario.hyperframes': 'For HyperFrames, describe the HTML motion piece: scenes, timeline, captions, audio-reactive moments, transitions, and capture/export requirements.',
  'designFiles.documentTemplate.scenario.audio': 'For audio, define voice or music direction, duration, mood, script or copy, pacing, pronunciation notes, and final use.',
  'designFiles.documentTemplate.scenario.liveArtifact': 'For live artifacts, describe data sources, refresh cadence, widgets, filters, interactions, empty/loading/error states, and any alerts or automations.',
  'designFiles.documentTemplate.scenario.designSystem': 'For design systems, list brand goals, tokens, typography, color, spacing, components, assets, references, and rules to follow or avoid.',
  'designFiles.documentTemplate.scenario.default': 'Describe the audience, deliverable, required content, references, constraints, and what done should look like.',
  'designFiles.documentTemplate.nextHeading': 'Next step',
  'designFiles.documentTemplate.nextBody': 'Review and edit this document, then ask OpenDesign to generate, revise, or operate from it.',

  'designFiles.projectMenu': 'Project actions',
  'designFiles.createDesignSystemFromProject': 'Create design system from this project',
  'designFiles.duplicateProject': 'Duplicate project',

  'designFiles.previewOpen': 'เปิดดู',
  'designFiles.previewClose': 'ปิดหน้าต่าง',
  'designFiles.modified': 'แก้ไปตอน {time} · {size}',
  'designFiles.weeksAgo': '{n} สัปดาห์มาแล้ว',
  'designFiles.groupBy': 'จัดกลุ่มตาม',
  'designFiles.groupByKind': 'ประเภท',
  'designFiles.groupByModified': 'แก้ไขล่าสุด',
  'designFiles.filterBy': 'กรองตามประเภท',
  'designFiles.filterClear': 'ล้าง',
  'designFiles.filterCount': '{n} ประเภท',
  'designFiles.expandGroup': 'ขยาย',
  'designFiles.collapseGroup': 'ย่อ',
  'designFiles.sectionPages': 'หน้าเว็บ',
  'designFiles.sectionScripts': 'สคริปต์',
  'designFiles.sectionImages': 'รูปภาพ',
  'designFiles.sectionSketches': 'แบบร่าง',
  'designFiles.sectionLiveArtifacts': 'อาร์ติแฟกต์แบบไลฟ์',
  'designFiles.sectionOther': 'อื่นๆ',
  'designFiles.modifiedToday': 'วันนี้',
  'designFiles.modifiedYesterday': 'เมื่อวาน',
  'designFiles.modifiedPrevious7Days': '7 วันก่อนหน้า',
  'designFiles.modifiedPrevious30Days': '30 วันก่อนหน้า',
  'designFiles.modifiedOlder': 'เก่ากว่า',
  'designFiles.showMore': 'เปิดดูอีก +{n}',
  'designFiles.kindHtml': 'ไฟล์ HTML',
  'designFiles.kindImage': 'รูปภาพ',
  'designFiles.kindSketch': 'ภาพวาดร่าง',
  'designFiles.kindText': 'ข้อความ',
  'designFiles.kindCode': 'สคริปต์โค้ด',
  'designFiles.kindPdf': 'เอกสาร PDF',
  'designFiles.kindDocument': 'ไฟล์เอกสาร',
  'designFiles.kindPresentation': 'สไลด์',
  'designFiles.kindSpreadsheet': 'ตารางตัวเลข',
  'designFiles.kindLiveArtifact': 'ตัวแอป Live artifact',
  'designFiles.kindBinary': 'ไฟล์ไบนารี',
  'designFiles.kindFolder': 'โฟลเดอร์',
  'designFiles.folderCount': '{n} ไฟล์',
  'designFiles.newFolderTitle': 'โฟลเดอร์ใหม่',
  'designFiles.newFolderLabel': 'ชื่อโฟลเดอร์',
  'designFiles.moveTitle': 'ย้ายไปยังโฟลเดอร์',
  'designFiles.moveLabel': 'โฟลเดอร์ปลายทาง',
  'designFiles.moveRoot': 'รากของโปรเจกต์',
  'designFiles.moveNewFolder': 'โฟลเดอร์ใหม่…',
  'designFiles.move': 'ย้าย',
  'designFiles.copyPath': 'คัดลอกเส้นทาง',
  'designFiles.copiedPath': 'คัดลอกเส้นทางแล้ว',
  'designFiles.copyLocalPath': 'คัดลอกเส้นทางไฟล์ในเครื่อง',
  'designFiles.copiedLocalPath': 'คัดลอกเส้นทางไฟล์ในเครื่องแล้ว',
  'designFiles.deleteFolderConfirm': 'ลบโฟลเดอร์ "{name}" และเนื้อหาทั้งหมดหรือไม่?',
  'designFiles.folderCreated': 'สร้างโฟลเดอร์ "{name}" แล้ว',
  'designFiles.folderDeleted': 'ลบโฟลเดอร์ "{name}" แล้ว',
  'designFiles.filesMoved': 'ย้าย {n} รายการไปยัง {dest} แล้ว',
  'designFiles.colName': 'ชื่อ',
  'designFiles.colKind': 'ชนิด',
  'designFiles.colModified': 'ใช้งานล่าสุด',
  'designFiles.perPage': 'จำนวนแสดง',
  'designFiles.all': 'ทั้งหมด',
  'designFiles.prev': 'ก่อนหน้า',
  'designFiles.next': 'ถัดไป',
  'designFiles.jumpToPage': 'ไปหน้าที่',
  'designFiles.pageInfo': '{start}–{end} รวม {total}',
  'designFiles.sectionFolders': 'โฟลเดอร์',
  'designFiles.sectionStylesheets': 'สไตล์ชีต',
  'designFiles.sectionDocuments': 'เอกสาร',
  'designFiles.kindStylesheet': 'สไตล์ชีต',
  'designFiles.modifiedExt': 'แก้ไขเมื่อ {time} · {size} · {ext}',
  'designFiles.usefulInfoLabel': 'ข้อมูลที่เป็นประโยชน์',
  'designFiles.usefulInfoTip': 'ดับเบิลคลิกที่ไฟล์ใดก็ได้เพื่อเปิดในแท็บเต็ม',
  'designFiles.usefulInfoTip2': 'พิมพ์ @ ในแชทเพื่ออ้างอิงไฟล์เป็นบริบท',
  'designFiles.usefulInfoTip4': 'เลือกระบบดีไซน์เพื่อให้ผลลัพธ์ตรงกับสไตล์แบรนด์ของคุณ',
  'designFiles.usefulInfoTip5': 'ยังไม่มีไอเดีย? ลองเทมเพลตปลั๊กอินในคอมมูนิตี้บนหน้าแรก',
  'designFiles.usefulInfoTip6': 'มีคำถามหรือข้อเสนอแนะ? เข้าร่วม Discord ของเรา',
  'designFiles.usefulInfoTip7': 'ถ้าชอบ OpenDesign ฝากกดดาวให้เราบน GitHub',
  'designFiles.usefulInfoTip8': 'ติดตาม @OpenDesignHQ บน X เพื่อรับข่าวสารล่าสุด',
  'designFiles.usefulInfoTip9': 'ลากรูป เอกสาร หรือทั้งโฟลเดอร์มาที่แผงนี้ เอเจนต์จะใช้เป็นบริบท',
  'designFiles.usefulInfoTip10': 'กด สเก็ตช์ใหม่ วาดเลย์เอาต์คร่าว ๆ แล้วให้เอเจนต์สร้างตาม',
  'designFiles.usefulInfoTip11': 'เลือกองค์ประกอบใดก็ได้ในพรีวิวเพื่อคอมเมนต์ เอเจนต์จะแก้ไขเฉพาะจุด',
  'designFiles.usefulInfoTip12': 'ผลลัพธ์ยังไม่ถูกใจ? วงกลมชี้จุดเร็วกว่าอธิบายใหม่',
  'designFiles.usefulInfoTip13': 'ส่งออกดีไซน์เป็น PDF รูปภาพ หรือ HTML แบบสแตนด์อโลนได้ในคลิกเดียว',
  'designFiles.usefulInfoTip14': 'ถูกใจโปรเจกต์ไหน บันทึกเป็นเทมเพลตได้จากเมนูแชร์',
  'designFiles.usefulInfoTip15': 'หลังดีพลอยแล้ว สร้างการ์ดแชร์โซเชียลได้ทันที',
  'designFiles.usefulInfoTip16': 'ติดตาม @opendesign.ai บน Threads เพื่อดูความเคลื่อนไหวเบื้องหลัง',
  'designFiles.usefulInfoTip17': 'ติดตาม @opendesign.ai บน Instagram เพื่อรับแรงบันดาลใจด้านดีไซน์',
  'designFiles.usefulInfoTip18': 'สมัครติดตาม OpenDesign บน YouTube เพื่อดูบทเรียนและเดโม',
  'designFiles.usefulInfoTip19': 'ติดตาม OpenDesign บน LinkedIn เพื่อรับข่าวสารผลิตภัณฑ์',
  'designFiles.usefulInfoTip20': 'ติดตาม OpenDesign บน Xiaohongshu เพื่อรับเคล็ดลับและแรงบันดาลใจ',
  'quickSwitcher.placeholder': 'ค้นหาและเปิด…',
  'quickSwitcher.empty': 'ไร้ไฟล์ที่หาได้',
  'quickSwitcher.noMatches': 'ไม่เจอรายการที่ตรง',
  'quickSwitcher.navigate': 'ใช้ลูกศรหา',
  'quickSwitcher.open': 'เปิดได้เลย',
  'quickSwitcher.close': 'ปิดออก',
  'sketch.save': 'บันทึกรูป',
  'sketch.cancel': 'ยกเลิก',
  'sketch.saving': 'กำลังบันทึกรูปภาพ…',
  'sketch.saved': 'บันทึกแล้ว',
  'sketch.tooltipMainMenu': 'เมนูหลัก: บันทึก ส่งออก ความช่วยเหลือ และการตั้งค่าผืนผ้าใบ',
  'sketch.tooltipLock': "Keep the current drawing tool active for repeated use",
  'sketch.tooltipHand': "Pan the canvas without selecting objects",
  'sketch.tooltipSelection': "Select, move, resize, or edit objects on the canvas",
  'sketch.tooltipRectangle': "Draw a rectangle or card area",
  'sketch.tooltipDiamond': "Draw a diamond for decisions or branching structure",
  'sketch.tooltipEllipse': "Draw a circle or ellipse",
  'sketch.tooltipArrow': "Draw a directional connector or flow arrow",
  'sketch.tooltipLine': "Draw a straight divider or connector line",
  'sketch.tooltipFreedraw': "Draw freehand lines on the canvas",
  'sketch.tooltipText': "Add editable text to the canvas",
  'sketch.tooltipImage': "Insert an image into the canvas",
  'sketch.tooltipEraser': "Erase objects from the canvas",
  'sketch.tooltipFrame': "Create a frame to group a region of the canvas",
  'sketch.tooltipEmbeddable': "Web Embed only supports valid https:// or http:// links",
  'sketch.tooltipLaser': "Point at canvas content temporarily without changing it",
  'sketch.tooltipMoreTools': "Open additional tools such as frame, web embed, and laser pointer",
  'sketch.tooltipDirty': 'มีการเปลี่ยนผ่าน',
  'sketch.tooltipClean': 'บันทึกสมบูรณ์',
  'fileViewer.empty': 'คลิกที่ไฟล์เพื่อแสดงดู',
  'fileViewer.loading': 'กำลังเรียกโหลด…',
  'fileViewer.exportPptx': 'ส่งข้อมูลเป็น PPTX',
  'fileViewer.openInNewTab': 'เข้าจากหน้าต่างใหม่',
  'fileViewer.copyPath': 'ก็อปปี้ลิ้งก์',
  "fileViewer.copyingLink": "กำลังคัดลอก…",
  'fileViewer.copied': 'ทำการคัดลอก!',
  'fileViewer.share': 'แชร์ต่อ',
  'fileViewer.binaryMeta': 'ข้อมูล Binary · {size}',
  'fileViewer.binaryNote': 'เก็บไว้ในรูปแบบคอมพิวเตอร์ ({size} bytes). ให้คุณกดดาวน์โหลดโหลดดู',
  'fileViewer.pdfMeta': 'PDF ตัวย่อ · {size}',
  'fileViewer.documentMeta': 'ไฟล์เอกสาร',
  'fileViewer.presentationMeta': 'พรีเซนเทชั่น',
  'fileViewer.spreadsheetMeta': 'สเปรดชีตแสดงตาราง',
  'fileViewer.previewUnavailable': 'พรีวิวใช้ไม่ได้ ขอให้เปิดไฟล์จากภายนอกดู',
  'fileViewer.download': 'กดโหลด',
  'fileViewer.open': 'เรียกใช้',
  'fileViewer.imageMeta': 'รูปภาพขนาด · {size}',
  'fileViewer.reactMeta': 'โค้ด React · {size}',
  'fileViewer.sketchMeta': 'สเก็ตช์ · {size}',
  'fileViewer.markdownStreamingMeta': 'เตรียมหน้าพรีวิว…',
  'fileViewer.markdownErrorMeta': 'เกิดการเออเร่อในการจำลอง (อาจมีข้อมูลตกหล่น)',
  'fileViewer.markdownStreamingStatus': 'รอจำลอง… แสดง Markdown มาบ้างแล้ว',
  'fileViewer.markdownErrorStatus': 'พังในขั้นจำลอง แสดงชิ้นส่วนเดิมล่าสุด',
  'fileViewer.markdownSaving': "Saving...",
  'fileViewer.markdownSaveFailed': "Save failed",
  'fileViewer.markdownSaved': "Saved",
  'fileViewer.markdownAutoSaved': "Auto-saved · {time}",
  'fileViewer.markdownAutoSaveHint': "Auto-save on",
  'fileViewer.markdownViewMode': "Markdown view mode",
  'fileViewer.split': "Split",
  'fileViewer.markdownEditor': "Markdown editor",
  'fileViewer.markdownEditorPlaceholder': "Type notes, requirements, or instructions for this document...",
  'fileViewer.markdownPreview': "Markdown preview",
  'fileViewer.videoMeta': 'วิดีโอมาแล้ว · {size}',
  'fileViewer.audioMeta': 'คลิปเสียง · {size}',
  'fileViewer.reload': 'โหลดทับ',
  'fileViewer.reloadDisk': 'ดึงโหลดจากแหล่งล่าสุด',
  'fileViewer.copy': 'ก็อปปี้',
  'fileViewer.copyTitle': 'คัดลอกแบบจัดเต็ม',
  'fileViewer.saveDisabled': 'ปุ่มเซฟ (ตอนนี้อ่านได้เท่านั้น)',
  'fileViewer.save': 'เซฟด่วน',
  'fileViewer.preview': 'หน้าพรีวิว',
  'fileViewer.source': 'ซอร์สไฟล์',
  'fileViewer.tweaks': 'ตั้งปรับแต่ง',
  'fileViewer.tweaksUnavailable': 'ไม่มีพาเนลตั้งปรับแต่งในชิ้นงานนี้',
  'fileViewer.jsxModuleTitle': 'ไม่มีการแสดงตัวอย่างแบบสแตนด์อโลน',
  'fileViewer.jsxModuleBody': 'แชร์ได้เฉพาะไฟล์ HTML ที่ทำงานได้ด้วยตัวเองเท่านั้น โปรดส่งออกคอมโพเนนต์นี้เป็น HTML ก่อน',
  'fileViewer.jsxModuleCta': 'เปิดหน้าที่แสดงผลไฟล์นี้:',
  'fileViewer.comment': 'ช่วยคอมเมนต์',
  'fileViewer.edit': 'จัดการแก้ไข',
  'fileViewer.draw': 'วาดรูป',
  'fileViewer.mark': 'มาร์ก',
  'fileViewer.markTool': 'เครื่องมือมาร์ก',
  'fileViewer.boxSelect': 'เลือกแบบกล่อง',
  'fileViewer.textTool': 'ข้อความ',
  'fileViewer.textAnnotationRemove': 'ลบข้อความ',
  'fileViewer.screenshot': 'ภาพหน้าจอ',
  'fileViewer.versions.entry': 'เวอร์ชัน',
  'fileViewer.versions.entryFull': 'ประวัติเวอร์ชัน',
  'fileViewer.versions.title': 'เวอร์ชัน',
  'fileViewer.versions.countOne': '1 เวอร์ชัน',
  'fileViewer.versions.countMany': '{count} เวอร์ชัน',
  'fileViewer.versions.current': 'ปัจจุบัน',
  'fileViewer.versions.sourceAi': 'AI edit',
  'fileViewer.versions.sourceManual': 'Manual edit',
  'fileViewer.versions.sourceRestore': 'Restored',
  'fileViewer.versions.restoredFrom': 'Restored from v{version}',
  'fileViewer.versions.versionLabel': 'เวอร์ชัน {version}',
  'fileViewer.versions.listAria': 'เวอร์ชันของไฟล์',
  'fileViewer.versions.loading': 'กำลังโหลดเวอร์ชัน...',
  'fileViewer.versions.empty': 'ยังไม่มีเวอร์ชัน',
  'fileViewer.versions.loadFailed': 'ไม่สามารถโหลดเวอร์ชันได้',
  'fileViewer.versions.previewFailed': 'ไม่สามารถโหลดตัวอย่างเวอร์ชันนี้ได้',
  'fileViewer.versions.previewLoading': 'กำลังโหลดตัวอย่างเวอร์ชัน...',
  'fileViewer.versions.noPrompt': 'ไม่มีพรอมป์ที่บันทึกไว้',
  'fileViewer.versions.noPromptBody': 'ไม่มีการบันทึกพรอมป์สำหรับเวอร์ชันนี้',
  'fileViewer.versions.promptTitle': 'พรอมป์',
  'fileViewer.versions.copyPrompt': 'คัดลอกพรอมป์',
  'fileViewer.versions.fullscreen': 'ตัวอย่างเต็มหน้าจอ',
  'fileViewer.versions.open': 'เปิดตัวอย่างในหน้าต่างใหม่',
  'fileViewer.versions.currentHelp': 'นี่คือเวอร์ชันปัจจุบันอยู่แล้ว',
  'fileViewer.versions.restoreHelp': 'การสลับจะกู้คืน HTML นี้เป็นเวอร์ชันปัจจุบันใหม่',
  'fileViewer.versions.restore': 'สลับไปเวอร์ชันนี้',
  'fileViewer.versions.restoreConfirmTitle': 'สลับไปยังเวอร์ชันนี้หรือไม่?',
  'fileViewer.versions.restoreConfirmCta': 'สลับ',
  'fileViewer.versions.restoring': 'กำลังสลับ...',
  'fileViewer.versions.restoreFailed': 'ไม่สามารถสลับไปเวอร์ชันนี้ได้',
  'fileViewer.versions.restoreSuccess': 'สลับไปเวอร์ชันนี้แล้ว',
  'fileViewer.editScreenshotToChat': 'ส่งภาพหน้าจอไปยังแชท',
  'manualEdit.layers': 'เลเยอร์',
  'manualEdit.editableCount': 'ใช้แก้ได้ {count} รูปแบบ',
  'manualEdit.hiddenBadge': 'ซ่อน',
  'manualEdit.title': 'กล่องควบคุม',
  'manualEdit.fallbackTitle': 'แก้ไข',
  'manualEdit.movePanel': 'ย้ายแผงแก้ไข',
  'manualEdit.editParams': 'แก้ไขพารามิเตอร์',
  'manualEdit.closePanel': 'ปิดแผงแก้ไข',
  'manualEdit.selectLayer': 'เลือกเลเยอร์ขึ้นมา',
  'manualEdit.empty': 'เลือกกล่องด้านบนเพื่อเปิดดู',
  'manualEdit.noEditableLayers': 'ไม่พบเลเยอร์ที่แก้ไขได้',
  'manualEdit.noClass': 'ไร้คลาสสไตล์',
  'manualEdit.tabsAria': 'แท็บปรับโครง',
  'manualEdit.tabContent': 'ตัวหนังสือ',
  'manualEdit.tabStyle': 'สไตล์การตกแต่ง',
  'manualEdit.tabAttributes': 'พิกัดส่วนเสริม',
  'manualEdit.tabHtml': 'โค้ด HTML',
  'manualEdit.tabSource': 'ต้นกำเนิดโค้ด',
  'manualEdit.attributesJson': 'พิกัด JSON',
  'manualEdit.selectedHtml': 'โค้ดในตัวที่เลือก',
  'manualEdit.fullSource': 'เนื้อแท้ข้อมูลระบบ',
  'manualEdit.applyContent': 'รับเนื้อหาเข้า',
  'manualEdit.applyStyle': 'ใช้โครงตกแต่ง',
  'manualEdit.applyAttributes': 'รับพิกัดเข้า',
  'manualEdit.applyHtml': 'ตั้งต้น HTML',
  'manualEdit.applySource': 'รับโค้ดรันระบบ',
  'manualEdit.invalidAttributes': 'JSON แอททริบิวต์ใช้งานจริงไม่ได้',
  'manualEdit.changes': 'จุดถูกแก้แล้ว',
  'manualEdit.undo': 'กลับไปเก่า',
  'manualEdit.redo': 'เลื่อนมาใหม่',
  'manualEdit.noChanges': 'การใช้มือแก้ยังไม่มี',
  'manualEdit.imageUrl': 'จุดฝังภาพ (URL)',
  'manualEdit.altText': 'ตัวหนังสือข้อความลับ',
  'manualEdit.label': 'ตัวหนังสือข้างหน้า',
  'manualEdit.text': 'ข้อความ',
  'manualEdit.href': 'ตัวลิ้งก์ข้ามทาง (Href)',
  'manualEdit.textColor': 'ชุดสีตัวหนังสือ',
  'manualEdit.background': 'สีแผ่นพื้นหลัง',
  'manualEdit.fontSize': 'ความใหญ่ตัวหนังสือ',
  'manualEdit.weight': 'น้ำหนักความเข้ม',
  'manualEdit.align': 'ชิดกะตำแหน่ง',
  'manualEdit.textAlignLeft': 'ชิดซ้าย',
  'manualEdit.textAlignCenter': 'กึ่งกลาง',
  'manualEdit.textAlignRight': 'ชิดขวา',
  'manualEdit.padding': 'ขยายเขตภายใน',
  'manualEdit.margin': 'ขยายเขตภายนอก',
  'manualEdit.radius': 'ขอบมน',
  'manualEdit.referenceValues': 'ค่าอ้างอิง',
  'manualEdit.referenceValuesEmpty': 'ไม่มีค่าอ้างอิงที่ตรงกัน',
  'manualEdit.referenceValuesLoading': 'กำลังโหลด…',
  'manualEdit.lineHeight': 'ความสูงบรรทัด',
  'manualEdit.letterSpacing': 'ระยะห่างตัวอักษร',
  'manualEdit.borderStyle': 'รูปแบบเส้นขอบ',
  'manualEdit.borderStyleSolid': 'เส้นทึบ',
  'manualEdit.borderStyleDashed': 'เส้นประ',
  'manualEdit.borderStyleDotted': 'เส้นจุด',
  'manualEdit.borderStyleDouble': 'เส้นคู่',
  'manualEdit.borderStyleNone': 'ไม่มี',
  'manualEdit.border': 'ความหนาเส้น',
  'manualEdit.width': 'ขนาดความกว้าง',
  'manualEdit.minHeight': 'ส่วนเตี้ยที่สุด',
  'manualEdit.deleteElement': 'ลบองค์ประกอบ',
  'manualEdit.deleteElementConfirm': 'ลบองค์ประกอบที่เลือกหรือไม่ สามารถยกเลิกได้ด้วยเลิกทำ',
  'manualEdit.alignCenter': "Center",
  'manualEdit.opacity': "Opacity",
  'manualEdit.uploadImage': 'อัปโหลดรูปภาพ',
  'manualEdit.uploadingImage': 'กำลังอัปโหลดรูปภาพ…',
  'manualEdit.uploadImageFailed': 'ไม่สามารถอัปโหลดรูปภาพได้',
  'manualEdit.focusSlides': 'โฟกัสสไลด์',
  'manualEdit.showPanels': 'แสดงแผง',
  'manualEdit.parameters': "Parameters",
  'manualEdit.fontFamily': "Font",
  'manualEdit.borderColor': "Border color",
  'manualEdit.borderWidth': "Border width",
  'manualEdit.height': "Height",
  'manualEdit.sideTop': "Top",
  'manualEdit.sideBottom': "Bottom",
  'manualEdit.sideLeft': "Left",
  'manualEdit.sideRight': "Right",
  'manualEdit.layoutDirection': "Direction",
  'manualEdit.distribution': "Distribution",
  'manualEdit.gap': "Gap",
  'manualEdit.layoutUnavailable': "Layout controls are available for flex or grid containers.",
  'manualEdit.directionRow': "Horizontal",
  'manualEdit.directionRowReverse': "Horizontal reverse",
  'manualEdit.directionColumn': "Vertical",
  'manualEdit.directionColumnReverse': "Vertical reverse",
  'manualEdit.justifyStart': "Start",
  'manualEdit.justifyCenter': "Center",
  'manualEdit.justifyEnd': "End",
  'manualEdit.justifyBetween': "Space between",
  'manualEdit.justifyAround': "Space around",
  'manualEdit.justifyEvenly': "Space evenly",
  'manualEdit.alignStart': "Start",
  'manualEdit.alignEnd': "End",
  'manualEdit.alignStretch': "Stretch",
  'manualEdit.alignBaseline': "Baseline",
  'fileViewer.zoomOut': 'หุบมุมมอง',
  'fileViewer.zoomIn': 'ซูมมองชัด',
  'fileViewer.resetZoom': 'ซูมรีเซ็ตหน้าจอ',
  'fileViewer.viewportAria': 'วิวพอร์ตตัวอย่าง',
  'fileViewer.viewportDesktop': 'เดสก์ท็อป',
  'fileViewer.viewportDesktopTitle': 'ตัวอย่างเดสก์ท็อปแบบเต็มความกว้าง',
  'fileViewer.viewportTablet': 'แท็บเล็ต',
  'fileViewer.viewportTabletTitle': 'ตัวอย่างแท็บเล็ตที่ 820 × 1180 (เกณฑ์แนวตั้งสมัยใหม่)',
  'fileViewer.viewportMobile': 'มือถือ',
  'fileViewer.viewportMobileTitle': 'ตัวอย่างมือถือที่ 390 × 844',
  'fileViewer.reloadAria': 'กดรีโหลดให้สด',
  'fileViewer.previousSlide': 'เลื่อนสไลด์ก่อนหน้า',
  'fileViewer.nextSlide': 'สไลด์แผ่นหน้า',
  'fileViewer.slideNavAria': 'ตัวเลื่อนเปลี่ยนหน้า',
  'fileViewer.speakerNotes': 'โน้ตผู้บรรยาย',
  'fileViewer.speakerNotesSlide': 'สไลด์ {current} / {total}',
  'fileViewer.speakerNotesEmpty': 'ไม่มีโน้ตผู้บรรยายสำหรับสไลด์นี้',
  'fileViewer.speakerNotesEdit': 'แก้ไข',
  'fileViewer.speakerNotesSave': 'บันทึกโน้ต',
  'fileViewer.speakerNotesSaving': 'กำลังบันทึก…',
  'fileViewer.speakerNotesSaved': 'บันทึกแล้ว',
  'fileViewer.speakerNotesSaveFailed': 'ไม่สามารถบันทึกโน้ตผู้บรรยายได้',
  'fileViewer.speakerNotesPlaceholder': 'เพิ่มโน้ตผู้บรรยายสำหรับสไลด์นี้…',
  'fileViewer.previewAssetBlockedTitle': 'บล็อกแอสเซ็ตตัวอย่างแล้ว',
  'fileViewer.previewAssetBlockedDetail': 'โหลด {filePath} ไม่ได้ แทนที่ symlink ภายนอกด้วยไฟล์ภายในโปรเจกต์นี้',
  'fileViewer.presenterReset': 'รีเซ็ต',
  'fileViewer.present': 'เปิดจอโชว์',
  'fileViewer.presentInTab': 'ค้างในหน้าจอแท็บ',
  'fileViewer.presentFullscreen': 'ยืดให้เต็มที่หน้าจอ',
  'fileViewer.presentNewTab': 'เข้าสู่ลิ้งก์หน้าใหม่',
  'fileViewer.presentFromBeginning': 'เริ่มจากต้น',
  'fileViewer.presentFromCurrentSlide': 'เริ่มจากสไลด์ปัจจุบัน',
  'fileViewer.presenterMode': 'โหมดผู้นำเสนอ',
  'fileViewer.exitPresentation': 'หนีออกโหมดคนโชว์',
  'fileViewer.shareLabel': 'แชร์',
  'fileViewer.shareMenuShareLink': 'แชร์',
  'fileViewer.shareMenuPublishOnline': 'แชร์บนโฮสติ้งของคุณ',
  'fileViewer.shareMenuDownload': 'ดาวน์โหลด',
  'fileViewer.shareMenuPresentation': 'งานนำเสนอ',
  'fileViewer.shareMenuSourceFiles': 'ไฟล์ต้นฉบับ',
  'fileViewer.shareMenuSave': 'บันทึก',
  'fileViewer.shareMenuPublishViaOd': 'แชร์อย่างรวดเร็ว · OpenDesign',
  'fileViewer.unifiedShareAria': 'Share and export actions',
  "fileViewer.moreSharingOptions": "ตัวเลือกการแชร์เพิ่มเติม",
  'fileViewer.unifiedShareTab': 'Share',
  'fileViewer.unifiedExportTab': 'Export',
  'fileViewer.unifiedSendTab': 'Send to...',
  'fileViewer.openFileForHistory': 'Open a file to view version history',
  "fileViewer.workspaceVisibilityTitle": "การมองเห็นในพื้นที่ทำงาน",
  'fileViewer.workspaceShareTitle': 'Share project in workspace',
  'fileViewer.workspaceSharePrivateDescription': 'Only you can access this project. Choose workspace members to share it with the team.',
  'fileViewer.workspaceShareWorkspaceDescription': 'Members of this workspace can access this project.',
  'fileViewer.workspaceAccessPrivate': 'Only me',
  'fileViewer.workspaceAccessMembers': 'Workspace members',
  'fileViewer.publishSingleFileTitle': 'สร้างลิงก์แชร์',
  "fileViewer.generateAndCopyLink": "สร้างและคัดลอกลิงก์",
  "fileViewer.linkAccessTitle": "การเข้าถึงลิงก์",
  "fileViewer.linkAccessDescription": "ผู้รับสามารถดูตัวอย่างและความคิดเห็นที่มีอยู่ได้ แต่ไม่รวมบทสนทนาและโค้ด",
  "fileViewer.publicLinkUnavailable": "เผยแพร่แล้ว แต่ลิงก์แชร์ไม่พร้อมใช้งานชั่วคราว",
  'fileViewer.publishSingleFileDescription': 'ทุกคนที่มีลิงก์สามารถดูออนไลน์ได้',
  'fileViewer.openFileRequired': 'Open a file to use this.',
  'fileViewer.publishFile': 'Publish file',
  'fileViewer.publishingFile': 'กำลังสร้างลิงก์…',
  "fileViewer.uploadingFile": "กำลังอัปโหลด",
  "fileViewer.shareReopening": "กำลังเปิดใหม่…",
  "fileViewer.publishingContinuesOnClose": "การปิดแผงนี้จะไม่ขัดจังหวะการอัปโหลด",
  "fileViewer.publishMakesProjectTeamVisible": "หลังเผยแพร่ สมาชิกในทีมจะมองเห็นโปรเจกต์นี้ได้",
  'fileViewer.unpublishFile': 'หยุดแชร์',
  'fileViewer.shareEmptyStateTitle': 'ยังไม่มีอะไรให้แชร์',
  'fileViewer.shareEmptyStateDescription': 'สร้างหรือเข้าร่วมทีมเพื่อแชร์ไฟล์นี้กับเพื่อนร่วมทีม',
  'fileViewer.shareEmptyStateCreateTeam': 'สร้างทีม',
  'fileViewer.shareTeamMissingTitle': 'ยังไม่มีทีมให้แชร์ด้วย',

  'fileViewer.publishFileRequiresTeam': 'การเผยแพร่ลิงก์สาธารณะต้องใช้พื้นที่ทำงานแบบทีม สลับไปยังพื้นที่ทำงานแบบทีม หรือใช้ Deploy เพื่อเผยแพร่ไฟล์นี้',
  'fileViewer.publishFileRequiresWorkspace': 'การสร้างลิงก์แชร์ต้องเข้าสู่ระบบเวิร์กสเปซ เข้าสู่ระบบ OpenDesign Cloud หรือแชร์ไฟล์นี้ผ่านการดีพลอย',
  'fileViewer.publishFileTooLarge': "โปรเจกต์นี้เกินขีดจำกัดการแชร์ 20 MiB โปรดลดขนาด HTML และทรัพยากรที่อ้างอิง แล้วลองอีกครั้ง",
  'fileViewer.publishFileEntryIndexConflict': "“{from}” อ้างอิงไฟล์ index.html ที่รูทของโปรเจกต์ ซึ่งชนกับตำแหน่งที่หน้าแชร์ถูกเผยแพร่ โปรดเปลี่ยนชื่อ index.html นั้น (เช่น เป็น {name}) แล้วอัปเดตการอ้างอิง หรือแชร์ index.html โดยตรง",
  'fileViewer.copyFixForAgent': "คัดลอกวิธีแก้ให้เอเจนต์",
  'fileViewer.copyFixForAgentFailed': "คัดลอกไม่สำเร็จ โปรดเลือกคำสั่งด้านล่างแล้วคัดลอกด้วยตนเอง",
  "fileViewer.shareUpdateHint": "ไฟล์มีการเปลี่ยนแปลงใหม่ ผู้เข้าชมยังเห็นเวอร์ชันก่อนหน้า",
  "fileViewer.shareUpdateLink": "อัปเดตลิงก์",
  "fileViewer.signInToUpdate": "เข้าสู่ระบบเพื่ออัปเดต",
  "fileViewer.signInToShare": "เข้าสู่ระบบเพื่อแชร์",
  "fileViewer.shareOutdatedSignInHint": "ไฟล์นี้มีการเปลี่ยนแปลงใหม่ เข้าสู่ระบบเพื่ออัปเดตหรือปิดลิงก์",
  'fileViewer.signInToShareDescription': "ลงชื่อเข้าใช้ Open Design เพื่อสร้างลิงก์แชร์และเชิญผู้อื่นให้ดูและแสดงความคิดเห็น",
  "fileViewer.shareUpdateSuccess": "อัปเดตแล้ว ผู้เยี่ยมชมจะเห็นเวอร์ชันล่าสุดหลังรีเฟรช",
  "fileViewer.shareUpdateFailed": "อัปเดตไม่สำเร็จ ผู้เยี่ยมชมยังคงเห็นเวอร์ชันก่อนหน้า",
  "fileViewer.shareUpdateUncertain": "ไม่ทราบผลการอัปเดต เนื้อหาลิงก์สาธารณะอาจเปลี่ยนไป ตรวจสอบลิงก์หรือหยุดแชร์ก่อนลองอีกครั้ง",
  "fileViewer.shareUpdateRetry": "ลองอีกครั้ง",
  "fileViewer.unpublishFileFailed": "ปิดใช้งานลิงก์ไม่สำเร็จ โปรดลองอีกครั้ง",
  "fileViewer.publishFileFailed": "สร้างลิงก์แชร์ไม่สำเร็จ โปรดลองอีกครั้งในภายหลัง",
  'fileViewer.publishFileConnectionFailed': 'การเชื่อมต่อล้มเหลวหรือหมดเวลา โปรดตรวจสอบเครือข่ายและสถานะการแชร์ก่อนลองใหม่',
  'fileViewer.publishFileSignInRequired': 'ไม่สามารถยืนยันการเข้าสู่ระบบได้ โปรดเข้าสู่ระบบอีกครั้ง',
  'fileViewer.publishFileAccessDenied': 'คุณไม่มีสิทธิ์ดำเนินการแชร์นี้',
  'fileViewer.publishFileServiceRejected': 'บริการแชร์ปฏิเสธคำขอ โปรดตรวจสอบบัญชีและสถานะการแชร์',
  'fileViewer.publishFileLocalSessionFailed': 'การเตรียมแชร์ในเครื่องล้มเหลว โปรดตรวจสอบการตั้งค่าไคลเอนต์',
  'fileViewer.publishFileUnconfirmed': 'ไม่สามารถยืนยันผลการแชร์ได้ โปรดตรวจสอบสถานะก่อนเผยแพร่อีกครั้ง',
  'fileViewer.shareCheckLoading': 'กำลังตรวจสอบการแชร์…',
  'fileViewer.shareCheckFailed': 'ไม่สามารถตรวจสอบการแชร์ให้เสร็จสิ้นได้ โปรดลองอีกครั้ง',
  'fileViewer.workspaceShareSuccess': 'Shared with workspace members',
  'fileViewer.workspaceShareFailed': 'Could not share with workspace',
  'fileViewer.workspaceUnshareSuccess': 'Moved back to private',
  'fileViewer.workspaceUnshareFailed': 'Could not move back to private',
  'fileViewer.readonlySharedNoExport': 'Shared project is read-only: you can comment, but cannot edit or export.',
  'fileViewer.copyShareLink': 'คัดลอกลิงก์แชร์',
  "fileViewer.copyLinkManually": "ไม่สามารถคัดลอกอัตโนมัติได้ โปรดคัดลอกลิงก์ด้านบนด้วยตนเอง",
  'fileViewer.openSharePage': 'เปิดหน้าแชร์',
  'fileViewer.shareLinkRequiresDeploy': 'เผยแพร่ออนไลน์ก่อนเพื่อรับลิงก์',
  'fileViewer.shareLinkPublishGuide': 'เผยแพร่ออนไลน์ด้านบนเพื่อเปิดใช้การแชร์ ↑',
  'fileViewer.shareAfterGenerationComplete': 'แชร์ได้หลังจากสร้างเสร็จ',
  'fileViewer.copyProviderLink': 'คัดลอกลิงก์ {provider}',
  'fileViewer.copyCloudflareLink': 'คัดลอกลิงก์ Cloudflare',
  'fileViewer.screenshotCopying': 'กำลังคัดลอกภาพหน้าจอ...',
  'fileViewer.screenshotCopied': 'คัดลอกภาพหน้าจอไปยังคลิปบอร์ดแล้ว',
  'fileViewer.screenshotClipboardDenied': 'เบราว์เซอร์บล็อกการเข้าถึงคลิปบอร์ด',
  'fileViewer.screenshotPreviewLoading': 'ตัวอย่างยังคงโหลดอยู่ ลองอีกครั้งในอีกสักครู่',
  'fileViewer.screenshotCaptureFailed': 'ไม่สามารถจับภาพตัวอย่างได้ โปรดลองอีกครั้ง',
  'fileViewer.exportPdf': 'เปลี่ยนฟอร์แมตเอาไปเป็น PDF',
  'fileViewer.exportPdfAllSlides': 'ดาวน์โหลดทั้งหน้าเป็น PDF',
  'fileViewer.exportPptxBusy': 'ต้องให้ทำระบบของปัจจุบันจนสำเร็จก่อน',
  'fileViewer.exportPptxHint': 'ส่งข้อมูลเพื่อให้ทำการแปลเอกสารเป็น PPTX',
  'fileViewer.exportPptxNa': 'งาน PPTX ไม่สามารถดึงออกในจุดนี้ได้',
  'fileViewer.exportDaemonUnreachable': 'ไม่สามารถเชื่อมต่อกับ daemon ได้ กรุณาลองใหม่อีกครั้ง',
  'fileViewer.exportZip': 'สูบทั้งหมดมาในรูป .zip',
  'fileViewer.exportHtml': 'เอาไปแค่รูปไฟล์ HTML',
  'fileViewer.exportMd': 'แปลงข้อความแบบฉบับเป็น Markdown',
  'fileViewer.exportImage': 'ส่งออกเป็นรูปภาพ',
  'fileViewer.exportPptxImages': 'ส่งออกเป็น PPTX (รูปภาพ)',
  'fileViewer.exportPptxEditable': 'ส่งออกเป็น PPTX (แก้ไขได้)',
  'fileViewer.exportPptxEditableHint': 'Native editable shapes & text (not pixel-perfect)',
  'fileViewer.exportPptxModalSubtitle': "Choose how to export, then download.",
  'fileViewer.exportPptxScreenshot': "Screenshot PPTX",
  'fileViewer.exportPptxScreenshotHint': "One image per slide — pixel-perfect, but not editable.",
  'fileViewer.exportPptxConfirm': "Export",
  'fileViewer.exportPptxRecommended': "Recommended",
  'fileViewer.exportingProgress': 'กำลังส่งออก…',
  'fileViewer.exportSlideProgress': 'กำลังส่งออกสไลด์ {current}/{total}…',
  'fileViewer.exportingElapsed': 'กำลังส่งออก… {seconds} วินาที',
  'fileViewer.exportSlideEta': 'สไลด์ {current}/{total} · เหลือ ~{seconds} วินาที',
  'fileViewer.exportFailedTitle': 'ส่งออกไม่สำเร็จ',
  'fileViewer.exportFailedDescription': 'การส่งออกครั้งนี้ยังไม่เสร็จสมบูรณ์ กรุณาลองใหม่อีกครั้ง',
  'fileViewer.exportDone': 'ส่งออกเสร็จสิ้น',
  'fileViewer.exportImageFailed': 'การจับภาพล้มเหลว กรุณาลองอีกครั้งหรือใช้เครื่องมือจับภาพหน้าจอของเบราว์เซอร์',
  'fileViewer.exportImageModalSubtitle': 'เลือกรูปแบบ แล้วดาวน์โหลดตัวอย่างปัจจุบันเป็นรูปภาพ',
  'fileViewer.exportImageFormatLabel': 'รูปแบบ',
  'fileViewer.exportImageSaving': 'กำลังบันทึกรูปภาพ…',
  'fileViewer.exportImageSaved': 'บันทึกรูปภาพแล้ว',
  'fileViewer.exportImageDownloadStarted': 'เริ่มดาวน์โหลดแล้ว',
  'fileViewer.exportImageDownloadDetails': 'หากไม่มีหน้าต่างบันทึกเป็นปรากฏขึ้น ให้ตรวจสอบ {filename} ในโฟลเดอร์ดาวน์โหลดของเบราว์เซอร์',
  'fileViewer.exportJsx': 'นำโค้ดในรูปแบบ React JSX ออก',
  'fileViewer.exportReactHtml': 'แยกโหลดมาแค่โครง HTML เท่านั้น',
  'fileViewer.exportStarted': 'เริ่มการส่งออกแล้ว',
  'fileViewer.saveAsTemplate': 'จัดเก็บในหมวดเทมเพลต…',
  'fileViewer.savingTemplate': 'ระบบคอยเซฟแม่แบบให้…',
  'fileViewer.savedTemplate': 'ได้สร้างเทมเพลตใหม่ชื่อ "{name}"',
  'fileViewer.savedTemplateFail': 'ติดปัญหาที่การจำข้อมูลเทมเพลต — ทบทวนให้ดีแล้วกดอีกหน',
  'fileViewer.templateNamePrompt': 'ระบุชื่อตัวเทมเพลต',
  'fileViewer.templateNameDefault': 'แม่แบบว่างไม่มีการระบุชื่อ',
  'fileViewer.templateDescPrompt': 'อธิบายลักษณะเพิ่มเติม (ไม่จำเป็นต้องใส่เลยก็ได้ — แต่มีก็ดีต่อความเข้าใจในครั้งหน้า)',
  'liveArtifact.refresh.button': 'ดึงค่าเริ่มระบบอีกหน',
  'liveArtifact.refresh.buttonTitle': 'รีค่าการทำตัว Live artifact ใหม่',
  'liveArtifact.refresh.loadingTitle': 'ขอเวลาเพื่อดึงของ Live artifact…',
  'liveArtifact.refresh.noSourceTitle': 'ของดั้งเดิมยังไม่เคยมีให้ทำการอัปเดตต่อ',
  'liveArtifact.refresh.running': 'ระบบรันหาค่าอีกคราว…',
  'liveArtifact.refresh.runningMessage': 'เรียกโครงและหน้าตัวโชว์อยู่ โปรดเผื่อเวลา',
  'liveArtifact.refresh.runningAction': 'สิ่งพรีวิวที่มีจากของเก่าอยู่จะได้เห็นเรื่อยไป จนของครั้งหน้าสำเร็จถึงโชว์',
  'liveArtifact.refresh.successOne': 'ผ่านตลอด ได้ผลของล่าสุดแทนแล้ว',
  'liveArtifact.refresh.successMany': 'ผ่านตลอด ได้ผลของล่าสุดแทนแล้ว',
  'liveArtifact.refresh.successAction': 'เปลี่ยนระบบของเดิมเสร็จ ภาพโชว์ใหม่เอาไปใช้งานต่อแล้ว',
  'liveArtifact.refresh.previousFailure': 'ของคราวก่อนหลุดความสำเร็จไป: {message}',
  'liveArtifact.refresh.failureAction': 'ตรวจสอบปัญหาและช่องทางข้อมูลของตัวเดิมก่อน เพื่อกดเปิดใช้งานอีกที',
  'liveArtifact.refresh.networkFailure': 'รีเฟรชเครือข่ายส่งไม่ติด อาจจะมีเรื่องสัญญานตก',
  'liveArtifact.refresh.genericFailure': 'ระบบรีไม่สมบูรณ์',
  'liveArtifact.refresh.statusNever': 'ไร้สิ่งที่สามารถดึงค่าได้',
  'liveArtifact.refresh.statusReady': 'เตรียมเริ่มลุยรอบดึงใหม่',
  'liveArtifact.refresh.statusSucceeded': 'ได้ที่ของสดใหม่',
  'liveArtifact.refresh.statusFailed': 'เสียสูญกับการรอรีข้อมูล',
  'liveArtifact.refresh.statusRunning': 'กำลังรีเฟรช',
  'liveArtifact.refresh.statusRunningDescription': 'การรีเฟรชกำลังดำเนินการอยู่ในขณะนี้',
  'liveArtifact.refresh.statusSucceededDescription': 'การรีเฟรชครั้งล่าสุดเสร็จสมบูรณ์',
  'liveArtifact.refresh.statusFailedDescription': 'ความพยายามรีเฟรชครั้งล่าสุดไม่เสร็จสมบูรณ์',
  'liveArtifact.refresh.statusReadyDescription': 'มีการตั้งค่าแหล่งข้อมูลที่รีเฟรชได้ แต่ไม่มีการรันใดกำลังดำเนินอยู่',
  'liveArtifact.refresh.statusNeverDescription': 'อาร์ติแฟกต์แบบไลฟ์นี้ยังไม่มีแหล่งข้อมูลสำหรับรีเฟรช',
  'liveArtifact.refresh.eventStarted': 'เริ่มแล้ว',
  'liveArtifact.refresh.eventSucceeded': 'สำเร็จ',
  'liveArtifact.refresh.eventFailed': 'ล้มเหลว',
  'liveArtifact.refresh.eventStartedDetail': 'เริ่มรีเฟรชแล้ว…',
  'liveArtifact.refresh.sourcesUpdatedOne': 'อัปเดตแล้ว {n} แหล่งข้อมูล',
  'liveArtifact.refresh.sourcesUpdatedMany': 'อัปเดตแล้ว {n} แหล่งข้อมูล',
  'liveArtifact.refresh.timelineEmpty': 'ยังไม่มีกิจกรรมการรีเฟรชในเซสชันนี้ เรียกใช้รีเฟรชเพื่อบันทึกไทม์ไลน์ หรือรอการรันอัตโนมัติ',
  'liveArtifact.refresh.heroLastRefreshedLabel': 'รีเฟรชล่าสุด',
  'liveArtifact.refresh.heroLastRefreshedNever': 'ไม่เคย',
  'liveArtifact.refresh.justNow': 'เมื่อสักครู่',
  'liveArtifact.refresh.factCreated': 'สร้างแล้ว',
  'liveArtifact.refresh.factLastUpdated': 'อัปเดตล่าสุด',
  'liveArtifact.refresh.factUnknown': 'ไม่ทราบ',
  'liveArtifact.refresh.persistedTitle': 'ประวัติการรีเฟรชที่บันทึกไว้',
  'liveArtifact.refresh.persistedHint': 'รายการที่โหลดจาก refreshes.jsonl',
  'liveArtifact.refresh.persistedEmpty': 'ยังไม่มีประวัติการรีเฟรชที่บันทึกไว้',
  'liveArtifact.refresh.persistedStatusSucceeded': 'สำเร็จ',
  'liveArtifact.refresh.persistedStatusRunning': 'กำลังทำงาน',
  'liveArtifact.refresh.persistedStatusFailed': 'ล้มเหลว',
  'liveArtifact.refresh.persistedStatusCancelled': 'ยกเลิกแล้ว',
  'liveArtifact.refresh.persistedStatusSkipped': 'ข้ามแล้ว',
  'liveArtifact.refresh.sessionTitle': 'กิจกรรมของเซสชัน',
  'liveArtifact.refresh.sessionHint': 'เหตุการณ์ที่สังเกตได้ขณะเปิดแท็บนี้',
  'liveArtifact.refresh.docSourceTitle': 'แหล่งที่มาของเอกสาร',
  'liveArtifact.refresh.docSourceHint': 'กำหนดค่าแหล่งที่มาแล้ว',
  'liveArtifact.refresh.docSourceType': 'ประเภท',
  'liveArtifact.refresh.docSourceTool': 'เครื่องมือ',
  'liveArtifact.refresh.docSourceConnector': 'ตัวเชื่อมต่อ',
  'liveArtifact.refresh.debugSummary': 'ข้อมูลเมตาสำหรับการดีบักขั้นสูง',
  'liveArtifact.refresh.debugNote': 'อาจรวมถึง ID ของ connector ชื่อไฟล์ ข้อมูลเมตาของแหล่งที่มา และเส้นทางอาร์ติแฟกต์ภายใน',
  'liveArtifact.viewer.tabPreview': 'พรีวิวภาพ',
  'liveArtifact.viewer.tabCode': 'คำสั่งโค้ด',
  'liveArtifact.viewer.tabData': 'ผลข้อมูล',
  'liveArtifact.viewer.tabRefreshHistory': 'ข้อมูลตอนสั่งเรียกครั้งเก่า',
  'liveArtifact.viewer.dataEmpty': 'Data.json ในตัวของยังไม่โผล่',
  'liveArtifact.viewer.code.templateHeading': 'โครงอักษร HTML เทมเพลต',
  'liveArtifact.viewer.code.renderedHeading': 'สิ่งที่สร้างเรนเดอร์มาที่แท้จริงแบบ HTML',
  'liveArtifact.viewer.code.templateHelp': 'แม่พิมพ์ถูกเตรียมการรวมด้วยค่าตัวของ data.json ไว้พร้อมโชว์พรีวิวแล้ว',
  'liveArtifact.viewer.code.renderedHelp': 'หน้าตาดั้งเดิมของที่สร้างได้ไว้เข้าใช้จริงแบบฉบับ index.html',
  'liveArtifact.viewer.code.variantAria': 'หมวดรวมส่วนแบบร่าง',
  'liveArtifact.viewer.code.variantTemplate': 'กลุ่มเทมเพลต',
  'liveArtifact.viewer.code.variantRendered': 'เรนเดอร์แล้ว',
  'liveArtifact.viewer.code.loading': 'ตามโค้ดเข้ามา…',
  'liveArtifact.viewer.code.unavailable': 'โค้ดที่หาอาจจะไร้ซึ่งข้อมูล',
  'liveArtifact.viewer.code.empty': 'ไม่มีสิ่งใดเขียนตกค้างไว้เลยในนี้',
  'fileViewer.deployToVercel': 'ขึ้นสู่ระดับ Deploy เพื่อ Vercel',
  'fileViewer.redeployToVercel': 'Deploy ทับอันเดิม',
  'fileViewer.deployingToVercel': 'ขอ Deploy เข้าสู่ผู้ดูแล Vercel…',
  'fileViewer.deployProviderLabel': 'ส่วนพื้นที่ผู้จัดการ',
  'fileViewer.vercelProvider': 'ทีม Vercel',
  'fileViewer.cloudflarePagesProvider': 'โฮส Cloudflare Pages',
  'fileViewer.deployTargetLabel': 'เป้าหมาย',
  'fileViewer.deployTargetPreview': 'ตัวอย่าง',
  'fileViewer.deployTargetProduction': 'โปรดักชัน',
  'fileViewer.deployToProvider': 'จัดนำโฮสติ้งไปเพื่อ {provider}',
  'fileViewer.redeployToProvider': 'ใช้ทับการ Deploy กับทาง {provider}',
  'fileViewer.deployingToProvider': 'กำลังย้ายข้อมูลเข้าไปสู่ {provider}…',
  'fileViewer.preparingPublicLink': 'จัดทำลิ้งก์ให้พบเห็นทางด้านนอก…',
  'fileViewer.copyDeployLink': 'ลอกลิ้งก์เซฟใช้',
  'fileViewer.deployModalTitle': 'สั่งขึ้นโฮสต์เพื่อ Deploy',
  'fileViewer.deployModalSubtitle': 'เลือกจัดการผสานเชื่อมการทำงานในรูป HTML นี้ให้ออกไปได้เลย',
  'fileViewer.vercelToken': 'ระบบเหรียญของ Vercel Token',
  'fileViewer.vercelTokenGetLink': 'ขอเอา Vercel Token นำมาใช้',
  'fileViewer.vercelTokenPlaceholder': 'วางลงรหัส Vercel Token',
  'fileViewer.vercelTokenReuseHint': 'จะนำข้อมูลเดิมที่ถูกจัดเก็บมาใช้ต่อเลย หากต้องการตัวอื่นก็เอามาพิมพ์ตรงนี้',
  'fileViewer.vercelTokenRequired': 'วางรหัสตัว Vercel ก่อน ถึงจะเริ่มได้',
  'fileViewer.cloudflareApiToken': 'ใช้โทเคนจากฝั่ง Cloudflare',
  'fileViewer.cloudflareApiTokenGetLink': 'รับ API token',
  'fileViewer.cloudflareApiTokenPlaceholder': 'นำ Cloudflare ตัวใหม่แปะตรงช่อง',
  'fileViewer.cloudflareApiTokenReuseHint': 'โทเค็นตัวที่ผูกไว้จะได้การใช้งานก่อนเป็นอย่างดี ต้องการตัวใหม่ก็นำทับได้เลย',
  'fileViewer.cloudflareApiTokenRequired': 'เซฟ Cloudflare เพื่อเข้าใช้งานให้ถูกต้อง',
  'fileViewer.cloudflareApiTokenScopeHint': 'เลือก Pages Edit ตอนสร้าง API token; โดเมนแบบกำหนดเองต้องใช้ Zone Read / DNS Edit',
  'fileViewer.vercelTeamId': 'กรอกรหัสสำหรับระดับทีม ID',
  'fileViewer.vercelTeamSlug': 'นามพ่วงทีมแบบย่อ',
  'fileViewer.cloudflareAccountId': 'หมวดระดับรหัสบัญชีหลัก',
  'fileViewer.cloudflareAccountIdHint': 'ค้นหา account ID ได้ในแดชบอร์ด Cloudflare',
  'fileViewer.cloudflareAccountIdRequired': 'โปรดป้อนเก็บไว้ Cloudflare หลัก Account ID ในเครื่องก่อนเริ่ม',
  'fileViewer.cloudflareZoneLabel': 'ตัวเชื่อมแบบโดเมน',
  'fileViewer.cloudflareZonePlaceholder': 'นำเครื่องมือตั้งต่าในหน้าหลักเพื่อเปิดลิงก์ทั้งหมดมาใช้',
  'fileViewer.cloudflareZoneRequired': 'เอาตัว Cloudflare โดเมน มากรอกให้เสร็จ',
  'fileViewer.cloudflareZonesLoading': 'เครื่องมือกำลังเช็ค Cloudflare โดเมน ทั้งระบบ…',
  'fileViewer.cloudflareZonesRefresh': 'รีข้อมูลเรียกตัวโดเมน',
  'fileViewer.cloudflareZonesLoadFailed': 'การเซฟตัวของโดเมนเข้าใน Cloudflare ประสบข้อไม่พบของที่จะโหลดได้',
  'fileViewer.cloudflareZonesEmpty': 'บัญชีนี้ยังขาดการเข้าเซฟข้อมูลจากโดเมนระดับแบบสมบูรณ์มาใช้ด้วยกัน',
  'fileViewer.cloudflareDomainPrefixLabel': 'กลุ่มของคำนำหน้าใน Subdomain Prefix',
  'fileViewer.cloudflareDomainPrefixPlaceholder': 'เดโม่ (demo)',
  'fileViewer.cloudflareDomainPrefixInvalid': 'คำโดเมนรองนี้ให้ใช้อักษรพิเศษอย่างยัติภังค์ (ขีด) กับตัวเลขและพิมพ์เล็กได้ ไม่ให้ใช้อย่างอื่นที่ผิดแปลกไปเลย',
  'fileViewer.cloudflareHostnamePreview': 'ความพร้อมตัวโฮสต์รอง: {hostname}',
  'fileViewer.cloudflareCustomDomainHint': 'ไม่บังคับ: ผูกโดเมนแบบกำหนดเอง หากเว้นว่างไว้จะยังสร้างลิงก์ pages.dev',
  'fileViewer.cloudflarePagesDevLinkLabel': 'ลิ้งก์จากช่องทางฟรี pages.dev URL',
  'fileViewer.cloudflareCustomDomainLinkLabel': 'ตัวลิ้งก์ Custom แบบมีโดเมนเสริม',
  'fileViewer.optional': 'ตัวเลือกเสริม',
  'fileViewer.vercelPreviewOnly': 'ปัจจุบันการโชว์ Deploy มีเปิดให้แต่พรีวิวการใช้งานเท่านั้น',
  'fileViewer.cloudflarePagesPreviewHint': 'สามารถส่งข้อมูลโฮสต์ผ่านแบบ Direct Upload ตรงเข้าสู่ของ Cloudflare ไปเลย',
  'fileViewer.savingConfig': 'คอยจัดระเบียบให้…',
  'fileViewer.deployConfigSaveFailed': 'จำคำสั่งเชื่อมระบบฝั่ง Vercel เข้ามาไม่ได้',
  'fileViewer.deployFailed': 'เกิดความล้มเหลวกับการเรียกตัว Deployment ขอไปปรับเครื่องมือ Vercel ใหม่แล้วลองซ้ำนะ',
  'fileViewer.deployProviderConfigSaveFailed': 'ปรับเปลี่ยนและนำตั้งค่าเซฟไม่ได้บนฝั่งผู้บริการ {provider}',
  'fileViewer.deployProviderFailed': 'โฮสต์ไม่ติดสำหรับตัวผู้ดำเนินการ {provider} เช็คการควบคุมดูอีกรอบก่อนเถอะ',
  'fileViewer.deployResultLabel': 'ที่อยู่แบบ URL ซึ่งอัพลง',
  'fileViewer.deployLinkReady': 'ลุยได้ทันที',
  'fileViewer.deploySuccessToast': 'อัปโหลดการ Deploy สำเร็จแล้ว',
  'fileViewer.deploySuccessToastDetails': '{provider} · {url}',
  'fileViewer.deployLinkPreparingLabel': 'เตรียมออกสู่หน้าผู้คนข้างนอก',
  'fileViewer.deployLinkDelayed': 'ตัวเว็บนั้นเข้าใช้งานได้แต่ความพร้อมยังถูกแช่ไว้บ้างอยู่',
  'fileViewer.deployLinkFailed': 'โดเมนส่วนตัวที่พยายามมีอยู่ดันไม่เชื่อมกัน',
  'fileViewer.deployLinkProtectedLabel': 'ใส่ตัวยืนยันและปกป้องให้กับการข้ามระบบไว้',
  'fileViewer.deployLinkProtected': 'ถึงจะเอาเว็บเข้าไปไว้ให้แล้วแต่การให้ดูตัวอย่างยังเข้ายาก ปลดรหัสความปลอดภัยเข้าออกที หรือสลับเป็นแบบ Custom',
  'fileViewer.retryLink': 'เข้ากดรีโหลดซ้ำหน่อย',
  'questionForm.submit': 'ส่งผ่าน',
  'questionForm.skip': 'ข้ามตัวนี้',
  'questionForm.locked': 'สำเร็จตอบไปแล้ว',
  'tool.openInTab': 'จับเรียก {name} ไว้ให้เข้าหน้าใหม่ของแท็บ',
  'tool.open': 'เข้าไป',
  'tool.todos': 'สิ่งที่วางแผนต้องทำ',
  'tool.todosExpand': 'แสดงงาน',
  'tool.todosCollapse': 'ซ่อนงาน',
  'tool.todosDone': 'เสร็จสิ้น',
  'tool.todosDismiss': 'ปิดรายการงาน',
  'tool.write': 'ใส่เขียนลงไป',
  'tool.edit': 'จัดการปรับปรุง',
  'tool.read': 'มองเห็นภาพ',
  'tool.delete': 'ลบ',
  'tool.bash': 'สั่ง Bash ทำ',
  'tool.glob': 'หาสิ่ง Glob เอา',
  'tool.grep': 'หาการค้น Grep ลงไป',
  'tool.fetch': 'ดึงรับส่ง Fetch',
  'tool.search': 'สืบเสาะ',
  'tool.lines': '{n} เป็นจำนวนบรรัด',
  'tool.changeSingular': 'ปรับจุดหนึ่งแล้ว',
  'tool.changePlural': 'เปลี่ยนแก้ไขมาเยอะเลย',
  'tool.in': 'ผ่านทางที่อยู่ของ {path}',
  'tool.hide': 'ถูกแอบแฝง',
  'tool.output': 'ข้อสั่งสรุปหน้าจอ',
  'tool.running': 'เริ่มทำงานต่อ…',
  'tool.error': 'สะดุดขัดข้อง',
  'tool.done': 'จบบริบูรณ์',
  'assistant.role': 'หน่วยผู้ช่วยเหลือส่วนตัว',
  'assistant.workingLabel': 'ดำเนินระบบรับทำงานอยู่',
  'assistant.doneLabel': 'บรรลุสู่ระดับพร้อมแล้ว',
  'assistant.awaitingReplyLabel': 'รอการตอบกลับ',
  'assistant.canceledLabel': 'หยุดงานแล้ว',
  'assistant.canceledDetail': 'การทำงานครั้งนี้หยุดลงตามการดำเนินการของคุณ',
  'assistant.copyMarkdown': 'คัดลอก',
  'assistant.forkConversation': 'สนทนาใหม่',
  'assistant.forkingConversation': 'กำลังเริ่มสนทนาใหม่…',
  'assistant.forkNote': 'ต่อจากการสนทนาก่อนหน้า',
  'assistant.shareToOpenDesign': 'แชร์ไปยัง OpenDesign',
  'assistant.shareToOpenDesignBusy': 'กำลังเตรียมแพ็กเกจ…',
  'assistant.feedbackPrompt': 'ข้อเสนอแนะ',
  'assistant.feedbackPositive': 'มีประโยชน์',
  'assistant.feedbackNegative': 'ไม่มีประโยชน์',
  'assistant.feedbackReasonTitle': 'บอกเราว่าทำไม',
  "assistant.feedbackReasonTitleNegative": "มีอะไรผิดพลาด?",
  "assistant.feedbackDiscordNegative": "เล่ารายละเอียดเพิ่มเติมใน {discord} เพื่อให้ทีมเข้าใจปัญหาและตามต่อได้",
  "assistant.feedbackDiscordPositive": "แชร์สิ่งที่คุณทำกับชุมชน {discord} หรือส่งภาพหน้าจอมาเล่าว่าอะไรเวิร์ก",
  'assistant.feedbackReasonPositiveMatched': 'เข้าใจคำขอของฉัน',
  'assistant.feedbackReasonPositiveVisual': 'ดูดี',
  'assistant.feedbackReasonPositiveUseful': 'โครงสร้างมีประโยชน์',
  'assistant.feedbackReasonPositiveEasy': 'แก้ไขต่อได้ง่าย',
  'assistant.feedbackReasonPositiveDesignSystem': 'ทำตามดีไซน์ซิสเต็ม',
  'assistant.feedbackReasonNegativeMissed': 'ไม่ได้แก้ตามที่บอก',
  'assistant.feedbackReasonNegativeVisual': 'ภาพไม่สอดคล้องกัน',
  'assistant.feedbackReasonNegativeIncomplete': 'ผลลัพธ์ไม่สมบูรณ์',
  'assistant.feedbackReasonNegativeHard': 'ใช้งานยาก',
  'assistant.feedbackReasonNegativeCouldNotRun': 'ใช้งานไม่ได้',
  'assistant.feedbackReasonNegativeTooSlow': 'ช้าเกินไป',
  'assistant.feedbackReasonNegativeDesignSystem': 'ไม่ได้ทำตามดีไซน์ซิสเต็ม',
  'assistant.feedbackReasonOther': 'อื่น ๆ',
  'assistant.feedbackReasonPlaceholder': 'เพิ่มรายละเอียด (ไม่บังคับ)',
  'assistant.feedbackReasonSubmit': 'ส่ง',
  "assistant.emptyResponseLabel": "ไม่สามารถทำงานให้เสร็จได้",
  "assistant.emptyResponseMessage": "การเรียกใช้งานครั้งนี้ล้มเหลว โปรดลองอีกครั้ง หากล้มเหลวอีก โปรดติดต่อฝ่ายสนับสนุน",
  'assistant.unfinishedLabel': 'งานยังไม่เสร็จสมบูรณ์',
  'assistant.unfinishedDetail': 'งานนี้ยังมีอีก {n} รายการที่ยังไม่เสร็จ',
  'assistant.unfinishedSummary': 'งาน {n} ขั้นลืมอยู่ข้างหลัง',
  'assistant.unfinishedMore': 'ทิ้งเพิ่มมาอีก +{n}',
  'assistant.continueRemaining': 'สานต่อภาระหน้าที่หลงเหลือที',
  'chat.resumeRunCta': 'ดำเนินการต่อ',
  'chat.runError.contactSupportCta': "ติดต่อเรา",
  'chat.runError.exportLogsCta': "ส่งออกบันทึก",
  'chat.runError.switchModelCta': "เปลี่ยนโมเดล",
  'chat.runError.openSettingsCta': 'เปิดการตั้งค่า',
  "chat.runError.title.readOnlyAccess": "ไม่มีสิทธิ์แก้ไขโปรเจกต์",
  "chat.runError.title.messagesUnavailable": "โหลดเนื้อหาการสนทนาไม่สำเร็จ",
  "chat.runError.actionBlocked.readOnly": "ขณะนี้คุณมีสิทธิ์ดูโปรเจกต์นี้เท่านั้น จึงไม่สามารถเรียกใช้งานได้",
  "chat.runError.actionBlocked.messagesUnavailable": "ขณะนี้ไม่สามารถอ่านเนื้อหาการสนทนาได้ โปรดลองอีกครั้ง หากยังไม่สำเร็จ โปรดติดต่อฝ่ายสนับสนุน",
  'chat.runError.actionBlocked.billing': "กำลังตรวจสอบว่าพื้นที่ทำงานใดเป็นผู้จ่ายสำหรับโปรเจกต์นี้ โปรดลองใหม่อีกสักครู่",
  'chat.runError.actionBlocked.busy': "บทสนทนานี้ยังมีงานที่กำลังทำงานอยู่ ลองใหม่ได้เมื่องานเสร็จ",
  'chat.support.channel.feishu': "ชุมชน Feishu",
  'chat.support.channel.discord': "Discord",
  'chat.amrBalanceOwner.title': 'ยอดคงเหลือของทีมไม่เพียงพอ',
  'chat.amrBalanceOwner.message': 'ยอดคงเหลือของทีมไม่เพียงพอ โปรดติดต่อผู้ดูแลทีมเพื่อเติมเงินหรืออัปเกรดการสมัครใช้งาน',
  'chat.amrBalanceOwner.messageNoOwnerName': 'ยอดคงเหลือของทีมไม่เพียงพอ โปรดติดต่อผู้ดูแลทีมเพื่อเติมเงินหรืออัปเกรดการสมัครใช้งาน',
  'chat.amrBalanceOwner.dismissCta': "รับทราบ",
  'assistant.outTokens': 'หมดการจ่ายใน {n} โทเคน',
  'assistant.producedFiles': 'ดึงงานมาจากระบบไฟล์',
  'assistant.openFile': 'เรียก',
  'assistant.downloadFile': 'สูบลงตัวเครื่อง',
  "nextStep.imageContinue": "ปรับปรุงต่อ",
  "nextStep.imageVariants": "สร้างรูปแบบอื่น / ชุดใหม่",
  "nextStep.imageStyle": "ปรับสไตล์ / องค์ประกอบภาพ",
  'nextStep.title': 'ขั้นตอนถัดไป',
  'nextStep.suggestionsLabel': 'ขั้นตอนถัดไปที่แนะนำ',
  'nextStep.more': 'เพิ่มเติม',
  'nextStep.share': 'แชร์',
  'nextStep.download': 'ดาวน์โหลด',
  'nextStep.createDesignSystemTitle': 'Create design system',
  'nextStep.createDesignSystemBody': 'Duplicate this project into a design-system workspace and start an agent pass from all current files and references.',
  'nextStep.createDesignSystemBusy': 'Creating design system...',
  'nextStep.contribute': 'มีส่วนร่วม',
  'nextStep.planGenerateTitle': "Generate from document",
  'nextStep.planGenerateBody': "Use the approved Markdown plan as the source of truth for the next design run.",
  'nextStep.planImproveTitle': "Improve document",
  'nextStep.planImproveBody': "Tighten the current plan document before generating the final artifact.",
  'nextStep.planGeneratePrompt': "Use `{file}` as the source of truth. Read the document first, preserve its decisions, then generate the final design artifact that matches it. If it is a slide outline, generate the deck; if it is a PRD/prototype plan, generate the prototype or wireframes; if it is a storyboard/creative brief, generate the matching visual/media artifact. Before generating, call out any blocking TODOs or contradictions you cannot resolve.",
  'nextStep.planImprovePrompt': "Read `{file}` and improve it in place as an editable plan document. Tighten scope, fill weak sections, add missing acceptance checks, and keep TODO/open questions where user input is still needed. Do not generate the final design artifact yet.",
  'nextStep.planImproveArtifactTitle': "Improve artifact",
  'nextStep.planImproveArtifactBody': "Keep iterating the generated artifact instead of going back to planning.",
  'nextStep.planImproveArtifactPrompt': "Improve `{artifact}` in place. Keep the existing working artifact and make the highest-impact product, visual, interaction, and content improvements. Preserve behavior that already works, then summarize changed files and any remaining risks.",
  'nextStep.planMergeTitle': "Align document and artifact",
  'nextStep.planMergeBody': "Reconcile the plan and generated artifact so they advance together.",
  'nextStep.planMergePrompt': "Read `{document}` and `{artifact}` together. Treat the document as the intent and the artifact as the current implementation. Reconcile them: update the artifact to match confirmed decisions, update the document only where it is stale, and keep explicit TODO/open questions for anything still unresolved. Preserve existing working behavior and summarize what changed in both files.",

  'nextStep.projectContinueTitle': 'Continue working',
  'nextStep.projectGenerateArtifactTitle': 'Generate artifact',
  'nextStep.designSystemAiRefineTitle': 'AI refine design system',
  'nextStep.designSystemAuditKitTitle': 'Audit tokens & kit',

  'nextStep.brandAiOptimizeTitle': 'Refine extracted design system',
  'nextStep.brandAiOptimizeBody': 'Starts an agent pass that consumes model tokens, re-extracts the source, and updates this design system in place.',
  'nextStep.brandCreateDesignTitle': 'Create with this design system',
  'nextStep.brandCreateDesignBody': 'Start a new design using the extracted colors, type, assets, and system guidance.',
  'nextStep.brandCreateDesignPrompt': 'Create a new design with the {designSystem} design system.',

  'nextStep.brandContinueExtractionTitle': 'Continue extraction',
  'nextStep.brandContinueExtractionBody': 'After the Browser tab is past any verification, read it and keep filling the saved kit.',
  'nextStep.brandContinueExtractionBusy': 'Continuing extraction...',
  'nextStep.brandContinueAiExtractionTitle': 'Continue with agent',
  'nextStep.brandContinueAiExtractionProgrammaticBody': 'Use the selected agent to extract from the saved draft if the programmatic pass still cannot finish.',
  'nextStep.brandContinueAiExtractionAiBody': 'Resume the selected agent from the current brand scaffold and finish the same design system.',
  'nextStep.brandContinueAiExtractionBusy': 'Continuing with agent...',
  'nextStep.createDesignBusy': 'กำลังสร้างงานออกแบบ...',
  'assistant.thinking': 'ไตร่ตรอง…',
  'assistant.thought': 'คิดแล้ว',
  'assistant.thoughtFor': 'คิด {s} วินาที',
  'assistant.designSystemDirectionLocked': 'เลือกระบบการออกแบบที่ใช้งานอยู่แล้ว ทิศทางภาพถูกกำหนดไว้แล้ว',
  'assistant.waitingFirstOutput': 'รอบอกการประมวลครั้งเปิดฉาก',
  'assistant.statusBootingAgent': 'เริ่มปลุกเอเจนต์ก่อน',
  'assistant.statusPreparing': 'กำลังเตรียม...',
  'assistant.statusStarting': 'ขึ้นเดินหน้าสู่ระบบแล้ว',
  'assistant.statusRequesting': 'ผลักภาระด้วยคำสั่งเข้ามารับใช้',
  'assistant.statusThinking': 'ครุ่นคิดคำตอบเตรียมไว้ให้ดี',
  'assistant.statusStreaming': 'ส่งถ่ายผลลัพธ์มาตลอดต่อเนื่อง',
  'assistant.statusCompactingContext': 'กำลังกระชับบริบท',
  'assistant.slowHint': 'ใช้ขอบเขตเวลามากผิดคาด ฟอร์มตอบควรมาราว 5-10 วินาที — หยุดไว้และขอเขียนเข้าไปให้เป็นที่เข้าใจอีกทีดีไหม',
  'assistant.verbEditing': 'แก้ไขโครงใหม่',
  'assistant.verbWriting': 'นั่งเขียนเพิ่มเติม',
  'assistant.verbReading': 'รับชมพิจารณาข้อมูล',
  'assistant.verbSearching': 'ไล่สายตาหา',
  'assistant.verbRunning': 'เดินระบบคำสั่งไป',
  'assistant.verbTodos': 'สร้างกำหนดของเป้าหมายหน้า',
  'assistant.verbFetching': 'ชักนำผลผ่านตัวออนไลน์',
  'assistant.verbCalling': 'ตามสั่งเครื่องมือมาใช้',
  'qf.answered': 'ได้ส่งคำไปแล้ว',
  "qf.unanswered": "ยังไม่ได้ตอบ",
  "qf.unansweredContinued": "คำถามนี้ไม่ได้รับคำตอบ และการสนทนาได้ดำเนินต่อแล้ว",
  'qf.answeredConfirmed': 'ยืนยันแล้ว',
  'qf.answeredSkipped': 'ข้ามแล้ว',
  "chat.att.cancelUpload": "ยกเลิกการอัปโหลด {name}",
  "chat.att.retry": "ลองอีกครั้ง",
  "chat.attachments.scrollNext": "ดูไฟล์แนบถัดไป",
  "chat.attachments.scrollPrev": "ดูไฟล์แนบก่อนหน้า",
  "chat.input.collapse": "ย่อ",
  "chat.input.expandFull": "แสดงข้อความทั้งหมด",
  "chat.input.viewAll": "ดูทั้งหมด",
  "chat.artifact.export": "ส่งออก",
  "chat.artifact.pending": "กำลังสร้าง…",
  "chat.artifact.shareStatusUnknown": "ไม่ทราบสถานะ",
  "chat.artifact.published": "แชร์แล้ว",
  "chat.artifact.publish": "แชร์",
  "chat.edge.paused": "หยุดงานด้วยตนเองแล้ว",
  "chat.edge.reconnectCta": "เชื่อมต่อใหม่",
  "chat.edge.reconnectDetail": "ดูรายละเอียด",
  "chat.edge.reconnectFailed": "ไม่สามารถกู้คืนการเชื่อมต่อเครือข่าย",
  "chat.edge.reconnectFailedDescription": "โปรดตรวจสอบการเชื่อมต่อเครือข่ายแล้วลองอีกครั้ง",
  "chat.edge.reconnecting": "กำลังกู้คืนการเชื่อมต่อเครือข่าย",
  "chat.edge.reconnectingDescription": "กำลังพยายามเชื่อมต่อครั้งที่ {attempt}/{max} โปรดรอสักครู่",
  "chat.edge.retrying": "กำลังลองใหม่",
  "chat.edge.retryingRateLimitedTitle": "บริการโมเดลมีคำขอจำนวนมาก",
  "chat.edge.retryingRateLimitedDescription": "ขณะนี้มีคำขอไปยังบริการโมเดลนี้จำนวนมาก และถึงขีดจำกัดความถี่คำขอของผู้ให้บริการแล้ว โปรดลองใหม่ในภายหลัง หรือสลับไปใช้โมเดลอื่น",
  "qf.visualNext": "สไตล์ถัดไป",
  "qf.visualPrev": "สไตล์ก่อนหน้า",
  "qf.visualRandom": "สุ่ม",
  "qf.visualReshuffle": "เปลี่ยนชุดใหม่",
  "qf.visualViewFan": "ซ้อนกลับ",
  "qf.visualViewGrid": "แสดงเป็นตาราง",
  "qf.confirmed": "ยืนยันแล้ว",
  "qf.picked": "เลือกแล้ว {count}",
  "qf.moreOptions": "ตัวเลือกเพิ่มเติม",
  "qf.colorPresets": "สีที่ตั้งไว้",
  "qf.colorCustom": "สีกำหนดเอง",
  "qf.colorPickerLabel": "เปิดตัวเลือกสี",
  "qf.colorHexLabel": "ค่าสีเลขฐานสิบหก",
  "qf.colorPreview": "ตัวอย่าง: สีเน้นจะแสดงแบบนี้ในอินเทอร์เฟซ",
  "qf.colorInvalid": "กรอกรหัสสีเลขฐานสิบหก 6 หลัก เช่น #3b82f6",
  'qf.choose': 'จิ้มเลือกเถอะ…',
  'qf.customLabel': 'Custom answer',
  'qf.customPlaceholder': 'Type your own answer...',
  'qf.otherOption': 'อื่นๆ',
  'qf.ownAnswer': 'เขียนเอง',
  'qf.required': 'เป็นของต้องจัดให้เสมอ',
  'qf.lockedSubmitted': 'ข้อมูลรับไปสู่มือเอเจนต์แบบไม่มีตกค้าง เพื่อต่อความรันได้จนเสร็จสิ้น',
  'qf.lockedPrev': 'หน้าจอกรอบนี้มาจากแบบข้อมูลผ่านแล้ว',
  'qf.hint': 'ระบุเลือกตามที่มองเห็นว่าชอบใจอันไหน หากไม่ได้รู้สึกว่าอยากใช้อะไรก็ข้ามไป เอเจนต์คอยวางเกณฑ์ค่าพื้นฐานไว้ด้วยตัวเขาเอง',
  'qf.submitDefault': "ถัดไป",
  'qf.submitDisabledTitle': 'นำคำลงในกล่องที่จำเป็นให้ครบกันก่อน',
  'qf.submitTitle': "ถัดไป",
  'questions.tabLabel': 'คำถาม',
  'questions.banner': 'ขออนุญาตถามคำถามสั้น ๆ สองสามข้อได้ไหม',
  'questions.bannerAnswered': 'ตอบคำถามแล้ว',
  'questions.strategyBlockedNotice': "งานนี้ถูกหยุดโดยด่านตรวจคุณภาพของกลยุทธ์ จึงไม่สามารถส่งฟอร์มนี้ได้อีก โปรดเริ่มคำขอใหม่เพื่อดำเนินการต่อ",
  'questions.continue': 'ดำเนินการต่อ',
  'questions.generating': 'กำลังสร้างคำถาม…',
  'questions.skipAll': "ข้าม · คุณตัดสินใจ",
  'questions.autoSkipHint': 'ดำเนินการต่อโดยอัตโนมัติเมื่อหมดเวลา',
  'questions.submitting': 'กำลังส่ง…',
  'sketch.toolSelect': 'จิ้มเลือกตัวสิ่งของ',
  'sketch.toolPen': 'ปากกาวาดลาย',
  'sketch.toolText': 'ข้อความอักษร',
  'sketch.toolRect': 'ทำกรอบสี่เหลี่ยม',
  'sketch.toolArrow': 'ทำลูกศรชี้',
  'sketch.toolEraser': 'ยางลบเก็บลาย',
  'sketch.color': 'หยิบสีระบาย',
  'sketch.strokeSize': 'เพิ่มระดับความหนาเส้นวาด',
  'sketch.undo': 'ดึงกลับขั้นที่เพิ่งวาดไป',
  'sketch.clear': 'ลบทำความสะอาดเต็มแผ่น',
  'sketch.close': 'ทิ้งและปิดหน้าต่าง',
  'sketch.closeConfirm': 'ต้องการละทิ้งของที่ปรับยังไม่จบในร่างภาพวาดและออกไปเลยหรือ?',
  'sketch.textPrompt': 'ใส่ข้อความของคุณลง:',
  'sketch.textModalTitle': 'เติมข้อความลงที่ตัวหนังสือ',
  'critiqueTheater.userFacingName': 'คณะกรรมการตัดสินดีไซน์',
  'critiqueTheater.roleDesigner': 'นักออกแบบ',
  'critiqueTheater.roleCritic': 'นักวิจารณ์',
  'critiqueTheater.roleBrand': 'แบรนด์',
  'critiqueTheater.roleA11y': 'การเข้าถึง',
  'critiqueTheater.roleCopy': 'คัดลอก',
  'critiqueTheater.roundLabel': 'รอบที่ {n} จาก {m}',
  'critiqueTheater.mustFix': 'ต้องแก้ไข {n} รายการ',
  'critiqueTheater.composite': 'คะแนนรวม',
  'critiqueTheater.threshold': 'เกณฑ์ขั้นต่ำ',
  'critiqueTheater.consensus': 'ฉันทามติ',
  'critiqueTheater.interrupt': 'ขัดจังหวะ',
  'critiqueTheater.interrupting': 'กำลังหยุดชั่วคราว…',
  'critiqueTheater.interrupted': 'ถูกขัดจังหวะ',
  'critiqueTheater.degradedHeading': 'คณะกรรมการออฟไลน์ในการรันนี้',
  'critiqueTheater.degradedReasonMalformed': 'ผลลัพธ์ของคณะกรรมการมีรูปแบบไม่ถูกต้อง (ตัวแยกวิเคราะห์ปฏิเสธบล็อก)',
  'critiqueTheater.degradedReasonOversize': 'ผลลัพธ์ของคณะกรรมการเกินขีดจำกัดไบต์ที่ปลอดภัย',
  'critiqueTheater.degradedReasonAdapter': 'อะแดปเตอร์ {adapter} ไม่รองรับโปรโตคอล Critique',
  'critiqueTheater.degradedReasonProtocol': 'อะแดปเตอร์ {adapter} ส่งเวอร์ชันโปรโตคอลที่ไม่รองรับ',
  'critiqueTheater.degradedReasonMissingArtifact': 'การรันเสร็จสิ้นโดยไม่มีอาร์ติแฟกต์สุดท้าย',
  'critiqueTheater.replay': 'เล่นซ้ำ',
  'critiqueTheater.replaySpeed': 'ความเร็วในการเล่นซ้ำ',
  'critiqueTheater.readOnly': 'อ่านอย่างเดียว',
  'critiqueTheater.shippedSummary': 'ส่งออกในรอบ {round} · คะแนนรวม {composite}',
  'critiqueTheater.interruptedSummary': 'ถูกขัดจังหวะในรอบ {round} · คะแนนรวมที่ดีที่สุด {composite}',
  'critiqueTheater.shippedBadge': 'ส่งมอบแล้ว',
  'critiqueTheater.belowThresholdBadge': 'ต่ำกว่าเกณฑ์',
  'critiqueTheater.timedOutBadge': 'หมดเวลา',
  'critiqueTheater.failedHeading': 'การรันล้มเหลว',
  'critiqueTheater.failedReasonCliExit': 'Agent CLI ออกจากการทำงานด้วยรหัสที่ไม่ใช่ศูนย์ก่อนที่ panel จะทำงานเสร็จ',
  'critiqueTheater.failedReasonPerRoundTimeout': 'รอบหนึ่งใช้เวลาเกินงบประมาณเวลาที่กำหนด',
  'critiqueTheater.failedReasonTotalTimeout': 'การรันทั้งหมดใช้เวลาเกินงบประมาณเวลารวมที่กำหนด',
  'critiqueTheater.failedReasonOrchestrator': 'เกิดข้อผิดพลาดภายในของตัวจัดการการทำงาน',
  'critiqueTheater.transcriptEmpty': 'ยังไม่มี transcript ให้เล่นซ้ำ รันการวิจารณ์เพื่อบันทึกหนึ่งรายการ',
  'critiqueTheater.transcriptLoading': 'กำลังโหลดบทถอดความ…',
  'critiqueTheater.transcriptError': 'ไม่สามารถโหลด transcript ได้: {error}',
  'critiqueTheater.replaySpeedPaused': 'หยุดชั่วคราว',
  'critiqueTheater.replaySpeedInstant': 'ทันที',
  'critiqueTheater.replaySpeedLive': 'สด',
  'critiqueTheater.replaySpeedFast': 'เร็ว',
  'critiqueTheater.settingsNav': 'คณะกรรมการตัดสินดีไซน์',
  'critiqueTheater.settingsNavHint': 'การรีวิวงานออกแบบห้า panel สำหรับการรันของคุณ',
  'critiqueTheater.settingsEnabledLabel': 'แสดง Design Jury ระหว่างการรันของ Agent',
  'critiqueTheater.settingsEnabledDescription': 'เมื่อเปิดใช้งาน การรีวิวห้า panel จะปรากฏควบคู่ไปกับการสร้างของ Agent และให้คะแนนผลลัพธ์ก่อนส่งออก คุณสามารถขัดจังหวะได้ทุกเมื่อ',
  'critiqueTheater.settingsEnabledProjectHint': 'บันทึกไว้สำหรับโปรเจกต์นี้แล้ว การรันใหม่ในโปรเจกต์นี้จะถูกส่งผ่าน Design Jury ที่ฝั่งเซิร์ฟเวอร์',
  'critiqueTheater.settingsEnabledNoProjectHint': 'เปิดโปรเจกต์เพื่อบันทึกสิ่งนี้ที่ฝั่งเซิร์ฟเวอร์ จนกว่าจะถึงตอนนั้น การตั้งค่านี้จะเปลี่ยนเฉพาะค่ากำหนดในเบราว์เซอร์เท่านั้น',
  'pet.title': 'เพื่อนสัตว์เลี้ยง',
  'pet.subtitle': 'มารับน้องเอาไว้ดูแลในบนหน้าจอโปรเจกต์',
  'pet.navTitle': 'เพื่อนสัตว์เลี้ยง',
  'pet.navHint': 'ให้รับน้องเข้ามาอยู่กับตัวเอง',
  'pet.tabBuiltIn': 'มาพร้อมเปิดระบบ',
  'pet.tabBuiltInHint': 'จัดกลุ่มให้พร้อมใช้กับชุดระบบจาก OpenDesign แล้ว — เอาได้เลย',
  'pet.builtInEmpty': 'ของที่จัดกลุ่มจากข้างในมาไม่เห็นเลย ถ้าระบบออนไลน์อยู่ก็ขอตัวรีไปหามันต่อให้ที',
  'pet.tabCustom': 'สร้างของสไตล์แต่งเติมเอาเอง',
  'pet.tabCustomHint': 'มีตัวสัตว์ของเอง สร้างชื่อ กำหนดรูป เอามาวางปรับได้เสร็จสรรพ',
  'pet.tabCommunity': 'จากเพื่อนชุมชน',
  'pet.tabCommunityHint': 'เป็นพวกตัวสัตว์จากการผลิตใน Codex — ดูๆ และรับเลี้ยงต่อ หรือสั่งเจาะจงให้ทำแบบของที่ตัวเลือกเอาได้',
  'pet.tabsAria': 'ช่องทางของน้องเอาที่ไหนมาดี',
  'pet.adopt': 'เอาไปดูแลรับเลี้ยง',
  'pet.adoptedBadge': 'อยู่ในช่วงรับเลี้ยงไปแล้ว',
  'pet.adoptCallout': 'เอาไปดูแลรับเลี้ยงเถอะนะ',
  'pet.changePet': 'เปลื่ยนเพื่อนคู่หูตัวอื่นเอามาดีกว่า',
  'pet.wake': 'ลืมตื่นเถิด',
  'pet.tuck': 'กลับไปซุกรังเถอะ',
  'pet.wakeTitle': 'ไปเรียกตื่นออกมา — แสดงโชว์ให้พร้อม',
  'pet.tuckTitle': 'ม้วนกลับที่นอน — เอาออกจากการแสดงโชว์ไปก่อน',
  'pet.settingsTitle': 'เข้ามาที่แถบการตั้งปรับสัตว์เลี้ยง',
  'pet.useCustom': 'นำเพื่อนของฉันมาเป็นโชว์คู่หู',
  'pet.customTitle': 'ทำสัตว์ตัวโปรดของคุณเลย',
  'pet.customHint': 'จัดระเบียบใส่ชื่อ อีโมจิ หรือสิ่งที่มีเพื่อนำมาเป็นโชว์สัตว์แบบสมบูรณ์พร้อม',
  'pet.customGreetingPlaceholder': 'ทักทายส่งเสียงบอกสักคำสิ…',
  'pet.fieldName': 'เรียกน้องสัตว์ว่า',
  'pet.fieldGlyph': 'ใช้อีโมจินี้แหล่ะ',
  'pet.fieldGlyphHint': 'เหมาะสุดก็คือแบบอีโมจิเดี่ยวมาตัวนึง (เช่น 🐝, 🦄, 🐢)',
  'pet.fieldGreeting': 'เสียงคำทักทายที่กล่าวไว้',
  'pet.fieldAccent': 'ใช้สีโทนสดใสของเน้นตัว',
  'pet.fieldAccentCustom': 'ปรับแต่งของสีด้วยตัวเอง',
  'pet.fieldAccentDefault': 'สีเน้นเริ่มต้น',
  'pet.overlayAria': 'เป็นโชว์แผงของสัตว์',
  'pet.spriteAria': 'นี่ของ {name} — ตัวกดจับลากและแชทเข้าพูด',
  'pet.spriteTitle': 'แวะมาหวัดดีจาก {name}! จิ้มมาสนทนากัน',
  'pet.taskSummarySingle': 'งาน Agent {count} งานกำลังทำงานอยู่',
  'pet.taskSummaryMultiple': 'งาน Agent {count} งานกำลังทำงานอยู่ใน {projects} โปรเจกต์',
  'pet.taskSummaryRecentSingle': 'งาน Agent {count} งานเพิ่งเสร็จสิ้น',
  'pet.taskSummaryRecentMultiple': 'งาน Agent {count} งานเพิ่งเสร็จสิ้น',
  'pet.taskListAria': 'งาน Agent ที่กำลังทำงาน',
  'pet.taskOpenProject': 'เปิด {project}',
  'pet.taskGroup.running': 'กำลังทำงาน',
  'pet.taskGroup.queued': 'กำลังรอ',
  'pet.taskGroup.recent': 'เพิ่งเสร็จสิ้น',
  'pet.idleQuote.leonardo.text': 'การเรียนรู้ไม่เคยทำให้จิตใจเหนื่อยล้า',
  'pet.idleQuote.leonardo.author': 'Leonardo da Vinci',
  'pet.idleQuote.michelangelo.text': 'ฉันเห็นเทวดาในก้อนหินอ่อนและแกะสลักจนกระทั่งปลดปล่อยเขาให้เป็นอิสระ',
  'pet.idleQuote.michelangelo.author': 'Michelangelo',
  'pet.idleQuote.bernini.text': 'มีสองสิ่งที่ช่วยประติมากรได้: แสงและเงา',
  'pet.idleQuote.bernini.author': 'Gian Lorenzo Bernini',
  'pet.idleQuote.raphael.text': 'เมื่อกำลังวาดภาพ คนเราไม่ได้คิด',
  'pet.idleQuote.raphael.author': 'Raphael',
  'pet.idleQuote.caravaggio.text': 'ผลงานทั้งหมด ไม่ว่าจะเป็นอะไรหรือใครวาด ล้วนเป็นเพียงสิ่งไร้ค่าและเรื่องเล็กน้อยแบบเด็กๆ เว้นแต่จะถูกสร้างและวาดขึ้นจากชีวิตจริง',
  'pet.idleQuote.caravaggio.author': 'Caravaggio',
  'pet.idleQuote.rodin.text': 'สิ่งสำคัญที่สุดคือการได้รู้สึกซาบซึ้ง ได้รัก ได้หวัง ได้สั่นไหว ได้มีชีวิต',
  'pet.idleQuote.rodin.author': 'Auguste Rodin',
  'pet.composerTitle': 'เพื่อนสัตว์เลี้ยง — เรียกตื่น ม้วนไปนอน หรือเอาอันไหนสักที',
  'pet.composerMenuTitle': 'เพื่อนสัตว์เลี้ยง',
  'pet.composerMenuHint': 'ตัวเลือกพิเศษ: ลองพิมพ์ /pet เพื่อเปลี่ยนการใช้งานโหมด',
  'pet.composerOpenSettings': 'จัดการสัตว์เลี้ยง',
  'pet.welcomeTeaserTitle': 'เปิดรับเพื่อนมา',
  'pet.welcomeTeaserBody': 'ตัวกระจุ๋มกระจิ๋มอยู่ลอยไปมาบนพื้นที่ที่โชว์แวะทัก',
  'pet.welcomeTeaserCta': 'เลือกมาตัวนึงสิ',
  'pet.imageUpload': 'ส่งแถบภาพเคลื่อนไหวสไปรต์',
  'pet.imageReplace': 'โละเปลี่ยนใส่ของภาพสไปรต์ให้มาใหม่',
  'pet.imageRemove': 'หยุดกลับสู่อีโมจิตามปกติก่อน',
  'pet.imageHintIdle': 'รองรับทั้งไฟล์แบบ PNG, JPG, WebP, GIF รวมไปถึง SVG ของที่อัพเข้ามา ถ้าใช้แผ่นเคลื่อนไหวหลายช่อง ก็ต้องเซตส่วนตัวที่กรอบมาให้ด้วย',
  'pet.imageHintActive': 'รูปสัตว์โชว์การแสดงผลพร้อมใช้ ถ้าใส่เฟรมไว้ > 1 มันจะไปรันให้ดูผ่านของแผ่นแสดงตามที่ว่ามา',
  'pet.fieldFrames': 'จำนวนเฟรมที่แบ่ง',
  'pet.fieldFramesHint': 'มีแค่ 1 = ปักนิ่งเอาไว้ให้ มีของ > 1 = ลากมาเคลื่อนไปเรื่อยตามการใส่',
  'pet.fieldFps': 'วิ่งจังหวะฉับไว (fps)',
  'pet.fieldFpsHint': 'ให้กำหนดตามใจว่าหมุนมาเปลี่ยนช่องเร็วแค่ไหน',
  'pet.atlasImport': 'เอาของสไปรต์ Codex ใช้นำเข้า',
  'pet.atlasImportTitle': 'มาให้ดึงแบบสไปรต์สัตว์แบบฟัก (hatch-pet) แผนที่เข้าฉบับ 8x9 / 192x208 (แบบรับได้ของ PNG และ WebP)',
  'pet.atlasPickerTitle': 'ไปลองกดตรงแถบของโชว์ความเคลื่อนไหวมาสักชุด',
  'pet.atlasPickerHint': 'ของ Codex ที่รวมแผงสัตว์ไว้มีราว 9 แถวของการเคลือนมาด้วย ของที่พร้อมมาแล้วตามพื้นฐานมักจะทำแผ่นแบบครบเซต พอมีเวลาที่น้องขยับตามทิศทางเมาส์หรือเอามาพักเฉยๆ ก็พร้อมที่จะใช้ตลอด สามารถแช่ภาพหรือเอาตามการเล่นก็ตั้งตามใจในนั้นได้',
  'pet.atlasCancel': 'ทิ้งและปล่อยตัวเลือกนี้ไปเถิด',
  'pet.atlasAdopt': 'ล็อคแช่ตามแถวที่เลือกมา',
  'pet.atlasAdoptFull': 'ลากเข้าเอาในของแผนเต็มแบบจัดฉากเอง (เน้นทำทิศทางขยับเป็นหลายท่วงท่า)',
  'pet.atlasAdoptFullTitle': 'ครอบคลุมมาเก็บทั้งแถวให้โชว์ทุกอย่างเวลามีทิศทาง หรือโดนเมาส์รบกวน',
  'pet.atlasAdoptRowTitle': 'ตัดมาแบ่งใช้เน้นส่วนเด่นๆ ให้ทำวิ่งซ้ำๆ ของเฉพาะเจาะจงกันเลย',
  'pet.atlasActiveHint': 'อยู่ในของที่ตัวแอนิเมชันเปิดตามฉบับเต็มใช้งานตลอด — น้องพร้อมแล้วที่มีจะเปลี่ยนการแสดงอารมณ์ไป (ทั้งขยับไปมา ลาก หรืออยู่หยุดพักนิ่ง)',
  'pet.atlasRow.idle': 'ยืนนิ่งรับสถานะ',
  'pet.atlasRow.running-right': 'พุ่งตัวทางด้านขวา',
  'pet.atlasRow.running-left': 'พุ่งตัวไปในทิศทางซ้าย',
  'pet.atlasRow.waving': 'ทักทายโบกสะบัด',
  'pet.atlasRow.jumping': 'กระโดดลอยตัว',
  'pet.atlasRow.failed': 'รับทราบถึงข้อขัดข้องล้มเหลว',
  'pet.atlasRow.waiting': 'ทอดทิ้งไว้รอบางสิ่ง',
  'pet.atlasRow.running': 'พุ่งทะยานวิ่ง',
  'pet.atlasRow.review': 'ทำการไล่ทบทวนตรวจดูผลลัพธ์กัน',
  'pet.hatchTitle': 'เสกหาตัวน้องสัตว์ AI ด้วยตัวเองจากฟักไข่ใหม่เลย',
  'pet.hatchHint': 'เอาของเครื่องมือที่ฝังใช้จากข้างใน (hatch-pet skill) กดรับนำมาปั้นผลสไปรต์หน้าของ Codex ในหน้าจอและนำเข้ามายังตระกูลที่นี่ซะ',
  'pet.hatchConcept': 'ของไอเดียสัตว์ตัวหลัก (เสริมใส่หรือไม่ใส่ก็ว่าตามต้องการ)',
  'pet.hatchConceptPlaceholder': 'อาทิ หมาปั๊กแบบภาพ 8-บิท สวมชุดหมวกนิตติ้งมา',
  'pet.hatchCopy': 'จิ้มเพื่อก็อปปี้สคริปต์นี้ออกไว้ได้',
  'pet.hatchCopied': 'จัดการคัดลอกมาอยู่บนคลิปบอร์ดเสร็จแล้ว!',
  'pet.hatchFoot': 'หลังจากเครื่องมือเซฟสัตว์เลี้ยงไว้ ให้กลับมาที่นี่เพื่อทำการเลือก "นำเข้าภาพ Codex sprite" และระบุเลย',
  'pet.slashPopoverAria': 'แถบเข้าชุดเครื่องมือ Slash พิเศษ',
  'pet.slashPopoverTitle': 'สั่งทำงานตามคำพูดตรง',
  'pet.slashPopoverHint': 'ไล่ชี้จากทิศทาง ↑↓ นำเอา enter เข้าจับสั่ง · esc ไม่เอาหน้าต่างแล้วออกไป',
  'pet.slashPet': 'โหมดตั้งกลับแบบ เปิดเอา/ปิดรับ พร้อมการเข้าจัดระบบตัวของสัตว์เลยทันใจ',
  'pet.slashMcp': 'Open MCP server settings or insert a server tool hint.',
  'pet.slashPetWake': 'เรียกตัวที่เตรียมลอยมาโชว์รับในจอ',
  'pet.slashPetTuck': 'เอากลับพับโชว์เข้าที่ไปตอนนี้นี่แหล่ะ',
  'pet.slashHatch': 'ก่อแบบเสกตัวของจากแบบฉบับ Codex ทำเข้าจากตรงระบบความสามารถ hatch-pet เสียด้วย',
  'pet.slashHatchArg': '<รายละเอียดการออกแบบคอนเซปต์>',
  'pet.slashSearch': 'รับให้สั่งดึงของคำสั่งที่ใช้เพื่อตรวจเว็บแบบ OD วิ่งค้นหากันได้',
  'pet.slashSearchArg': '<รายละเอียดการนำทางสืบค้น>',
  'pet.codexTitle': 'แบบสดๆ ฟักจากข้างในเลย',
  'pet.codexSubtitle': 'สิ่งที่เป็นพวกนี้คือตัวน้องๆ ที่ได้จากทักษะ hatch-pet โดยกดปุ๊บก็ไปพร้อมกับการให้ตัวเข้ามาทันที',
  'pet.codexSubtitleWithDir': 'ในเวลาที่เข้าดึงสแกนตามตัวจากระบบไดเรกทอรี {dir} ที่จะได้ให้ตัวเลือกการเข้าจัดการของ hatch-pet',
  'pet.codexEmpty': 'ไร้แววเลยตอนนี้ ไม่พบแบบของอะไรใหม่เลยที่ฟักออกมาได้ ไปตามปุ่มการใช้พิมพ์แบบ /hatch ดูเอาไว้สร้างขึ้นนะ',
  'pet.codexLoading': 'อยู่ระหว่างพิจารณาจับแบบการฟักสัตว์มาให้เห็นกัน…',
  'pet.codexRefresh': 'ดึงโหลดเข้ามาอีก',
  'pet.codexAdopt': 'กดยอมรับดูแลไปเลย',
  'pet.codexAdopting': 'สู่โหมดกำลังเข้าเอาตัวดูแลไปแล้วนะ…',
  'pet.communitySync': 'มาจับซิงค์หาเหล่าแบบจากส่วนชุมชนลงเครื่องมาสิ',
  'pet.communitySyncing': 'จัดการไล่จับข้อมูลดาวน์โหลดมาให้คอยอยู่…',
  'pet.communitySyncTitle': 'จับข้อมูลเพื่อซิงค์รุ่นเข้าแบบ Codex Pet Share ทั้งของแบบ j20 นำดึงสู่ในของ ~/.codex/pets/ ให้',
  'pet.communitySyncDone': 'ดำเนินการซิงค์ลุล่วงด้วยไปได้ {wrote} ของรุ่นสัตว์ใหม่ ({total} ค่ามีทั้งหมดในผลนะ)',
  'pet.communitySyncFailed': 'ซิงค์เข้าล้มซะแล้ว มีเออเร่อแบบนี้ขึ้นเลย: {error}',
  'pet.codexBundled': 'รวมมามัดชุดใหญ่',
  'pet.codexBundledTitle': 'เตรียมมาให้กับ OpenDesign แล้ว — ไม่ต้องดาวน์โหลดใหม่',
  'settings.systemPrefsTitle': 'การตั้งค่าระบบ',
  'settings.systemPrefsHint': 'เสียงแจ้งเมื่อเสร็จสิ้น การแจ้งเตือนของเบราว์เซอร์ และการแจ้งเตือนสถานะงาน',
  'settings.notifications': 'การรับส่งข้อมูลการแจ้งเตือน',
  'settings.notificationsHint': 'มีระบบใช้บอกทั้งส่งเตือนเดสก์ท็อป และเปิดเสียงที่รันรับใช้เข้าแบบทำงานลุล่วง',
  'settings.notifyCompletionSound': 'ส่งเสียงแสดงให้รับรู้',
  'settings.notifyCompletionSoundHint': 'ทำงานดังขึ้นเมื่อถึงจังหวะผลลุล่วง เป็นค่าตั้งที่ปิดก่อนด้วยค่าระดับพื้นฐานเอาไว้เลย',
  'settings.notifySuccessSound': 'โทนเสียงแจ้งงานผ่านตลอดรอดตาย',
  'settings.notifyFailureSound': 'โทนเสียงแบบเกิดล้มเหลว',
  'settings.notifyDesktop': 'ป้ายกล่องเตือนหน้าจอเดสก์ท็อป',
  'settings.notifyDesktopHint': 'ส่งไปเตือนให้เวลาหน้าจอหรือตัวหน้าต่างโดนไปไม่ได้ตั้งโฟกัสมองดูเอาไว้',
  'settings.notifyDesktopBlocked': 'ยังติดปิดกั้นแบบของในเบราว์เซอร์ไปแล้ว ให้เปิดไปตั้งค่าความอนุญาตรับในส่วนที่ทำในแผงจัดการตัวเว็บให้หน่อย',
  'settings.notifyDesktopUnsupported': 'หมดโอกาสรองรับกันไปในการทำแบบแผงการแจ้งนี้บนอุปกรณ์ที่เป็นอยู่นี่ซะ',
  'settings.notifyTest': 'กดลองฟังตัวเทสดู',
  'settings.notifyTestSent': 'ถูกลากผ่านส่งคำโชว์ข้อตัวทดสอบนี้ไป ถ้าระดับป้ายตัวเตือนไม่มีขึ้นเลย ควรตามเข้าไปจัดใหม่ดูในการของแจ้งทั้งระบบบนและเบราว์เซอร์ล่ะกัน',
  'settings.notifyTestFailed': 'เรียกการส่งเตือนเกิดความล้มเหลว ลองตรวจระดับตัวเซตติ้งในส่วนระบบของเตือนแบบระบบเบราว์เซอร์หน่อยแล้วกัน',
  'settings.notifySoundDing': 'ดังติ๊งสิ',
  'settings.notifySoundChime': 'ลั่นเหมือนดังกระดิ่ง',
  'settings.notifySoundTwoToneUp': 'โทนดังปรับขึ้นไป 2 จังหวะ',
  'settings.notifySoundPluck': 'เสียงดั่งโดนสายกระตุกไปมา',
  'settings.notifySoundBuzz': 'เป็นจังหวะกระตุ้นอารมณ์สั่นเลย',
  'settings.notifySoundTwoToneDown': 'โทนดังลดถอย 2 จังหวะ',
  'settings.notifySoundThud': 'เสียงหนักเน้นโครมให้ระวัง',
  'settings.skills': 'ทักษะ',
  'settings.skillsHint': 'ทักษะเชิงฟังก์ชันที่ Agent สามารถเรียกใช้ระหว่างทำงานได้',
  'settings.skillsNew': 'Skill ใหม่',
  'settings.skillsEmpty': 'เลือก skill ทางด้านซ้าย หรือสร้างใหม่',
  'settings.skillsEdit': 'แก้ไข',
  'settings.skillsDelete': 'ลบ',
  'settings.skillsDeleteConfirm': 'ยืนยันการลบ',
  'settings.skillsName': 'ชื่อ',
  'settings.skillsTriggers': 'ทริกเกอร์ (คั่นด้วยจุลภาคหรือขึ้นบรรทัดใหม่)',
  'settings.skillsDescription': 'คำอธิบาย',
  'settings.skillsBody': 'เนื้อหา SKILL.md',
  'settings.skillsCreate': 'สร้าง',
  'settings.skillsSave': 'บันทึก',
  'settings.skillsSaving': 'กำลังบันทึก…',
  'settings.skillsOverrideCreate': 'สร้างการแทนที่ของผู้ใช้',
  'settings.skillsOverrideSave': 'บันทึกเป็นการแทนที่ของผู้ใช้',
  'settings.skillsBuiltInOverrideWarning': 'การแก้ไขสกิลในตัวนี้จะสร้างการแทนที่ของผู้ใช้ รายการในตัวจะถูกซ่อนจากรายการจนกว่าคุณจะลบการแทนที่ ดำเนินการต่อหรือไม่?',
  'settings.skillsFiles': 'ไฟล์',
  'settings.skillsNoFiles': 'ไม่มีไฟล์ในโฟลเดอร์ทักษะนี้',
  'settings.skillsNameRequired': 'ต้องระบุชื่อทักษะ',
  'settings.skillsBodyRequired': 'ต้องระบุเนื้อหาทักษะ',
  'settings.designSystems': 'ระบบดีไซน์',
  'settings.designSystemsHint': 'จัดการว่า design system ใดบ้างที่จะปรากฏในแกลเลอรีหน้าแรก',
  'settings.designSystemsInstalled': 'ติดตั้งแล้ว',
  'settings.designSystemsAdd': 'เพิ่มระบบออกแบบ',
  'settings.designSystemsHiddenCount': 'ซ่อน {count} รายการจากแกลเลอรีหน้าแรก',
  'settings.designSystemsShowAll': 'แสดงทั้งหมด',
  'settings.designSystemsShowHidden': 'แสดงรายการที่ซ่อน',
  'settings.designSystemsSource': 'แหล่งที่มา',
  'settings.designSystemsSourceLocal': 'ในเครื่อง',
  'settings.designSystemsSourceGithub': 'GitHub',
  'settings.designSystemsSourceShadcn': 'shadcn',
  'settings.designSystemsShadcnReference': 'การอ้างอิงรีจิสทรี shadcn',
  'settings.designSystemsImportShadcn': 'นำเข้าจาก shadcn',
  'settings.designSystemsStructure': 'โครงสร้าง',
  'settings.designSystemsModeHybrid': 'ไฮบริด',
  'settings.designSystemsModeNormalized': 'ปรับมาตรฐาน',
  'settings.designSystemsModeVerbatim': 'คงเดิม',
  'settings.designSystemsCraft': 'Craft',
  'settings.designSystemsCraftColor': 'สี',
  'settings.designSystemsCraftAccessibility': 'การเข้าถึง',
  'settings.designSystemsGithubUrl': 'URL GitHub',
  'settings.designSystemsProjectPath': 'พาธโปรเจกต์',
  'settings.designSystemsImportGithub': 'นำเข้าจาก GitHub',
  'settings.designSystemsImportProject': 'นำเข้าจากโปรเจกต์',
  'settings.designSystemsImportedStatus': 'นำเข้า {title} แล้ว',
  'settings.designSystemsViewImported': 'ดูระบบออกแบบที่นำเข้า',
  'settings.designSystemsCategory': 'หมวดหมู่',
  'settings.designSystemsAllCategories': 'ทุกหมวดหมู่',
  'settings.designSystemsShowInHomeGallery': 'แสดงในแกลเลอรีหน้าแรก',
  'settings.projectLocations': 'ตำแหน่งโปรเจกต์',
  'settings.projectLocationsHint': 'รากที่เก็บเวิร์กสเปซ',
  'settings.projectLocationsDescription': 'เพิ่มฐานงานที่สามารถเก็บโฟลเดอร์โปรเจกต์ OpenDesign ได้หลายรายการ โปรเจกต์ใหม่จะถูกบันทึกเป็นหนึ่งโฟลเดอร์ภายในฐานที่เลือก',
  'settings.projectLocationsSaveError': 'ไม่สามารถบันทึกตำแหน่งโปรเจกต์ได้ ตรวจสอบว่าแต่ละพาธเป็นโฟลเดอร์ที่เข้าถึงได้',
  'settings.projectLocationsSaved': 'บันทึกตำแหน่งโปรเจกต์แล้ว',
  'settings.projectLocationsScanError': 'ไม่สามารถสแกนตำแหน่งโปรเจกต์ได้',
  'settings.projectLocationsScanComplete': 'สแกนเสร็จแล้ว: นำเข้า {imported} รายการ, ลงทะเบียนไว้แล้ว {existing} รายการ',
  'settings.projectLocationsNoFolderSelected': 'ไม่ได้เลือกโฟลเดอร์',
  'settings.projectLocationsDuplicate': 'เพิ่มฐานงานนี้ไว้แล้ว',
  'settings.projectLocationsWorkBaseMeta': 'ฐานงาน · โปรเจกต์จะถูกสร้างเป็นโฟลเดอร์ย่อยที่นี่',
  'settings.projectLocationsAddFolder': 'เพิ่มโฟลเดอร์…',
  'settings.projectLocationsDefaultBadge': 'ตำแหน่งเริ่มต้น',
  'settings.projectLocationsMakeDefault': 'ตั้งเป็นค่าเริ่มต้น',
  'settings.projectLocationsDefaultSaved': 'อัปเดตตำแหน่งโปรเจกต์เริ่มต้นแล้ว',
  'settings.librarySkills': 'พวก Skills',
  'settings.libraryDesignSystems': 'ตัวของระบบแบบ Design Systems',
  'settings.librarySearch': 'ต้องการหาสิ่งใด…',
  'settings.libraryAll': 'ทุกชิ้นส่วนเอามา',
  'settings.libraryPreview': 'ชมภาพเตรียม',
  'settings.libraryPreviewClose': 'นำเก็บซ่อน',
  'settings.libraryLoading': 'ในระบบเรียกมารอ…',
  'settings.libraryNoResults': 'ตัวหานี้มีอันที่ไม่มีตรงใดๆ กับที่ค้นเข้ามาเลยล่ะ',
  'settings.libraryEnabled': 'เปิดเข้าตัวโหมด',
  'settings.libraryDisabled': 'งับการแสดงอยู่',
  'settings.connectorsNavHint': 'แหล่งของระบบที่ไว้เข้าถึงจากที่ตั้งในของตัวพ่วงแผงอื่น',
  'settings.connectorsHint': 'ให้คอยเข้ามาปรับเซตและมองเข้าจัดการส่วนตัวบริการระบบที่เชื่อมผูกมากับดีไวซ์ในอันนี้ด้วย',
  'settings.connectorsComposioApiKey': 'ใส่ส่วนตัวของคีย์แบบ Composio API',
  'settings.connectorsSavedTitle': 'ดึงสู่ความพร้อมเก็บในที่ Local Daemon เลย',
  'settings.connectorsSavedWithTail': 'พร้อมใช้แล้ว · ••••{tail}',
  'settings.connectorsSaved': 'บันทึกพร้อม',
  'settings.connectorsGetApiKey': 'หาเส้นทางคีย์เข้า API Key',
  'settings.connectorsReplaceKeyPlaceholder': 'หามาใส่ของตัวคีย์ที่ตั้งในของแทนส่วนเก็บไปก่อนแล้วได้ตรงนี้',
  'settings.connectorsApiKeyPlaceholder': 'อัดเข้ากับตัว Composio API key ในนี่แหล่ะ',
  'settings.connectorsClear': 'ให้เอาออกโล่งเลย',
  'settings.connectorsClearConfirmTitle': 'สั่งแบบกำจัดพร้อมเอาคีย์เก่าบน Composio API ที่ตั้งไว้นี้หรือไม่',
  'settings.connectorsClearConfirmBody': 'ของชุดนี้ส่งออกคีย์ไปหมายความตัวของแอปใดใดทางตัวเชื่อมทุกชนิดที่จะติดผูกมาตรง Composio ทิ้งให้หมดทุกแบบ ซึ่งพวกรวมแบบอย่างการมีบัญชีของระบบ อนุญาตตั้งตามทาง OAuth รวมเลยกับของความเข้ามือเอาทิ้งตามออกหมดเรียบเลย',
  'settings.connectorsClearConfirmContinue': 'ขอเดินข้ามเอาต่อ',
  'settings.connectorsClearFinalTitle': 'เรื่องนี้จะไปรบกวนให้ทุกตัวแอปพลิเคชั่นหลุดออก',
  'settings.connectorsClearFinalBody': 'คุณจะไม่สามารถทำอะไรกลับมาได้ จนกว่าจะใส่และเชื่อมเครื่องมือต่างๆ ใหม่',
  'settings.connectorsClearFinalConfirm': 'ลบคีย์และเลิกแอป',
  'settings.connectorsClearArming': 'สักแป๊บดึงเวลาตั้งเตรียมรับ…',
  'settings.connectorsClearCancel': 'กดแบบยกเลิกไป',
  'settings.connectorsSaveKey': 'อัดลงบันทึกชุดคีย์เลย',
  'settings.connectorsSaveKeyTitle': 'ดึงโอนความของคีย์ที่ได้รับกลับมาให้ที่ส่วนระบบเครื่องส่วน Local Daemon ต่อเลย',
  'settings.connectorsKeySaving': 'เก็บรักษาที่ส่วนข้อมูล…',
  'settings.connectorsKeySaved': 'บันทึกแล้ว ✓',
  'settings.connectorsKeyError': 'ไม่สามารถบันทึกได้ ลองตรวจสอบตัว Daemon ให้ดี',
  'settings.connectorsHelpSaved': 'รหัสเก็บอยู่ในเครื่องเรียบร้อย นำรหัสใหม่ใส่ได้ตลอด หรือเอาออกด้วยปุ่มล้างข้อมูล',
  'settings.connectorsHelpUnsaved': 'ผลต่างของการแก้ที่คงไม่ทันบันทึก — กดที่คำบันทึกคีย์มาทำให้เป็นบันทึกเข้าเอาในของระบบไว้เพื่อให้เปิดตรงข้อมูลหน้าได้ดูความพร้อมในแถบเครื่องมือ',
  'settings.connectorsHelpEmpty': 'ต้องเอาคีย์ลงก่อนจึงใช้เป็นตัวระบบเพิ่ม ข้อมูลอยู่ที่แอป และเครื่องของคุณเท่านั้น',
  'settings.connectorsLoadingSavedKey': 'ตรวจสอบตามส่วนที่จะเจอความตั้งการในส่วนการใช้บันทึกคีย์ตรงที่มาของ Local Daemon…',
  'settings.autosaveSaving': 'บันทึก…',
  'settings.autosaveSaved': 'บันทึกของข้อมูลสำเร็จ',
  'settings.autosaveError': 'เซฟข้อมูลไม่ได้ คาดว่า Daemon ขาดสัญญาณ',
  'settings.libraryToggleLabel': 'สลับโหมด',
  'settings.memory': 'หน่วยความจำ',
  'settings.memoryHint': 'ข้อเท็จจริงและบริบทที่บันทึกไว้สำหรับการแชทในอนาคต',
  'settings.customInstructionsTitle': 'กฎทั่วโลก',
  'settings.customInstructionsHint': 'คำสั่งตายตัวที่ OpenDesign ควรปฏิบัติตามในทุกการสนทนา บันทึกข้อเท็จจริง การตั้งค่า และบริบทของโปรเจกต์ไว้เป็นความทรงจำ',
  'settings.customInstructionsPlaceholder': 'เช่น "ใช้ TypeScript เสมอ เลือกใช้ functional component กระชับคำตอบให้สั้น"',
  'settings.memoryDescription': 'ควบคุมว่าจะนำข้อเท็จจริง การตั้งค่า และบริบทของโปรเจกต์ที่บันทึกไว้มาใช้ซ้ำในการสนทนาครั้งต่อไปหรือไม่',
  'settings.memoryEnabled': 'เปิดใช้งาน',
  'settings.memoryDisabled': 'ปิดใช้งาน',
  'settings.memoryEnableLabel': 'เปิดใช้การแทรกความทรงจำ',
  'settings.memoryDisabledBanner': 'ความทรงจำกำลังปิดอยู่ ข้อเท็จจริงที่มีอยู่ยังถูกเก็บไว้ในดิสก์ แต่จะไม่ถูกนำมารวมในการสนทนาใหม่ และการสนทนารอบใหม่จะไม่ดึงข้อมูลใหม่ออกมา',
  'settings.memoryNew': 'ความทรงจำใหม่',
  'settings.memoryEdit': 'แก้ไข',
  'settings.memoryDelete': 'ลบ',
  'settings.memoryPreview': 'ดูตัวอย่าง',
  'settings.memoryEmpty': 'ยังไม่มีความทรงจำ',
  'settings.memoryEmptyHintZh': '记住: 用户偏好深色主题',
  'settings.memoryEmptyHintEn': 'ฉันชอบโหมดมืด',
  'settings.memoryName': 'เช่น การตั้งค่า UI',
  'settings.memoryDesc': 'หนึ่งประโยค — ความทรงจำนี้เกี่ยวกับอะไร?',
  'settings.memoryBody': '- กฎข้อแรก\n- กฎข้อสอง\n\nเหตุผล: เหตุผลเพิ่มเติม (ไม่บังคับ)\nเมื่อใดจึงนำมาใช้: ขอบเขตเพิ่มเติม (ไม่บังคับ)',
  'settings.memoryBodyHint': 'ใส่กฎเป็นรายการก่อน จากนั้นจึงเพิ่มบรรทัด เหตุผล และ เมื่อใดจึงนำมาใช้ (ไม่บังคับ) รองรับ Markdown หรือคลิกตัวอย่างเริ่มต้นด้านบนเพื่อโหลดตัวอย่างที่ใช้งานได้',
  'settings.memoryStartersLabel': 'ต้องการจุดเริ่มต้นใช่ไหม? คลิกเพื่อกรอกแบบฟอร์ม:',
  'settings.memoryStarterUserName': 'บทบาทของฉัน',
  'settings.memoryStarterUserDesc': 'ฉันเป็นวิศวกร frontend ที่ทำงานกับเครื่องมือออกแบบ SaaS',
  'settings.memoryStarterUserBody': '- บทบาท: วิศวกร frontend อาวุโส\n- สแตก: React, TypeScript, Vite\n- โดเมน: เครื่องมือดีไซน์ / การทำงานร่วมกัน\n- เขตเวลา: GMT+8 (Asia/Shanghai)\n\nเมื่อใดที่จะใช้: แชทใดก็ได้ — ยกตัวอย่างโดยอิงกับเว็บ frontend',
  'settings.memoryStarterFeedbackName': 'การตั้งค่า UI',
  'settings.memoryStarterFeedbackDesc': 'โหมดมืด ตัวอักษรเนื้อหาขนาดใหญ่ ความหนาแน่นของข้อมูลต่ำ',
  'settings.memoryStarterFeedbackBody': '- ธีม: เข้มเป็นค่าเริ่มต้น\n- ข้อความเนื้อหา: ≥ 18px\n- ความหนาแน่นของข้อมูล: เน้นพื้นที่ว่าง มีรายการต่อหน้าจอน้อยลง\n\nเหตุผล: ลดอาการล้าของดวงตาระหว่างการใช้งานนาน ๆ\nเมื่อใดที่จะใช้: ทุกครั้งที่คุณสร้าง UI หน้าเว็บ หรือสไลด์',
  'settings.memoryStarterProjectName': 'โปรเจกต์ปัจจุบัน',
  'settings.memoryStarterProjectDesc': 'OpenDesign v0.5 — โปรแกรมแก้ไขดีไซน์ที่ขับเคลื่อนด้วยแชท',
  'settings.memoryStarterProjectBody': '- เป้าหมาย: ส่งมอบเอดิเตอร์แบบขับเคลื่อนด้วยแชตในไตรมาสนี้\n- ลำดับความสำคัญ: การเรนเดอร์แบบสตรีม, มัลติโมดัลในเครื่อง, ทำงานออฟไลน์เป็นหลัก\n- Stack: Next.js 16, Express daemon, SQLite\n\nเมื่อใดจึงนำมาใช้: ในการสนทนาใดก็ตามที่เกี่ยวกับโปรเจกต์นี้',
  'settings.memorySaveHint': 'ไม่ได้บันทึกอัตโนมัติ — คลิก สร้าง / บันทึก เพื่อปรับใช้',
  'settings.memoryIndexSaveHint': 'การแก้ไขดัชนีไม่ได้บันทึกอัตโนมัติ — คลิก บันทึกดัชนี เพื่อปรับใช้',
  'settings.memoryIndexUnsaved': 'การเปลี่ยนแปลงที่ยังไม่ได้บันทึก',
  'settings.memoryFlashCreated': '✓ สร้างความทรงจำแล้ว',
  'settings.memoryFlashSaved': '✓ บันทึกความทรงจำแล้ว',
  'settings.memoryFlashDeleted': '✓ ลบความทรงจำแล้ว',
  'settings.memoryFlashIndexSaved': '✓ บันทึกดัชนีแล้ว',
  'settings.memoryFlashPathCopied': '✓ คัดลอกเส้นทางแล้ว',
  'settings.memoryNameLabel': 'ชื่อเรื่อง',
  'settings.memoryTypeLabel': 'ประเภท',
  'settings.memoryDescLabel': 'คำอธิบาย',
  'settings.memoryBodyLabel': 'เนื้อหา',
  'settings.memoryTypeUser': 'ผู้ใช้',
  'settings.memoryTypeFeedback': 'ข้อเสนอแนะ',
  'settings.memoryTypeProject': 'โปรเจกต์',
  'settings.memoryTypeReference': 'การอ้างอิง',
  'settings.memoryTypeProfile': 'โปรไฟล์',
  'settings.memoryTypeRule': 'กฎ',
  'settings.memoryTabMemories': 'หน่วยความจำ',
  'settings.memoryTabMemoriesCaption': 'ดูและจัดการหน่วยความจำที่บันทึกไว้',
  'settings.memoryTabHow': 'วิธีการทำงาน',
  'settings.memoryTabHowCaption': 'สองลูปและการควบคุมของแต่ละลูป',
  'settings.memoryAddDisclosure': 'เพิ่มหรือนำเข้าหน่วยความจำ',
  'settings.memoryAddDisclosureHint': 'โปรไฟล์ การป้อนด้วยตนเอง หรือแอปที่เชื่อมต่อ',
  'settings.memoryProfileTab': 'โปรไฟล์การทำงาน',
  'settings.memoryProfileTabCaption': 'คุณคือใครและค่าเริ่มต้นของคุณ',
  'settings.memoryProfileTitle': 'โปรไฟล์การทำงานของคุณ',
  'settings.memoryProfileHint':
    'ข้อเท็จจริงสั้น ๆ เกี่ยวกับตัวคุณและค่าเริ่มต้นของคุณ ความทรงจำจะแทรกข้อมูลนี้ก่อนทุกงาน เพื่อให้เอเจนต์เข้าใจสิ่งที่คุณต้องการจากคำขอสั้น ๆ',
  'settings.memoryProfileName': 'โปรไฟล์การทำงาน',
  'settings.memoryProfileDescription':
    'บทบาท บริษัท โดเมน กลุ่มเป้าหมาย รสนิยม และค่าเริ่มต้นที่ผู้ช่วยควรนำมาใช้ซ้ำ',
  'settings.memoryProfileSave': 'บันทึกโปรไฟล์',
  'settings.memoryProfileSaving': 'กำลังบันทึก…',
  'settings.memoryProfileSaved': 'บันทึกโปรไฟล์แล้ว',
  'settings.memoryProfileRole': 'บทบาท',
  'settings.memoryProfileRolePlaceholder': 'เช่น Founder, designer, PM',
  'settings.memoryProfileCompany': 'บริษัท / ทีม',
  'settings.memoryProfileCompanyPlaceholder': 'เช่น Acme, growth team',
  'settings.memoryProfileDomain': 'โดเมน',
  'settings.memoryProfileDomainPlaceholder': 'เช่น B2B SaaS, fintech, devtools',
  'settings.memoryProfileAudience': 'กลุ่มเป้าหมายหลัก',
  'settings.memoryProfileAudiencePlaceholder': 'เช่น executives, engineers, end users',
  'settings.memoryProfileAesthetic': 'สุนทรียะ / รสนิยม',
  'settings.memoryProfileAestheticPlaceholder':
    'เช่น clean and editorial, light backgrounds, generous whitespace',
  'settings.memoryProfileDeliverables': 'ผลงานที่ต้องส่งมอบเป็นค่าเริ่มต้น',
  'settings.memoryProfileDeliverablesPlaceholder': 'เช่น landing pages, decks, one-pagers',
  'settings.memoryProfileLocale': 'ภูมิภาค / ภาษา',
  'settings.memoryProfileLocalePlaceholder': 'เช่น English (US), Simplified Chinese',
  'settings.memoryProfileGoals': 'เป้าหมายปัจจุบัน',
  'settings.memoryProfileGoalsPlaceholder':
    'เช่น ship the new pricing page, raise conversion on the trial flow',
  'settings.memoryHooksTitle': 'ฮุกความทรงจำ',
  'settings.memoryHooksHint':
    'เลือกว่าจะให้ส่วนใดของความทรงจำทำงานอัตโนมัติ สวิตช์หลักด้านบนจะปิดทั้งหมด',
  'settings.memoryHooksProfileLabel': 'ใช้โปรไฟล์ของฉัน',
  'settings.memoryHooksProfileDesc': 'แทรกโปรไฟล์การทำงานของคุณเข้าไปในทุกงาน',
  'settings.memoryHooksRewriteLabel': 'เขียนคำขอสั้น ๆ ใหม่',
  'settings.memoryHooksRewriteDesc': 'PRE: ขยายคำขอสั้น ๆ ให้เป็นบรีฟงานฉบับเต็ม',
  'settings.memoryHooksVerifyLabel': 'ตรวจสอบผลลัพธ์ด้วยตนเอง',
  'settings.memoryHooksVerifyDesc': 'POST: ตรวจผลลัพธ์เทียบกับกฎของคุณ แล้วแสดงสกอร์การ์ด',
  'settings.memoryHooksExtractionLabel': 'เรียนรู้จากการแชท',
  'settings.memoryHooksExtractionDesc': 'เก็บข้อเท็จจริงและการตั้งค่าที่เป็นประโยชน์จากการสนทนา',
  'settings.memoryIndex': 'MEMORY.md (ดัชนี)',
  'settings.memoryIndexSave': 'บันทึกดัชนี',
  'settings.memoryIndexReset': 'รีเซ็ต',
  'settings.memoryToastChanged': 'อัปเดตความทรงจำแล้ว',
  'settings.memoryToastClickHint': 'ดู',
  'settings.memoryAll': 'ทั้งหมด',
  'settings.memoryExtractions': 'ประวัติการดึงข้อมูล',
  'settings.memoryExtractionsHint': 'Regex ทำงานก่อน LLM ทำงานเบื้องหลัง',
  'settings.memoryExtractionsEmpty': 'ยังไม่มีการดึงข้อมูล การสนทนารอบถัดไปจะเติมข้อมูลลงในรายการนี้',
  'settings.memoryExtractionsRefresh': 'รีเฟรช',
  'settings.memoryExtractionsRefreshing': 'กำลังรีเฟรช…',
  'settings.memoryExtractionPhaseRunning': 'กำลังทำงาน…',
  'settings.memoryExtractionPhaseSuccess': 'สำเร็จ',
  'settings.memoryExtractionPhaseSkipped': 'ข้ามแล้ว',
  'settings.memoryExtractionPhaseFailed': 'ล้มเหลว',
  'settings.memoryExtractionSkipNoProvider': 'ยังไม่ได้ตั้งค่า API key สำหรับการดึงความทรงจำด้วย LLM',
  'settings.memoryExtractionSkipUnsupportedProvider': 'A saved media provider is not supported for LLM memory extraction.',
  'settings.memoryExtractionSkipDisabled': 'ความทรงจำถูกปิดใช้งาน',
  'settings.memoryExtractionSkipEmpty': 'ข้อความผู้ใช้ว่างเปล่า — ไม่มีอะไรให้ดึงข้อมูล',
  'settings.memoryExtractionSkipNoMatch': 'ไม่มีรูปแบบ regex ที่ตรงกับการสนทนารอบนี้',
  'settings.memoryExtractionKindHeuristic': 'regex',
  'settings.memoryExtractionKindLlm': 'LLM',
  'settings.memoryExtractionProviderEnv': 'env',
  'settings.memoryExtractionProviderMediaConfig': 'การตั้งค่าสื่อ',
  'settings.memoryExtractionProviderOverride': 'การตั้งค่าความทรงจำ',
  'settings.memoryExtractionProposed': 'ที่เสนอ',
  'settings.memoryExtractionWritten': 'เขียนแล้ว',
  'settings.memoryExtractionDuration': 'in',
  'settings.memoryExtractionDelete': 'ลบ',
  'settings.memoryExtractionsClear': 'ล้าง',
  'settings.memoryExtractionsClearTitle': 'ล้างประวัติการดึงข้อมูลทั้งหมด',
  'settings.memoryExtractionsClearConfirm': 'ล้างประวัติการดึงข้อมูลทั้งหมดหรือไม่? การกระทำนี้ไม่สามารถย้อนกลับได้',
  'settings.memoryNoProviderBannerTitle': 'การดึงความทรงจำด้วย LLM ไม่ได้ทำงานอยู่',
  'settings.memoryNoProviderBannerBody': 'ไม่พบ API key สำหรับตัวดึงความทรงจำ เพิ่ม OpenAI key ภายใต้ Media providers หรือตั้งค่า ANTHROPIC_API_KEY / OPENAI_API_KEY ในสภาพแวดล้อม เพื่อเปิดใช้การดึงข้อมูลที่ขับเคลื่อนด้วย LLM การดึงข้อมูลแบบฮิวริสติกด้วย regex ยังคงทำงานอยู่',
  'settings.memoryUnsupportedProviderBannerBody': 'A media provider key is saved, but Memory can only reuse text-capable providers: OpenAI, MiniMax, AIHubMix, and SenseAudio. Configure one of those under Media providers, set ANTHROPIC_API_KEY / OPENAI_API_KEY, or choose a Memory model in Advanced.',
  'settings.libraryInstall': 'ติดตั้ง',
  'settings.libraryInstallGithub': 'GitHub',
  'settings.libraryInstallLocal': 'พาธในเครื่อง',
  'settings.libraryInstallUrl': 'https://github.com/owner/repo',
  'settings.libraryInstallPath': '/path/to/skill-folder',
  'settings.libraryInstallButton': 'ติดตั้ง',
  'settings.libraryUninstall': 'ถอนการติดตั้ง',
  'settings.libraryBuiltIn': 'มีในตัว',
  'settings.libraryInstalled': 'ติดตั้งแล้ว',
  'settings.orbit.eyebrow': 'ระบบออโตเมชัน',
  'settings.orbit.title': 'วงโคจร (Orbit)',
  'settings.orbit.navHint': 'รวบรวมเหตุการณ์ในรอบวัน',
  'settings.orbit.lede': 'เก็บสรุปของแอปทั้งหมดมาบันทึกและโชว์ได้เลย',
  'settings.orbit.statusOnTitle': 'งานตารางประจำวันเดินเครื่องแล้ว',
  'settings.orbit.statusOffTitle': 'งานตารางประจำวันถูกปิด',
  'settings.orbit.statusActive': 'กำลังใช้',
  'settings.orbit.statusOff': 'ปิด',
  'settings.orbit.runTitle': 'กดใช้งาน และไปหน้าสรุปได้เลย',
  'settings.orbit.running': 'กำลังดึงสรุป…',
  'settings.orbit.runOpen': 'สั่งทำงานทันที',
  'settings.orbit.dailySummaryTitle': 'รายวันสรุปยอด',
  'settings.orbit.dailySummarySub': 'ใช้เวลาเพียง 1 หนในวัน ที่ทำหน้าที่',
  'settings.orbit.on': 'เปิด',
  'settings.orbit.off': 'ปิด',
  'settings.orbit.runTimeTitle': 'จองเวลาสรุปยอด',
  'settings.orbit.runTimeSub': '08:00 ใช้ตามเกณฑ์ปกติ หรือนำมาบันทึกเป็นค่าหลักสำหรับของในเครื่อง',
  'settings.orbit.runTimeAria': 'ตัวสรุปกิจกรรมใน Orbit ประจำวัน',
  'settings.orbit.nextRun': 'สรุปผลครั้งใหม่',
  'settings.orbit.nextRunScheduledAfterSave': 'รอเปิดตามตาราง (หลังการบันทึก)',
  'settings.orbit.schedule': 'นัดเวลา',
  'settings.orbit.pausedManualOnly': 'หยุดพักอยู่ (รันจากการกดเท่านั้น)',
  'settings.orbit.templateTitle': 'รูปแบบข้อความอธิบาย',
  'settings.orbit.templateMissing': 'เทมเพลต {id} ไม่ได้ติดตั้งไว้',
  'settings.orbit.templateMissingOption': '{id} (ยังหายไป)',
  'settings.orbit.templateMissingInstall': 'ใช้งานสกิลของ Orbit เพื่อกำหนดรูปแบบสรุปยอดข้อความได้ดั่งใจ',
  'settings.orbit.templateMissingPickAnother': 'เปลี่ยนการใช้ตัวแทนใหม่ตรงรายการ',
  'settings.orbit.templateResetTitle': 'รีเซ็ตสู่ {id}',
  'settings.orbit.templateReset': 'รีเซ็ต',
  'settings.orbit.templateHelp': 'ใช้คำสั่งตรงเข้าหาเพื่อความตรงไปตรงมา — เทมเพลตตัวนี้พร้อมเข้าสร้างผลในทุกตัววงโคจรให้ดี',
  'settings.orbit.templateAria': 'คำสั่งควบคุม Orbit',
  'settings.orbit.templatesLoading': 'กำลังโหลดรายการ…',
  'settings.orbit.templatesOptgroup': 'แบบฟอร์มการวิเคราะห์',
  'settings.orbit.lastRun': 'ครั้งท้ายสุด',
  'settings.orbit.triggerManual': 'จัดการสั่งรันเอง',
  'settings.orbit.triggerScheduled': 'จองไว้แล้ว',
  'settings.orbit.meterAria': 'ทั้งหมด {checked}, เข้าที่สำเร็จ {succeeded}, ยกเลิก {skipped}, ล้ม {failed}',
  'settings.orbit.countChecked': 'ที่รับงานไป',
  'settings.orbit.countSucceeded': 'เสร็จตามเป้า',
  'settings.orbit.countSkipped': 'โดนข้ามไป',
  'settings.orbit.countFailed': 'ไม่ลุล่วง',
  'settings.orbit.runError': 'หาที่รวมงานไม่ได้ โปรดเตรียมทั้งการเชื่อมต่อ และเครื่องมือ',
  'settings.orbit.gateAriaLabel': 'ระบบเรียกความพร้อม',
  'settings.orbit.gateEyebrow': 'ใช้ตัวเสริม',
  'settings.orbit.gateTitle': 'ต่อข้อมูลแอปทั้งหมดเพื่อใช้ Orbit',
  'settings.orbit.gateBody': 'Orbit ไว้ให้เป็นพื้นที่สำหรับดูทุกงาน ลองเปิดต่อเชื่อมอย่างน้อย 1 ก่อนเพื่อให้มันโชว์สถิติของทุกสิ่ง',
  'settings.orbit.gateBodyNoKey': 'Orbit ต้องการต่อเข้าส่วน Composio โปรดดึง API ลงเข้าหาก่อนจึงสามารถเข้าเครื่องได้',
  'settings.orbit.gateAction': 'ตั้งค่าแอปใหม่',
  'settings.orbit.gateActionNoKey': 'ติดตั้ง Composio',
  'settings.orbit.gateLoading': 'กำลังตรวจสิ่งที่คุณตั้งไว้…',
  'settings.orbit.controlsLockedBadge': 'มีล็อกเอาไว้',
  'settings.orbit.controlsLockedHint': 'ต้องการตัวแอปเพิ่มเพื่อใช้งานให้ครบกับกำหนดแบบฟอร์มได้',
  'settings.orbit.artifactKickerLive': 'ตัวจำลอง Live artifact',
  'settings.orbit.artifactKickerLegacy': 'เนื้อหาสรุปล่าสุด',
  'settings.orbit.artifactTitle': 'ความเคลื่อนไหวล่าสุดผ่าน Orbit',
  'settings.orbit.artifactMetaLive': 'เป็นแบบระบบอัปเดตเอง จากแอปพลิเคชั่นที่เชื่อมอยู่',
  'settings.orbit.artifactMetaLegacy': 'ข้อมูลยังไม่มีการเข้าทำตัว Live artifact — หากอยากให้ระบบขึ้น กรุณากด Orbit ทำงานไป',
  'settings.orbit.copyMarkdownTitle': 'จำลองสำเนาสถิติ',
  'settings.orbit.copied': 'เตรียมพร้อมจำลอง',
  'settings.orbit.copy': 'ก็อปปี้',
  'settings.orbit.openArtifact': 'เรียกไฟล์ระบบโชว์ความเคลื่อนไหว',
  'settings.orbit.sourceMarkdown': 'Markdown ของหน้าความเคลื่อนไหว',
  'notify.successTitle': 'งานลุล่วงแล้ว',
  'notify.failureTitle': 'ข้อมูลการงานล้มเหลว',
  'notify.successBody': 'แชทตอบบทสนทนาเรียบร้อย',
  'notify.failureBody': 'หน้าที่ทำผิดพลาด',
  'updater.available': 'มีอัปเดตใหม่',
  'updater.activeRunsTitle': 'OpenDesign ยังทำงานอยู่',
  'updater.activeRunsBody': 'ยังมีงานที่กำลังทำอยู่ {count} งาน การรีสตาร์ตตอนนี้จะหยุดงานเหล่านั้น',
  'updater.activeRunsUnknownBody': 'OpenDesign ไม่สามารถตรวจสอบได้ว่ามีงานกำลังทำอยู่หรือไม่ การรีสตาร์ตอาจหยุดงานที่กำลังทำอยู่',
  'updater.availableBody': 'OpenDesign {version} พร้อมใช้งานแล้ว จะดาวน์โหลดก่อนเปิดตัวติดตั้ง',
  'updater.checking': 'กำลังตรวจสอบอัปเดต',
  'updater.download': 'ดาวน์โหลดอัปเดต',
  'updater.downloading': 'กำลังดาวน์โหลดอัปเดต',
  'updater.downloadingPercent': 'กำลังดาวน์โหลดอัปเดต {percent}%',
  'updater.done': 'เสร็จสิ้น',
  'updater.failed': 'อัปเดตไม่สำเร็จ',
  'updater.installerOpenBody': 'ตัวติดตั้งเปิดอยู่ OpenDesign กำลังออกเพื่อให้คุณอัปเดตให้เสร็จ',
  'updater.installerOpened': 'เปิดตัวติดตั้งแล้ว',
  'updater.later': 'ภายหลัง',
  "updater.allowSilentUpdates": "อนุญาตให้ติดตั้งอัปเดตในแอปในอนาคตโดยอัตโนมัติ",
  'updater.openFailedFallback': 'ไม่สามารถเปิดตัวติดตั้งได้',
  'updater.installRestart': 'ติดตั้งและรีสตาร์ต',
  'updater.installingRestart': 'Installing and restarting...',
  'updater.openInstaller': 'ติดตั้งอัปเดต',
  'updater.opening': 'กำลังเปิดตัวติดตั้ง...',
  'updater.dialogAvailableGeneric': 'มีเวอร์ชันใหม่ให้ใช้งาน\nดาวน์โหลดเพื่อติดตั้งอัปเดต',
  'updater.dialogAvailableVersion': 'v{version} พร้อมให้อัปเดต\nดาวน์โหลดเพื่อติดตั้งอัปเดต',
  'updater.dialogCheckFailed': 'ตรวจสอบอัปเดตไม่สำเร็จ\nไม่สามารถดึงข้อมูลเวอร์ชันได้ชั่วคราว โปรดตรวจสอบการเชื่อมต่อเครือข่ายแล้วลองอีกครั้ง',
  'updater.dialogDownloadFailed': 'ดาวน์โหลดอัปเดตไม่เสร็จสมบูรณ์\nโปรดตรวจสอบว่าการเชื่อมต่อเครือข่ายใช้งานได้ปกติแล้วลองอีกครั้ง',
  'updater.downloadFailedTitle': 'ดาวน์โหลดอัปเดตไม่เสร็จสมบูรณ์',
  'updater.dialogReadyGeneric': 'เวอร์ชันใหม่พร้อมแล้ว\nประสบการณ์ดีขึ้น ดีไซน์ฉลาดขึ้น',
  'updater.dialogReadyVersion': 'v{version} พร้อมแล้ว\nประสบการณ์ดีขึ้น ดีไซน์ฉลาดขึ้น',
  'updater.dialogUnsupported': 'ไม่รองรับการอัปเดตในแอปสำหรับสภาพแวดล้อมนี้\nดาวน์โหลดเวอร์ชันล่าสุดจากหน้ารุ่นเผยแพร่',
  'updater.payloadReadyGeneric': 'A new OpenDesign update is ready. OpenDesign will close and restart automatically.',
  'updater.payloadReadyVersion': 'OpenDesign {version} is ready. OpenDesign will close and restart automatically.',
  'updater.quitButton': 'ออกจาก OpenDesign',
  'updater.quitFailedBody': 'ตัวติดตั้งเปิดอยู่ แต่ไม่สามารถออกจาก OpenDesign ได้ โปรดออกจาก OpenDesign ก่อนแทนที่แอป',
  'updater.quitFailedTitle': 'ออกไม่ได้',
  'updater.quitting': 'กำลังออก...',
  'updater.ready': 'อัปเดตพร้อมแล้ว',
  'updater.readyGeneric': 'เวอร์ชันใหม่พร้อมแล้ว OpenDesign จะปิดและเปิดตัวติดตั้ง',
  'updater.readyVersion': 'OpenDesign {version} พร้อมแล้ว OpenDesign จะปิดและเปิดตัวติดตั้ง',
  'updater.reinstallLearnMore': 'เรียนรู้เพิ่มเติม',
  'updater.reinstallReadyGeneric': 'การอัปเดตนี้ต้องติดตั้งใหม่ทั้งหมด OpenDesign จะปิดและเปิดตัวติดตั้ง',
  'updater.reinstallReadyVersion': 'OpenDesign {version} ต้องติดตั้งใหม่ทั้งหมด OpenDesign จะปิดและเปิดตัวติดตั้ง',
  'updater.restartAnyway': 'รีสตาร์ตต่อไป',
  'updater.upToDate': 'คุณใช้เวอร์ชันล่าสุดอยู่แล้ว',
  'updater.viewVersionFeatures': 'ดูฟีเจอร์ใหม่',
  'updater.manualDownload': 'ดาวน์โหลดด้วยตนเอง',
  'whatsNew.updatedTitle': 'OpenDesign {version} มาแล้ว',
  'whatsNew.cta': 'ดูบันทึกการอัปเดต',
  'newsletter.label': 'Newsletter (optional)',
  'newsletter.placeholder': 'you@studio.com',
  'settings.memoryModelInlineLabel': 'โมเดลหน่วยความจำ',
  'settings.memoryModelInlineSameAsChat': 'เหมือนกับแชท',
  'settings.memoryModelInlineSameAsChatWithModel': 'เหมือนกับแชท ({model})',
  'settings.memoryModelInlineSameAsChatWithProvider': 'เหมือนกับแชท ({provider})',
  'settings.memoryModelInlineHintCli': 'ไม่บังคับ ใช้ Local CLI ที่เลือกไว้เมื่อรองรับ เลือกโมเดลเฉพาะเมื่อต้องการแทนที่ค่าเริ่มต้นเท่านั้น',
  'settings.memoryModelInlineHintCliConstrained': 'ไม่บังคับ ใช้ Local CLI ที่เลือกไว้เมื่อรองรับ {provider} เป็นเพียงตระกูลผู้ให้บริการสำรองเท่านั้น',
  'settings.memoryModelInlineHintByok': 'ไม่บังคับ ใช้ API key ของแชทคุณซ้ำ — เลือกโมเดลที่ถูกกว่าเพื่อประหยัดค่าใช้จ่าย',
  'settings.memoryModelInlineHintByokNeutral': 'หน่วยความจำใช้โมเดลแยกจากแชท ค่าเริ่มต้นคือโมเดลแชทของคุณ',
  'settings.memoryModelInlineFlashSaved': 'บันทึกแล้ว',
  'settings.memoryModelInlineFlashCleared': 'ล้างแล้ว',
  'diagnostics.exportTitle': 'ส่งออกข้อมูลวินิจฉัย',
  'diagnostics.exportButton': 'ส่งออกข้อมูลวินิจฉัย',
  'diagnostics.exportHint': 'รวบรวมบันทึกแอปล่าสุดและข้อมูลเครื่องไว้ในไฟล์ zip ที่คุณสามารถแชร์กับทีมได้',
  'diagnostics.exporting': 'กำลังส่งออก…',
  'diagnostics.exportSuccess': 'บันทึกข้อมูลวินิจฉัยไปยัง {path} แล้ว',
  'diagnostics.exportFailed': 'ไม่สามารถส่งออกข้อมูลวินิจฉัยได้: {message}',
  'automations.eyebrow': 'เซสชัน Agent ตามกำหนดเวลา',
  'automations.title': 'ระบบอัตโนมัติ',
  'automations.lede': 'วางแผนการสนทนาที่เกิดขึ้นซ้ำสำหรับงานโปรเจกต์ สรุป Orbit และอาร์ติแฟกต์แบบสด',
  'automations.summaryAria': 'สรุประบบอัตโนมัติ',
  'automations.metricActive': 'ใช้งานอยู่',
  'automations.metricPaused': 'หยุดชั่วคราว',
  'automations.metricTemplates': 'เทมเพลต',
  'automations.newAutomation': 'ระบบอัตโนมัติใหม่',
  'automations.yourAutomations': 'ระบบอัตโนมัติของคุณ',
  'automations.loading': 'กำลังโหลด',
  'automations.emptyTitle': 'ยังไม่มีระบบอัตโนมัติ',
  'automations.emptyBody': 'สร้างจากเทมเพลตหรือเริ่มจากกำหนดการเปล่า',
  'automations.targetNewEachRun': 'โปรเจกต์ใหม่ทุกครั้งที่รัน',
  'automations.targetCreateEachRun': 'โปรเจกต์ใหม่ทุกครั้งที่รัน',
  'automations.lastRun': 'รันล่าสุด {time}',
  'automations.openResult': 'เปิดผลลัพธ์',
  'automations.run': 'รัน',
  'automations.runNowTitle': 'รันทันทีและเปิดการสนทนา',
  'automations.history': 'ประวัติ',
  'automations.hideHistory': 'ซ่อนประวัติ',
  'automations.edit': 'แก้ไข',
  'automations.pause': 'หยุดชั่วคราว',
  'automations.resume': 'ดำเนินการต่อ',
  'automations.deleteAria': 'ลบระบบอัตโนมัติ',
  'automations.deleteTitle': 'ลบระบบอัตโนมัตินี้',
  'automations.deleteConfirm': 'ลบระบบอัตโนมัตินี้หรือไม่? การรันที่ผ่านมาและโปรเจกต์ของมันจะยังคงอยู่',
  'automations.proposalsTitle': 'ข้อเสนอการพัฒนา',
  'automations.proposalsSub': 'ตรวจสอบผลลัพธ์ของระบบอัตโนมัติก่อนที่จะเปลี่ยนแปลงหน่วยความจำ ทักษะ หรือ design systems',
  'automations.proposalsPending': 'รอดำเนินการ {n} รายการ',
  'automations.apply': 'นำไปใช้',
  'automations.reject': 'ปฏิเสธ',
  'automations.proposalsDismissReason': 'ปิดใน Automations',
  'automations.templatesTitle': 'เทมเพลต',
  'automations.templatesSub': 'Orbit และอาร์ติแฟกต์แบบสดเป็นเทมเพลตภายในโฟลว์ระบบอัตโนมัติเดียวกัน',
  'automations.templatesCount': '{filtered} จาก {total}',
  'automations.templateFiltersAria': 'ตัวกรองเทมเพลต',
  'automations.templatesEmptyTitle': 'ยังไม่มีเทมเพลตในหมวดหมู่นี้',
  'automations.templatesEmptyBody': 'ลองตัวกรองอื่น หรือเริ่มจากระบบอัตโนมัติเปล่า',
  'automations.useTemplate': 'ใช้เทมเพลต',
  'automations.runHistoryLoading': 'กำลังโหลดประวัติการรัน...',
  'automations.runHistoryEmpty': 'ยังไม่มีการรัน',
  'automations.runHistoryTitle': 'ประวัติการรัน',
  'automations.runHistoryLatest': 'ล่าสุด 10 รายการ',
  'automations.crystallize': 'ตกผลึก',
  'automations.crystallizing': 'กำลังตกผลึก',
  'automations.crystallizeTitle': 'ร่างข้อเสนอทักษะและหน่วยความจำจากการรันนี้',
  'automations.crystallizeFailed': 'Crystallize failed: {error}',
  'automations.crystallizePartialSuccess': 'Crystallize created proposals, but Automations could not refresh the proposal list. Review the visible proposals or try refreshing.',
  'automations.crystallizeRefreshFailed': 'Crystallize finished, but Automations could not refresh proposals. Try refreshing before running it again.',
  'automations.crystallizeNoProposals': 'Crystallize finished, but no proposals were returned. Try refreshing or check the run details.',
  'automations.openConversation': 'เปิดการสนทนา',
  'automations.runHistoryAria': 'ประวัติการรันระบบอัตโนมัติ',
  'automations.proposalsAria': 'ข้อเสนอการพัฒนาระบบอัตโนมัติ',
  'automations.templatesAria': 'เทมเพลตระบบอัตโนมัติ',
  'automations.runInProgress': 'กำลังดำเนินการ',
  'automations.promptPlaceholder': 'ดึงกิจกรรม GitHub + Linear ของเมื่อวานและสรุปสิ่งที่เปลี่ยนแปลง',
  'automations.scheduleStatusPaused': 'หยุดชั่วคราว',
  'automations.nextRunManualOnly': 'รันด้วยตนเองเท่านั้น',
  'automations.nextRunScheduled': 'ตามกำหนดการ',
  'automations.nextRunAt': 'ครั้งถัดไป {time}',
  'automations.statusSucceeded': 'สำเร็จ',
  'automations.statusFailed': 'ล้มเหลว',
  'automations.statusRunning': 'กำลังรัน',
  'automations.statusQueued': 'อยู่ในคิว',
  'automations.statusCanceled': 'ยกเลิกแล้ว',
  'automations.kindOrbit': 'Orbit',
  'automations.kindLiveArtifact': 'อาร์ติแฟกต์แบบสด',
  'automations.kindAutomation': 'ระบบอัตโนมัติ',
  'automations.proposalTargetMemory': 'หน่วยความจำ',
  'automations.proposalTargetDesignSystem': 'ระบบดีไซน์',
  'automations.proposalTargetSkill': 'ทักษะ',
  'automations.proposalTargetTemplate': 'เทมเพลตระบบอัตโนมัติ',
  'automations.proposalActionCreate': 'สร้าง',
  'automations.proposalActionUpdate': 'อัปเดต',
  'automations.proposalActionMerge': 'ผสาน',
  'automations.proposalActionMove': 'ย้าย',
  'automations.proposalActionDelete': 'ลบ',
  'automations.proposalActionPromote': 'เลื่อนระดับ',
  'automations.filterAll': 'ทั้งหมด',
  'automations.filterOrbit': 'Orbit',
  'automations.filterLiveArtifacts': 'อาร์ติแฟกต์แบบสด',
  'automations.filterMemory': 'หน่วยความจำ',
  'automations.filterDesignSystems': 'ระบบดีไซน์',
  'automations.filterSkills': 'ทักษะ',
  'automations.filterConnectors': 'ตัวเชื่อมต่อ',
  'automations.filterCompression': 'การบีบอัด',
  'automations.filterRelease': 'การปล่อยเวอร์ชัน',
  'automations.filterQuality': 'คุณภาพ',
  'automations.tpl.memoryRefresh.title': 'รีเฟรชหน่วยความจำโปรเจกต์จากงานล่าสุด',
  'automations.tpl.memoryRefresh.desc': 'เปลี่ยนการตัดสินใจ ความชอบ และฟีดแบ็กที่เกิดขึ้นซ้ำให้เป็นการอัปเดตหน่วยความจำที่นำกลับมาใช้ใหม่ได้',
  'automations.tpl.designSystemRefresh.title': 'อัปเดต design systems จากอาร์ติแฟกต์ที่ส่งมอบแล้ว',
  'automations.tpl.designSystemRefresh.desc': 'ค้นหา token คอมโพเนนต์ และกฎที่นำกลับมาใช้ใหม่ได้จากงานออกแบบล่าสุด',
  'automations.tpl.liveArtifactRegistry.title': 'ตรวจสอบอาร์ติแฟกต์แบบสดและรีเฟรชเวอร์ชันที่ล้าสมัย',
  'automations.tpl.liveArtifactRegistry.desc': 'ทำให้แดชบอร์ด รายงาน และตัวอย่างที่คงอยู่ตลอดเป็นปัจจุบันแทนการสร้างซ้ำ',
  'automations.tpl.orbitDashboard.title': 'สร้างแดชบอร์ดกิจกรรมตัวเชื่อมต่อ',
  'automations.tpl.orbitDashboard.desc': 'รวบรวมตัวเชื่อมต่อที่เลือกไว้เป็นแดชบอร์ดแบบสดสไตล์ Orbit',
  'automations.tpl.releaseNotes.title': 'ร่างบันทึกการปล่อยเวอร์ชันจากงานออกแบบที่ส่งมอบแล้ว',
  'automations.tpl.releaseNotes.desc': 'เชื่อมโยง PR ที่ผสานแล้ว อาร์ติแฟกต์ และการเปลี่ยนแปลงที่เกี่ยวกับผลิตภัณฑ์เข้าเป็นบันทึกการปล่อยเวอร์ชัน',
  'automations.tpl.qualityRegressionWatch.title': 'เฝ้าระวังการถดถอยของการออกแบบและการพัฒนา',
  'automations.tpl.qualityRegressionWatch.desc': 'เปรียบเทียบการเปลี่ยนแปลงล่าสุดกับเกณฑ์มาตรฐาน เทรซ และข้อมูลอ้างอิงที่ยอมรับแล้ว',
  'automations.tpl.orbitDaily.title': 'สรุปตัวเชื่อมต่อรายวัน',
  'automations.tpl.orbitDaily.desc': 'รีเฟรชสรุปกิจกรรมตัวเชื่อมต่อตามกำหนดเวลา',
  'automations.tpl.liveStatusBoard.title': 'ทำให้อาร์ติแฟกต์สถานะแบบสดเป็นปัจจุบันอยู่เสมอ',
  'automations.tpl.liveStatusBoard.desc': 'อัปเดตอาร์ติแฟกต์ที่คงอยู่เพียงชิ้นเดียวแทนการสร้างรายงานใหม่ทุกครั้งที่รัน',
  'dsManager.areaAria': 'พื้นที่ design systems',
  'dsManager.tabDesignSystem': 'ระบบดีไซน์',
  'dsManager.tabTemplate': 'เทมเพลต',
  'dsManager.sourceAria': 'แหล่งที่มาของ design system',
  'dsManager.templateSourceAria': 'แหล่งที่มาของเทมเพลต',
  'dsManager.yourSystems': 'ระบบของคุณ',
  'dsManager.officialPresets': 'พรีเซ็ตอย่างเป็นทางการ',
  'dsManager.shareToTeam': 'Share to team',
  'dsManager.shareToTeamFailed': 'Couldn\'t share to team',
  'dsManager.syncToTeam': 'ซิงค์กับทีม',
  'dsManager.syncToTeamFailed': 'ซิงค์กับทีมไม่สำเร็จ',
  'dsManager.unshareFromTeam': 'Remove from team',
  'dsManager.unshareFromTeamFailed': 'Couldn\'t remove from team',
  'dsManager.teamSyncedReadOnly': 'Only the sharer or a workspace admin can change this',
  'dsManager.enterprise': 'องค์กร',
  'dsManager.yourTemplates': 'เทมเพลตของคุณ',
  'dsManager.yourSystemsAria': 'design systems ของคุณ',
  'dsManager.eyebrowDesignSystems': 'ระบบดีไซน์',
  'dsManager.yourSystemsHeading': 'ระบบของคุณ',
  'dsManager.filterAria': 'กรอง design systems',
  'dsManager.filterAll': 'ทั้งหมด',
  'dsManager.filterPublished': 'เผยแพร่แล้ว',
  'dsManager.filterDraft': 'ฉบับร่าง',
  'dsManager.createTitle': 'สร้าง design system ใหม่',
  'dsManager.createBody': 'สอน OpenDesign ให้รู้จักแบรนด์ ผลิตภัณฑ์ โค้ด แอสเซ็ต และข้อมูลอ้างอิงการออกแบบของคุณ',
  'dsManager.createAction': 'สร้าง',
  'dsManager.emptyMine': 'ยังไม่มี design systems สร้างจากบริบทผลิตภัณฑ์จริง ตรวจสอบฉบับร่าง แล้วเผยแพร่เพื่อใช้กับโปรเจกต์ในอนาคต',
  'dsManager.badgeDefault': 'ค่าเริ่มต้น',
  'dsManager.rowMetaUpdated': 'คุณ · อัปเดต {date}',
  'dsManager.edit': 'แก้ไข',
  'dsManager.openSystem': 'เปิด',
  'dsManager.editWithAgent': 'แก้ไขด้วย Agent',
  'dsManager.downloadTitle': 'ดาวน์โหลดระบบออกแบบ (.zip + SKILLS.md)',
  'dsManager.downloadAria': 'ดาวน์โหลด {title} เป็น .zip',
  'dsManager.downloadFailed': 'ไม่สามารถดาวน์โหลดระบบออกแบบได้ โปรดลองอีกครั้ง',
  'dsManager.deleteConfirm': 'ลบ “{title}” หรือไม่? การดำเนินการนี้จะนำร่างระบบออกแบบออกจากอุปกรณ์นี้',
  'dsManager.makeDefault': 'ตั้งเป็นค่าเริ่มต้น',
  'dsManager.statusPublished': 'เผยแพร่แล้ว',
  'dsManager.statusDraft': 'ฉบับร่าง',
  'dsManager.openSystemAria': 'เปิด {title}',
  'dsManager.deleteSystemAria': 'ลบ {title}',
  'dsManager.deletePermissionDenied': 'คุณไม่มีสิทธิ์ลบระบบดีไซน์นี้',
  'dsManager.presetsAria': 'พรีเซ็ต design system อย่างเป็นทางการ',
  'dsManager.eyebrowLibrary': 'ไลบรารี',
  'dsManager.eyebrowTemplates': 'เทมเพลต',
  'dsManager.yourTemplatesAria': 'เทมเพลตของคุณ',
  'dsManager.emptyTemplates': 'ยังไม่มีเทมเพลต สร้างจากโปรเจกต์ที่สร้างขึ้นใดก็ได้ผ่าน Share เมื่อเปิดใช้งานการเผยแพร่เทมเพลตแล้ว',
  'dsManager.templateDescFallback': 'สร้างจากโปรเจกต์',
  'dsManager.comingSoonBadge': 'เร็วๆ นี้',
  'dsManager.enterpriseDsTitle': 'Design systems สำหรับองค์กร',
  'dsManager.enterpriseDsBody': 'design systems ที่แชร์ในทีมและไลบรารีแบรนด์ที่มีการกำกับดูแลกำลังจะมาเร็วๆ นี้',
  'dsManager.enterpriseTplTitle': 'เทมเพลตสำหรับองค์กร',
  'dsManager.enterpriseTplBody': 'เทมเพลตที่ทีมอนุมัติและการเผยแพร่ทั่วทั้งองค์กรกำลังจะมาเร็วๆ นี้',
  'settings.instructionsTitle': 'คำสั่งและกฎ',
  'settings.instructionsSubtitle': 'พฤติกรรมตายตัวที่ผู้ช่วยควรปฏิบัติตาม',
  'settings.instructionsNavSub': 'พฤติกรรมตายตัวของผู้ช่วย',
  'settings.customInstructionsDesc': 'คำสั่งตายตัวที่ OpenDesign ปฏิบัติตามในทุกการแชต สิ่งเหล่านี้ไม่ใช่หน่วยความจำที่บันทึกไว้ ใช้ Memory สำหรับข้อเท็จจริง ความชอบ และบริบทของโปรเจกต์',
  'mcpClient.forwardedToLabel': 'ส่งต่อไปยัง:',
  'mcpClient.notForwardedToLabel': 'ไม่ได้ส่งต่อไปยัง:',
  'mcpClient.forwardedAcpNote': 'ACP adapter ที่ทำเครื่องหมาย stdio จะรับเฉพาะเซิร์ฟเวอร์ MCP แบบ stdio จากรายการนี้เท่านั้น รายการ HTTP และ SSE จะถูกตัดทิ้งในเวลาที่ spawn',
  'mcpClient.notForwardedNote': 'สำหรับ Agent เหล่านั้น ให้กำหนดค่าเซิร์ฟเวอร์ MCP ในไฟล์ config ของ Agent เอง (เช่น ~/.codex/config.toml, ~/.gemini/settings.json) เซิร์ฟเวอร์ด้านล่างจะไม่ถูกใช้งานที่นั่นโดยไม่มีการแจ้งเตือน',

  // Brands library + extraction
  'brand.libraryTitle': 'ชุดแบรนด์',
  'brand.librarySubtitle': 'Teach OpenDesign your brand kits — extract one from a website, then apply it in any chat.',
  'brand.newBrand': 'New Brand Kit',
  'brand.searchPlaceholder': 'Search your brand kits…',
  'brand.empty': 'No brand kits yet. Extract one from a website to get started.',
  'brand.colorsCount': '{count} colors',
  'brand.extracting': 'Extracting…',
  'brand.failed': 'Extraction failed',
  'brand.needsInput': 'Needs input',
  'brand.needsInputHint': 'Extraction paused — open the project to finish verification or answer the question.',
  'brand.appliedToChat': 'Using {name}',
  'brand.previewEmpty': 'Select a brand to preview',
  'brand.viewDetails': 'View details',
  'newBrand.title': 'New Brand',
  'newBrand.subtitle': 'วางเว็บไซต์ หรือเลือกแบรนด์ด้านล่าง แล้วเราจะดึงสี ฟอนต์ และโลโก้ของแบรนด์นั้น',
  'newBrand.urlLabel': 'Brand website',
  'newBrand.urlPlaceholder': 'yourcompany.com',
  'newBrand.extract': 'Extract brand',
  'newBrand.cancel': 'Cancel',
  'newBrand.close': 'Close',
  'newBrand.stage1': 'Fetching the site & measuring its design',
  'newBrand.stage2': 'Building a brand preview',
  'newBrand.stage3': 'Deriving & registering the design system',
  'newBrand.measured': '{colors} colors · {fonts} fonts · {logos} logos',
  'newBrand.done': 'Brand ready',
  'brandDetail.identity': 'Identity',
  'brandDetail.designLanguage': 'Design Language',
  'brandDetail.colors': 'Colors',
  'brandDetail.fonts': 'Fonts',
  'brandDetail.tone': 'Tone',
  'brandDetail.aesthetic': 'Aesthetic',
  'brandDetail.tagline': 'Tagline',
  'brandDetail.voice': 'Voice',
  'brandDetail.useInChat': 'Use in new chat',
  'brandDetail.delete': 'Delete brand',
  'brandDetail.back': 'ชุดแบรนด์',
  'brandDetail.refining': 'Refining this brand…',
  'brandDetail.notFound': 'Brand not found.',
  'brandDetail.logo': 'Logo',
  'brandDetail.typography': 'Typography',
  'brandDetail.palette': 'Palette',
  'brandDetail.voiceTone': 'Voice & tone',
  'brandDetail.imageryLayout': 'Imagery & layout',
  'brandDetail.images': 'Images',
  'brandDetail.designSystem': 'Design system',
  'brandDetail.brandAssets': 'Brand assets',
  'brandDetail.openProject': 'Open project',
  'brandDetail.themeLight': 'Light',
  'brandDetail.themeDark': 'Dark',
  'brandDetail.subjects': 'Subjects',
  'brandDetail.treatment': 'Treatment',
  'brandDetail.useLabel': 'Use',
  'brandDetail.avoidLabel': 'Avoid',
  'brandDetail.layoutPosture': 'Layout posture',
  'brandDetail.deleteConfirm': 'Delete "{name}"? This removes the brand and its design system.',
  'brandDetail.viewMore': 'Show all {count}',
  'brandDetail.viewLess': 'Show less',
  'settings.resetOnboarding': 'Reset onboarding',
  'settings.resetOnboardingDesc': 'Replay the first-run setup, including brand extraction.',
  'settings.resetOnboardingButton': 'Reset',
  'settings.clearUpdaterCacheTitle': 'ล้างแคชการอัปเดต',
  'settings.clearUpdaterCacheHint': 'ลบการอัปเดตที่ดาวน์โหลดแล้วและแคชเก่า จากนั้นรีเซ็ตสถานะการอัปเดต ใช้เมื่อการอัปเดตดูเหมือนค้าง',
  'settings.clearUpdaterCacheButton': 'ล้างแคช',
  'settings.clearUpdaterCacheConfirmButton': 'ยืนยันการล้าง',
  'settings.clearUpdaterCacheSuccess': 'ล้างแคชการอัปเดตแล้ว',
  'settings.clearUpdaterCacheFailed': 'ไม่สามารถล้างแคชการอัปเดตได้',
  'onboarding.brandTitle': 'Extract your brand kit',
  'onboarding.brandSubtitle': 'Paste a website and we\'ll turn its brand signals into a reusable brand kit for future work.',
  'onboarding.brandSkip': 'Skip for now',
  'onboarding.brandDone': 'Brand kit extracted',
  'onboarding.buildTitle': 'สร้างครั้งเดียว ใช้ได้ทุกที่',
  'onboarding.buildBody': 'OpenDesign เปลี่ยนแบรนด์ของคุณให้เป็นดีไซน์ซิสเต็มที่นำกลับมาใช้ซ้ำได้ แล้วทำให้ทุกสิ่งที่คุณสร้างสอดคล้องและตรงกับแบรนด์',
  'onboarding.buildBenefitMemoryTitle': 'One brand memory',
  'onboarding.buildBenefitMemoryBody': 'Colors, type, spacing, components, and voice become a DESIGN.md your agents can reuse.',
  'onboarding.buildBenefitAlignedTitle': 'Every output stays aligned',
  'onboarding.buildBenefitAlignedBody': 'Prototype, slide, PDF, dashboard, and marketing work all pull from the same rules.',
  'onboarding.buildBenefitSourcesTitle': 'Start from what you have',
  'onboarding.buildBenefitSourcesBody': 'Use a GitHub repo, website, existing DESIGN.md, screenshots, fonts, or Figma files.',
  'onboarding.buildPreviewLabel': 'Brand system',
  'onboarding.buildStart': 'สร้างดีไซน์ซิสเต็ม',
  'onboarding.buildHome': 'ไปที่หน้าหลัก',
  'dsCreate.referenceLabel': 'Copy from existing design system',
  'dsCreate.referenceLoading': 'Loading DESIGN.md...',
  'dsCreate.referenceLoadFailed': 'Could not load that design system.',
  'dsCreate.heroShowGuideAria': 'Show design system guide',
  'dsCreate.heroHideGuideAria': 'Hide design system guide',
  'dsCreate.heroShowGuideTitle': 'Show guide',
  'dsCreate.heroHideGuideTitle': 'Hide guide',
  'dsCreate.heroGuide': 'Guide',
  'dsCreate.missingSourceError': 'Add a website, DESIGN.md, description, file, Figma source, or notes to create a design system.',
  'dsCreate.continueToGeneration': 'Continue to generation',
  'dsCreate.embeddedTitle': 'Generate from your material',
  'dsCreate.embeddedBody': 'Start with a website or brand reference, then add any source files you already have.',
  'dsCreate.sourceSectionTitle': 'Extract from GitHub, websites, or source material',
  'dsCreate.sourceSectionBody': 'Start with a GitHub repo, website, DESIGN.md, or files that show your style. OpenDesign first creates a usable system quickly, then AI can refine it inside the project.',
  'dsCreate.githubWebsiteLabel': 'GitHub or website',
  'dsCreate.add': 'Add',
  'dsCreate.startFromBrand': 'Start from a brand',
  'dsCreate.brandPickerSubtitle': 'Search hundreds of brands — pick one and we\'ll add its site as a style reference.',
  'dsCreate.brandPickerQuickPicks': 'Popular brands — click to add',
  'dsCreate.addedSourceLinks': 'Added source links',
  'dsCreate.openSourceLabel': 'Open {label}',
  'dsCreate.removeSourceLabel': 'Remove {label}',
  'dsCreate.addFiles': 'Add files',
  'dsCreate.describeBrand': 'Describe brand',
  'dsCreate.optional': 'optional',
  'dsCreate.describeBrandHelp': 'Brand voice, intro and product context. Used in the fast pass and AI refinement.',
  'dsCreate.companyPlaceholder': 'e.g. Mission Impastabowl: fast-casual pasta restaurant with kiosk, mobile app and website',
  'dsCreate.pasteDesignMd': 'Paste DESIGN.md',
  'dsCreate.pasteDesignMdHelp': 'Paste a DESIGN.md to create directly from tokens, rationale and component guidance.',
  'dsCreate.reference': 'Reference',
  'dsCreate.designMdViewMode': 'DESIGN.md view mode',
  'dsCreate.advancedToggle': 'Advanced — repo, local code, Figma',
  'dsCreate.githubRepo': 'GitHub repo',
  'dsCreate.localCodeLabel': 'Link local code',
  'dsCreate.localCodeHelper': 'Use a folder or selected files from this computer.',
  'dsCreate.localCodePrompt': 'Drag a folder here or browse',
  'dsCreate.uploadFigLabel': 'Upload .fig',
  'dsCreate.uploadFigHelper': 'Decoded on your machine into real tokens, components & assets — no Figma account.',
  'dsCreate.uploadFigPrompt': 'Drop .fig here or browse',
  'dsCreate.figmaUrl': 'Figma URL',
  'dsCreate.figmaPlaceholder': 'https://figma.com/design/… or /file/…',
  'dsCreate.addedFigmaUrls': 'Added Figma URLs',
  'dsCreate.savedFigmaHelp': 'Saved as a Figma design source. The agent uses it as the canonical reference; export a .fig above for a full offline decode.',
  'dsCreate.notes': 'Notes',
  'dsCreate.notesPlaceholder': 'e.g. We use a warm, earthy color palette with rounded corners. Our brand voice is playful but professional...',
  'dsCreate.back': 'Back',
  'dsCreate.generate': 'Generate',
  'dsCreate.libraryPickerTitle': 'Select from library',
  'dsCreate.libraryPickerConfirm': 'Add to assets',
  'dsCreate.designMdPreviewKicker': 'DESIGN SYSTEM',
  'dsCreate.designMdPreviewTitle': 'DESIGN.md preview',
  'dsCreate.componentKit': 'component kit',
  'dsCreate.defaultTheme': 'default theme',
  'dsCreate.componentKitTitle': '{name} — component kit',
  'dsCreate.designMdGeneratedDescription': 'Generated from pasted DESIGN.md tokens, rationale and component guidance.',
  'dsCreate.previewButtons': 'Buttons',
  'dsCreate.previewButtonsHelp': 'Five types across three sizes.',
  'dsCreate.buttonPrimary': 'Primary',
  'dsCreate.buttonDashed': 'Dashed',
  'dsCreate.buttonText': 'Text',
  'dsCreate.buttonLink': 'Link',
  'dsCreate.sizeSmall': 'Small',
  'dsCreate.sizeMedium': 'Medium',
  'dsCreate.sizeLarge': 'Large',
  'dsCreate.previewTypeScale': 'Type scale',
  'dsCreate.extractedTokens': 'Extracted DESIGN.md tokens',
  'brandPicker.categorySoftware': 'Software',
  'brandPicker.categoryFinance': 'Finance',
  'brandPicker.categoryFashion': 'Fashion',
  'brandPicker.categoryActivewear': 'Activewear',
  'brandPicker.categoryBeauty': 'Beauty',
  'brandPicker.categoryWellness': 'Wellness',
  'brandPicker.categoryFood': 'Food',
  'brandPicker.categoryBeverage': 'Beverage',
  'brandPicker.categoryMedia': 'Media',
  'brandPicker.categoryEducation': 'Education',
  'brandPicker.categoryElectronics': 'Electronics',
  'brandPicker.categoryAutomotive': 'Automotive',
  'brandPicker.categoryHealthcare': 'Healthcare',
  'brandPicker.categoryTravel': 'Travel',
  'brandPicker.heading': 'เริ่มจากแบรนด์ที่คุณชื่นชอบ',
  'brandPicker.subtext': 'คลิกแบรนด์ใดก็ได้เพื่อดึงชุดแบรนด์จากเว็บไซต์ของแบรนด์นั้นโดยตรง',
  'brandPicker.quickPicksLabel': 'แบรนด์ยอดนิยม — คลิกเพื่อดึงข้อมูล',
  'brandPicker.searchPlaceholder': 'ค้นหาแบรนด์…',
  'brandPicker.allCategories': 'ทั้งหมด',
  'brandPicker.extractAction': 'ดึงข้อมูล',
  'brandPicker.showMore': 'แสดงเพิ่มเติม',
  'brandPicker.opening': 'กำลังเริ่มดึงข้อมูล — กำลังเปิด {brand}…',
  'ds.kitVisualize': 'แสดงภาพ',
  'ds.kitEdit': 'แก้ไข',
  'ds.kitSource': 'ซอร์ส',
  'ds.saveDesignMd': 'บันทึก DESIGN.md',
  'ds.saving': 'กำลังบันทึก…',
  'ds.copyDesignMd': 'คัดลอก DESIGN.md',
  'ds.editDesignMd': 'แก้ไข DESIGN.md',
  'ds.openDesignMd': 'เปิด DESIGN.md',
  'ds.copyDesignMdModule': 'คัดลอกส่วน {module}',
  'ds.editDesignMdModule': 'แก้ไขส่วน {module}',
  'ds.openDesignMdModule': 'เปิดส่วน {module}',
  'ds.uploadMd': 'อัปโหลด MD',
  'ds.uploadFont': 'เพิ่มไฟล์ฟอนต์',
  'ds.pasteImage': 'วางรูปภาพ',
  'ds.refresh': 'รีเฟรช',
  'ds.download': 'ดาวน์โหลด',
  'ds.importFolder': 'นำเข้าโฟลเดอร์',
  'ds.reset': 'รีเซ็ต',
  'ds.editingDesignMdHint': 'การแก้ไข Markdown นี้จะอัปเดตโมดูล kit ที่แสดงผลแล้ว',
  'ds.editingModuleHint': 'กำลังแก้ไขเฉพาะโมดูล {module}',
  'ds.manualEditModuleHint': 'Edit {module} here. Hover this section to reveal controls.',
  'ds.saveModule': 'บันทึกโมดูล',
  'ds.uploadLogo': 'อัปโหลดโลโก้',
  'ds.uploadImage': 'อัปโหลดรูปภาพ',
  'ds.uploading': 'กำลังอัปโหลด…',
  'ds.moduleEmptyLogo': 'ยังไม่มีโลโก้',
  'ds.moduleEmptyFonts': 'ยังไม่มีฟอนต์ที่บันทึกไว้',
  'ds.actionDone': 'เสร็จสิ้น',
  'ds.actionFailed': 'มีบางอย่างผิดพลาด โปรดลองอีกครั้ง',
  'ds.uploadDone': 'อัปโหลดแล้ว',
  'ds.uploadFailed': 'อัปโหลดไม่สำเร็จ โปรดลองอีกครั้ง',
  'ds.deleteLogo': 'ลบโลโก้',
  'ds.deleteImage': 'ลบ {caption}',
  'ds.deleteProjectConfirm': 'ลบ “{title}” หรือไม่? การดำเนินการนี้จะลบระบบออกแบบนี้และโปรเจกต์ของระบบออกจากอุปกรณ์นี้อย่างถาวร',
  'ds.deleteProjectAction': 'ลบ {title}',
  'ds.editColor': 'แก้ไข {name}',
  'ds.colorLabel': 'สี',
  'ds.hexLabel': 'Hex',
  'ds.hexValueLabel': 'ค่า Hex',
  'ds.saveColor': 'บันทึกสี',
  'ds.invalidHexColor': 'ป้อนสี Hex ที่ถูกต้อง เช่น #FF6A3D',
  'ds.colorSaveFailed': 'ไม่สามารถบันทึกสีนี้ได้',
  'ds.colorResetFailed': 'ไม่สามารถรีเซ็ตสีนี้ได้',
  'ds.designMdSectionLabel': 'ส่วน {module} ของ DESIGN.md',
  'ds.kitErrorTitle': 'มุมมองนี้พบปัญหา',
  'ds.kitErrorRetry': 'โหลดใหม่',
  'ds.shortcutsLabel': 'แป้นพิมพ์ลัด',
  'ds.shortcutsHint': 'ลัด: E แก้ไข · C คัดลอก · U อัปโหลด · R รีเฟรช · ⌫ ลบโลโก้',
  'ds.moduleEmptyImages': 'ยังไม่มีรูปภาพ',
  'ds.noOriginalColor': 'No original color is available for this swatch.',
  'ds.manifestReadFailed': 'Unable to read _ds_manifest.json.',
  'ds.reviewCollapseSection': 'Collapse {title}',
  'ds.reviewExpandSection': 'Expand {title}',
  'ds.reviewNeedsReview': 'Needs review',
  'ds.reviewLooksGood': 'Looks good',
  'ds.reviewActionsLabel': '{title} review',
  'ds.reviewNeedsWorkEllipsis': 'Needs work...',
  'ds.reviewEditFile': 'Edit {file}',
  'ds.reviewFeedbackLabel': 'Tell the agent what to change',
  'ds.reviewFeedbackPlaceholder': 'e.g. tighten spacing in {title}, regenerate this preview...',
  'ds.reviewChangedAfterFeedback': 'This section changed after your feedback. Review it again before publishing.',
  'ds.reviewChangedDuringRun': 'This section changed during the latest run. Review it before publishing.',
  'ds.reviewLastFeedback': 'Last feedback',
  'ds.previewGenerating': 'Generating preview...',
  'ds.creatingProjectTitle': 'Creating your design system...',
  'ds.creatingProjectSubtitle': 'Keep this tab open. You can come back in a few minutes.',
  'ds.generationProgressLabel': 'Design system generation progress {progress}%',
  'ds.publishRepoRequiredTitle': 'Finish importing your GitHub repo before you can publish.',
  'ds.publishDesignSystem': 'Publish design system',
  'ds.unpublishDesignSystem': 'Unpublish design system',
  'ds.published': 'Published',
  'ds.publish': 'Publish',
  'ds.extractionRunningTitle': 'Extracting design system',
  'ds.extractionCompleteTitle': 'Extraction complete',
  'ds.extractionRunningBody': 'OpenDesign is updating this system in place.',
  'ds.extractionCompleteBody': 'All extracted modules are shown below; empty sections are intentionally blank.',
  'ds.publishCardPublished': 'Your team\'s new projects can use this design system as context by default.',
  'ds.publishCardDraft': 'Your design system is ready, but your feedback will improve it. Publish it when it is ready to use in future projects.',
  'ds.useSystemTitle': 'Use this system',
  'ds.useSystemBody': 'Start a new design that inherits this system\'s colors, type, and components - kept on-brand automatically.',
  'ds.createNewDesign': 'Create new design',
  'ds.openSourceContext': 'Open source context',
  'ds.manifestNeedsAttention': 'Design manifest needs attention',
  'ds.openManifest': 'Open manifest',
  'ds.workspacePreparing': 'Preparing the design system workspace.',
  'ds.workspaceLoadingLabel': 'Design system workspace is loading',
  'ds.sectionQueued': 'Queued',
  'ds.sectionReviewUpdatedFiles': 'Updated files need review',
  'ds.reviewNeedsWork': 'Needs work',
  'ds.sectionRequiredFileMissing': 'Required file missing: {file}',
  'ds.sectionNoFilesYet': 'No files yet',
  'ds.generationSourceTitle': 'Source context',
  'ds.generationSourceDetail': 'Reading linked source context and repository evidence.',
  'ds.generationGuidanceTitle': 'Brand guidance',
  'ds.generationGuidanceDetail': 'Writing DESIGN.md guidance and voice.',
  'ds.generationTokensTitle': 'Design tokens',
  'ds.generationTokensDetail': 'Extracting colors, type, and spacing tokens.',
  'ds.generationPreviewsTitle': 'Preview cards',
  'ds.generationPreviewsDetail': 'Rendering reviewable preview cards.',
  'ds.generationUiKitTitle': 'UI kit',
  'ds.generationUiKitDetail': 'Creating reusable components and patterns.',
  'ds.generationAssetsTitle': 'Brand assets',
  'ds.generationAssetsDetail': 'Collecting logos, fonts, images, and icons.',
  'ds.phaseQueuedTypography': 'Typography queued',
  'ds.phaseQueuedTokens': 'Tokens queued',
  'ds.phaseQueuedSpacing': 'Spacing queued',
  'ds.phaseQueuedUiKit': 'UI kit queued',
  'ds.phaseQueuedAssets': 'Assets queued',
  'ds.phaseReadingTypography': 'Reading typography',
  'ds.phaseReadingTokens': 'Reading tokens',
  'ds.phaseReadingSpacing': 'Reading spacing',
  'ds.phaseReadingUiKit': 'Reading UI kit',
  'ds.phaseReadingAssets': 'Reading assets',
  'ds.phaseWritingTypography': 'Writing typography',
  'ds.phaseWritingTokens': 'Writing tokens',
  'ds.phaseWritingSpacing': 'Writing spacing',
  'ds.phaseBuildingUiKit': 'Building UI kit',
  'ds.phaseUpdatingAssets': 'Updating assets',
  'ds.phaseNeedsAttention': 'Needs attention',
  'ds.phaseUpdated': 'Updated',
  'ds.sectionActivityFromTodo': '{phase}: {todo}',
  'ds.sectionActivityReadFiles': 'Read {files}',
  'ds.sectionActivityPhaseFiles': '{phase}: {files}',
  'ds.sectionRunningReadingContext': 'Reading context for {title}.',
  'ds.sectionRunningNow': '{phase} now.',
  'ds.reviewLastReviewed': 'Last reviewed {time}',
  'ds.agentFeedbackQueued': 'Agent feedback queued',
  'ds.agentFeedbackSent': 'Agent feedback sent',
  'ds.agentFeedbackSentAt': 'Agent feedback sent {time}',
  'ds.agentFeedbackFailedWithError': 'Agent feedback failed: {error}',
  'ds.agentFeedbackFailed': 'Agent feedback failed',
  'ds.agentFeedbackUnknown': 'Agent feedback status unknown',
  'ds.repoConnectBannerTitle': 'Connect your repo to pull aspects of your design system',
  'ds.repoConnectCardTitle': 'Connect your repo',
  'ds.repoConnectPendingBody': 'Checking your GitHub connection...',
  'ds.repoConnectPendingButton': 'Checking GitHub...',
  'ds.repoConnectedTitle': 'GitHub is connected',
  'ds.repoConnectedBody': 'Re-import this repo to pull its files into your design system.',
  'ds.repoImportButton': 'Import repo',
  'ds.repoConnectBannerBody': 'Connect GitHub so OpenDesign can read your repository and pull colors, type, and components into this design system.',
  'ds.repoConnectCardBody': 'Pull colors, type, and components from your repository into this design system.',
  'ds.repoConnectButton': 'Connect GitHub',
  // Settings > Workspace region (E-frontend, D4.3): role-gated shell for
  // other-lane workspace destinations (members / billing / team space).
  'settings.workspace': 'Workspace',
  'settings.workspaceHint': 'Members, billing, and team spaces',
  'settings.workspaceLede': 'Team-level settings for this workspace. These areas are managed by the team service — open one to continue.',
  'settings.workspaceBack': 'Back to workspace',
  'settings.workspaceMembers': 'Members & invites',
  'settings.workspaceMembersHint': 'Manage who can access this workspace and send invitations.',
  'settings.workspaceBilling': 'Subscription & seats',
  'settings.workspaceBillingHint': 'Plan, seats, and payment for this workspace.',
  'settings.workspaceAutoRecharge': 'Auto-recharge',
  'settings.workspaceAutoRechargeHint': 'Automatically top up credits when the balance runs low.',
  'settings.workspaceTeamSpace': 'Team space',
  'settings.workspaceTeamSpaceHint': 'Shared projects and visibility for your team.',
  // Full-page Settings (`/settings`): sidebar nav head above the section list.
  'settings.pageBackToHome': 'Back to home',
  'settings.pageNavGroupPersonal': 'Personal',
  'newproj.startFromLabel': 'เริ่มจาก',
  'newproj.startBlank': 'ว่างเปล่า',
  'newproj.startBlankHint': 'เริ่มจากศูนย์',
  'workspace.pages': 'หน้า',
  'workspace.allProjectFiles': 'ไฟล์โปรเจกต์ทั้งหมด',
  'workspace.newBlankPage': 'หน้าเปล่าใหม่',
  'workspace.noPagesYet': 'ยังไม่มีหน้า',
  'workspace.pageCreateFailed': 'ไม่สามารถสร้างหน้าได้',
  'workspace.pageCreatorTitle': 'สร้างหน้า',
  'workspace.pageCreatorSearch': 'ค้นหาเทมเพลต',
  'workspace.pageCreatorCategoryAll': 'ทุกสถานการณ์',
  'workspace.pageCreatorEmpty': 'ไม่มีประเภทหน้าที่ตรงกับการค้นหาของคุณ',
  'workspace.pageCreatorPreview': 'ดูตัวอย่าง',
  'workspace.pageCreatorUse': 'ใช้',
  'fileViewer.presentInTabDeckHint': 'โน้ตผู้บรรยายในหน้าต่างป็อปอัป',
  'fileViewer.presentEscHint': 'กด Esc เพื่อออก',
  'fileViewer.presenterPause': 'หยุดชั่วคราว',
  'fileViewer.presenterResume': 'ทำต่อ',
  'fileViewer.presenterPrevious': 'ก่อนหน้า',
  'fileViewer.presenterNext': 'ถัดไป',
  'questions.uploadingFiles': 'กำลังอัปโหลดไฟล์…',
  'questions.uploadNeedsProject': 'การอัปโหลดไฟล์ต้องมีโปรเจกต์ที่ใช้งานอยู่',
  'questions.uploadPartialFailed': 'อัปโหลดแล้ว {uploaded} ไฟล์ แต่ล้มเหลว {failed} ไฟล์',
  'questions.uploadFailed': 'อัปโหลดล้มเหลว {failed} ไฟล์',
  // #5517 media-providers redesign: pill selector + single detail card.
  'settings.mediaProviderModelProviders': 'Providers',
  'settings.mediaProviderModel': 'Model',
  'settings.mediaProviderModelPlaceholder': 'Use provider default',
  'settings.mediaProviderDocsTitle': 'Documentation',
  'settings.mediaProviderDocsHint': 'View setup instructions for this provider.',
  'settings.mediaProviderSaveHint': 'Changes are not saved until you select Save.',
  'settings.mediaProviderNoKeyRequired': 'No key required',
  'settings.mediaProviderNoKeyHint': 'This provider uses a local login or bundled runtime.',
  'manualEdit.sectionImage': 'IMAGE',
  'manualEdit.sectionContent': 'CONTENT',
  'manualEdit.sectionPage': 'PAGE',
  'manualEdit.pageBackground': 'Background',
  'manualEdit.pageBaseSize': 'Base size',
  'manualEdit.pageStylesHtmlOnly': 'Page styles are available only for full HTML documents.',
  'pluginsView.createKindPlugin': 'Plugin',
  'pluginsView.createKindSkill': 'Skill',
  'pluginsView.importUrlLabel': 'URL',
  'pluginsView.shareActionBadge': 'Action plugin',
  'pluginsView.shareCloseAria': 'Close share confirmation',
  'pluginsView.shareWhatStarts': 'What this starts',
  'pluginsView.shareSourcePlugin': 'Source plugin',
  'pluginsView.shareFactPlugin': 'Plugin',
  'pluginsView.shareFactId': 'ID',
  'pluginsView.shareFactCopiedTo': 'Copied to',
  'pluginsView.shareFactTrust': 'Trust',
  'pluginsView.shareActionPrompt': 'Action prompt',
  'pluginsView.shareStarting': 'Starting…',
  'community.title': 'Community',
  'community.searchPlaceholder': 'Search',
  'community.searchAria': 'Search',
  'community.filtersAria': 'Template filters',
  'community.closePreview': 'Close preview',
  'community.typePrototype': 'Prototype',
  'community.typeLiveArtifact': 'Live Artifact',
  'community.typeSlides': 'Slides',
  'community.typeDocument': 'Document',
  'community.typeImage': 'Image',
  'community.typeVideo': 'Video',
  'community.typeHyperFrames': 'HyperFrames',
  'community.typeAudio': 'Audio',
  'community.typeWebGL': 'WebGL',
  'community.usePrompt': 'ลองเลย',
  'community.emptyTitle': 'ยังไม่มีเทมเพลต {type}',
  'community.emptyBody': 'เทมเพลตที่เผยแพร่ในชุมชนจะแสดงที่นี่',
  'marketplace.title': 'Plugins marketplace',
  'marketplace.filterTrusted': 'Trusted',
  'marketplace.filterRestricted': 'Restricted',
  'marketplace.emptyBefore': 'No plugins installed yet. Try',
  'marketplace.emptyAfter': ', or register a marketplace below.',
  'marketplace.trustPrefix': 'trust: ',
  'marketplace.catalogsTitle': 'Configured catalogs',
  'marketplace.catalogsEmpty': 'None registered. Add one with',
  'marketplace.pluginCount': '{count} plugin(s)',
  'genui.continue': 'Continue',
  'genui.authorize': 'Authorize',
  'genui.skip': 'Skip',
  'genui.acceptAll': 'Accept all',
  'genui.rejectAll': 'Reject all',
  'genui.submit': 'Submit',
  'genui.submitPartial': 'Submit partial decision',
  'genui.patchNotesPlaceholder': 'Notes for the patch author (optional)',
  'inspect.close': 'Close inspect',
  'inspect.colors': 'Colors',
  'inspect.text': 'Text',
  'inspect.background': 'Background',
  'inspect.typography': 'Typography',
  'inspect.size': 'Size',
  'inspect.weight': 'Weight',
  'inspect.align': 'Align',
  'inspect.padding': 'Padding',
  'inspect.radius': 'Radius',
  'inspect.resetElement': 'Reset element',
  'library.title': 'Library',
  'library.headerHint': 'Clip any page, design system, screenshot, image, or Figma import JSON into your Library — local-first, one click, no login.',
  'library.getClipper': 'Get the OpenDesign Web Clipper',
  'library.searchPlaceholder': 'Search captions, tags, titles…',
  'library.filterByKind': 'Filter by kind',
  'library.filterBySource': 'Filter by source',
  'library.kindAll': 'All kinds',
  'library.kindImages': 'Images',
  'library.kindElements': 'Elements',
  'library.kindDesignSystems': 'Design systems',
  'library.kindVideo': 'Video',
  'library.kindFonts': 'Fonts',
  'library.kindColors': 'Colors',
  'library.kindText': 'Text',
  'library.kindLinks': 'Links',
  'library.sourceAll': 'All sources',
  'library.sourceClipper': 'Clipper',
  'library.sourceAgent': 'Agent',
  'library.sourceDesignSystem': 'Design system',
  'library.sourceGenerated': 'Generated',
  'library.viewMode': 'View mode',
  'library.viewGrid': 'Grid',
  'library.viewGridTooltip': 'Show assets as a grid',
  'library.viewTimeline': 'Timeline',
  'library.viewTimelineTooltip': 'Group assets by day, newest first',
  'library.refresh': 'Refresh',
  'library.refreshTooltip': 'Reload the list with the current filters',
  'library.sync': 'Sync',
  'library.syncing': 'Syncing…',
  'library.syncTooltip': 'Pull your design systems and agent-generated artifacts into the Library',
  'library.upload': 'Upload',
  'library.uploadTooltip': 'Upload images, fonts, or files into the Library',
  'library.selectedCount': '{count} selected',
  'library.selectAll': 'Select all',
  'library.clear': 'Clear',
  'library.chatToDesign': 'Chat to design',
  'library.chatToDesignTitle': 'Start a chat to turn {count} into a design',
  'library.working': 'Working…',
  'library.useInDesignSystem': 'Use in design system',
  'library.createDesignSystem': 'Create new design system',
  'library.createDesignSystemSub': 'Open the create flow with these {count} attached',
  'library.refineExisting': 'Refine existing',
  'library.noEditableDesignSystems': 'No editable design systems yet.',
  'library.addAssetsAndRefine': 'Add assets & open to refine',
  'library.deleteCount': 'Delete {count}',
  'library.loading': 'Loading…',
  'library.emptyTitle': 'No assets yet.',
  'library.emptyHintBefore': 'Clip from any page with the OpenDesign Web Clipper, run',
  'library.emptyHintAfter': ', or upload inside a project — everything lands here.',
  'library.dropToUpload': 'Drop to upload to your Library',
  'library.confirmDeleteTitleOne': 'Delete {count} asset?',
  'library.confirmDeleteTitleMany': 'Delete {count} assets?',
  'library.confirmDeleteBodyOne': 'This permanently removes it from your Library. This can’t be undone.',
  'library.confirmDeleteBodyMany': 'This permanently removes them from your Library. This can’t be undone.',
  'library.cancel': 'Cancel',
  'library.today': 'Today',
  'library.yesterday': 'Yesterday',
  'library.previewAsset': 'Preview {title}',
  'library.selectAsset': 'Select asset',
  'library.deselectAsset': 'Deselect asset',
  'library.openDesignSystem': 'Open design system',
  'library.openProject': 'Open project',
  'library.opening': 'Opening…',
  'library.editAsPage': 'Edit as page',
  'library.viewSource': 'Source',
  'library.remove': 'Remove',
  'mcp.aboutTemplate': 'About {name}',
  'mcp.approvedRefresh': 'I’ve approved — Refresh',
  'mcp.approveInBrowserHint': 'Approve in the browser tab that opened. We\'ll catch the callback automatically — or click Refresh below if you completed it already.',
  'mcp.argsPlaceholder': 'space-separated',
  'mcp.authModeNone': 'No managed OAuth',
  'mcp.authModeOAuth': 'Managed OAuth',
  'mcp.browserDidntOpen': 'Browser didn\'t open?',
  'mcp.categoryDataViz': 'Data viz',
  'mcp.categoryDataVizHint': 'Charts and diagrams as proper image artifacts.',
  'mcp.categoryDesignSystems': 'Design systems',
  'mcp.categoryDesignSystemsHint': 'Figma read/write, design-token translation, brand inspiration.',
  'mcp.categoryImageEditing': 'Image editing',
  'mcp.categoryImageEditingHint': 'Local post-processing, OCR and CV-driven edits.',
  'mcp.categoryImageGeneration': 'Image generation',
  'mcp.categoryImageGenerationHint': 'Models that produce raster, vector or video assets.',
  'mcp.categoryPublishing': 'Publishing',
  'mcp.categoryPublishingHint': 'Push generated artifacts to a public URL.',
  'mcp.categoryUiComponents': 'UI components',
  'mcp.categoryUiComponentsHint': 'Designer-grade components, blocks and landing-page material.',
  'mcp.categoryUtilities': 'Utilities',
  'mcp.categoryUtilitiesHint': 'Filesystem, fetch, GitHub and similar generic tools.',
  'mcp.categoryWebCapture': 'Web capture',
  'mcp.categoryWebCaptureHint': 'Render a URL into an image so the agent can see what it built.',
  'mcp.checking': 'Checking…',
  'mcp.clickConnectHint': 'Click Connect to grant OpenDesign access via the provider\'s OAuth flow.',
  'mcp.closePicker': 'Close picker',
  'mcp.collapse': 'Collapse',
  'mcp.collapseServerAria': 'Collapse this MCP server',
  'mcp.commandPlaceholder': 'e.g. npx, node, /path/to/binary',
  'mcp.commandRequired': 'Command is required for stdio transport.',
  'mcp.completedAuthTitle': 'I\'ve completed authorization — check connection status now',
  'mcp.connect': 'Connect',
  'mcp.connected': 'Connected.',
  'mcp.connecting': 'Connecting…',
  'mcp.customServer': 'Custom server',
  'mcp.customServerDesc': 'Empty form. Pick stdio or SSE / HTTP and fill the fields yourself.',
  'mcp.disabled': 'Disabled',
  'mcp.disconnect': 'Disconnect',
  'mcp.disconnectFailed': 'Disconnect failed. Check daemon logs.',
  'mcp.disconnecting': 'Disconnecting…',
  'mcp.displayNamePlaceholder': 'Display name (optional)',
  'mcp.enabled': 'Enabled',
  'mcp.enableServerAria': 'Enable this MCP server',
  'mcp.expand': 'Expand',
  'mcp.expandServerAria': 'Expand this MCP server',
  'mcp.expandToEdit': 'Expand to edit',
  'mcp.fieldArgs': 'Args',
  'mcp.fieldCommand': 'Command',
  'mcp.fieldEnv': 'Env (KEY=VALUE)',
  'mcp.fieldEnvShort': 'Env',
  'mcp.fieldHeaders': 'Headers (KEY=VALUE)',
  'mcp.fieldId': 'ID',
  'mcp.fieldOAuthMode': 'OAuth mode',
  'mcp.fieldTransport': 'Transport',
  'mcp.fieldUrl': 'URL',
  'mcp.homepage': 'Homepage',
  'mcp.idInvalid': 'ID must start with a letter or digit and only contain letters, digits, dash, or underscore (max 64 chars).',
  'mcp.jsonHelperExampleHead': 'Example MCP JSON',
  'mcp.jsonHelperHttpNote': 'use url + headers instead of command / args',
  'mcp.jsonHelperToggle': 'Need help? Map your MCP server\'s JSON config using the example below.',
  'mcp.moveDown': 'Move down',
  'mcp.moveUp': 'Move up',
  'mcp.noManagedOAuth': 'No managed OAuth.',
  'mcp.noManagedOAuthSaveDirect': 'Save this server and OpenDesign will use it directly.',
  'mcp.noManagedOAuthUseAsConfigured': 'OpenDesign will use this server as configured. Add headers below if the server needs a token.',
  'mcp.nonExpiringToken': 'Non-expiring token.',
  'mcp.notConnected': 'Not connected.',
  'mcp.openAuthorizationPage': 'Open authorization page',
  'mcp.pickerFilterPlaceholder': 'Filter by name, transport, capability…',
  'mcp.pickerHint': 'Pre-fills the form. You can still edit any field after.',
  'mcp.pickerNoMatch': 'No templates match “{query}”. Try clearing the filter or use the custom server option below.',
  'mcp.pickTemplate': 'Pick a template',
  'mcp.reauthenticateTitle': 'Reauthenticate (replaces the existing token)',
  'mcp.recheckTokenTitle': 'Re-check token status against the daemon',
  'mcp.reconnect': 'Reconnect',
  'mcp.refresh': 'Refresh',
  'mcp.removeServer': 'Remove this MCP server',
  'mcp.saveFirstThenClick': 'Save first, then click',
  'mcp.starting': 'Starting…',
  'mcp.toGrantOAuthAccess': 'to grant OpenDesign access via the provider\'s OAuth flow.',
  'mcp.tokenExpires': 'Token expires {time}.',
  'mcp.transportAria': 'Transport: {transport}',
  'mcp.tryLabel': 'Try:',
  'mcp.tryPromptTitle': 'Paste this prompt into the chat composer to try the server end-to-end',
  'mcp.unnamedServer': 'Unnamed MCP server',
  'mcp.urlMalformed': 'URL is malformed.',
  'mcp.urlProtocolInvalid': 'URL must use http:// or https://.',
  'mcp.urlRequired': 'URL is required for SSE / HTTP transport.',
  'mcp.waitingForAuthorization': 'Waiting for authorization…',
  'memory.connectorReadFailed': 'Couldn\'t read {name}.',
  'memory.connectorNoReadableContent': 'No readable content from {name}.',
  'memory.providerLocalCli': 'Local CLI',
  'memory.providerFallbackName': 'Memory model',
  'memory.extractionSourceConnector': 'Connected apps were read, but OpenDesign could not turn that context into memory.',
  'memory.extractionSourceChat': 'OpenDesign could not run memory extraction for this chat.',
  'memory.failureAuthExpiredTitle': '{provider} authentication expired',
  'memory.failureAuthActionCli': 'Sign in to the selected Local CLI or choose a different Memory model.',
  'memory.failureAuthActionKey': 'Update the Memory extraction model key or sign in again.',
  'memory.failureQuotaTitle': '{provider} quota or rate limit hit',
  'memory.failureQuotaAction': 'Try again later or switch the Memory extraction model.',
  'memory.failureRequestTitle': '{provider} request failed',
  'memory.failureRequestActionCli': 'Check the selected Local CLI and try again.',
  'memory.failureRequestActionProvider': 'Check the model provider connection and try again.',
  'memory.failureGenericTitle': 'Memory extraction failed',
  'memory.failureGenericActionCli': 'Try again after checking the selected Local CLI.',
  'memory.failureGenericActionSettings': 'Try again after checking the Memory extraction model settings.',
  'memory.noData': 'No data',
  'memory.attemptReadTitle': 'Read {name}',
  'memory.attemptFailedTitle': 'Could not read {name}',
  'memory.attemptSkippedTitle': 'Skipped {name}',
  'memory.skipChatDisabled': 'Chat conversation learning is off.',
  'memory.kindConnectedApps': 'Connected apps',
  'memory.timeAgo': '{time} ago',
  'memory.scanRunningTitle': 'Scanning connected apps',
  'memory.scanFailedTitle': 'Connected app scan failed',
  'memory.scanSkippedTitle': 'Connected app scan skipped',
  'memory.scanSavedOne': 'Saved {count} memory',
  'memory.scanSavedOther': 'Saved {count} memories',
  'memory.scanNoNewMemories': 'No new memories found',
  'memory.scanTitle': 'Connected app scan',
  'memory.scanMetaChecking': 'Checking selected apps',
  'memory.scanMetaNeedsAttention': 'Needs attention',
  'memory.scanMetaFromConnectedApps': 'From connected apps',
  'memory.scanMetaCheckedApps': 'Checked selected apps',
  'memory.scanBusyLabel': 'Scanning apps',
  'memory.scanSelectPrompt': 'Select apps to scan',
  'memory.scanSelectedApps': 'Scan selected apps',
  'memory.connectorReadFailedRetry': 'Could not read connected apps. Try again from the Connectors tab.',
  'memory.appCountOne': '{count} app',
  'memory.appCountOther': '{count} apps',
  'memory.foundSuggestionsOne': 'Found {count} suggested memory from {apps}. Review before saving.',
  'memory.foundSuggestionsOther': 'Found {count} suggested memories from {apps}. Review before saving.',
  'memory.noSuggestionsFound': 'No memory suggestions found. OpenDesign could not read useful content from the selected app yet.',
  'memory.checkedNoSuggestionsOne': 'Checked {count} selected app, but found no new memory suggestions.',
  'memory.checkedNoSuggestionsOther': 'Checked {count} selected apps, but found no new memory suggestions.',
  'memory.savedFromConnectedAppsOne': 'Saved {count} memory from connected apps.',
  'memory.savedFromConnectedAppsOther': 'Saved {count} memories from connected apps.',
  'memory.savedPartial': 'Saved {saved} of {total} selected memories. Please try the remaining items again.',
  'memory.tabManual': 'Add manually',
  'memory.tabManualCaption': 'Write a fact or preference',
  'memory.tabConnected': 'Import from apps',
  'memory.tabConnectedCaption': 'Scan connected tools',
  'memory.storagePathAria': 'Memory storage path — click to copy',
  'memory.flowOnboarding': 'Onboarding',
  'memory.flowBrandContext': 'Brand context',
  'memory.flowChatSignals': 'Chat signals',
  'memory.flowSavedMemory': 'Saved memory',
  'memory.howCopy': 'Memory is gathered automatically from profile setup, project and brand extraction, connected apps, and useful facts learned during chats. The saved list below is the review surface; everything else stays quiet unless you open Add or Advanced.',
  'memory.areasAria': 'Memory areas',
  'memory.manualPanelHint': 'Add facts, preferences, or project context yourself. Fixed assistant behavior lives in Instructions / Rules.',
  'memory.connectedPanelHint': 'Choose apps to scan for design preferences, project context, and visual references. Nothing is scanned until you select an app.',
  'memory.loading': 'Loading',
  'memory.connectedCount': '{count} connected',
  'memory.manage': 'Manage',
  'memory.chooseSources': 'Choose sources',
  'memory.chooseSourcesHint': 'Select connected apps first. OpenDesign only scans the apps you choose.',
  'memory.selectedCount': '{count} selected',
  'memory.connectorListAria': 'Connected memory apps',
  'memory.readToolsCount': '{count} read tools',
  'memory.checkingConnectionStatus': 'Checking connection status…',
  'memory.finishAuthorization': 'Finish authorization in your browser, then return here',
  'memory.connectBeforeExtraction': 'Connect this app before extraction',
  'memory.useConnectorAria': 'Use {name} for memory extraction',
  'memory.selected': 'Selected',
  'memory.select': 'Select',
  'memory.reconnectConnectorAria': 'Reconnect {name}',
  'memory.connectConnectorAria': 'Connect {name}',
  'memory.connectStateChecking': 'Checking',
  'memory.connectStateWaiting': 'Waiting',
  'memory.connectStateConnecting': 'Connecting',
  'memory.reconnect': 'Reconnect',
  'memory.selectedOfConnectedOne': 'Selected {count} of {total} connected app.',
  'memory.selectedOfConnectedOther': 'Selected {count} of {total} connected apps.',
  'memory.suggestedMemories': 'Suggested memories',
  'memory.suggestedMemoriesHint': 'Review design-related memories before saving them.',
  'memory.saving': 'Saving',
  'memory.saveSelected': 'Save selected',
  'memory.discard': 'Discard',
  'memory.diagnosticsAria': 'Connected app read status',
  'memory.lastScan': 'Last scan',
  'memory.bytesRead': '{bytes} read',
  'memory.recentScans': 'Recent scans',
  'memory.runHistoryAria': 'Connected app memory run status',
  'memory.savedMemoryHint': 'Saved facts, preferences, and project context available to future chats.',
  'memory.savedCount': '{count} saved',
  'memory.extractionCountOne': '{count} extraction',
  'memory.extractionCountOther': '{count} extractions',
  'memory.emptyHintBefore': 'Tell the assistant a fact in chat — e.g.',
  'memory.emptyHintAfter': '— and it will be saved here automatically.',
  'memory.advancedHint': 'Inspect or edit the underlying memory index.',
  'memory.memoryTree': 'Memory tree',
  'memory.memoryTreeHint': 'Technical view of the same saved memories. Most users only need the saved-memory list above.',
  'memory.nodeCountOne': '{count} node',
  'memory.nodeCountOther': '{count} nodes',
  'dsCreate.addingSourceMaterial': 'Adding source material...',
  'dsCreate.browseFolder': 'Browse folder',
  'dsCreate.confirmBody': 'You\'ll land in a project that fills in live — logo, palette, typography, imagery — as it measures your brand. Keep the tab open.',
  'dsCreate.confirmTitle': 'OpenDesign will extract your design system.',
  'dsCreate.designMdPreviewFallbackName': 'Design system',
  'dsCreate.dropZoneSelections': '{label} selections',
  'dsCreate.extractDesignSystem': 'Extract design system',
  'dsCreate.extractionAlreadyStarting': 'Extraction is already starting. Please wait for the current request to finish.',
  'dsCreate.figmaFileFallbackLabel': 'Figma file',
  'dsCreate.figmaUrlInvalid': 'Enter a Figma file URL (https://figma.com/file/… or /design/…).',
  'dsCreate.githubAccessAutoBody': 'GitHub repo links use the first working access method; other website links are saved as source references.',
  'dsCreate.githubAccessAutoTitle': 'GitHub access: Auto',
  'dsCreate.githubAccessMethodsAria': 'GitHub repository access methods',
  'dsCreate.githubAuthorizeFailed': 'Could not start GitHub authorization.',
  'dsCreate.githubBadgeAutomatic': 'Automatic',
  'dsCreate.githubBadgeChecking': 'Checking',
  'dsCreate.githubBadgeComingSoon': 'Coming soon',
  'dsCreate.githubBadgeConnected': 'Connected',
  'dsCreate.githubBadgeNeedsAttention': 'Needs attention',
  'dsCreate.githubBadgeNotConfigured': 'Not configured',
  'dsCreate.githubBadgeOptional': 'Optional',
  'dsCreate.githubBadgePending': 'Pending',
  'dsCreate.githubComposioCheckingDesc': 'Checking connector status in the background; URL intake is not blocked.',
  'dsCreate.githubComposioConnectedAsDesc': 'Composio GitHub connector connected as {account}; it is available as fallback when this device cannot read the repository.',
  'dsCreate.githubComposioConnectedDesc': 'Composio GitHub connector is available as fallback when this device cannot read the repository.',
  'dsCreate.githubComposioDefaultDesc': 'Composio GitHub connector access for agent tools; repo URLs still work with local git or GitHub CLI.',
  'dsCreate.githubComposioErrorDesc': 'Reconnect the Composio GitHub connector, or continue with local git/GitHub CLI.',
  'dsCreate.githubComposioNotConfiguredDesc': 'Add a Composio API key only if this project needs connector-backed GitHub tools.',
  'dsCreate.githubComposioPendingDesc': 'Finish the Composio authorization window; local GitHub intake remains available.',
  'dsCreate.githubConfigureComposio': 'Configure Composio',
  'dsCreate.githubConnecting': 'Connecting...',
  'dsCreate.githubConnectorCheckFailed': 'Could not check the GitHub connector.',
  'dsCreate.githubConnectorCheckTimeout': 'Could not finish checking GitHub connector. You can still add repository URLs or connect GitHub manually.',
  'dsCreate.githubConnectViaComposio': 'Connect via Composio',
  'dsCreate.githubDisconnect': 'Disconnect',
  'dsCreate.githubDisconnectFailed': 'Could not disconnect GitHub.',
  'dsCreate.githubDisconnecting': 'Disconnecting...',
  'dsCreate.githubHideAccessMethods': 'Hide access methods',
  'dsCreate.githubMethodConnectorPlatform': 'Connector platform',
  'dsCreate.githubMethodOdAccount': 'OpenDesign account',
  'dsCreate.githubMethodOdAccountDesc': 'Native GitHub sign-in managed by OpenDesign; this build does not use an OD-managed GitHub token yet.',
  'dsCreate.githubMethodThisDevice': 'This device',
  'dsCreate.githubMethodThisDeviceDesc': 'Uses public git clone, local git credentials, or GitHub CLI auth available on this machine.',
  'dsCreate.githubOpenAuthorization': 'Open authorization',
  'dsCreate.githubShowAccessMethods': 'Show access methods',
  'dsCreate.libraryPartiallyAdded': 'Added {added} of {total} item(s) from the library.',
  'dsCreate.localCodeFilesSelected': '{count} local code files selected',
  'dsCreate.prepareProjectFailed': 'Could not prepare the design system project.',
  'dsCreate.removeFile': 'Remove {name}',
  'dsCreate.startingExtraction': 'Starting extraction...',
  'dsFlow.activityDetailFailed': 'The chat message has the run details. You can adjust the request and try again.',
  'dsFlow.activityDetailReady': 'Review the updated Design System and Design Files tabs.',
  'dsFlow.activityDetailRunning': 'Watching project files and preparing the review draft.',
  'dsFlow.activityFailedTitle': 'Workspace update needs attention',
  'dsFlow.activityProgressAria': 'Workspace update progress {progress}%',
  'dsFlow.activityReadyTitle': 'Workspace update ready',
  'dsFlow.activityRunningTitle': 'OpenDesign is updating this system',
  'dsFlow.addBrandFonts': 'Add brand font files',
  'dsFlow.agentMsgCapturedDirection': 'Captured direction: {summary}',
  'dsFlow.agentMsgCreating': 'I am creating the design system workspace, preview cards, and supporting files from the context you provided.',
  'dsFlow.agentMsgReady': 'Your design system draft is ready. Review the Design System tab, inspect generated files, publish it, or ask me for changes here.',
  'dsFlow.agentMsgRevision': 'I am applying your feedback to the design system. You can keep reviewing the current draft while the revision runs.',
  'dsFlow.agentMsgTokenRebuild': 'I am preparing a token contract rebuild for review. The active contract will stay unchanged until the revision is accepted.',
  'dsFlow.agentPushLayer': 'Agent push layer',
  'dsFlow.assetsLabel': 'Assets',
  'dsFlow.auditNeedsRepair': '{summary} Review the audit details before running a repair.',
  'dsFlow.brandFontsMissingBody': 'Typography previews are using substitute web fonts until brand font files are added.',
  'dsFlow.brandFontsMissingTitle': 'Brand font files missing',
  'dsFlow.chatCreateRequest': 'Create design system',
  'dsFlow.chatSeedUpdateSystem': 'Update this design system: ',
  'dsFlow.composerPlaceholder': 'Follow-up action: use AI extraction to refine this system. Longer run; updates land here.',
  'dsFlow.conversationCreateFailed': 'Could not create a design system conversation.',
  'dsFlow.evidenceFallbackTokens': 'Fallback tokens',
  'dsFlow.evidenceFonts': 'Fonts',
  'dsFlow.evidenceIndexes': 'Evidence indexes',
  'dsFlow.evidenceScannedFiles': 'Scanned files',
  'dsFlow.evidenceSnippets': 'Snippets',
  'dsFlow.evidenceSourceTokens': 'Source tokens',
  'dsFlow.fileDraftPreview': 'File draft preview',
  'dsFlow.filesTouched': 'Files touched',
  'dsFlow.forceRebuild': 'Force',
  'dsFlow.generalRevision': 'General revision',
  'dsFlow.generationCompleted': 'Generation completed',
  'dsFlow.generationProgressAria': 'Generation progress {progress}%',
  'dsFlow.generationStopped': 'Generation stopped',
  'dsFlow.generationStoppedWithError': 'Generation stopped: {error}',
  'dsFlow.jobCompleted': '{noun} completed',
  'dsFlow.jobDetailGeneration': 'Preparing the remaining files.',
  'dsFlow.jobDetailReady': 'Review workspace is ready.',
  'dsFlow.jobDetailRevision': 'Applying your feedback.',
  'dsFlow.jobDetailTokenRebuild': 'Preparing a reviewable token contract draft.',
  'dsFlow.jobNeedsAttention': '{noun} needs attention',
  'dsFlow.jobNounGeneration': 'Generation',
  'dsFlow.jobNounRevision': 'Revision',
  'dsFlow.jobNounTokenRebuild': 'Token rebuild',
  'dsFlow.jobRebuildingTokens': 'OpenDesign is rebuilding tokens',
  'dsFlow.jobRevising': 'OpenDesign is revising',
  'dsFlow.jobStillWorking': 'OpenDesign is still working',
  'dsFlow.loadingDesignSystem': 'Loading design system...',
  'dsFlow.metaEvidenceNotes': 'Evidence notes',
  'dsFlow.metaScannedInventory': 'Scanned file inventory',
  'dsFlow.metaSnippetIndex': 'Snippet index',
  'dsFlow.metaTokenExtraction': 'Token extraction evidence',
  'dsFlow.metaTokenReport': 'Token contract quality report',
  'dsFlow.movedBackToDraft': 'Moved back to draft',
  'dsFlow.needsWorkSeed': 'Needs work on {title}: ',
  'dsFlow.no': 'No',
  'dsFlow.openingDesignSystemWorkspace': 'Opening the design system workspace...',
  'dsFlow.openingWorkspace': 'Opening the workspace...',
  'dsFlow.packageFallbackMeta': '{source} · DESIGN.md-only fallback',
  'dsFlow.packageLegacy': 'Legacy design system',
  'dsFlow.packageManifestMeta': '{source} · {mode} mode · manifest indexed',
  'dsFlow.packagePillFallback': 'Fallback',
  'dsFlow.packagePillReady': 'Hybrid ready',
  'dsFlow.packageStructured': 'Structured import package',
  'dsFlow.pendingRevision': 'Pending revision',
  'dsFlow.pickLocalAgentFirst': 'Pick a local agent first, then ask OpenDesign to update this design system.',
  'dsFlow.previewPages': 'Preview pages',
  'dsFlow.proposedChanges': 'Proposed changes',
  'dsFlow.publishCardReady': 'OpenDesign is ready for review. Give feedback on the work so far, then publish when it is useful for future projects.',
  'dsFlow.publishCardRevision': 'OpenDesign is applying your feedback. You can keep reviewing while the updated draft is prepared.',
  'dsFlow.publishCardTokenRebuild': 'OpenDesign is preparing a token contract rebuild for review. The active contract stays unchanged until you accept it.',
  'dsFlow.publishCardWorking': 'OpenDesign is still working, but you can start giving feedback on the work so far.',
  'dsFlow.pullLayer': 'Pull layer',
  'dsFlow.rebuildTokenContract': 'Rebuild token contract',
  'dsFlow.reviewDraftTitle': 'Review draft design system',
  'dsFlow.revisionAccept': 'Accept',
  'dsFlow.revisionAccepted': 'Revision accepted',
  'dsFlow.revisionAcceptFailed': 'Could not accept revision',
  'dsFlow.revisionHistory': 'Revision history',
  'dsFlow.revisionMsgAccepted': 'Accepted. The design system draft now includes this update.',
  'dsFlow.revisionMsgPending': 'I prepared a proposed update. Review the diff card on the right, then accept it or ask for another change.',
  'dsFlow.revisionMsgRejected': 'Rejected. I left the current design system unchanged.',
  'dsFlow.revisionProgressUnavailable': 'Could not read revision progress',
  'dsFlow.revisionReady': 'Revision ready for review',
  'dsFlow.revisionReject': 'Reject',
  'dsFlow.revisionRejected': 'Revision rejected',
  'dsFlow.revisionRejectFailed': 'Could not reject revision',
  'dsFlow.revisionStopped': 'Revision stopped',
  'dsFlow.revisionStoppedWithError': 'Revision stopped: {error}',
  'dsFlow.saveChangesFailed': 'Could not save changes',
  'dsFlow.savedDesignMd': 'Saved DESIGN.md',
  'dsFlow.sectionDraftBody': 'Draft body',
  'dsFlow.sectionFallbackTitle': 'Section',
  'dsFlow.sectionMarkedLooksGood': '{title} marked as looks good',
  'dsFlow.sectionNoContent': 'No content yet.',
  'dsFlow.sectionNoDetails': 'No details yet.',
  'dsFlow.setDefaultAction': 'Default for new chats',
  'dsFlow.setDefaultTitle': 'Preselect this design system for new chats and new projects.',
  'dsFlow.sourceEvidence': 'Source evidence',
  'dsFlow.sourceTypeBundled': 'Bundled',
  'dsFlow.sourceTypeDefault': 'Design system',
  'dsFlow.sourceTypeGithub': 'GitHub import',
  'dsFlow.sourceTypeInstalled': 'Installed',
  'dsFlow.sourceTypeLocal': 'Local import',
  'dsFlow.sourceTypeUser': 'User workspace',
  'dsFlow.statusUpdateFailed': 'Could not update status',
  'dsFlow.stepReadCurrentSystem': 'Read current system',
  'dsFlow.stepRefreshReview': 'Refresh review',
  'dsFlow.stepUpdateDesignFiles': 'Update design files',
  'dsFlow.subtitleBrand': 'Logo, voice and usage rules',
  'dsFlow.subtitleColor': 'Palette and semantic roles',
  'dsFlow.subtitleComponents': 'Reusable interface patterns',
  'dsFlow.subtitleDefault': 'Design guidance',
  'dsFlow.subtitleSpacing': 'Spacing scale and radius tokens',
  'dsFlow.subtitleTypography': 'Text hierarchy and styles',
  'dsFlow.tabDesignFiles': 'Design Files',
  'dsFlow.tabDesignSystem': 'Design System',
  'dsFlow.tokenContractLabel': 'Token contract',
  'dsFlow.tokenContractRebuildRecommended': 'rebuild recommended',
  'dsFlow.tokenContractReportAvailable': 'quality report available',
  'dsFlow.tokenContractScore': 'score {score}',
  'dsFlow.tokenRebuildStarted': 'Token contract rebuild started',
  'dsFlow.tokenRebuildStartFailed': 'Could not start token contract rebuild',
  'dsFlow.workspaceOpenFailed': 'Could not open the design system workspace.',
  'dsFlow.workspaceUpdatedReview': 'Workspace updated. Review the files or ask for another change.',
  'dsFlow.workspaceUpdatedSynced': 'Workspace updated and DESIGN.md synced for review.',
  'dsFlow.workspaceUpdatedWithAudit': 'Workspace updated. {summary}',
  'dsFlow.yes': 'Yes',
  'pluginDetail.backToList': 'Back to list',
  'pluginDetail.quickCommands': 'Quick commands',
  'pluginDetail.noQuickCommands': 'No quick commands available.',
  'pluginDetail.dataConnections': 'Data connections',
  'pluginDetail.noDataConnections': 'This suite does not require any external data connections.',
  'pluginDetail.knowledgeSkills': 'Knowledge skills',
  'pluginDetail.noKnowledgeSkills': 'This suite has no standalone knowledge skills yet.',
  'pluginDetail.officialBadge': 'OpenDesign official',
  'pluginDetail.loadFailed': 'Failed to load plugin: {error}',
  'pluginDetail.applyFailed': 'Apply failed. Make sure the daemon is reachable.',
  'pluginDetail.examples': 'Examples',
  'skillDetail.providedBy': 'provided by {author}',
  'skillDetail.markdownNotice': 'The following content is taken verbatim from this skill’s SKILL.md',
  'skillDetail.loadFailed': 'Couldn’t load this skill’s SKILL.md.',
  'skillDetail.previewAria': '{title} SKILL.md preview',
  'common.dismiss': 'Dismiss',
  'campaign.deepseekV4Flash.headline': 'คราวนี้ ใช้ความอัจฉริยะระดับสูงได้ไม่จำกัด',
  'campaign.deepseekV4Flash.description': 'แลนดิง เว็บไซต์ เด็ค และรูปภาพ — ทำได้เท่าที่ต้องการ',
  'campaign.deepseekV4Flash.benefit': 'DeepSeek V4 Pro และ V4 Flash ไม่จำกัด',
  'campaign.deepseekV4Flash.timing': '13–27 ส.ค.: ใช้ฟรีในช่วงแคมเปญ',
  'campaign.deepseekV4Flash.ruleSummary': '13–27 ส.ค. ผู้ใช้แบบชำระเงินสามารถใช้ DeepSeek V4 Pro และ V4 Flash ได้ฟรีใน OpenDesign การใช้งานผิดปกติในวงกว้างอาจทำให้สิทธิ์ถูกระงับ',
  'campaign.deepseekV4Flash.windowLabel': '13–27 ส.ค.',
  'campaign.deepseekV4Flash.weekFreeSuffix': 'ฟรีสองสัปดาห์',
  'campaign.deepseekV4Flash.boundary': 'โควตาโมเดลไม่จำกัดและการสร้างฟรีในแพ็กเกจใช้ได้เฉพาะใน OpenDesign เท่านั้น — ไม่ผ่าน MCP / CLI / API หรือช่องทางอื่น การตีความสุดท้ายเป็นของ OpenDesign บางโมเดลอาจต้องรอคิวในช่วงเวลาที่มีผู้ใช้งานหนาแน่น',
  'campaign.deepseekV4Flash.countdownLabel': 'นับถอยหลังแคมเปญ',
  'campaign.deepseekV4Flash.countdownEnded': 'แคมเปญสิ้นสุดแล้ว',
  'campaign.deepseekV4Flash.countdownRemaining': '{days}ว {hms}',
  'campaign.deepseekV4Flash.closeAria': 'ปิด',
  'campaign.deepseekV4Flash.unlocked': 'ปลดล็อกแล้ว',
  'campaign.deepseekV4Flash.locked': 'ล็อกอยู่',
  'campaign.deepseekV4Flash.later': 'ไว้ทีหลัง',
  'campaign.deepseekV4Flash.paid.eyebrow': 'ฟรีสองสัปดาห์',
  'campaign.deepseekV4Flash.paid.status': 'ปลดล็อกแล้ว · 13–27 ส.ค.',
  'campaign.deepseekV4Flash.paid.cta': 'ใช้เลย',
  'campaign.deepseekV4Flash.paid.modelBadge': 'ไม่จำกัด',
  'campaign.deepseekV4Flash.unpaid.eyebrow': 'ฟรีสำหรับแพ็กเกจแบบชำระเงิน',
  'campaign.deepseekV4Flash.unpaid.status': 'อัปเกรดเพื่อปลดล็อก · ถึง 27 ส.ค.',
  'campaign.deepseekV4Flash.unpaid.cta': 'อัปเกรดแล้วใช้',
  'campaign.deepseekV4Flash.unpaid.modelBadge': 'ต้องอัปเกรด',
  'campaign.deepseekV4Flash.unpaid.tooltip': 'สมัครแพ็กเกจในช่วงแคมเปญเพื่อใช้ฟรี สิ้นสุด 27 ส.ค.',
  'campaign.deepseekV4Flash.restricted.modelBadge': 'ระงับชั่วคราว',
  'campaign.deepseekV4Flash.restricted.tooltip': 'ตรวจพบการใช้งานปริมาณสูงผิดปกติ จึงระงับสิทธิ์แคมเปญ ติดต่อฝ่ายสนับสนุนหากต้องการความช่วยเหลือ',
  'campaign.deepseekV4Flash.workbenchBadge': 'DeepSeek V4 Pro + V4 Flash ไม่จำกัด ฟรี',
  'campaign.deepseekV4Flash.workbenchBadgeAria': 'DeepSeek V4 Pro และ V4 Flash ไม่จำกัด ฟรี — ดูราคา',

  'experienceSurvey.tag': "อยากฟังความคิดเห็นของคุณ — ช่วยกันพัฒนา OpenDesign",
  'experienceSurvey.close': "ปิด",
  'experienceSurvey.recommendation': "คุณมีแนวโน้มจะแนะนำ OpenDesign ให้เพื่อนร่วมงานหรือเพื่อนมากแค่ไหน?",
  'experienceSurvey.recommendationLow': "ไม่แนะนำเลย",
  'experienceSurvey.recommendationHigh': "แนะนำแน่นอน",
  'experienceSurvey.improvement': "อยากให้เราปรับปรุงเรื่องใดก่อน?",
  'experienceSurvey.improvement.wrongOutput': "ไม่ใช่สิ่งที่ขอ",
  'experienceSurvey.improvement.falseDone': "บอกว่าเสร็จแต่ไม่มีอะไรเปลี่ยน",
  'experienceSurvey.improvement.hardToUse': "ใช้งานยาก",
  'experienceSurvey.improvement.upgradePrompts': "ป๊อปอัปชวนสมัครเยอะเกินไป",
  'experienceSurvey.improvement.stuck': "ค้างหรือล้มเหลว",
  'experienceSurvey.improvement.slow': "ช้าเกินไป",
  'experienceSurvey.improvement.looks': "ผลลัพธ์ไม่สวย",
  'experienceSurvey.improvement.regression': "ทำพังส่วนอื่น",
  'experienceSurvey.improvement.other': "อื่น ๆ",
  'experienceSurvey.otherPlaceholder': "เล่าด้วยคำพูดของคุณ",
  'experienceSurvey.submit': "ส่ง",
  'experienceSurvey.skip': "ข้ามไป",
  'experienceSurvey.thanksTitle': "ขอบคุณ!",
  'experienceSurvey.thanksBody': "ความคิดเห็นของคุณจะส่งตรงถึงทีมงาน",
  'chat.record.verb.read': "อ่าน",
  'chat.record.verb.write': "สร้าง",
  'chat.record.verb.edit': "แก้ไข",
  'chat.record.verb.search': "ค้นหา",
  'chat.record.verb.exec': "รัน",
  'chat.record.failed': "ล้มเหลว",
  'chat.record.hits': "{count} รายการ",
  'chat.record.slowUpstream': 'ผู้ให้บริการตอบสนองช้า — รอมาแล้ว {seconds} วินาที',
  'chat.record.running': "กำลังทำงาน",
  'chat.record.thinking': "กำลังคิด",
  'chat.record.thinkingTokens': "{count} โทเคน",
  'chat.record.thoughts': "กระบวนการคิด",
  'chat.record.done': "เสร็จแล้ว",
  'chat.record.failedTurn': "รันไม่สำเร็จ",
  'chat.record.plan': "แผน · {count} ขั้น",
  'chat.record.planStep': "ขั้นตอนที่ {current} จาก {total}",
  'chat.record.imageBatch': "กำลังสร้างภาพประกอบ",
  'chat.record.imageCount': "{count} ภาพ",
  'chat.record.retry': "ลองใหม่",
  'chat.record.viewImage': "ดูภาพที่ {index}",
  'chat.record.viewLarge': "ดูภาพขนาดเต็ม",
  'chat.record.imagePending': "กำลังสร้างภาพประกอบ…",
  'chat.record.audioBatch': "กำลังสร้างเสียง",
  'chat.record.videoBatch': "กำลังสร้างวิดีโอ",
  'chat.record.audioCount': "{count} คลิป",
  'chat.record.videoCount': "{count} วิดีโอ",
  'chat.record.audioPending': "กำลังสร้างเสียง…",
  'chat.record.videoPending': "กำลังสร้างวิดีโอ…",
  'chat.record.viewAudio': "เปิดเสียง {index}",
  'chat.record.viewVideo': "เปิดวิดีโอ {index}",
  'chat.designSystemStatus.title': "กำลังสร้างพื้นที่ทำงานดีไซน์ซิสเต็ม",
  'chat.designSystemStatus.description': "Open Design กำลังใช้แหล่งที่มาจากการตั้งค่าเพื่อสร้างโปรเจกต์นี้",
  'labs.title': "Open Design Labs",
  'labs.itemAbout': "เกี่ยวกับ {name}",
  'labs.navHint': "ทดลองความสามารถก่อนเปิดตัวจริง",
  'labs.pageDesc': "ลองใช้ฟีเจอร์ทดลอง ฟีเจอร์และความพร้อมใช้งานอาจเปลี่ยนแปลงในแต่ละเวอร์ชัน",
  'labs.harnessName': "Design Harness",
  'labs.harnessHint': "เมื่อเปิด การสร้างครั้งถัดไปจะใช้กลยุทธ์ล่าสุดของ OpenDesign ให้ผลงานประณีตขึ้นชัดเจน (เบต้า)",
  'labs.harnessTooltip': "สลับไปใช้ agent harness ที่ Open Design สร้างขึ้นสำหรับงานออกแบบ ผลลัพธ์จะดีขึ้นชัดเจนทั้งการจัดวาง โครงสร้าง และความสมบูรณ์",
  'labs.harnessScope': "ปัจจุบันครอบคลุมต้นแบบ สไลด์ สื่อการตลาด และ Hyperframes โดย agent บางตัวยังไม่รองรับ",
  'labs.envOverrideNotice': "การตั้งค่านี้ถูกควบคุมด้วยตัวแปรสภาพแวดล้อม จึงเปลี่ยนที่นี่ไม่ได้",
  'labs.loadFailedNotice': "อ่านการตั้งค่านี้ไม่ได้ กรุณาตรวจสอบว่า daemon ในเครื่องกำลังทำงานอยู่",
  'labs.optOutPrompt': "กลับไปใช้วิธีเดิมแล้ว มีอะไรไม่เหมาะ",
  'labs.optOutWorseOutput': "ผลงานแย่ลง",
  'labs.optOutTooSlow': "ช้าเกินไป",
  'labs.optOutNotWhatIWanted': "ไม่ใช่สิ่งที่ต้องการ",
  'labs.optOutOther': "อื่น ๆ",
  'labs.optOutSkip': "ข้าม",
  'labs.optOutOtherPlaceholder': "อะไรที่ไม่เหมาะบ้าง",
  'labs.optOutSubmit': "ส่ง",
  'chat.conversationsSearchPlaceholder': "ค้นหาการสนทนา",
  'chat.conversationsNoMatches': "ไม่พบการสนทนาที่ตรงกัน",
  'chat.attachments.preview': "ดูตัวอย่าง {name}",
  'chat.record.canceled': "ยกเลิกแล้ว",
  'chat.record.pending': "ยังไม่เริ่ม",
  'chat.record.unfinished': "ยังไม่เสร็จ",
  'comment.authorRole.owner': 'เจ้าของ',
  'comment.authorRole.admin': 'ผู้ดูแลระบบ',
  'comment.authorRole.member': 'สมาชิก',
  'comment.authorRole.sharePage': 'หน้าที่แชร์',
  'comment.sharePageCommentReadOnly': 'ไม่สามารถแก้ไขความคิดเห็นจากหน้าแชร์ได้',
  'comment.unsentDiscardNotice': 'คุณมีความคิดเห็นที่ยังไม่ได้ส่ง คลิกอีกครั้งเพื่อละทิ้งและสลับ',
  'comment.anchorState.reanchored': 'อ้างอิงจากเวอร์ชันเก่า',
  'comment.anchorState.stale': 'จุดยึดอาจถูกย้ายแล้ว',
  'comment.saveTargetMissing': 'The comment target no longer exists. Select an element again; your draft is kept.',
  'comment.savePreviewNotReady': 'The preview is refreshing. Your draft is kept; try saving again when it is ready.',
  'comment.anchorState.lost': 'ไม่พบจุดยึด',
};
